import {
  __commonJS,
  __export,
  __toESM
} from "./chunk-U67V476Y.js";

// ../node_modules/@babel/runtime/helpers/typeof.js
var require_typeof = __commonJS({
  "../node_modules/@babel/runtime/helpers/typeof.js"(exports, module2) {
    function _typeof2(o) {
      "@babel/helpers - typeof";
      return module2.exports = _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports, _typeof2(o);
    }
    module2.exports = _typeof2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../node_modules/@babel/runtime/helpers/regeneratorRuntime.js
var require_regeneratorRuntime = __commonJS({
  "../node_modules/@babel/runtime/helpers/regeneratorRuntime.js"(exports, module2) {
    var _typeof2 = require_typeof()["default"];
    function _regeneratorRuntime3() {
      "use strict";
      module2.exports = _regeneratorRuntime3 = function _regeneratorRuntime4() {
        return e;
      }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
      var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t2, e2, r2) {
        t2[e2] = r2.value;
      }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
      function define2(t2, e2, r2) {
        return Object.defineProperty(t2, e2, {
          value: r2,
          enumerable: true,
          configurable: true,
          writable: true
        }), t2[e2];
      }
      try {
        define2({}, "");
      } catch (t2) {
        define2 = function define3(t3, e2, r2) {
          return t3[e2] = r2;
        };
      }
      function wrap(t2, e2, r2, n2) {
        var i2 = e2 && e2.prototype instanceof Generator ? e2 : Generator, a2 = Object.create(i2.prototype), c2 = new Context(n2 || []);
        return o(a2, "_invoke", {
          value: makeInvokeMethod(t2, r2, c2)
        }), a2;
      }
      function tryCatch(t2, e2, r2) {
        try {
          return {
            type: "normal",
            arg: t2.call(e2, r2)
          };
        } catch (t3) {
          return {
            type: "throw",
            arg: t3
          };
        }
      }
      e.wrap = wrap;
      var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
      function Generator() {
      }
      function GeneratorFunction() {
      }
      function GeneratorFunctionPrototype() {
      }
      var p = {};
      define2(p, a, function() {
        return this;
      });
      var d = Object.getPrototypeOf, v = d && d(d(values([])));
      v && v !== r && n.call(v, a) && (p = v);
      var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
      function defineIteratorMethods(t2) {
        ["next", "throw", "return"].forEach(function(e2) {
          define2(t2, e2, function(t3) {
            return this._invoke(e2, t3);
          });
        });
      }
      function AsyncIterator(t2, e2) {
        function invoke(r3, o2, i2, a2) {
          var c2 = tryCatch(t2[r3], t2, o2);
          if ("throw" !== c2.type) {
            var u2 = c2.arg, h2 = u2.value;
            return h2 && "object" == _typeof2(h2) && n.call(h2, "__await") ? e2.resolve(h2.__await).then(function(t3) {
              invoke("next", t3, i2, a2);
            }, function(t3) {
              invoke("throw", t3, i2, a2);
            }) : e2.resolve(h2).then(function(t3) {
              u2.value = t3, i2(u2);
            }, function(t3) {
              return invoke("throw", t3, i2, a2);
            });
          }
          a2(c2.arg);
        }
        var r2;
        o(this, "_invoke", {
          value: function value(t3, n2) {
            function callInvokeWithMethodAndArg() {
              return new e2(function(e3, r3) {
                invoke(t3, n2, e3, r3);
              });
            }
            return r2 = r2 ? r2.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
          }
        });
      }
      function makeInvokeMethod(e2, r2, n2) {
        var o2 = h;
        return function(i2, a2) {
          if (o2 === f) throw Error("Generator is already running");
          if (o2 === s) {
            if ("throw" === i2) throw a2;
            return {
              value: t,
              done: true
            };
          }
          for (n2.method = i2, n2.arg = a2; ; ) {
            var c2 = n2.delegate;
            if (c2) {
              var u2 = maybeInvokeDelegate(c2, n2);
              if (u2) {
                if (u2 === y) continue;
                return u2;
              }
            }
            if ("next" === n2.method) n2.sent = n2._sent = n2.arg;
            else if ("throw" === n2.method) {
              if (o2 === h) throw o2 = s, n2.arg;
              n2.dispatchException(n2.arg);
            } else "return" === n2.method && n2.abrupt("return", n2.arg);
            o2 = f;
            var p2 = tryCatch(e2, r2, n2);
            if ("normal" === p2.type) {
              if (o2 = n2.done ? s : l, p2.arg === y) continue;
              return {
                value: p2.arg,
                done: n2.done
              };
            }
            "throw" === p2.type && (o2 = s, n2.method = "throw", n2.arg = p2.arg);
          }
        };
      }
      function maybeInvokeDelegate(e2, r2) {
        var n2 = r2.method, o2 = e2.iterator[n2];
        if (o2 === t) return r2.delegate = null, "throw" === n2 && e2.iterator["return"] && (r2.method = "return", r2.arg = t, maybeInvokeDelegate(e2, r2), "throw" === r2.method) || "return" !== n2 && (r2.method = "throw", r2.arg = new TypeError("The iterator does not provide a '" + n2 + "' method")), y;
        var i2 = tryCatch(o2, e2.iterator, r2.arg);
        if ("throw" === i2.type) return r2.method = "throw", r2.arg = i2.arg, r2.delegate = null, y;
        var a2 = i2.arg;
        return a2 ? a2.done ? (r2[e2.resultName] = a2.value, r2.next = e2.nextLoc, "return" !== r2.method && (r2.method = "next", r2.arg = t), r2.delegate = null, y) : a2 : (r2.method = "throw", r2.arg = new TypeError("iterator result is not an object"), r2.delegate = null, y);
      }
      function pushTryEntry(t2) {
        var e2 = {
          tryLoc: t2[0]
        };
        1 in t2 && (e2.catchLoc = t2[1]), 2 in t2 && (e2.finallyLoc = t2[2], e2.afterLoc = t2[3]), this.tryEntries.push(e2);
      }
      function resetTryEntry(t2) {
        var e2 = t2.completion || {};
        e2.type = "normal", delete e2.arg, t2.completion = e2;
      }
      function Context(t2) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t2.forEach(pushTryEntry, this), this.reset(true);
      }
      function values(e2) {
        if (e2 || "" === e2) {
          var r2 = e2[a];
          if (r2) return r2.call(e2);
          if ("function" == typeof e2.next) return e2;
          if (!isNaN(e2.length)) {
            var o2 = -1, i2 = function next() {
              for (; ++o2 < e2.length; ) if (n.call(e2, o2)) return next.value = e2[o2], next.done = false, next;
              return next.value = t, next.done = true, next;
            };
            return i2.next = i2;
          }
        }
        throw new TypeError(_typeof2(e2) + " is not iterable");
      }
      return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
      }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
      }), GeneratorFunction.displayName = define2(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t2) {
        var e2 = "function" == typeof t2 && t2.constructor;
        return !!e2 && (e2 === GeneratorFunction || "GeneratorFunction" === (e2.displayName || e2.name));
      }, e.mark = function(t2) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t2, GeneratorFunctionPrototype) : (t2.__proto__ = GeneratorFunctionPrototype, define2(t2, u, "GeneratorFunction")), t2.prototype = Object.create(g), t2;
      }, e.awrap = function(t2) {
        return {
          __await: t2
        };
      }, defineIteratorMethods(AsyncIterator.prototype), define2(AsyncIterator.prototype, c, function() {
        return this;
      }), e.AsyncIterator = AsyncIterator, e.async = function(t2, r2, n2, o2, i2) {
        void 0 === i2 && (i2 = Promise);
        var a2 = new AsyncIterator(wrap(t2, r2, n2, o2), i2);
        return e.isGeneratorFunction(r2) ? a2 : a2.next().then(function(t3) {
          return t3.done ? t3.value : a2.next();
        });
      }, defineIteratorMethods(g), define2(g, u, "Generator"), define2(g, a, function() {
        return this;
      }), define2(g, "toString", function() {
        return "[object Generator]";
      }), e.keys = function(t2) {
        var e2 = Object(t2), r2 = [];
        for (var n2 in e2) r2.push(n2);
        return r2.reverse(), function next() {
          for (; r2.length; ) {
            var t3 = r2.pop();
            if (t3 in e2) return next.value = t3, next.done = false, next;
          }
          return next.done = true, next;
        };
      }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e2) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = false, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e2) for (var r2 in this) "t" === r2.charAt(0) && n.call(this, r2) && !isNaN(+r2.slice(1)) && (this[r2] = t);
        },
        stop: function stop() {
          this.done = true;
          var t2 = this.tryEntries[0].completion;
          if ("throw" === t2.type) throw t2.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e2) {
          if (this.done) throw e2;
          var r2 = this;
          function handle(n2, o3) {
            return a2.type = "throw", a2.arg = e2, r2.next = n2, o3 && (r2.method = "next", r2.arg = t), !!o3;
          }
          for (var o2 = this.tryEntries.length - 1; o2 >= 0; --o2) {
            var i2 = this.tryEntries[o2], a2 = i2.completion;
            if ("root" === i2.tryLoc) return handle("end");
            if (i2.tryLoc <= this.prev) {
              var c2 = n.call(i2, "catchLoc"), u2 = n.call(i2, "finallyLoc");
              if (c2 && u2) {
                if (this.prev < i2.catchLoc) return handle(i2.catchLoc, true);
                if (this.prev < i2.finallyLoc) return handle(i2.finallyLoc);
              } else if (c2) {
                if (this.prev < i2.catchLoc) return handle(i2.catchLoc, true);
              } else {
                if (!u2) throw Error("try statement without catch or finally");
                if (this.prev < i2.finallyLoc) return handle(i2.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t2, e2) {
          for (var r2 = this.tryEntries.length - 1; r2 >= 0; --r2) {
            var o2 = this.tryEntries[r2];
            if (o2.tryLoc <= this.prev && n.call(o2, "finallyLoc") && this.prev < o2.finallyLoc) {
              var i2 = o2;
              break;
            }
          }
          i2 && ("break" === t2 || "continue" === t2) && i2.tryLoc <= e2 && e2 <= i2.finallyLoc && (i2 = null);
          var a2 = i2 ? i2.completion : {};
          return a2.type = t2, a2.arg = e2, i2 ? (this.method = "next", this.next = i2.finallyLoc, y) : this.complete(a2);
        },
        complete: function complete(t2, e2) {
          if ("throw" === t2.type) throw t2.arg;
          return "break" === t2.type || "continue" === t2.type ? this.next = t2.arg : "return" === t2.type ? (this.rval = this.arg = t2.arg, this.method = "return", this.next = "end") : "normal" === t2.type && e2 && (this.next = e2), y;
        },
        finish: function finish(t2) {
          for (var e2 = this.tryEntries.length - 1; e2 >= 0; --e2) {
            var r2 = this.tryEntries[e2];
            if (r2.finallyLoc === t2) return this.complete(r2.completion, r2.afterLoc), resetTryEntry(r2), y;
          }
        },
        "catch": function _catch(t2) {
          for (var e2 = this.tryEntries.length - 1; e2 >= 0; --e2) {
            var r2 = this.tryEntries[e2];
            if (r2.tryLoc === t2) {
              var n2 = r2.completion;
              if ("throw" === n2.type) {
                var o2 = n2.arg;
                resetTryEntry(r2);
              }
              return o2;
            }
          }
          throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e2, r2, n2) {
          return this.delegate = {
            iterator: values(e2),
            resultName: r2,
            nextLoc: n2
          }, "next" === this.method && (this.arg = t), y;
        }
      }, e;
    }
    module2.exports = _regeneratorRuntime3, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../node_modules/@babel/runtime/regenerator/index.js
var require_regenerator = __commonJS({
  "../node_modules/@babel/runtime/regenerator/index.js"(exports, module2) {
    var runtime = require_regeneratorRuntime()();
    module2.exports = runtime;
    try {
      regeneratorRuntime = runtime;
    } catch (accidentalStrictMode) {
      if (typeof globalThis === "object") {
        globalThis.regeneratorRuntime = runtime;
      } else {
        Function("r", "regeneratorRuntime = r")(runtime);
      }
    }
  }
});

// ../node_modules/@xmldom/xmldom/lib/conventions.js
var require_conventions = __commonJS({
  "../node_modules/@xmldom/xmldom/lib/conventions.js"(exports) {
    "use strict";
    function find(list, predicate, ac) {
      if (ac === void 0) {
        ac = Array.prototype;
      }
      if (list && typeof ac.find === "function") {
        return ac.find.call(list, predicate);
      }
      for (var i = 0; i < list.length; i++) {
        if (Object.prototype.hasOwnProperty.call(list, i)) {
          var item = list[i];
          if (predicate.call(void 0, item, i, list)) {
            return item;
          }
        }
      }
    }
    function freeze(object, oc) {
      if (oc === void 0) {
        oc = Object;
      }
      return oc && typeof oc.freeze === "function" ? oc.freeze(object) : object;
    }
    function assign(target, source) {
      if (target === null || typeof target !== "object") {
        throw new TypeError("target is not an object");
      }
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
      return target;
    }
    var MIME_TYPE = freeze({
      /**
       * `text/html`, the only mime type that triggers treating an XML document as HTML.
       *
       * @see DOMParser.SupportedType.isHTML
       * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
       * @see https://en.wikipedia.org/wiki/HTML Wikipedia
       * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
       * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
       */
      HTML: "text/html",
      /**
       * Helper method to check a mime type if it indicates an HTML document
       *
       * @param {string} [value]
       * @returns {boolean}
       *
       * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
       * @see https://en.wikipedia.org/wiki/HTML Wikipedia
       * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
       * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
      isHTML: function(value) {
        return value === MIME_TYPE.HTML;
      },
      /**
       * `application/xml`, the standard mime type for XML documents.
       *
       * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
       * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
       * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
       */
      XML_APPLICATION: "application/xml",
      /**
       * `text/html`, an alias for `application/xml`.
       *
       * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
       * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
       * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
       */
      XML_TEXT: "text/xml",
      /**
       * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
       * but is parsed as an XML document.
       *
       * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
       * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
       * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
       */
      XML_XHTML_APPLICATION: "application/xhtml+xml",
      /**
       * `image/svg+xml`,
       *
       * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
       * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
       * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
       */
      XML_SVG_IMAGE: "image/svg+xml"
    });
    var NAMESPACE = freeze({
      /**
       * The XHTML namespace.
       *
       * @see http://www.w3.org/1999/xhtml
       */
      HTML: "http://www.w3.org/1999/xhtml",
      /**
       * Checks if `uri` equals `NAMESPACE.HTML`.
       *
       * @param {string} [uri]
       *
       * @see NAMESPACE.HTML
       */
      isHTML: function(uri) {
        return uri === NAMESPACE.HTML;
      },
      /**
       * The SVG namespace.
       *
       * @see http://www.w3.org/2000/svg
       */
      SVG: "http://www.w3.org/2000/svg",
      /**
       * The `xml:` namespace.
       *
       * @see http://www.w3.org/XML/1998/namespace
       */
      XML: "http://www.w3.org/XML/1998/namespace",
      /**
       * The `xmlns:` namespace
       *
       * @see https://www.w3.org/2000/xmlns/
       */
      XMLNS: "http://www.w3.org/2000/xmlns/"
    });
    exports.assign = assign;
    exports.find = find;
    exports.freeze = freeze;
    exports.MIME_TYPE = MIME_TYPE;
    exports.NAMESPACE = NAMESPACE;
  }
});

// ../node_modules/@xmldom/xmldom/lib/dom.js
var require_dom = __commonJS({
  "../node_modules/@xmldom/xmldom/lib/dom.js"(exports) {
    var conventions = require_conventions();
    var find = conventions.find;
    var NAMESPACE = conventions.NAMESPACE;
    function notEmptyString(input) {
      return input !== "";
    }
    function splitOnASCIIWhitespace(input) {
      return input ? input.split(/[\t\n\f\r ]+/).filter(notEmptyString) : [];
    }
    function orderedSetReducer(current, element) {
      if (!current.hasOwnProperty(element)) {
        current[element] = true;
      }
      return current;
    }
    function toOrderedSet(input) {
      if (!input) return [];
      var list = splitOnASCIIWhitespace(input);
      return Object.keys(list.reduce(orderedSetReducer, {}));
    }
    function arrayIncludes(list) {
      return function(element) {
        return list && list.indexOf(element) !== -1;
      };
    }
    function copy(src, dest) {
      for (var p in src) {
        if (Object.prototype.hasOwnProperty.call(src, p)) {
          dest[p] = src[p];
        }
      }
    }
    function _extends(Class, Super) {
      var pt = Class.prototype;
      if (!(pt instanceof Super)) {
        let t2 = function() {
        };
        var t = t2;
        ;
        t2.prototype = Super.prototype;
        t2 = new t2();
        copy(pt, t2);
        Class.prototype = pt = t2;
      }
      if (pt.constructor != Class) {
        if (typeof Class != "function") {
          console.error("unknown Class:" + Class);
        }
        pt.constructor = Class;
      }
    }
    var NodeType = {};
    var ELEMENT_NODE = NodeType.ELEMENT_NODE = 1;
    var ATTRIBUTE_NODE = NodeType.ATTRIBUTE_NODE = 2;
    var TEXT_NODE = NodeType.TEXT_NODE = 3;
    var CDATA_SECTION_NODE = NodeType.CDATA_SECTION_NODE = 4;
    var ENTITY_REFERENCE_NODE = NodeType.ENTITY_REFERENCE_NODE = 5;
    var ENTITY_NODE = NodeType.ENTITY_NODE = 6;
    var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
    var COMMENT_NODE = NodeType.COMMENT_NODE = 8;
    var DOCUMENT_NODE = NodeType.DOCUMENT_NODE = 9;
    var DOCUMENT_TYPE_NODE = NodeType.DOCUMENT_TYPE_NODE = 10;
    var DOCUMENT_FRAGMENT_NODE = NodeType.DOCUMENT_FRAGMENT_NODE = 11;
    var NOTATION_NODE = NodeType.NOTATION_NODE = 12;
    var ExceptionCode = {};
    var ExceptionMessage = {};
    var INDEX_SIZE_ERR = ExceptionCode.INDEX_SIZE_ERR = (ExceptionMessage[1] = "Index size error", 1);
    var DOMSTRING_SIZE_ERR = ExceptionCode.DOMSTRING_SIZE_ERR = (ExceptionMessage[2] = "DOMString size error", 2);
    var HIERARCHY_REQUEST_ERR = ExceptionCode.HIERARCHY_REQUEST_ERR = (ExceptionMessage[3] = "Hierarchy request error", 3);
    var WRONG_DOCUMENT_ERR = ExceptionCode.WRONG_DOCUMENT_ERR = (ExceptionMessage[4] = "Wrong document", 4);
    var INVALID_CHARACTER_ERR = ExceptionCode.INVALID_CHARACTER_ERR = (ExceptionMessage[5] = "Invalid character", 5);
    var NO_DATA_ALLOWED_ERR = ExceptionCode.NO_DATA_ALLOWED_ERR = (ExceptionMessage[6] = "No data allowed", 6);
    var NO_MODIFICATION_ALLOWED_ERR = ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = (ExceptionMessage[7] = "No modification allowed", 7);
    var NOT_FOUND_ERR = ExceptionCode.NOT_FOUND_ERR = (ExceptionMessage[8] = "Not found", 8);
    var NOT_SUPPORTED_ERR = ExceptionCode.NOT_SUPPORTED_ERR = (ExceptionMessage[9] = "Not supported", 9);
    var INUSE_ATTRIBUTE_ERR = ExceptionCode.INUSE_ATTRIBUTE_ERR = (ExceptionMessage[10] = "Attribute in use", 10);
    var INVALID_STATE_ERR = ExceptionCode.INVALID_STATE_ERR = (ExceptionMessage[11] = "Invalid state", 11);
    var SYNTAX_ERR = ExceptionCode.SYNTAX_ERR = (ExceptionMessage[12] = "Syntax error", 12);
    var INVALID_MODIFICATION_ERR = ExceptionCode.INVALID_MODIFICATION_ERR = (ExceptionMessage[13] = "Invalid modification", 13);
    var NAMESPACE_ERR = ExceptionCode.NAMESPACE_ERR = (ExceptionMessage[14] = "Invalid namespace", 14);
    var INVALID_ACCESS_ERR = ExceptionCode.INVALID_ACCESS_ERR = (ExceptionMessage[15] = "Invalid access", 15);
    function DOMException(code, message) {
      if (message instanceof Error) {
        var error2 = message;
      } else {
        error2 = this;
        Error.call(this, ExceptionMessage[code]);
        this.message = ExceptionMessage[code];
        if (Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
      }
      error2.code = code;
      if (message) this.message = this.message + ": " + message;
      return error2;
    }
    DOMException.prototype = Error.prototype;
    copy(ExceptionCode, DOMException);
    function NodeList() {
    }
    NodeList.prototype = {
      /**
       * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
       * @standard level1
       */
      length: 0,
      /**
       * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
       * @standard level1
       * @param index  unsigned long
       *   Index into the collection.
       * @return Node
       * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
       */
      item: function(index) {
        return index >= 0 && index < this.length ? this[index] : null;
      },
      toString: function(isHTML, nodeFilter) {
        for (var buf = [], i = 0; i < this.length; i++) {
          serializeToString(this[i], buf, isHTML, nodeFilter);
        }
        return buf.join("");
      },
      /**
       * @private
       * @param {function (Node):boolean} predicate
       * @returns {Node[]}
       */
      filter: function(predicate) {
        return Array.prototype.filter.call(this, predicate);
      },
      /**
       * @private
       * @param {Node} item
       * @returns {number}
       */
      indexOf: function(item) {
        return Array.prototype.indexOf.call(this, item);
      }
    };
    function LiveNodeList(node, refresh) {
      this._node = node;
      this._refresh = refresh;
      _updateLiveList(this);
    }
    function _updateLiveList(list) {
      var inc = list._node._inc || list._node.ownerDocument._inc;
      if (list._inc !== inc) {
        var ls = list._refresh(list._node);
        __set__(list, "length", ls.length);
        if (!list.$$length || ls.length < list.$$length) {
          for (var i = ls.length; i in list; i++) {
            if (Object.prototype.hasOwnProperty.call(list, i)) {
              delete list[i];
            }
          }
        }
        copy(ls, list);
        list._inc = inc;
      }
    }
    LiveNodeList.prototype.item = function(i) {
      _updateLiveList(this);
      return this[i] || null;
    };
    _extends(LiveNodeList, NodeList);
    function NamedNodeMap() {
    }
    function _findNodeIndex(list, node) {
      var i = list.length;
      while (i--) {
        if (list[i] === node) {
          return i;
        }
      }
    }
    function _addNamedNode(el, list, newAttr, oldAttr) {
      if (oldAttr) {
        list[_findNodeIndex(list, oldAttr)] = newAttr;
      } else {
        list[list.length++] = newAttr;
      }
      if (el) {
        newAttr.ownerElement = el;
        var doc = el.ownerDocument;
        if (doc) {
          oldAttr && _onRemoveAttribute(doc, el, oldAttr);
          _onAddAttribute(doc, el, newAttr);
        }
      }
    }
    function _removeNamedNode(el, list, attr) {
      var i = _findNodeIndex(list, attr);
      if (i >= 0) {
        var lastIndex = list.length - 1;
        while (i < lastIndex) {
          list[i] = list[++i];
        }
        list.length = lastIndex;
        if (el) {
          var doc = el.ownerDocument;
          if (doc) {
            _onRemoveAttribute(doc, el, attr);
            attr.ownerElement = null;
          }
        }
      } else {
        throw new DOMException(NOT_FOUND_ERR, new Error(el.tagName + "@" + attr));
      }
    }
    NamedNodeMap.prototype = {
      length: 0,
      item: NodeList.prototype.item,
      getNamedItem: function(key) {
        var i = this.length;
        while (i--) {
          var attr = this[i];
          if (attr.nodeName == key) {
            return attr;
          }
        }
      },
      setNamedItem: function(attr) {
        var el = attr.ownerElement;
        if (el && el != this._ownerElement) {
          throw new DOMException(INUSE_ATTRIBUTE_ERR);
        }
        var oldAttr = this.getNamedItem(attr.nodeName);
        _addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
      },
      /* returns Node */
      setNamedItemNS: function(attr) {
        var el = attr.ownerElement, oldAttr;
        if (el && el != this._ownerElement) {
          throw new DOMException(INUSE_ATTRIBUTE_ERR);
        }
        oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
        _addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
      },
      /* returns Node */
      removeNamedItem: function(key) {
        var attr = this.getNamedItem(key);
        _removeNamedNode(this._ownerElement, this, attr);
        return attr;
      },
      // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
      //for level2
      removeNamedItemNS: function(namespaceURI, localName) {
        var attr = this.getNamedItemNS(namespaceURI, localName);
        _removeNamedNode(this._ownerElement, this, attr);
        return attr;
      },
      getNamedItemNS: function(namespaceURI, localName) {
        var i = this.length;
        while (i--) {
          var node = this[i];
          if (node.localName == localName && node.namespaceURI == namespaceURI) {
            return node;
          }
        }
        return null;
      }
    };
    function DOMImplementation() {
    }
    DOMImplementation.prototype = {
      /**
       * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
       * The different implementations fairly diverged in what kind of features were reported.
       * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
       *
       * @deprecated It is deprecated and modern browsers return true in all cases.
       *
       * @param {string} feature
       * @param {string} [version]
       * @returns {boolean} always true
       *
       * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
       * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
       * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
       */
      hasFeature: function(feature, version) {
        return true;
      },
      /**
       * Creates an XML Document object of the specified type with its document element.
       *
       * __It behaves slightly different from the description in the living standard__:
       * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
       * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
       * - this implementation is not validating names or qualified names
       *   (when parsing XML strings, the SAX parser takes care of that)
       *
       * @param {string|null} namespaceURI
       * @param {string} qualifiedName
       * @param {DocumentType=null} doctype
       * @returns {Document}
       *
       * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
       * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
       * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
       *
       * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
       * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
       * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
       */
      createDocument: function(namespaceURI, qualifiedName, doctype) {
        var doc = new Document();
        doc.implementation = this;
        doc.childNodes = new NodeList();
        doc.doctype = doctype || null;
        if (doctype) {
          doc.appendChild(doctype);
        }
        if (qualifiedName) {
          var root = doc.createElementNS(namespaceURI, qualifiedName);
          doc.appendChild(root);
        }
        return doc;
      },
      /**
       * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
       *
       * __This behavior is slightly different from the in the specs__:
       * - this implementation is not validating names or qualified names
       *   (when parsing XML strings, the SAX parser takes care of that)
       *
       * @param {string} qualifiedName
       * @param {string} [publicId]
       * @param {string} [systemId]
       * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
       * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
       *
       * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
       * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
       * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
       *
       * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
       * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
       * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
       */
      createDocumentType: function(qualifiedName, publicId, systemId) {
        var node = new DocumentType();
        node.name = qualifiedName;
        node.nodeName = qualifiedName;
        node.publicId = publicId || "";
        node.systemId = systemId || "";
        return node;
      }
    };
    function Node3() {
    }
    Node3.prototype = {
      firstChild: null,
      lastChild: null,
      previousSibling: null,
      nextSibling: null,
      attributes: null,
      parentNode: null,
      childNodes: null,
      ownerDocument: null,
      nodeValue: null,
      namespaceURI: null,
      prefix: null,
      localName: null,
      // Modified in DOM Level 2:
      insertBefore: function(newChild, refChild) {
        return _insertBefore(this, newChild, refChild);
      },
      replaceChild: function(newChild, oldChild) {
        _insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
        if (oldChild) {
          this.removeChild(oldChild);
        }
      },
      removeChild: function(oldChild) {
        return _removeChild(this, oldChild);
      },
      appendChild: function(newChild) {
        return this.insertBefore(newChild, null);
      },
      hasChildNodes: function() {
        return this.firstChild != null;
      },
      cloneNode: function(deep) {
        return cloneNode(this.ownerDocument || this, this, deep);
      },
      // Modified in DOM Level 2:
      normalize: function() {
        var child = this.firstChild;
        while (child) {
          var next = child.nextSibling;
          if (next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE) {
            this.removeChild(next);
            child.appendData(next.data);
          } else {
            child.normalize();
            child = next;
          }
        }
      },
      // Introduced in DOM Level 2:
      isSupported: function(feature, version) {
        return this.ownerDocument.implementation.hasFeature(feature, version);
      },
      // Introduced in DOM Level 2:
      hasAttributes: function() {
        return this.attributes.length > 0;
      },
      /**
       * Look up the prefix associated to the given namespace URI, starting from this node.
       * **The default namespace declarations are ignored by this method.**
       * See Namespace Prefix Lookup for details on the algorithm used by this method.
       *
       * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
       *
       * @param {string | null} namespaceURI
       * @returns {string | null}
       * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
       * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
       * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
       * @see https://github.com/xmldom/xmldom/issues/322
       */
      lookupPrefix: function(namespaceURI) {
        var el = this;
        while (el) {
          var map = el._nsMap;
          if (map) {
            for (var n in map) {
              if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) {
                return n;
              }
            }
          }
          el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
      },
      // Introduced in DOM Level 3:
      lookupNamespaceURI: function(prefix) {
        var el = this;
        while (el) {
          var map = el._nsMap;
          if (map) {
            if (Object.prototype.hasOwnProperty.call(map, prefix)) {
              return map[prefix];
            }
          }
          el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
      },
      // Introduced in DOM Level 3:
      isDefaultNamespace: function(namespaceURI) {
        var prefix = this.lookupPrefix(namespaceURI);
        return prefix == null;
      }
    };
    function _xmlEncoder(c) {
      return c == "<" && "&lt;" || c == ">" && "&gt;" || c == "&" && "&amp;" || c == '"' && "&quot;" || "&#" + c.charCodeAt() + ";";
    }
    copy(NodeType, Node3);
    copy(NodeType, Node3.prototype);
    function _visitNode(node, callback) {
      if (callback(node)) {
        return true;
      }
      if (node = node.firstChild) {
        do {
          if (_visitNode(node, callback)) {
            return true;
          }
        } while (node = node.nextSibling);
      }
    }
    function Document() {
      this.ownerDocument = this;
    }
    function _onAddAttribute(doc, el, newAttr) {
      doc && doc._inc++;
      var ns3 = newAttr.namespaceURI;
      if (ns3 === NAMESPACE.XMLNS) {
        el._nsMap[newAttr.prefix ? newAttr.localName : ""] = newAttr.value;
      }
    }
    function _onRemoveAttribute(doc, el, newAttr, remove) {
      doc && doc._inc++;
      var ns3 = newAttr.namespaceURI;
      if (ns3 === NAMESPACE.XMLNS) {
        delete el._nsMap[newAttr.prefix ? newAttr.localName : ""];
      }
    }
    function _onUpdateChild(doc, el, newChild) {
      if (doc && doc._inc) {
        doc._inc++;
        var cs = el.childNodes;
        if (newChild) {
          cs[cs.length++] = newChild;
        } else {
          var child = el.firstChild;
          var i = 0;
          while (child) {
            cs[i++] = child;
            child = child.nextSibling;
          }
          cs.length = i;
          delete cs[cs.length];
        }
      }
    }
    function _removeChild(parentNode, child) {
      var previous = child.previousSibling;
      var next = child.nextSibling;
      if (previous) {
        previous.nextSibling = next;
      } else {
        parentNode.firstChild = next;
      }
      if (next) {
        next.previousSibling = previous;
      } else {
        parentNode.lastChild = previous;
      }
      child.parentNode = null;
      child.previousSibling = null;
      child.nextSibling = null;
      _onUpdateChild(parentNode.ownerDocument, parentNode);
      return child;
    }
    function hasValidParentNodeType(node) {
      return node && (node.nodeType === Node3.DOCUMENT_NODE || node.nodeType === Node3.DOCUMENT_FRAGMENT_NODE || node.nodeType === Node3.ELEMENT_NODE);
    }
    function hasInsertableNodeType(node) {
      return node && (isElementNode(node) || isTextNode(node) || isDocTypeNode(node) || node.nodeType === Node3.DOCUMENT_FRAGMENT_NODE || node.nodeType === Node3.COMMENT_NODE || node.nodeType === Node3.PROCESSING_INSTRUCTION_NODE);
    }
    function isDocTypeNode(node) {
      return node && node.nodeType === Node3.DOCUMENT_TYPE_NODE;
    }
    function isElementNode(node) {
      return node && node.nodeType === Node3.ELEMENT_NODE;
    }
    function isTextNode(node) {
      return node && node.nodeType === Node3.TEXT_NODE;
    }
    function isElementInsertionPossible(doc, child) {
      var parentChildNodes = doc.childNodes || [];
      if (find(parentChildNodes, isElementNode) || isDocTypeNode(child)) {
        return false;
      }
      var docTypeNode = find(parentChildNodes, isDocTypeNode);
      return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
    }
    function isElementReplacementPossible(doc, child) {
      var parentChildNodes = doc.childNodes || [];
      function hasElementChildThatIsNotChild(node) {
        return isElementNode(node) && node !== child;
      }
      if (find(parentChildNodes, hasElementChildThatIsNotChild)) {
        return false;
      }
      var docTypeNode = find(parentChildNodes, isDocTypeNode);
      return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
    }
    function assertPreInsertionValidity1to5(parent, node, child) {
      if (!hasValidParentNodeType(parent)) {
        throw new DOMException(HIERARCHY_REQUEST_ERR, "Unexpected parent node type " + parent.nodeType);
      }
      if (child && child.parentNode !== parent) {
        throw new DOMException(NOT_FOUND_ERR, "child not in parent");
      }
      if (
        // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
        !hasInsertableNodeType(node) || // 5. If either `node` is a Text node and `parent` is a document,
        // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
        // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
        // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
        isDocTypeNode(node) && parent.nodeType !== Node3.DOCUMENT_NODE
      ) {
        throw new DOMException(
          HIERARCHY_REQUEST_ERR,
          "Unexpected node type " + node.nodeType + " for parent node type " + parent.nodeType
        );
      }
    }
    function assertPreInsertionValidityInDocument(parent, node, child) {
      var parentChildNodes = parent.childNodes || [];
      var nodeChildNodes = node.childNodes || [];
      if (node.nodeType === Node3.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter(isElementNode);
        if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
          throw new DOMException(HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
        }
        if (nodeChildElements.length === 1 && !isElementInsertionPossible(parent, child)) {
          throw new DOMException(HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
        }
      }
      if (isElementNode(node)) {
        if (!isElementInsertionPossible(parent, child)) {
          throw new DOMException(HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
        }
      }
      if (isDocTypeNode(node)) {
        if (find(parentChildNodes, isDocTypeNode)) {
          throw new DOMException(HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
        }
        var parentElementChild = find(parentChildNodes, isElementNode);
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
          throw new DOMException(HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
        }
        if (!child && parentElementChild) {
          throw new DOMException(HIERARCHY_REQUEST_ERR, "Doctype can not be appended since element is present");
        }
      }
    }
    function assertPreReplacementValidityInDocument(parent, node, child) {
      var parentChildNodes = parent.childNodes || [];
      var nodeChildNodes = node.childNodes || [];
      if (node.nodeType === Node3.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter(isElementNode);
        if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
          throw new DOMException(HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
        }
        if (nodeChildElements.length === 1 && !isElementReplacementPossible(parent, child)) {
          throw new DOMException(HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
        }
      }
      if (isElementNode(node)) {
        if (!isElementReplacementPossible(parent, child)) {
          throw new DOMException(HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
        }
      }
      if (isDocTypeNode(node)) {
        let hasDoctypeChildThatIsNotChild2 = function(node2) {
          return isDocTypeNode(node2) && node2 !== child;
        };
        var hasDoctypeChildThatIsNotChild = hasDoctypeChildThatIsNotChild2;
        if (find(parentChildNodes, hasDoctypeChildThatIsNotChild2)) {
          throw new DOMException(HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
        }
        var parentElementChild = find(parentChildNodes, isElementNode);
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
          throw new DOMException(HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
        }
      }
    }
    function _insertBefore(parent, node, child, _inDocumentAssertion) {
      assertPreInsertionValidity1to5(parent, node, child);
      if (parent.nodeType === Node3.DOCUMENT_NODE) {
        (_inDocumentAssertion || assertPreInsertionValidityInDocument)(parent, node, child);
      }
      var cp = node.parentNode;
      if (cp) {
        cp.removeChild(node);
      }
      if (node.nodeType === DOCUMENT_FRAGMENT_NODE) {
        var newFirst = node.firstChild;
        if (newFirst == null) {
          return node;
        }
        var newLast = node.lastChild;
      } else {
        newFirst = newLast = node;
      }
      var pre = child ? child.previousSibling : parent.lastChild;
      newFirst.previousSibling = pre;
      newLast.nextSibling = child;
      if (pre) {
        pre.nextSibling = newFirst;
      } else {
        parent.firstChild = newFirst;
      }
      if (child == null) {
        parent.lastChild = newLast;
      } else {
        child.previousSibling = newLast;
      }
      do {
        newFirst.parentNode = parent;
      } while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
      _onUpdateChild(parent.ownerDocument || parent, parent);
      if (node.nodeType == DOCUMENT_FRAGMENT_NODE) {
        node.firstChild = node.lastChild = null;
      }
      return node;
    }
    function _appendSingleChild(parentNode, newChild) {
      if (newChild.parentNode) {
        newChild.parentNode.removeChild(newChild);
      }
      newChild.parentNode = parentNode;
      newChild.previousSibling = parentNode.lastChild;
      newChild.nextSibling = null;
      if (newChild.previousSibling) {
        newChild.previousSibling.nextSibling = newChild;
      } else {
        parentNode.firstChild = newChild;
      }
      parentNode.lastChild = newChild;
      _onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
      return newChild;
    }
    Document.prototype = {
      //implementation : null,
      nodeName: "#document",
      nodeType: DOCUMENT_NODE,
      /**
       * The DocumentType node of the document.
       *
       * @readonly
       * @type DocumentType
       */
      doctype: null,
      documentElement: null,
      _inc: 1,
      insertBefore: function(newChild, refChild) {
        if (newChild.nodeType == DOCUMENT_FRAGMENT_NODE) {
          var child = newChild.firstChild;
          while (child) {
            var next = child.nextSibling;
            this.insertBefore(child, refChild);
            child = next;
          }
          return newChild;
        }
        _insertBefore(this, newChild, refChild);
        newChild.ownerDocument = this;
        if (this.documentElement === null && newChild.nodeType === ELEMENT_NODE) {
          this.documentElement = newChild;
        }
        return newChild;
      },
      removeChild: function(oldChild) {
        if (this.documentElement == oldChild) {
          this.documentElement = null;
        }
        return _removeChild(this, oldChild);
      },
      replaceChild: function(newChild, oldChild) {
        _insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
        newChild.ownerDocument = this;
        if (oldChild) {
          this.removeChild(oldChild);
        }
        if (isElementNode(newChild)) {
          this.documentElement = newChild;
        }
      },
      // Introduced in DOM Level 2:
      importNode: function(importedNode, deep) {
        return importNode(this, importedNode, deep);
      },
      // Introduced in DOM Level 2:
      getElementById: function(id3) {
        var rtv = null;
        _visitNode(this.documentElement, function(node) {
          if (node.nodeType == ELEMENT_NODE) {
            if (node.getAttribute("id") == id3) {
              rtv = node;
              return true;
            }
          }
        });
        return rtv;
      },
      /**
       * The `getElementsByClassName` method of `Document` interface returns an array-like object
       * of all child elements which have **all** of the given class name(s).
       *
       * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
       *
       *
       * Warning: This is a live LiveNodeList.
       * Changes in the DOM will reflect in the array as the changes occur.
       * If an element selected by this array no longer qualifies for the selector,
       * it will automatically be removed. Be aware of this for iteration purposes.
       *
       * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
       *
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
       * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
       */
      getElementsByClassName: function(classNames) {
        var classNamesSet = toOrderedSet(classNames);
        return new LiveNodeList(this, function(base) {
          var ls = [];
          if (classNamesSet.length > 0) {
            _visitNode(base.documentElement, function(node) {
              if (node !== base && node.nodeType === ELEMENT_NODE) {
                var nodeClassNames = node.getAttribute("class");
                if (nodeClassNames) {
                  var matches = classNames === nodeClassNames;
                  if (!matches) {
                    var nodeClassNamesSet = toOrderedSet(nodeClassNames);
                    matches = classNamesSet.every(arrayIncludes(nodeClassNamesSet));
                  }
                  if (matches) {
                    ls.push(node);
                  }
                }
              }
            });
          }
          return ls;
        });
      },
      //document factory method:
      createElement: function(tagName) {
        var node = new Element();
        node.ownerDocument = this;
        node.nodeName = tagName;
        node.tagName = tagName;
        node.localName = tagName;
        node.childNodes = new NodeList();
        var attrs = node.attributes = new NamedNodeMap();
        attrs._ownerElement = node;
        return node;
      },
      createDocumentFragment: function() {
        var node = new DocumentFragment();
        node.ownerDocument = this;
        node.childNodes = new NodeList();
        return node;
      },
      createTextNode: function(data) {
        var node = new Text();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
      },
      createComment: function(data) {
        var node = new Comment();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
      },
      createCDATASection: function(data) {
        var node = new CDATASection();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
      },
      createProcessingInstruction: function(target, data) {
        var node = new ProcessingInstruction();
        node.ownerDocument = this;
        node.tagName = node.nodeName = node.target = target;
        node.nodeValue = node.data = data;
        return node;
      },
      createAttribute: function(name) {
        var node = new Attr();
        node.ownerDocument = this;
        node.name = name;
        node.nodeName = name;
        node.localName = name;
        node.specified = true;
        return node;
      },
      createEntityReference: function(name) {
        var node = new EntityReference();
        node.ownerDocument = this;
        node.nodeName = name;
        return node;
      },
      // Introduced in DOM Level 2:
      createElementNS: function(namespaceURI, qualifiedName) {
        var node = new Element();
        var pl = qualifiedName.split(":");
        var attrs = node.attributes = new NamedNodeMap();
        node.childNodes = new NodeList();
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.tagName = qualifiedName;
        node.namespaceURI = namespaceURI;
        if (pl.length == 2) {
          node.prefix = pl[0];
          node.localName = pl[1];
        } else {
          node.localName = qualifiedName;
        }
        attrs._ownerElement = node;
        return node;
      },
      // Introduced in DOM Level 2:
      createAttributeNS: function(namespaceURI, qualifiedName) {
        var node = new Attr();
        var pl = qualifiedName.split(":");
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.name = qualifiedName;
        node.namespaceURI = namespaceURI;
        node.specified = true;
        if (pl.length == 2) {
          node.prefix = pl[0];
          node.localName = pl[1];
        } else {
          node.localName = qualifiedName;
        }
        return node;
      }
    };
    _extends(Document, Node3);
    function Element() {
      this._nsMap = {};
    }
    Element.prototype = {
      nodeType: ELEMENT_NODE,
      hasAttribute: function(name) {
        return this.getAttributeNode(name) != null;
      },
      getAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        return attr && attr.value || "";
      },
      getAttributeNode: function(name) {
        return this.attributes.getNamedItem(name);
      },
      setAttribute: function(name, value) {
        var attr = this.ownerDocument.createAttribute(name);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
      },
      removeAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        attr && this.removeAttributeNode(attr);
      },
      //four real opeartion method
      appendChild: function(newChild) {
        if (newChild.nodeType === DOCUMENT_FRAGMENT_NODE) {
          return this.insertBefore(newChild, null);
        } else {
          return _appendSingleChild(this, newChild);
        }
      },
      setAttributeNode: function(newAttr) {
        return this.attributes.setNamedItem(newAttr);
      },
      setAttributeNodeNS: function(newAttr) {
        return this.attributes.setNamedItemNS(newAttr);
      },
      removeAttributeNode: function(oldAttr) {
        return this.attributes.removeNamedItem(oldAttr.nodeName);
      },
      //get real attribute name,and remove it by removeAttributeNode
      removeAttributeNS: function(namespaceURI, localName) {
        var old = this.getAttributeNodeNS(namespaceURI, localName);
        old && this.removeAttributeNode(old);
      },
      hasAttributeNS: function(namespaceURI, localName) {
        return this.getAttributeNodeNS(namespaceURI, localName) != null;
      },
      getAttributeNS: function(namespaceURI, localName) {
        var attr = this.getAttributeNodeNS(namespaceURI, localName);
        return attr && attr.value || "";
      },
      setAttributeNS: function(namespaceURI, qualifiedName, value) {
        var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
      },
      getAttributeNodeNS: function(namespaceURI, localName) {
        return this.attributes.getNamedItemNS(namespaceURI, localName);
      },
      getElementsByTagName: function(tagName) {
        return new LiveNodeList(this, function(base) {
          var ls = [];
          _visitNode(base, function(node) {
            if (node !== base && node.nodeType == ELEMENT_NODE && (tagName === "*" || node.tagName == tagName)) {
              ls.push(node);
            }
          });
          return ls;
        });
      },
      getElementsByTagNameNS: function(namespaceURI, localName) {
        return new LiveNodeList(this, function(base) {
          var ls = [];
          _visitNode(base, function(node) {
            if (node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === "*" || node.namespaceURI === namespaceURI) && (localName === "*" || node.localName == localName)) {
              ls.push(node);
            }
          });
          return ls;
        });
      }
    };
    Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
    Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;
    _extends(Element, Node3);
    function Attr() {
    }
    Attr.prototype.nodeType = ATTRIBUTE_NODE;
    _extends(Attr, Node3);
    function CharacterData() {
    }
    CharacterData.prototype = {
      data: "",
      substringData: function(offset, count) {
        return this.data.substring(offset, offset + count);
      },
      appendData: function(text) {
        text = this.data + text;
        this.nodeValue = this.data = text;
        this.length = text.length;
      },
      insertData: function(offset, text) {
        this.replaceData(offset, 0, text);
      },
      appendChild: function(newChild) {
        throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR]);
      },
      deleteData: function(offset, count) {
        this.replaceData(offset, count, "");
      },
      replaceData: function(offset, count, text) {
        var start = this.data.substring(0, offset);
        var end = this.data.substring(offset + count);
        text = start + text + end;
        this.nodeValue = this.data = text;
        this.length = text.length;
      }
    };
    _extends(CharacterData, Node3);
    function Text() {
    }
    Text.prototype = {
      nodeName: "#text",
      nodeType: TEXT_NODE,
      splitText: function(offset) {
        var text = this.data;
        var newText = text.substring(offset);
        text = text.substring(0, offset);
        this.data = this.nodeValue = text;
        this.length = text.length;
        var newNode = this.ownerDocument.createTextNode(newText);
        if (this.parentNode) {
          this.parentNode.insertBefore(newNode, this.nextSibling);
        }
        return newNode;
      }
    };
    _extends(Text, CharacterData);
    function Comment() {
    }
    Comment.prototype = {
      nodeName: "#comment",
      nodeType: COMMENT_NODE
    };
    _extends(Comment, CharacterData);
    function CDATASection() {
    }
    CDATASection.prototype = {
      nodeName: "#cdata-section",
      nodeType: CDATA_SECTION_NODE
    };
    _extends(CDATASection, CharacterData);
    function DocumentType() {
    }
    DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
    _extends(DocumentType, Node3);
    function Notation() {
    }
    Notation.prototype.nodeType = NOTATION_NODE;
    _extends(Notation, Node3);
    function Entity() {
    }
    Entity.prototype.nodeType = ENTITY_NODE;
    _extends(Entity, Node3);
    function EntityReference() {
    }
    EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
    _extends(EntityReference, Node3);
    function DocumentFragment() {
    }
    DocumentFragment.prototype.nodeName = "#document-fragment";
    DocumentFragment.prototype.nodeType = DOCUMENT_FRAGMENT_NODE;
    _extends(DocumentFragment, Node3);
    function ProcessingInstruction() {
    }
    ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
    _extends(ProcessingInstruction, Node3);
    function XMLSerializer() {
    }
    XMLSerializer.prototype.serializeToString = function(node, isHtml, nodeFilter) {
      return nodeSerializeToString.call(node, isHtml, nodeFilter);
    };
    Node3.prototype.toString = nodeSerializeToString;
    function nodeSerializeToString(isHtml, nodeFilter) {
      var buf = [];
      var refNode = this.nodeType == 9 && this.documentElement || this;
      var prefix = refNode.prefix;
      var uri = refNode.namespaceURI;
      if (uri && prefix == null) {
        var prefix = refNode.lookupPrefix(uri);
        if (prefix == null) {
          var visibleNamespaces = [
            { namespace: uri, prefix: null }
            //{namespace:uri,prefix:''}
          ];
        }
      }
      serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces);
      return buf.join("");
    }
    function needNamespaceDefine(node, isHTML, visibleNamespaces) {
      var prefix = node.prefix || "";
      var uri = node.namespaceURI;
      if (!uri) {
        return false;
      }
      if (prefix === "xml" && uri === NAMESPACE.XML || uri === NAMESPACE.XMLNS) {
        return false;
      }
      var i = visibleNamespaces.length;
      while (i--) {
        var ns3 = visibleNamespaces[i];
        if (ns3.prefix === prefix) {
          return ns3.namespace !== uri;
        }
      }
      return true;
    }
    function addSerializedAttribute(buf, qualifiedName, value) {
      buf.push(" ", qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, _xmlEncoder), '"');
    }
    function serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces) {
      if (!visibleNamespaces) {
        visibleNamespaces = [];
      }
      if (nodeFilter) {
        node = nodeFilter(node);
        if (node) {
          if (typeof node == "string") {
            buf.push(node);
            return;
          }
        } else {
          return;
        }
      }
      switch (node.nodeType) {
        case ELEMENT_NODE:
          var attrs = node.attributes;
          var len = attrs.length;
          var child = node.firstChild;
          var nodeName = node.tagName;
          isHTML = NAMESPACE.isHTML(node.namespaceURI) || isHTML;
          var prefixedNodeName = nodeName;
          if (!isHTML && !node.prefix && node.namespaceURI) {
            var defaultNS;
            for (var ai = 0; ai < attrs.length; ai++) {
              if (attrs.item(ai).name === "xmlns") {
                defaultNS = attrs.item(ai).value;
                break;
              }
            }
            if (!defaultNS) {
              for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
                var namespace = visibleNamespaces[nsi];
                if (namespace.prefix === "" && namespace.namespace === node.namespaceURI) {
                  defaultNS = namespace.namespace;
                  break;
                }
              }
            }
            if (defaultNS !== node.namespaceURI) {
              for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
                var namespace = visibleNamespaces[nsi];
                if (namespace.namespace === node.namespaceURI) {
                  if (namespace.prefix) {
                    prefixedNodeName = namespace.prefix + ":" + nodeName;
                  }
                  break;
                }
              }
            }
          }
          buf.push("<", prefixedNodeName);
          for (var i = 0; i < len; i++) {
            var attr = attrs.item(i);
            if (attr.prefix == "xmlns") {
              visibleNamespaces.push({ prefix: attr.localName, namespace: attr.value });
            } else if (attr.nodeName == "xmlns") {
              visibleNamespaces.push({ prefix: "", namespace: attr.value });
            }
          }
          for (var i = 0; i < len; i++) {
            var attr = attrs.item(i);
            if (needNamespaceDefine(attr, isHTML, visibleNamespaces)) {
              var prefix = attr.prefix || "";
              var uri = attr.namespaceURI;
              addSerializedAttribute(buf, prefix ? "xmlns:" + prefix : "xmlns", uri);
              visibleNamespaces.push({ prefix, namespace: uri });
            }
            serializeToString(attr, buf, isHTML, nodeFilter, visibleNamespaces);
          }
          if (nodeName === prefixedNodeName && needNamespaceDefine(node, isHTML, visibleNamespaces)) {
            var prefix = node.prefix || "";
            var uri = node.namespaceURI;
            addSerializedAttribute(buf, prefix ? "xmlns:" + prefix : "xmlns", uri);
            visibleNamespaces.push({ prefix, namespace: uri });
          }
          if (child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
            buf.push(">");
            if (isHTML && /^script$/i.test(nodeName)) {
              while (child) {
                if (child.data) {
                  buf.push(child.data);
                } else {
                  serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                }
                child = child.nextSibling;
              }
            } else {
              while (child) {
                serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                child = child.nextSibling;
              }
            }
            buf.push("</", prefixedNodeName, ">");
          } else {
            buf.push("/>");
          }
          return;
        case DOCUMENT_NODE:
        case DOCUMENT_FRAGMENT_NODE:
          var child = node.firstChild;
          while (child) {
            serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
            child = child.nextSibling;
          }
          return;
        case ATTRIBUTE_NODE:
          return addSerializedAttribute(buf, node.name, node.value);
        case TEXT_NODE:
          return buf.push(
            node.data.replace(/[<&>]/g, _xmlEncoder)
          );
        case CDATA_SECTION_NODE:
          return buf.push("<![CDATA[", node.data, "]]>");
        case COMMENT_NODE:
          return buf.push("<!--", node.data, "-->");
        case DOCUMENT_TYPE_NODE:
          var pubid = node.publicId;
          var sysid = node.systemId;
          buf.push("<!DOCTYPE ", node.name);
          if (pubid) {
            buf.push(" PUBLIC ", pubid);
            if (sysid && sysid != ".") {
              buf.push(" ", sysid);
            }
            buf.push(">");
          } else if (sysid && sysid != ".") {
            buf.push(" SYSTEM ", sysid, ">");
          } else {
            var sub = node.internalSubset;
            if (sub) {
              buf.push(" [", sub, "]");
            }
            buf.push(">");
          }
          return;
        case PROCESSING_INSTRUCTION_NODE:
          return buf.push("<?", node.target, " ", node.data, "?>");
        case ENTITY_REFERENCE_NODE:
          return buf.push("&", node.nodeName, ";");
        //case ENTITY_NODE:
        //case NOTATION_NODE:
        default:
          buf.push("??", node.nodeName);
      }
    }
    function importNode(doc, node, deep) {
      var node2;
      switch (node.nodeType) {
        case ELEMENT_NODE:
          node2 = node.cloneNode(false);
          node2.ownerDocument = doc;
        //var attrs = node2.attributes;
        //var len = attrs.length;
        //for(var i=0;i<len;i++){
        //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
        //}
        case DOCUMENT_FRAGMENT_NODE:
          break;
        case ATTRIBUTE_NODE:
          deep = true;
          break;
      }
      if (!node2) {
        node2 = node.cloneNode(false);
      }
      node2.ownerDocument = doc;
      node2.parentNode = null;
      if (deep) {
        var child = node.firstChild;
        while (child) {
          node2.appendChild(importNode(doc, child, deep));
          child = child.nextSibling;
        }
      }
      return node2;
    }
    function cloneNode(doc, node, deep) {
      var node2 = new node.constructor();
      for (var n in node) {
        if (Object.prototype.hasOwnProperty.call(node, n)) {
          var v = node[n];
          if (typeof v != "object") {
            if (v != node2[n]) {
              node2[n] = v;
            }
          }
        }
      }
      if (node.childNodes) {
        node2.childNodes = new NodeList();
      }
      node2.ownerDocument = doc;
      switch (node2.nodeType) {
        case ELEMENT_NODE:
          var attrs = node.attributes;
          var attrs2 = node2.attributes = new NamedNodeMap();
          var len = attrs.length;
          attrs2._ownerElement = node2;
          for (var i = 0; i < len; i++) {
            node2.setAttributeNode(cloneNode(doc, attrs.item(i), true));
          }
          break;
          ;
        case ATTRIBUTE_NODE:
          deep = true;
      }
      if (deep) {
        var child = node.firstChild;
        while (child) {
          node2.appendChild(cloneNode(doc, child, deep));
          child = child.nextSibling;
        }
      }
      return node2;
    }
    function __set__(object, key, value) {
      object[key] = value;
    }
    try {
      if (Object.defineProperty) {
        let getTextContent2 = function(node) {
          switch (node.nodeType) {
            case ELEMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
              var buf = [];
              node = node.firstChild;
              while (node) {
                if (node.nodeType !== 7 && node.nodeType !== 8) {
                  buf.push(getTextContent2(node));
                }
                node = node.nextSibling;
              }
              return buf.join("");
            default:
              return node.nodeValue;
          }
        };
        getTextContent = getTextContent2;
        Object.defineProperty(LiveNodeList.prototype, "length", {
          get: function() {
            _updateLiveList(this);
            return this.$$length;
          }
        });
        Object.defineProperty(Node3.prototype, "textContent", {
          get: function() {
            return getTextContent2(this);
          },
          set: function(data) {
            switch (this.nodeType) {
              case ELEMENT_NODE:
              case DOCUMENT_FRAGMENT_NODE:
                while (this.firstChild) {
                  this.removeChild(this.firstChild);
                }
                if (data || String(data)) {
                  this.appendChild(this.ownerDocument.createTextNode(data));
                }
                break;
              default:
                this.data = data;
                this.value = data;
                this.nodeValue = data;
            }
          }
        });
        __set__ = function(object, key, value) {
          object["$$" + key] = value;
        };
      }
    } catch (e) {
    }
    var getTextContent;
    exports.DocumentType = DocumentType;
    exports.DOMException = DOMException;
    exports.DOMImplementation = DOMImplementation;
    exports.Element = Element;
    exports.Node = Node3;
    exports.NodeList = NodeList;
    exports.XMLSerializer = XMLSerializer;
  }
});

// ../node_modules/@xmldom/xmldom/lib/entities.js
var require_entities = __commonJS({
  "../node_modules/@xmldom/xmldom/lib/entities.js"(exports) {
    "use strict";
    var freeze = require_conventions().freeze;
    exports.XML_ENTITIES = freeze({
      amp: "&",
      apos: "'",
      gt: ">",
      lt: "<",
      quot: '"'
    });
    exports.HTML_ENTITIES = freeze({
      Aacute: "\xC1",
      aacute: "\xE1",
      Abreve: "\u0102",
      abreve: "\u0103",
      ac: "\u223E",
      acd: "\u223F",
      acE: "\u223E\u0333",
      Acirc: "\xC2",
      acirc: "\xE2",
      acute: "\xB4",
      Acy: "\u0410",
      acy: "\u0430",
      AElig: "\xC6",
      aelig: "\xE6",
      af: "\u2061",
      Afr: "\u{1D504}",
      afr: "\u{1D51E}",
      Agrave: "\xC0",
      agrave: "\xE0",
      alefsym: "\u2135",
      aleph: "\u2135",
      Alpha: "\u0391",
      alpha: "\u03B1",
      Amacr: "\u0100",
      amacr: "\u0101",
      amalg: "\u2A3F",
      AMP: "&",
      amp: "&",
      And: "\u2A53",
      and: "\u2227",
      andand: "\u2A55",
      andd: "\u2A5C",
      andslope: "\u2A58",
      andv: "\u2A5A",
      ang: "\u2220",
      ange: "\u29A4",
      angle: "\u2220",
      angmsd: "\u2221",
      angmsdaa: "\u29A8",
      angmsdab: "\u29A9",
      angmsdac: "\u29AA",
      angmsdad: "\u29AB",
      angmsdae: "\u29AC",
      angmsdaf: "\u29AD",
      angmsdag: "\u29AE",
      angmsdah: "\u29AF",
      angrt: "\u221F",
      angrtvb: "\u22BE",
      angrtvbd: "\u299D",
      angsph: "\u2222",
      angst: "\xC5",
      angzarr: "\u237C",
      Aogon: "\u0104",
      aogon: "\u0105",
      Aopf: "\u{1D538}",
      aopf: "\u{1D552}",
      ap: "\u2248",
      apacir: "\u2A6F",
      apE: "\u2A70",
      ape: "\u224A",
      apid: "\u224B",
      apos: "'",
      ApplyFunction: "\u2061",
      approx: "\u2248",
      approxeq: "\u224A",
      Aring: "\xC5",
      aring: "\xE5",
      Ascr: "\u{1D49C}",
      ascr: "\u{1D4B6}",
      Assign: "\u2254",
      ast: "*",
      asymp: "\u2248",
      asympeq: "\u224D",
      Atilde: "\xC3",
      atilde: "\xE3",
      Auml: "\xC4",
      auml: "\xE4",
      awconint: "\u2233",
      awint: "\u2A11",
      backcong: "\u224C",
      backepsilon: "\u03F6",
      backprime: "\u2035",
      backsim: "\u223D",
      backsimeq: "\u22CD",
      Backslash: "\u2216",
      Barv: "\u2AE7",
      barvee: "\u22BD",
      Barwed: "\u2306",
      barwed: "\u2305",
      barwedge: "\u2305",
      bbrk: "\u23B5",
      bbrktbrk: "\u23B6",
      bcong: "\u224C",
      Bcy: "\u0411",
      bcy: "\u0431",
      bdquo: "\u201E",
      becaus: "\u2235",
      Because: "\u2235",
      because: "\u2235",
      bemptyv: "\u29B0",
      bepsi: "\u03F6",
      bernou: "\u212C",
      Bernoullis: "\u212C",
      Beta: "\u0392",
      beta: "\u03B2",
      beth: "\u2136",
      between: "\u226C",
      Bfr: "\u{1D505}",
      bfr: "\u{1D51F}",
      bigcap: "\u22C2",
      bigcirc: "\u25EF",
      bigcup: "\u22C3",
      bigodot: "\u2A00",
      bigoplus: "\u2A01",
      bigotimes: "\u2A02",
      bigsqcup: "\u2A06",
      bigstar: "\u2605",
      bigtriangledown: "\u25BD",
      bigtriangleup: "\u25B3",
      biguplus: "\u2A04",
      bigvee: "\u22C1",
      bigwedge: "\u22C0",
      bkarow: "\u290D",
      blacklozenge: "\u29EB",
      blacksquare: "\u25AA",
      blacktriangle: "\u25B4",
      blacktriangledown: "\u25BE",
      blacktriangleleft: "\u25C2",
      blacktriangleright: "\u25B8",
      blank: "\u2423",
      blk12: "\u2592",
      blk14: "\u2591",
      blk34: "\u2593",
      block: "\u2588",
      bne: "=\u20E5",
      bnequiv: "\u2261\u20E5",
      bNot: "\u2AED",
      bnot: "\u2310",
      Bopf: "\u{1D539}",
      bopf: "\u{1D553}",
      bot: "\u22A5",
      bottom: "\u22A5",
      bowtie: "\u22C8",
      boxbox: "\u29C9",
      boxDL: "\u2557",
      boxDl: "\u2556",
      boxdL: "\u2555",
      boxdl: "\u2510",
      boxDR: "\u2554",
      boxDr: "\u2553",
      boxdR: "\u2552",
      boxdr: "\u250C",
      boxH: "\u2550",
      boxh: "\u2500",
      boxHD: "\u2566",
      boxHd: "\u2564",
      boxhD: "\u2565",
      boxhd: "\u252C",
      boxHU: "\u2569",
      boxHu: "\u2567",
      boxhU: "\u2568",
      boxhu: "\u2534",
      boxminus: "\u229F",
      boxplus: "\u229E",
      boxtimes: "\u22A0",
      boxUL: "\u255D",
      boxUl: "\u255C",
      boxuL: "\u255B",
      boxul: "\u2518",
      boxUR: "\u255A",
      boxUr: "\u2559",
      boxuR: "\u2558",
      boxur: "\u2514",
      boxV: "\u2551",
      boxv: "\u2502",
      boxVH: "\u256C",
      boxVh: "\u256B",
      boxvH: "\u256A",
      boxvh: "\u253C",
      boxVL: "\u2563",
      boxVl: "\u2562",
      boxvL: "\u2561",
      boxvl: "\u2524",
      boxVR: "\u2560",
      boxVr: "\u255F",
      boxvR: "\u255E",
      boxvr: "\u251C",
      bprime: "\u2035",
      Breve: "\u02D8",
      breve: "\u02D8",
      brvbar: "\xA6",
      Bscr: "\u212C",
      bscr: "\u{1D4B7}",
      bsemi: "\u204F",
      bsim: "\u223D",
      bsime: "\u22CD",
      bsol: "\\",
      bsolb: "\u29C5",
      bsolhsub: "\u27C8",
      bull: "\u2022",
      bullet: "\u2022",
      bump: "\u224E",
      bumpE: "\u2AAE",
      bumpe: "\u224F",
      Bumpeq: "\u224E",
      bumpeq: "\u224F",
      Cacute: "\u0106",
      cacute: "\u0107",
      Cap: "\u22D2",
      cap: "\u2229",
      capand: "\u2A44",
      capbrcup: "\u2A49",
      capcap: "\u2A4B",
      capcup: "\u2A47",
      capdot: "\u2A40",
      CapitalDifferentialD: "\u2145",
      caps: "\u2229\uFE00",
      caret: "\u2041",
      caron: "\u02C7",
      Cayleys: "\u212D",
      ccaps: "\u2A4D",
      Ccaron: "\u010C",
      ccaron: "\u010D",
      Ccedil: "\xC7",
      ccedil: "\xE7",
      Ccirc: "\u0108",
      ccirc: "\u0109",
      Cconint: "\u2230",
      ccups: "\u2A4C",
      ccupssm: "\u2A50",
      Cdot: "\u010A",
      cdot: "\u010B",
      cedil: "\xB8",
      Cedilla: "\xB8",
      cemptyv: "\u29B2",
      cent: "\xA2",
      CenterDot: "\xB7",
      centerdot: "\xB7",
      Cfr: "\u212D",
      cfr: "\u{1D520}",
      CHcy: "\u0427",
      chcy: "\u0447",
      check: "\u2713",
      checkmark: "\u2713",
      Chi: "\u03A7",
      chi: "\u03C7",
      cir: "\u25CB",
      circ: "\u02C6",
      circeq: "\u2257",
      circlearrowleft: "\u21BA",
      circlearrowright: "\u21BB",
      circledast: "\u229B",
      circledcirc: "\u229A",
      circleddash: "\u229D",
      CircleDot: "\u2299",
      circledR: "\xAE",
      circledS: "\u24C8",
      CircleMinus: "\u2296",
      CirclePlus: "\u2295",
      CircleTimes: "\u2297",
      cirE: "\u29C3",
      cire: "\u2257",
      cirfnint: "\u2A10",
      cirmid: "\u2AEF",
      cirscir: "\u29C2",
      ClockwiseContourIntegral: "\u2232",
      CloseCurlyDoubleQuote: "\u201D",
      CloseCurlyQuote: "\u2019",
      clubs: "\u2663",
      clubsuit: "\u2663",
      Colon: "\u2237",
      colon: ":",
      Colone: "\u2A74",
      colone: "\u2254",
      coloneq: "\u2254",
      comma: ",",
      commat: "@",
      comp: "\u2201",
      compfn: "\u2218",
      complement: "\u2201",
      complexes: "\u2102",
      cong: "\u2245",
      congdot: "\u2A6D",
      Congruent: "\u2261",
      Conint: "\u222F",
      conint: "\u222E",
      ContourIntegral: "\u222E",
      Copf: "\u2102",
      copf: "\u{1D554}",
      coprod: "\u2210",
      Coproduct: "\u2210",
      COPY: "\xA9",
      copy: "\xA9",
      copysr: "\u2117",
      CounterClockwiseContourIntegral: "\u2233",
      crarr: "\u21B5",
      Cross: "\u2A2F",
      cross: "\u2717",
      Cscr: "\u{1D49E}",
      cscr: "\u{1D4B8}",
      csub: "\u2ACF",
      csube: "\u2AD1",
      csup: "\u2AD0",
      csupe: "\u2AD2",
      ctdot: "\u22EF",
      cudarrl: "\u2938",
      cudarrr: "\u2935",
      cuepr: "\u22DE",
      cuesc: "\u22DF",
      cularr: "\u21B6",
      cularrp: "\u293D",
      Cup: "\u22D3",
      cup: "\u222A",
      cupbrcap: "\u2A48",
      CupCap: "\u224D",
      cupcap: "\u2A46",
      cupcup: "\u2A4A",
      cupdot: "\u228D",
      cupor: "\u2A45",
      cups: "\u222A\uFE00",
      curarr: "\u21B7",
      curarrm: "\u293C",
      curlyeqprec: "\u22DE",
      curlyeqsucc: "\u22DF",
      curlyvee: "\u22CE",
      curlywedge: "\u22CF",
      curren: "\xA4",
      curvearrowleft: "\u21B6",
      curvearrowright: "\u21B7",
      cuvee: "\u22CE",
      cuwed: "\u22CF",
      cwconint: "\u2232",
      cwint: "\u2231",
      cylcty: "\u232D",
      Dagger: "\u2021",
      dagger: "\u2020",
      daleth: "\u2138",
      Darr: "\u21A1",
      dArr: "\u21D3",
      darr: "\u2193",
      dash: "\u2010",
      Dashv: "\u2AE4",
      dashv: "\u22A3",
      dbkarow: "\u290F",
      dblac: "\u02DD",
      Dcaron: "\u010E",
      dcaron: "\u010F",
      Dcy: "\u0414",
      dcy: "\u0434",
      DD: "\u2145",
      dd: "\u2146",
      ddagger: "\u2021",
      ddarr: "\u21CA",
      DDotrahd: "\u2911",
      ddotseq: "\u2A77",
      deg: "\xB0",
      Del: "\u2207",
      Delta: "\u0394",
      delta: "\u03B4",
      demptyv: "\u29B1",
      dfisht: "\u297F",
      Dfr: "\u{1D507}",
      dfr: "\u{1D521}",
      dHar: "\u2965",
      dharl: "\u21C3",
      dharr: "\u21C2",
      DiacriticalAcute: "\xB4",
      DiacriticalDot: "\u02D9",
      DiacriticalDoubleAcute: "\u02DD",
      DiacriticalGrave: "`",
      DiacriticalTilde: "\u02DC",
      diam: "\u22C4",
      Diamond: "\u22C4",
      diamond: "\u22C4",
      diamondsuit: "\u2666",
      diams: "\u2666",
      die: "\xA8",
      DifferentialD: "\u2146",
      digamma: "\u03DD",
      disin: "\u22F2",
      div: "\xF7",
      divide: "\xF7",
      divideontimes: "\u22C7",
      divonx: "\u22C7",
      DJcy: "\u0402",
      djcy: "\u0452",
      dlcorn: "\u231E",
      dlcrop: "\u230D",
      dollar: "$",
      Dopf: "\u{1D53B}",
      dopf: "\u{1D555}",
      Dot: "\xA8",
      dot: "\u02D9",
      DotDot: "\u20DC",
      doteq: "\u2250",
      doteqdot: "\u2251",
      DotEqual: "\u2250",
      dotminus: "\u2238",
      dotplus: "\u2214",
      dotsquare: "\u22A1",
      doublebarwedge: "\u2306",
      DoubleContourIntegral: "\u222F",
      DoubleDot: "\xA8",
      DoubleDownArrow: "\u21D3",
      DoubleLeftArrow: "\u21D0",
      DoubleLeftRightArrow: "\u21D4",
      DoubleLeftTee: "\u2AE4",
      DoubleLongLeftArrow: "\u27F8",
      DoubleLongLeftRightArrow: "\u27FA",
      DoubleLongRightArrow: "\u27F9",
      DoubleRightArrow: "\u21D2",
      DoubleRightTee: "\u22A8",
      DoubleUpArrow: "\u21D1",
      DoubleUpDownArrow: "\u21D5",
      DoubleVerticalBar: "\u2225",
      DownArrow: "\u2193",
      Downarrow: "\u21D3",
      downarrow: "\u2193",
      DownArrowBar: "\u2913",
      DownArrowUpArrow: "\u21F5",
      DownBreve: "\u0311",
      downdownarrows: "\u21CA",
      downharpoonleft: "\u21C3",
      downharpoonright: "\u21C2",
      DownLeftRightVector: "\u2950",
      DownLeftTeeVector: "\u295E",
      DownLeftVector: "\u21BD",
      DownLeftVectorBar: "\u2956",
      DownRightTeeVector: "\u295F",
      DownRightVector: "\u21C1",
      DownRightVectorBar: "\u2957",
      DownTee: "\u22A4",
      DownTeeArrow: "\u21A7",
      drbkarow: "\u2910",
      drcorn: "\u231F",
      drcrop: "\u230C",
      Dscr: "\u{1D49F}",
      dscr: "\u{1D4B9}",
      DScy: "\u0405",
      dscy: "\u0455",
      dsol: "\u29F6",
      Dstrok: "\u0110",
      dstrok: "\u0111",
      dtdot: "\u22F1",
      dtri: "\u25BF",
      dtrif: "\u25BE",
      duarr: "\u21F5",
      duhar: "\u296F",
      dwangle: "\u29A6",
      DZcy: "\u040F",
      dzcy: "\u045F",
      dzigrarr: "\u27FF",
      Eacute: "\xC9",
      eacute: "\xE9",
      easter: "\u2A6E",
      Ecaron: "\u011A",
      ecaron: "\u011B",
      ecir: "\u2256",
      Ecirc: "\xCA",
      ecirc: "\xEA",
      ecolon: "\u2255",
      Ecy: "\u042D",
      ecy: "\u044D",
      eDDot: "\u2A77",
      Edot: "\u0116",
      eDot: "\u2251",
      edot: "\u0117",
      ee: "\u2147",
      efDot: "\u2252",
      Efr: "\u{1D508}",
      efr: "\u{1D522}",
      eg: "\u2A9A",
      Egrave: "\xC8",
      egrave: "\xE8",
      egs: "\u2A96",
      egsdot: "\u2A98",
      el: "\u2A99",
      Element: "\u2208",
      elinters: "\u23E7",
      ell: "\u2113",
      els: "\u2A95",
      elsdot: "\u2A97",
      Emacr: "\u0112",
      emacr: "\u0113",
      empty: "\u2205",
      emptyset: "\u2205",
      EmptySmallSquare: "\u25FB",
      emptyv: "\u2205",
      EmptyVerySmallSquare: "\u25AB",
      emsp: "\u2003",
      emsp13: "\u2004",
      emsp14: "\u2005",
      ENG: "\u014A",
      eng: "\u014B",
      ensp: "\u2002",
      Eogon: "\u0118",
      eogon: "\u0119",
      Eopf: "\u{1D53C}",
      eopf: "\u{1D556}",
      epar: "\u22D5",
      eparsl: "\u29E3",
      eplus: "\u2A71",
      epsi: "\u03B5",
      Epsilon: "\u0395",
      epsilon: "\u03B5",
      epsiv: "\u03F5",
      eqcirc: "\u2256",
      eqcolon: "\u2255",
      eqsim: "\u2242",
      eqslantgtr: "\u2A96",
      eqslantless: "\u2A95",
      Equal: "\u2A75",
      equals: "=",
      EqualTilde: "\u2242",
      equest: "\u225F",
      Equilibrium: "\u21CC",
      equiv: "\u2261",
      equivDD: "\u2A78",
      eqvparsl: "\u29E5",
      erarr: "\u2971",
      erDot: "\u2253",
      Escr: "\u2130",
      escr: "\u212F",
      esdot: "\u2250",
      Esim: "\u2A73",
      esim: "\u2242",
      Eta: "\u0397",
      eta: "\u03B7",
      ETH: "\xD0",
      eth: "\xF0",
      Euml: "\xCB",
      euml: "\xEB",
      euro: "\u20AC",
      excl: "!",
      exist: "\u2203",
      Exists: "\u2203",
      expectation: "\u2130",
      ExponentialE: "\u2147",
      exponentiale: "\u2147",
      fallingdotseq: "\u2252",
      Fcy: "\u0424",
      fcy: "\u0444",
      female: "\u2640",
      ffilig: "\uFB03",
      fflig: "\uFB00",
      ffllig: "\uFB04",
      Ffr: "\u{1D509}",
      ffr: "\u{1D523}",
      filig: "\uFB01",
      FilledSmallSquare: "\u25FC",
      FilledVerySmallSquare: "\u25AA",
      fjlig: "fj",
      flat: "\u266D",
      fllig: "\uFB02",
      fltns: "\u25B1",
      fnof: "\u0192",
      Fopf: "\u{1D53D}",
      fopf: "\u{1D557}",
      ForAll: "\u2200",
      forall: "\u2200",
      fork: "\u22D4",
      forkv: "\u2AD9",
      Fouriertrf: "\u2131",
      fpartint: "\u2A0D",
      frac12: "\xBD",
      frac13: "\u2153",
      frac14: "\xBC",
      frac15: "\u2155",
      frac16: "\u2159",
      frac18: "\u215B",
      frac23: "\u2154",
      frac25: "\u2156",
      frac34: "\xBE",
      frac35: "\u2157",
      frac38: "\u215C",
      frac45: "\u2158",
      frac56: "\u215A",
      frac58: "\u215D",
      frac78: "\u215E",
      frasl: "\u2044",
      frown: "\u2322",
      Fscr: "\u2131",
      fscr: "\u{1D4BB}",
      gacute: "\u01F5",
      Gamma: "\u0393",
      gamma: "\u03B3",
      Gammad: "\u03DC",
      gammad: "\u03DD",
      gap: "\u2A86",
      Gbreve: "\u011E",
      gbreve: "\u011F",
      Gcedil: "\u0122",
      Gcirc: "\u011C",
      gcirc: "\u011D",
      Gcy: "\u0413",
      gcy: "\u0433",
      Gdot: "\u0120",
      gdot: "\u0121",
      gE: "\u2267",
      ge: "\u2265",
      gEl: "\u2A8C",
      gel: "\u22DB",
      geq: "\u2265",
      geqq: "\u2267",
      geqslant: "\u2A7E",
      ges: "\u2A7E",
      gescc: "\u2AA9",
      gesdot: "\u2A80",
      gesdoto: "\u2A82",
      gesdotol: "\u2A84",
      gesl: "\u22DB\uFE00",
      gesles: "\u2A94",
      Gfr: "\u{1D50A}",
      gfr: "\u{1D524}",
      Gg: "\u22D9",
      gg: "\u226B",
      ggg: "\u22D9",
      gimel: "\u2137",
      GJcy: "\u0403",
      gjcy: "\u0453",
      gl: "\u2277",
      gla: "\u2AA5",
      glE: "\u2A92",
      glj: "\u2AA4",
      gnap: "\u2A8A",
      gnapprox: "\u2A8A",
      gnE: "\u2269",
      gne: "\u2A88",
      gneq: "\u2A88",
      gneqq: "\u2269",
      gnsim: "\u22E7",
      Gopf: "\u{1D53E}",
      gopf: "\u{1D558}",
      grave: "`",
      GreaterEqual: "\u2265",
      GreaterEqualLess: "\u22DB",
      GreaterFullEqual: "\u2267",
      GreaterGreater: "\u2AA2",
      GreaterLess: "\u2277",
      GreaterSlantEqual: "\u2A7E",
      GreaterTilde: "\u2273",
      Gscr: "\u{1D4A2}",
      gscr: "\u210A",
      gsim: "\u2273",
      gsime: "\u2A8E",
      gsiml: "\u2A90",
      Gt: "\u226B",
      GT: ">",
      gt: ">",
      gtcc: "\u2AA7",
      gtcir: "\u2A7A",
      gtdot: "\u22D7",
      gtlPar: "\u2995",
      gtquest: "\u2A7C",
      gtrapprox: "\u2A86",
      gtrarr: "\u2978",
      gtrdot: "\u22D7",
      gtreqless: "\u22DB",
      gtreqqless: "\u2A8C",
      gtrless: "\u2277",
      gtrsim: "\u2273",
      gvertneqq: "\u2269\uFE00",
      gvnE: "\u2269\uFE00",
      Hacek: "\u02C7",
      hairsp: "\u200A",
      half: "\xBD",
      hamilt: "\u210B",
      HARDcy: "\u042A",
      hardcy: "\u044A",
      hArr: "\u21D4",
      harr: "\u2194",
      harrcir: "\u2948",
      harrw: "\u21AD",
      Hat: "^",
      hbar: "\u210F",
      Hcirc: "\u0124",
      hcirc: "\u0125",
      hearts: "\u2665",
      heartsuit: "\u2665",
      hellip: "\u2026",
      hercon: "\u22B9",
      Hfr: "\u210C",
      hfr: "\u{1D525}",
      HilbertSpace: "\u210B",
      hksearow: "\u2925",
      hkswarow: "\u2926",
      hoarr: "\u21FF",
      homtht: "\u223B",
      hookleftarrow: "\u21A9",
      hookrightarrow: "\u21AA",
      Hopf: "\u210D",
      hopf: "\u{1D559}",
      horbar: "\u2015",
      HorizontalLine: "\u2500",
      Hscr: "\u210B",
      hscr: "\u{1D4BD}",
      hslash: "\u210F",
      Hstrok: "\u0126",
      hstrok: "\u0127",
      HumpDownHump: "\u224E",
      HumpEqual: "\u224F",
      hybull: "\u2043",
      hyphen: "\u2010",
      Iacute: "\xCD",
      iacute: "\xED",
      ic: "\u2063",
      Icirc: "\xCE",
      icirc: "\xEE",
      Icy: "\u0418",
      icy: "\u0438",
      Idot: "\u0130",
      IEcy: "\u0415",
      iecy: "\u0435",
      iexcl: "\xA1",
      iff: "\u21D4",
      Ifr: "\u2111",
      ifr: "\u{1D526}",
      Igrave: "\xCC",
      igrave: "\xEC",
      ii: "\u2148",
      iiiint: "\u2A0C",
      iiint: "\u222D",
      iinfin: "\u29DC",
      iiota: "\u2129",
      IJlig: "\u0132",
      ijlig: "\u0133",
      Im: "\u2111",
      Imacr: "\u012A",
      imacr: "\u012B",
      image: "\u2111",
      ImaginaryI: "\u2148",
      imagline: "\u2110",
      imagpart: "\u2111",
      imath: "\u0131",
      imof: "\u22B7",
      imped: "\u01B5",
      Implies: "\u21D2",
      in: "\u2208",
      incare: "\u2105",
      infin: "\u221E",
      infintie: "\u29DD",
      inodot: "\u0131",
      Int: "\u222C",
      int: "\u222B",
      intcal: "\u22BA",
      integers: "\u2124",
      Integral: "\u222B",
      intercal: "\u22BA",
      Intersection: "\u22C2",
      intlarhk: "\u2A17",
      intprod: "\u2A3C",
      InvisibleComma: "\u2063",
      InvisibleTimes: "\u2062",
      IOcy: "\u0401",
      iocy: "\u0451",
      Iogon: "\u012E",
      iogon: "\u012F",
      Iopf: "\u{1D540}",
      iopf: "\u{1D55A}",
      Iota: "\u0399",
      iota: "\u03B9",
      iprod: "\u2A3C",
      iquest: "\xBF",
      Iscr: "\u2110",
      iscr: "\u{1D4BE}",
      isin: "\u2208",
      isindot: "\u22F5",
      isinE: "\u22F9",
      isins: "\u22F4",
      isinsv: "\u22F3",
      isinv: "\u2208",
      it: "\u2062",
      Itilde: "\u0128",
      itilde: "\u0129",
      Iukcy: "\u0406",
      iukcy: "\u0456",
      Iuml: "\xCF",
      iuml: "\xEF",
      Jcirc: "\u0134",
      jcirc: "\u0135",
      Jcy: "\u0419",
      jcy: "\u0439",
      Jfr: "\u{1D50D}",
      jfr: "\u{1D527}",
      jmath: "\u0237",
      Jopf: "\u{1D541}",
      jopf: "\u{1D55B}",
      Jscr: "\u{1D4A5}",
      jscr: "\u{1D4BF}",
      Jsercy: "\u0408",
      jsercy: "\u0458",
      Jukcy: "\u0404",
      jukcy: "\u0454",
      Kappa: "\u039A",
      kappa: "\u03BA",
      kappav: "\u03F0",
      Kcedil: "\u0136",
      kcedil: "\u0137",
      Kcy: "\u041A",
      kcy: "\u043A",
      Kfr: "\u{1D50E}",
      kfr: "\u{1D528}",
      kgreen: "\u0138",
      KHcy: "\u0425",
      khcy: "\u0445",
      KJcy: "\u040C",
      kjcy: "\u045C",
      Kopf: "\u{1D542}",
      kopf: "\u{1D55C}",
      Kscr: "\u{1D4A6}",
      kscr: "\u{1D4C0}",
      lAarr: "\u21DA",
      Lacute: "\u0139",
      lacute: "\u013A",
      laemptyv: "\u29B4",
      lagran: "\u2112",
      Lambda: "\u039B",
      lambda: "\u03BB",
      Lang: "\u27EA",
      lang: "\u27E8",
      langd: "\u2991",
      langle: "\u27E8",
      lap: "\u2A85",
      Laplacetrf: "\u2112",
      laquo: "\xAB",
      Larr: "\u219E",
      lArr: "\u21D0",
      larr: "\u2190",
      larrb: "\u21E4",
      larrbfs: "\u291F",
      larrfs: "\u291D",
      larrhk: "\u21A9",
      larrlp: "\u21AB",
      larrpl: "\u2939",
      larrsim: "\u2973",
      larrtl: "\u21A2",
      lat: "\u2AAB",
      lAtail: "\u291B",
      latail: "\u2919",
      late: "\u2AAD",
      lates: "\u2AAD\uFE00",
      lBarr: "\u290E",
      lbarr: "\u290C",
      lbbrk: "\u2772",
      lbrace: "{",
      lbrack: "[",
      lbrke: "\u298B",
      lbrksld: "\u298F",
      lbrkslu: "\u298D",
      Lcaron: "\u013D",
      lcaron: "\u013E",
      Lcedil: "\u013B",
      lcedil: "\u013C",
      lceil: "\u2308",
      lcub: "{",
      Lcy: "\u041B",
      lcy: "\u043B",
      ldca: "\u2936",
      ldquo: "\u201C",
      ldquor: "\u201E",
      ldrdhar: "\u2967",
      ldrushar: "\u294B",
      ldsh: "\u21B2",
      lE: "\u2266",
      le: "\u2264",
      LeftAngleBracket: "\u27E8",
      LeftArrow: "\u2190",
      Leftarrow: "\u21D0",
      leftarrow: "\u2190",
      LeftArrowBar: "\u21E4",
      LeftArrowRightArrow: "\u21C6",
      leftarrowtail: "\u21A2",
      LeftCeiling: "\u2308",
      LeftDoubleBracket: "\u27E6",
      LeftDownTeeVector: "\u2961",
      LeftDownVector: "\u21C3",
      LeftDownVectorBar: "\u2959",
      LeftFloor: "\u230A",
      leftharpoondown: "\u21BD",
      leftharpoonup: "\u21BC",
      leftleftarrows: "\u21C7",
      LeftRightArrow: "\u2194",
      Leftrightarrow: "\u21D4",
      leftrightarrow: "\u2194",
      leftrightarrows: "\u21C6",
      leftrightharpoons: "\u21CB",
      leftrightsquigarrow: "\u21AD",
      LeftRightVector: "\u294E",
      LeftTee: "\u22A3",
      LeftTeeArrow: "\u21A4",
      LeftTeeVector: "\u295A",
      leftthreetimes: "\u22CB",
      LeftTriangle: "\u22B2",
      LeftTriangleBar: "\u29CF",
      LeftTriangleEqual: "\u22B4",
      LeftUpDownVector: "\u2951",
      LeftUpTeeVector: "\u2960",
      LeftUpVector: "\u21BF",
      LeftUpVectorBar: "\u2958",
      LeftVector: "\u21BC",
      LeftVectorBar: "\u2952",
      lEg: "\u2A8B",
      leg: "\u22DA",
      leq: "\u2264",
      leqq: "\u2266",
      leqslant: "\u2A7D",
      les: "\u2A7D",
      lescc: "\u2AA8",
      lesdot: "\u2A7F",
      lesdoto: "\u2A81",
      lesdotor: "\u2A83",
      lesg: "\u22DA\uFE00",
      lesges: "\u2A93",
      lessapprox: "\u2A85",
      lessdot: "\u22D6",
      lesseqgtr: "\u22DA",
      lesseqqgtr: "\u2A8B",
      LessEqualGreater: "\u22DA",
      LessFullEqual: "\u2266",
      LessGreater: "\u2276",
      lessgtr: "\u2276",
      LessLess: "\u2AA1",
      lesssim: "\u2272",
      LessSlantEqual: "\u2A7D",
      LessTilde: "\u2272",
      lfisht: "\u297C",
      lfloor: "\u230A",
      Lfr: "\u{1D50F}",
      lfr: "\u{1D529}",
      lg: "\u2276",
      lgE: "\u2A91",
      lHar: "\u2962",
      lhard: "\u21BD",
      lharu: "\u21BC",
      lharul: "\u296A",
      lhblk: "\u2584",
      LJcy: "\u0409",
      ljcy: "\u0459",
      Ll: "\u22D8",
      ll: "\u226A",
      llarr: "\u21C7",
      llcorner: "\u231E",
      Lleftarrow: "\u21DA",
      llhard: "\u296B",
      lltri: "\u25FA",
      Lmidot: "\u013F",
      lmidot: "\u0140",
      lmoust: "\u23B0",
      lmoustache: "\u23B0",
      lnap: "\u2A89",
      lnapprox: "\u2A89",
      lnE: "\u2268",
      lne: "\u2A87",
      lneq: "\u2A87",
      lneqq: "\u2268",
      lnsim: "\u22E6",
      loang: "\u27EC",
      loarr: "\u21FD",
      lobrk: "\u27E6",
      LongLeftArrow: "\u27F5",
      Longleftarrow: "\u27F8",
      longleftarrow: "\u27F5",
      LongLeftRightArrow: "\u27F7",
      Longleftrightarrow: "\u27FA",
      longleftrightarrow: "\u27F7",
      longmapsto: "\u27FC",
      LongRightArrow: "\u27F6",
      Longrightarrow: "\u27F9",
      longrightarrow: "\u27F6",
      looparrowleft: "\u21AB",
      looparrowright: "\u21AC",
      lopar: "\u2985",
      Lopf: "\u{1D543}",
      lopf: "\u{1D55D}",
      loplus: "\u2A2D",
      lotimes: "\u2A34",
      lowast: "\u2217",
      lowbar: "_",
      LowerLeftArrow: "\u2199",
      LowerRightArrow: "\u2198",
      loz: "\u25CA",
      lozenge: "\u25CA",
      lozf: "\u29EB",
      lpar: "(",
      lparlt: "\u2993",
      lrarr: "\u21C6",
      lrcorner: "\u231F",
      lrhar: "\u21CB",
      lrhard: "\u296D",
      lrm: "\u200E",
      lrtri: "\u22BF",
      lsaquo: "\u2039",
      Lscr: "\u2112",
      lscr: "\u{1D4C1}",
      Lsh: "\u21B0",
      lsh: "\u21B0",
      lsim: "\u2272",
      lsime: "\u2A8D",
      lsimg: "\u2A8F",
      lsqb: "[",
      lsquo: "\u2018",
      lsquor: "\u201A",
      Lstrok: "\u0141",
      lstrok: "\u0142",
      Lt: "\u226A",
      LT: "<",
      lt: "<",
      ltcc: "\u2AA6",
      ltcir: "\u2A79",
      ltdot: "\u22D6",
      lthree: "\u22CB",
      ltimes: "\u22C9",
      ltlarr: "\u2976",
      ltquest: "\u2A7B",
      ltri: "\u25C3",
      ltrie: "\u22B4",
      ltrif: "\u25C2",
      ltrPar: "\u2996",
      lurdshar: "\u294A",
      luruhar: "\u2966",
      lvertneqq: "\u2268\uFE00",
      lvnE: "\u2268\uFE00",
      macr: "\xAF",
      male: "\u2642",
      malt: "\u2720",
      maltese: "\u2720",
      Map: "\u2905",
      map: "\u21A6",
      mapsto: "\u21A6",
      mapstodown: "\u21A7",
      mapstoleft: "\u21A4",
      mapstoup: "\u21A5",
      marker: "\u25AE",
      mcomma: "\u2A29",
      Mcy: "\u041C",
      mcy: "\u043C",
      mdash: "\u2014",
      mDDot: "\u223A",
      measuredangle: "\u2221",
      MediumSpace: "\u205F",
      Mellintrf: "\u2133",
      Mfr: "\u{1D510}",
      mfr: "\u{1D52A}",
      mho: "\u2127",
      micro: "\xB5",
      mid: "\u2223",
      midast: "*",
      midcir: "\u2AF0",
      middot: "\xB7",
      minus: "\u2212",
      minusb: "\u229F",
      minusd: "\u2238",
      minusdu: "\u2A2A",
      MinusPlus: "\u2213",
      mlcp: "\u2ADB",
      mldr: "\u2026",
      mnplus: "\u2213",
      models: "\u22A7",
      Mopf: "\u{1D544}",
      mopf: "\u{1D55E}",
      mp: "\u2213",
      Mscr: "\u2133",
      mscr: "\u{1D4C2}",
      mstpos: "\u223E",
      Mu: "\u039C",
      mu: "\u03BC",
      multimap: "\u22B8",
      mumap: "\u22B8",
      nabla: "\u2207",
      Nacute: "\u0143",
      nacute: "\u0144",
      nang: "\u2220\u20D2",
      nap: "\u2249",
      napE: "\u2A70\u0338",
      napid: "\u224B\u0338",
      napos: "\u0149",
      napprox: "\u2249",
      natur: "\u266E",
      natural: "\u266E",
      naturals: "\u2115",
      nbsp: "\xA0",
      nbump: "\u224E\u0338",
      nbumpe: "\u224F\u0338",
      ncap: "\u2A43",
      Ncaron: "\u0147",
      ncaron: "\u0148",
      Ncedil: "\u0145",
      ncedil: "\u0146",
      ncong: "\u2247",
      ncongdot: "\u2A6D\u0338",
      ncup: "\u2A42",
      Ncy: "\u041D",
      ncy: "\u043D",
      ndash: "\u2013",
      ne: "\u2260",
      nearhk: "\u2924",
      neArr: "\u21D7",
      nearr: "\u2197",
      nearrow: "\u2197",
      nedot: "\u2250\u0338",
      NegativeMediumSpace: "\u200B",
      NegativeThickSpace: "\u200B",
      NegativeThinSpace: "\u200B",
      NegativeVeryThinSpace: "\u200B",
      nequiv: "\u2262",
      nesear: "\u2928",
      nesim: "\u2242\u0338",
      NestedGreaterGreater: "\u226B",
      NestedLessLess: "\u226A",
      NewLine: "\n",
      nexist: "\u2204",
      nexists: "\u2204",
      Nfr: "\u{1D511}",
      nfr: "\u{1D52B}",
      ngE: "\u2267\u0338",
      nge: "\u2271",
      ngeq: "\u2271",
      ngeqq: "\u2267\u0338",
      ngeqslant: "\u2A7E\u0338",
      nges: "\u2A7E\u0338",
      nGg: "\u22D9\u0338",
      ngsim: "\u2275",
      nGt: "\u226B\u20D2",
      ngt: "\u226F",
      ngtr: "\u226F",
      nGtv: "\u226B\u0338",
      nhArr: "\u21CE",
      nharr: "\u21AE",
      nhpar: "\u2AF2",
      ni: "\u220B",
      nis: "\u22FC",
      nisd: "\u22FA",
      niv: "\u220B",
      NJcy: "\u040A",
      njcy: "\u045A",
      nlArr: "\u21CD",
      nlarr: "\u219A",
      nldr: "\u2025",
      nlE: "\u2266\u0338",
      nle: "\u2270",
      nLeftarrow: "\u21CD",
      nleftarrow: "\u219A",
      nLeftrightarrow: "\u21CE",
      nleftrightarrow: "\u21AE",
      nleq: "\u2270",
      nleqq: "\u2266\u0338",
      nleqslant: "\u2A7D\u0338",
      nles: "\u2A7D\u0338",
      nless: "\u226E",
      nLl: "\u22D8\u0338",
      nlsim: "\u2274",
      nLt: "\u226A\u20D2",
      nlt: "\u226E",
      nltri: "\u22EA",
      nltrie: "\u22EC",
      nLtv: "\u226A\u0338",
      nmid: "\u2224",
      NoBreak: "\u2060",
      NonBreakingSpace: "\xA0",
      Nopf: "\u2115",
      nopf: "\u{1D55F}",
      Not: "\u2AEC",
      not: "\xAC",
      NotCongruent: "\u2262",
      NotCupCap: "\u226D",
      NotDoubleVerticalBar: "\u2226",
      NotElement: "\u2209",
      NotEqual: "\u2260",
      NotEqualTilde: "\u2242\u0338",
      NotExists: "\u2204",
      NotGreater: "\u226F",
      NotGreaterEqual: "\u2271",
      NotGreaterFullEqual: "\u2267\u0338",
      NotGreaterGreater: "\u226B\u0338",
      NotGreaterLess: "\u2279",
      NotGreaterSlantEqual: "\u2A7E\u0338",
      NotGreaterTilde: "\u2275",
      NotHumpDownHump: "\u224E\u0338",
      NotHumpEqual: "\u224F\u0338",
      notin: "\u2209",
      notindot: "\u22F5\u0338",
      notinE: "\u22F9\u0338",
      notinva: "\u2209",
      notinvb: "\u22F7",
      notinvc: "\u22F6",
      NotLeftTriangle: "\u22EA",
      NotLeftTriangleBar: "\u29CF\u0338",
      NotLeftTriangleEqual: "\u22EC",
      NotLess: "\u226E",
      NotLessEqual: "\u2270",
      NotLessGreater: "\u2278",
      NotLessLess: "\u226A\u0338",
      NotLessSlantEqual: "\u2A7D\u0338",
      NotLessTilde: "\u2274",
      NotNestedGreaterGreater: "\u2AA2\u0338",
      NotNestedLessLess: "\u2AA1\u0338",
      notni: "\u220C",
      notniva: "\u220C",
      notnivb: "\u22FE",
      notnivc: "\u22FD",
      NotPrecedes: "\u2280",
      NotPrecedesEqual: "\u2AAF\u0338",
      NotPrecedesSlantEqual: "\u22E0",
      NotReverseElement: "\u220C",
      NotRightTriangle: "\u22EB",
      NotRightTriangleBar: "\u29D0\u0338",
      NotRightTriangleEqual: "\u22ED",
      NotSquareSubset: "\u228F\u0338",
      NotSquareSubsetEqual: "\u22E2",
      NotSquareSuperset: "\u2290\u0338",
      NotSquareSupersetEqual: "\u22E3",
      NotSubset: "\u2282\u20D2",
      NotSubsetEqual: "\u2288",
      NotSucceeds: "\u2281",
      NotSucceedsEqual: "\u2AB0\u0338",
      NotSucceedsSlantEqual: "\u22E1",
      NotSucceedsTilde: "\u227F\u0338",
      NotSuperset: "\u2283\u20D2",
      NotSupersetEqual: "\u2289",
      NotTilde: "\u2241",
      NotTildeEqual: "\u2244",
      NotTildeFullEqual: "\u2247",
      NotTildeTilde: "\u2249",
      NotVerticalBar: "\u2224",
      npar: "\u2226",
      nparallel: "\u2226",
      nparsl: "\u2AFD\u20E5",
      npart: "\u2202\u0338",
      npolint: "\u2A14",
      npr: "\u2280",
      nprcue: "\u22E0",
      npre: "\u2AAF\u0338",
      nprec: "\u2280",
      npreceq: "\u2AAF\u0338",
      nrArr: "\u21CF",
      nrarr: "\u219B",
      nrarrc: "\u2933\u0338",
      nrarrw: "\u219D\u0338",
      nRightarrow: "\u21CF",
      nrightarrow: "\u219B",
      nrtri: "\u22EB",
      nrtrie: "\u22ED",
      nsc: "\u2281",
      nsccue: "\u22E1",
      nsce: "\u2AB0\u0338",
      Nscr: "\u{1D4A9}",
      nscr: "\u{1D4C3}",
      nshortmid: "\u2224",
      nshortparallel: "\u2226",
      nsim: "\u2241",
      nsime: "\u2244",
      nsimeq: "\u2244",
      nsmid: "\u2224",
      nspar: "\u2226",
      nsqsube: "\u22E2",
      nsqsupe: "\u22E3",
      nsub: "\u2284",
      nsubE: "\u2AC5\u0338",
      nsube: "\u2288",
      nsubset: "\u2282\u20D2",
      nsubseteq: "\u2288",
      nsubseteqq: "\u2AC5\u0338",
      nsucc: "\u2281",
      nsucceq: "\u2AB0\u0338",
      nsup: "\u2285",
      nsupE: "\u2AC6\u0338",
      nsupe: "\u2289",
      nsupset: "\u2283\u20D2",
      nsupseteq: "\u2289",
      nsupseteqq: "\u2AC6\u0338",
      ntgl: "\u2279",
      Ntilde: "\xD1",
      ntilde: "\xF1",
      ntlg: "\u2278",
      ntriangleleft: "\u22EA",
      ntrianglelefteq: "\u22EC",
      ntriangleright: "\u22EB",
      ntrianglerighteq: "\u22ED",
      Nu: "\u039D",
      nu: "\u03BD",
      num: "#",
      numero: "\u2116",
      numsp: "\u2007",
      nvap: "\u224D\u20D2",
      nVDash: "\u22AF",
      nVdash: "\u22AE",
      nvDash: "\u22AD",
      nvdash: "\u22AC",
      nvge: "\u2265\u20D2",
      nvgt: ">\u20D2",
      nvHarr: "\u2904",
      nvinfin: "\u29DE",
      nvlArr: "\u2902",
      nvle: "\u2264\u20D2",
      nvlt: "<\u20D2",
      nvltrie: "\u22B4\u20D2",
      nvrArr: "\u2903",
      nvrtrie: "\u22B5\u20D2",
      nvsim: "\u223C\u20D2",
      nwarhk: "\u2923",
      nwArr: "\u21D6",
      nwarr: "\u2196",
      nwarrow: "\u2196",
      nwnear: "\u2927",
      Oacute: "\xD3",
      oacute: "\xF3",
      oast: "\u229B",
      ocir: "\u229A",
      Ocirc: "\xD4",
      ocirc: "\xF4",
      Ocy: "\u041E",
      ocy: "\u043E",
      odash: "\u229D",
      Odblac: "\u0150",
      odblac: "\u0151",
      odiv: "\u2A38",
      odot: "\u2299",
      odsold: "\u29BC",
      OElig: "\u0152",
      oelig: "\u0153",
      ofcir: "\u29BF",
      Ofr: "\u{1D512}",
      ofr: "\u{1D52C}",
      ogon: "\u02DB",
      Ograve: "\xD2",
      ograve: "\xF2",
      ogt: "\u29C1",
      ohbar: "\u29B5",
      ohm: "\u03A9",
      oint: "\u222E",
      olarr: "\u21BA",
      olcir: "\u29BE",
      olcross: "\u29BB",
      oline: "\u203E",
      olt: "\u29C0",
      Omacr: "\u014C",
      omacr: "\u014D",
      Omega: "\u03A9",
      omega: "\u03C9",
      Omicron: "\u039F",
      omicron: "\u03BF",
      omid: "\u29B6",
      ominus: "\u2296",
      Oopf: "\u{1D546}",
      oopf: "\u{1D560}",
      opar: "\u29B7",
      OpenCurlyDoubleQuote: "\u201C",
      OpenCurlyQuote: "\u2018",
      operp: "\u29B9",
      oplus: "\u2295",
      Or: "\u2A54",
      or: "\u2228",
      orarr: "\u21BB",
      ord: "\u2A5D",
      order: "\u2134",
      orderof: "\u2134",
      ordf: "\xAA",
      ordm: "\xBA",
      origof: "\u22B6",
      oror: "\u2A56",
      orslope: "\u2A57",
      orv: "\u2A5B",
      oS: "\u24C8",
      Oscr: "\u{1D4AA}",
      oscr: "\u2134",
      Oslash: "\xD8",
      oslash: "\xF8",
      osol: "\u2298",
      Otilde: "\xD5",
      otilde: "\xF5",
      Otimes: "\u2A37",
      otimes: "\u2297",
      otimesas: "\u2A36",
      Ouml: "\xD6",
      ouml: "\xF6",
      ovbar: "\u233D",
      OverBar: "\u203E",
      OverBrace: "\u23DE",
      OverBracket: "\u23B4",
      OverParenthesis: "\u23DC",
      par: "\u2225",
      para: "\xB6",
      parallel: "\u2225",
      parsim: "\u2AF3",
      parsl: "\u2AFD",
      part: "\u2202",
      PartialD: "\u2202",
      Pcy: "\u041F",
      pcy: "\u043F",
      percnt: "%",
      period: ".",
      permil: "\u2030",
      perp: "\u22A5",
      pertenk: "\u2031",
      Pfr: "\u{1D513}",
      pfr: "\u{1D52D}",
      Phi: "\u03A6",
      phi: "\u03C6",
      phiv: "\u03D5",
      phmmat: "\u2133",
      phone: "\u260E",
      Pi: "\u03A0",
      pi: "\u03C0",
      pitchfork: "\u22D4",
      piv: "\u03D6",
      planck: "\u210F",
      planckh: "\u210E",
      plankv: "\u210F",
      plus: "+",
      plusacir: "\u2A23",
      plusb: "\u229E",
      pluscir: "\u2A22",
      plusdo: "\u2214",
      plusdu: "\u2A25",
      pluse: "\u2A72",
      PlusMinus: "\xB1",
      plusmn: "\xB1",
      plussim: "\u2A26",
      plustwo: "\u2A27",
      pm: "\xB1",
      Poincareplane: "\u210C",
      pointint: "\u2A15",
      Popf: "\u2119",
      popf: "\u{1D561}",
      pound: "\xA3",
      Pr: "\u2ABB",
      pr: "\u227A",
      prap: "\u2AB7",
      prcue: "\u227C",
      prE: "\u2AB3",
      pre: "\u2AAF",
      prec: "\u227A",
      precapprox: "\u2AB7",
      preccurlyeq: "\u227C",
      Precedes: "\u227A",
      PrecedesEqual: "\u2AAF",
      PrecedesSlantEqual: "\u227C",
      PrecedesTilde: "\u227E",
      preceq: "\u2AAF",
      precnapprox: "\u2AB9",
      precneqq: "\u2AB5",
      precnsim: "\u22E8",
      precsim: "\u227E",
      Prime: "\u2033",
      prime: "\u2032",
      primes: "\u2119",
      prnap: "\u2AB9",
      prnE: "\u2AB5",
      prnsim: "\u22E8",
      prod: "\u220F",
      Product: "\u220F",
      profalar: "\u232E",
      profline: "\u2312",
      profsurf: "\u2313",
      prop: "\u221D",
      Proportion: "\u2237",
      Proportional: "\u221D",
      propto: "\u221D",
      prsim: "\u227E",
      prurel: "\u22B0",
      Pscr: "\u{1D4AB}",
      pscr: "\u{1D4C5}",
      Psi: "\u03A8",
      psi: "\u03C8",
      puncsp: "\u2008",
      Qfr: "\u{1D514}",
      qfr: "\u{1D52E}",
      qint: "\u2A0C",
      Qopf: "\u211A",
      qopf: "\u{1D562}",
      qprime: "\u2057",
      Qscr: "\u{1D4AC}",
      qscr: "\u{1D4C6}",
      quaternions: "\u210D",
      quatint: "\u2A16",
      quest: "?",
      questeq: "\u225F",
      QUOT: '"',
      quot: '"',
      rAarr: "\u21DB",
      race: "\u223D\u0331",
      Racute: "\u0154",
      racute: "\u0155",
      radic: "\u221A",
      raemptyv: "\u29B3",
      Rang: "\u27EB",
      rang: "\u27E9",
      rangd: "\u2992",
      range: "\u29A5",
      rangle: "\u27E9",
      raquo: "\xBB",
      Rarr: "\u21A0",
      rArr: "\u21D2",
      rarr: "\u2192",
      rarrap: "\u2975",
      rarrb: "\u21E5",
      rarrbfs: "\u2920",
      rarrc: "\u2933",
      rarrfs: "\u291E",
      rarrhk: "\u21AA",
      rarrlp: "\u21AC",
      rarrpl: "\u2945",
      rarrsim: "\u2974",
      Rarrtl: "\u2916",
      rarrtl: "\u21A3",
      rarrw: "\u219D",
      rAtail: "\u291C",
      ratail: "\u291A",
      ratio: "\u2236",
      rationals: "\u211A",
      RBarr: "\u2910",
      rBarr: "\u290F",
      rbarr: "\u290D",
      rbbrk: "\u2773",
      rbrace: "}",
      rbrack: "]",
      rbrke: "\u298C",
      rbrksld: "\u298E",
      rbrkslu: "\u2990",
      Rcaron: "\u0158",
      rcaron: "\u0159",
      Rcedil: "\u0156",
      rcedil: "\u0157",
      rceil: "\u2309",
      rcub: "}",
      Rcy: "\u0420",
      rcy: "\u0440",
      rdca: "\u2937",
      rdldhar: "\u2969",
      rdquo: "\u201D",
      rdquor: "\u201D",
      rdsh: "\u21B3",
      Re: "\u211C",
      real: "\u211C",
      realine: "\u211B",
      realpart: "\u211C",
      reals: "\u211D",
      rect: "\u25AD",
      REG: "\xAE",
      reg: "\xAE",
      ReverseElement: "\u220B",
      ReverseEquilibrium: "\u21CB",
      ReverseUpEquilibrium: "\u296F",
      rfisht: "\u297D",
      rfloor: "\u230B",
      Rfr: "\u211C",
      rfr: "\u{1D52F}",
      rHar: "\u2964",
      rhard: "\u21C1",
      rharu: "\u21C0",
      rharul: "\u296C",
      Rho: "\u03A1",
      rho: "\u03C1",
      rhov: "\u03F1",
      RightAngleBracket: "\u27E9",
      RightArrow: "\u2192",
      Rightarrow: "\u21D2",
      rightarrow: "\u2192",
      RightArrowBar: "\u21E5",
      RightArrowLeftArrow: "\u21C4",
      rightarrowtail: "\u21A3",
      RightCeiling: "\u2309",
      RightDoubleBracket: "\u27E7",
      RightDownTeeVector: "\u295D",
      RightDownVector: "\u21C2",
      RightDownVectorBar: "\u2955",
      RightFloor: "\u230B",
      rightharpoondown: "\u21C1",
      rightharpoonup: "\u21C0",
      rightleftarrows: "\u21C4",
      rightleftharpoons: "\u21CC",
      rightrightarrows: "\u21C9",
      rightsquigarrow: "\u219D",
      RightTee: "\u22A2",
      RightTeeArrow: "\u21A6",
      RightTeeVector: "\u295B",
      rightthreetimes: "\u22CC",
      RightTriangle: "\u22B3",
      RightTriangleBar: "\u29D0",
      RightTriangleEqual: "\u22B5",
      RightUpDownVector: "\u294F",
      RightUpTeeVector: "\u295C",
      RightUpVector: "\u21BE",
      RightUpVectorBar: "\u2954",
      RightVector: "\u21C0",
      RightVectorBar: "\u2953",
      ring: "\u02DA",
      risingdotseq: "\u2253",
      rlarr: "\u21C4",
      rlhar: "\u21CC",
      rlm: "\u200F",
      rmoust: "\u23B1",
      rmoustache: "\u23B1",
      rnmid: "\u2AEE",
      roang: "\u27ED",
      roarr: "\u21FE",
      robrk: "\u27E7",
      ropar: "\u2986",
      Ropf: "\u211D",
      ropf: "\u{1D563}",
      roplus: "\u2A2E",
      rotimes: "\u2A35",
      RoundImplies: "\u2970",
      rpar: ")",
      rpargt: "\u2994",
      rppolint: "\u2A12",
      rrarr: "\u21C9",
      Rrightarrow: "\u21DB",
      rsaquo: "\u203A",
      Rscr: "\u211B",
      rscr: "\u{1D4C7}",
      Rsh: "\u21B1",
      rsh: "\u21B1",
      rsqb: "]",
      rsquo: "\u2019",
      rsquor: "\u2019",
      rthree: "\u22CC",
      rtimes: "\u22CA",
      rtri: "\u25B9",
      rtrie: "\u22B5",
      rtrif: "\u25B8",
      rtriltri: "\u29CE",
      RuleDelayed: "\u29F4",
      ruluhar: "\u2968",
      rx: "\u211E",
      Sacute: "\u015A",
      sacute: "\u015B",
      sbquo: "\u201A",
      Sc: "\u2ABC",
      sc: "\u227B",
      scap: "\u2AB8",
      Scaron: "\u0160",
      scaron: "\u0161",
      sccue: "\u227D",
      scE: "\u2AB4",
      sce: "\u2AB0",
      Scedil: "\u015E",
      scedil: "\u015F",
      Scirc: "\u015C",
      scirc: "\u015D",
      scnap: "\u2ABA",
      scnE: "\u2AB6",
      scnsim: "\u22E9",
      scpolint: "\u2A13",
      scsim: "\u227F",
      Scy: "\u0421",
      scy: "\u0441",
      sdot: "\u22C5",
      sdotb: "\u22A1",
      sdote: "\u2A66",
      searhk: "\u2925",
      seArr: "\u21D8",
      searr: "\u2198",
      searrow: "\u2198",
      sect: "\xA7",
      semi: ";",
      seswar: "\u2929",
      setminus: "\u2216",
      setmn: "\u2216",
      sext: "\u2736",
      Sfr: "\u{1D516}",
      sfr: "\u{1D530}",
      sfrown: "\u2322",
      sharp: "\u266F",
      SHCHcy: "\u0429",
      shchcy: "\u0449",
      SHcy: "\u0428",
      shcy: "\u0448",
      ShortDownArrow: "\u2193",
      ShortLeftArrow: "\u2190",
      shortmid: "\u2223",
      shortparallel: "\u2225",
      ShortRightArrow: "\u2192",
      ShortUpArrow: "\u2191",
      shy: "\xAD",
      Sigma: "\u03A3",
      sigma: "\u03C3",
      sigmaf: "\u03C2",
      sigmav: "\u03C2",
      sim: "\u223C",
      simdot: "\u2A6A",
      sime: "\u2243",
      simeq: "\u2243",
      simg: "\u2A9E",
      simgE: "\u2AA0",
      siml: "\u2A9D",
      simlE: "\u2A9F",
      simne: "\u2246",
      simplus: "\u2A24",
      simrarr: "\u2972",
      slarr: "\u2190",
      SmallCircle: "\u2218",
      smallsetminus: "\u2216",
      smashp: "\u2A33",
      smeparsl: "\u29E4",
      smid: "\u2223",
      smile: "\u2323",
      smt: "\u2AAA",
      smte: "\u2AAC",
      smtes: "\u2AAC\uFE00",
      SOFTcy: "\u042C",
      softcy: "\u044C",
      sol: "/",
      solb: "\u29C4",
      solbar: "\u233F",
      Sopf: "\u{1D54A}",
      sopf: "\u{1D564}",
      spades: "\u2660",
      spadesuit: "\u2660",
      spar: "\u2225",
      sqcap: "\u2293",
      sqcaps: "\u2293\uFE00",
      sqcup: "\u2294",
      sqcups: "\u2294\uFE00",
      Sqrt: "\u221A",
      sqsub: "\u228F",
      sqsube: "\u2291",
      sqsubset: "\u228F",
      sqsubseteq: "\u2291",
      sqsup: "\u2290",
      sqsupe: "\u2292",
      sqsupset: "\u2290",
      sqsupseteq: "\u2292",
      squ: "\u25A1",
      Square: "\u25A1",
      square: "\u25A1",
      SquareIntersection: "\u2293",
      SquareSubset: "\u228F",
      SquareSubsetEqual: "\u2291",
      SquareSuperset: "\u2290",
      SquareSupersetEqual: "\u2292",
      SquareUnion: "\u2294",
      squarf: "\u25AA",
      squf: "\u25AA",
      srarr: "\u2192",
      Sscr: "\u{1D4AE}",
      sscr: "\u{1D4C8}",
      ssetmn: "\u2216",
      ssmile: "\u2323",
      sstarf: "\u22C6",
      Star: "\u22C6",
      star: "\u2606",
      starf: "\u2605",
      straightepsilon: "\u03F5",
      straightphi: "\u03D5",
      strns: "\xAF",
      Sub: "\u22D0",
      sub: "\u2282",
      subdot: "\u2ABD",
      subE: "\u2AC5",
      sube: "\u2286",
      subedot: "\u2AC3",
      submult: "\u2AC1",
      subnE: "\u2ACB",
      subne: "\u228A",
      subplus: "\u2ABF",
      subrarr: "\u2979",
      Subset: "\u22D0",
      subset: "\u2282",
      subseteq: "\u2286",
      subseteqq: "\u2AC5",
      SubsetEqual: "\u2286",
      subsetneq: "\u228A",
      subsetneqq: "\u2ACB",
      subsim: "\u2AC7",
      subsub: "\u2AD5",
      subsup: "\u2AD3",
      succ: "\u227B",
      succapprox: "\u2AB8",
      succcurlyeq: "\u227D",
      Succeeds: "\u227B",
      SucceedsEqual: "\u2AB0",
      SucceedsSlantEqual: "\u227D",
      SucceedsTilde: "\u227F",
      succeq: "\u2AB0",
      succnapprox: "\u2ABA",
      succneqq: "\u2AB6",
      succnsim: "\u22E9",
      succsim: "\u227F",
      SuchThat: "\u220B",
      Sum: "\u2211",
      sum: "\u2211",
      sung: "\u266A",
      Sup: "\u22D1",
      sup: "\u2283",
      sup1: "\xB9",
      sup2: "\xB2",
      sup3: "\xB3",
      supdot: "\u2ABE",
      supdsub: "\u2AD8",
      supE: "\u2AC6",
      supe: "\u2287",
      supedot: "\u2AC4",
      Superset: "\u2283",
      SupersetEqual: "\u2287",
      suphsol: "\u27C9",
      suphsub: "\u2AD7",
      suplarr: "\u297B",
      supmult: "\u2AC2",
      supnE: "\u2ACC",
      supne: "\u228B",
      supplus: "\u2AC0",
      Supset: "\u22D1",
      supset: "\u2283",
      supseteq: "\u2287",
      supseteqq: "\u2AC6",
      supsetneq: "\u228B",
      supsetneqq: "\u2ACC",
      supsim: "\u2AC8",
      supsub: "\u2AD4",
      supsup: "\u2AD6",
      swarhk: "\u2926",
      swArr: "\u21D9",
      swarr: "\u2199",
      swarrow: "\u2199",
      swnwar: "\u292A",
      szlig: "\xDF",
      Tab: "	",
      target: "\u2316",
      Tau: "\u03A4",
      tau: "\u03C4",
      tbrk: "\u23B4",
      Tcaron: "\u0164",
      tcaron: "\u0165",
      Tcedil: "\u0162",
      tcedil: "\u0163",
      Tcy: "\u0422",
      tcy: "\u0442",
      tdot: "\u20DB",
      telrec: "\u2315",
      Tfr: "\u{1D517}",
      tfr: "\u{1D531}",
      there4: "\u2234",
      Therefore: "\u2234",
      therefore: "\u2234",
      Theta: "\u0398",
      theta: "\u03B8",
      thetasym: "\u03D1",
      thetav: "\u03D1",
      thickapprox: "\u2248",
      thicksim: "\u223C",
      ThickSpace: "\u205F\u200A",
      thinsp: "\u2009",
      ThinSpace: "\u2009",
      thkap: "\u2248",
      thksim: "\u223C",
      THORN: "\xDE",
      thorn: "\xFE",
      Tilde: "\u223C",
      tilde: "\u02DC",
      TildeEqual: "\u2243",
      TildeFullEqual: "\u2245",
      TildeTilde: "\u2248",
      times: "\xD7",
      timesb: "\u22A0",
      timesbar: "\u2A31",
      timesd: "\u2A30",
      tint: "\u222D",
      toea: "\u2928",
      top: "\u22A4",
      topbot: "\u2336",
      topcir: "\u2AF1",
      Topf: "\u{1D54B}",
      topf: "\u{1D565}",
      topfork: "\u2ADA",
      tosa: "\u2929",
      tprime: "\u2034",
      TRADE: "\u2122",
      trade: "\u2122",
      triangle: "\u25B5",
      triangledown: "\u25BF",
      triangleleft: "\u25C3",
      trianglelefteq: "\u22B4",
      triangleq: "\u225C",
      triangleright: "\u25B9",
      trianglerighteq: "\u22B5",
      tridot: "\u25EC",
      trie: "\u225C",
      triminus: "\u2A3A",
      TripleDot: "\u20DB",
      triplus: "\u2A39",
      trisb: "\u29CD",
      tritime: "\u2A3B",
      trpezium: "\u23E2",
      Tscr: "\u{1D4AF}",
      tscr: "\u{1D4C9}",
      TScy: "\u0426",
      tscy: "\u0446",
      TSHcy: "\u040B",
      tshcy: "\u045B",
      Tstrok: "\u0166",
      tstrok: "\u0167",
      twixt: "\u226C",
      twoheadleftarrow: "\u219E",
      twoheadrightarrow: "\u21A0",
      Uacute: "\xDA",
      uacute: "\xFA",
      Uarr: "\u219F",
      uArr: "\u21D1",
      uarr: "\u2191",
      Uarrocir: "\u2949",
      Ubrcy: "\u040E",
      ubrcy: "\u045E",
      Ubreve: "\u016C",
      ubreve: "\u016D",
      Ucirc: "\xDB",
      ucirc: "\xFB",
      Ucy: "\u0423",
      ucy: "\u0443",
      udarr: "\u21C5",
      Udblac: "\u0170",
      udblac: "\u0171",
      udhar: "\u296E",
      ufisht: "\u297E",
      Ufr: "\u{1D518}",
      ufr: "\u{1D532}",
      Ugrave: "\xD9",
      ugrave: "\xF9",
      uHar: "\u2963",
      uharl: "\u21BF",
      uharr: "\u21BE",
      uhblk: "\u2580",
      ulcorn: "\u231C",
      ulcorner: "\u231C",
      ulcrop: "\u230F",
      ultri: "\u25F8",
      Umacr: "\u016A",
      umacr: "\u016B",
      uml: "\xA8",
      UnderBar: "_",
      UnderBrace: "\u23DF",
      UnderBracket: "\u23B5",
      UnderParenthesis: "\u23DD",
      Union: "\u22C3",
      UnionPlus: "\u228E",
      Uogon: "\u0172",
      uogon: "\u0173",
      Uopf: "\u{1D54C}",
      uopf: "\u{1D566}",
      UpArrow: "\u2191",
      Uparrow: "\u21D1",
      uparrow: "\u2191",
      UpArrowBar: "\u2912",
      UpArrowDownArrow: "\u21C5",
      UpDownArrow: "\u2195",
      Updownarrow: "\u21D5",
      updownarrow: "\u2195",
      UpEquilibrium: "\u296E",
      upharpoonleft: "\u21BF",
      upharpoonright: "\u21BE",
      uplus: "\u228E",
      UpperLeftArrow: "\u2196",
      UpperRightArrow: "\u2197",
      Upsi: "\u03D2",
      upsi: "\u03C5",
      upsih: "\u03D2",
      Upsilon: "\u03A5",
      upsilon: "\u03C5",
      UpTee: "\u22A5",
      UpTeeArrow: "\u21A5",
      upuparrows: "\u21C8",
      urcorn: "\u231D",
      urcorner: "\u231D",
      urcrop: "\u230E",
      Uring: "\u016E",
      uring: "\u016F",
      urtri: "\u25F9",
      Uscr: "\u{1D4B0}",
      uscr: "\u{1D4CA}",
      utdot: "\u22F0",
      Utilde: "\u0168",
      utilde: "\u0169",
      utri: "\u25B5",
      utrif: "\u25B4",
      uuarr: "\u21C8",
      Uuml: "\xDC",
      uuml: "\xFC",
      uwangle: "\u29A7",
      vangrt: "\u299C",
      varepsilon: "\u03F5",
      varkappa: "\u03F0",
      varnothing: "\u2205",
      varphi: "\u03D5",
      varpi: "\u03D6",
      varpropto: "\u221D",
      vArr: "\u21D5",
      varr: "\u2195",
      varrho: "\u03F1",
      varsigma: "\u03C2",
      varsubsetneq: "\u228A\uFE00",
      varsubsetneqq: "\u2ACB\uFE00",
      varsupsetneq: "\u228B\uFE00",
      varsupsetneqq: "\u2ACC\uFE00",
      vartheta: "\u03D1",
      vartriangleleft: "\u22B2",
      vartriangleright: "\u22B3",
      Vbar: "\u2AEB",
      vBar: "\u2AE8",
      vBarv: "\u2AE9",
      Vcy: "\u0412",
      vcy: "\u0432",
      VDash: "\u22AB",
      Vdash: "\u22A9",
      vDash: "\u22A8",
      vdash: "\u22A2",
      Vdashl: "\u2AE6",
      Vee: "\u22C1",
      vee: "\u2228",
      veebar: "\u22BB",
      veeeq: "\u225A",
      vellip: "\u22EE",
      Verbar: "\u2016",
      verbar: "|",
      Vert: "\u2016",
      vert: "|",
      VerticalBar: "\u2223",
      VerticalLine: "|",
      VerticalSeparator: "\u2758",
      VerticalTilde: "\u2240",
      VeryThinSpace: "\u200A",
      Vfr: "\u{1D519}",
      vfr: "\u{1D533}",
      vltri: "\u22B2",
      vnsub: "\u2282\u20D2",
      vnsup: "\u2283\u20D2",
      Vopf: "\u{1D54D}",
      vopf: "\u{1D567}",
      vprop: "\u221D",
      vrtri: "\u22B3",
      Vscr: "\u{1D4B1}",
      vscr: "\u{1D4CB}",
      vsubnE: "\u2ACB\uFE00",
      vsubne: "\u228A\uFE00",
      vsupnE: "\u2ACC\uFE00",
      vsupne: "\u228B\uFE00",
      Vvdash: "\u22AA",
      vzigzag: "\u299A",
      Wcirc: "\u0174",
      wcirc: "\u0175",
      wedbar: "\u2A5F",
      Wedge: "\u22C0",
      wedge: "\u2227",
      wedgeq: "\u2259",
      weierp: "\u2118",
      Wfr: "\u{1D51A}",
      wfr: "\u{1D534}",
      Wopf: "\u{1D54E}",
      wopf: "\u{1D568}",
      wp: "\u2118",
      wr: "\u2240",
      wreath: "\u2240",
      Wscr: "\u{1D4B2}",
      wscr: "\u{1D4CC}",
      xcap: "\u22C2",
      xcirc: "\u25EF",
      xcup: "\u22C3",
      xdtri: "\u25BD",
      Xfr: "\u{1D51B}",
      xfr: "\u{1D535}",
      xhArr: "\u27FA",
      xharr: "\u27F7",
      Xi: "\u039E",
      xi: "\u03BE",
      xlArr: "\u27F8",
      xlarr: "\u27F5",
      xmap: "\u27FC",
      xnis: "\u22FB",
      xodot: "\u2A00",
      Xopf: "\u{1D54F}",
      xopf: "\u{1D569}",
      xoplus: "\u2A01",
      xotime: "\u2A02",
      xrArr: "\u27F9",
      xrarr: "\u27F6",
      Xscr: "\u{1D4B3}",
      xscr: "\u{1D4CD}",
      xsqcup: "\u2A06",
      xuplus: "\u2A04",
      xutri: "\u25B3",
      xvee: "\u22C1",
      xwedge: "\u22C0",
      Yacute: "\xDD",
      yacute: "\xFD",
      YAcy: "\u042F",
      yacy: "\u044F",
      Ycirc: "\u0176",
      ycirc: "\u0177",
      Ycy: "\u042B",
      ycy: "\u044B",
      yen: "\xA5",
      Yfr: "\u{1D51C}",
      yfr: "\u{1D536}",
      YIcy: "\u0407",
      yicy: "\u0457",
      Yopf: "\u{1D550}",
      yopf: "\u{1D56A}",
      Yscr: "\u{1D4B4}",
      yscr: "\u{1D4CE}",
      YUcy: "\u042E",
      yucy: "\u044E",
      Yuml: "\u0178",
      yuml: "\xFF",
      Zacute: "\u0179",
      zacute: "\u017A",
      Zcaron: "\u017D",
      zcaron: "\u017E",
      Zcy: "\u0417",
      zcy: "\u0437",
      Zdot: "\u017B",
      zdot: "\u017C",
      zeetrf: "\u2128",
      ZeroWidthSpace: "\u200B",
      Zeta: "\u0396",
      zeta: "\u03B6",
      Zfr: "\u2128",
      zfr: "\u{1D537}",
      ZHcy: "\u0416",
      zhcy: "\u0436",
      zigrarr: "\u21DD",
      Zopf: "\u2124",
      zopf: "\u{1D56B}",
      Zscr: "\u{1D4B5}",
      zscr: "\u{1D4CF}",
      zwj: "\u200D",
      zwnj: "\u200C"
    });
    exports.entityMap = exports.HTML_ENTITIES;
  }
});

// ../node_modules/@xmldom/xmldom/lib/sax.js
var require_sax = __commonJS({
  "../node_modules/@xmldom/xmldom/lib/sax.js"(exports) {
    var NAMESPACE = require_conventions().NAMESPACE;
    var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
    var nameChar = new RegExp("[\\-\\.0-9" + nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
    var tagNamePattern = new RegExp("^" + nameStartChar.source + nameChar.source + "*(?::" + nameStartChar.source + nameChar.source + "*)?$");
    var S_TAG = 0;
    var S_ATTR = 1;
    var S_ATTR_SPACE = 2;
    var S_EQ = 3;
    var S_ATTR_NOQUOT_VALUE = 4;
    var S_ATTR_END = 5;
    var S_TAG_SPACE = 6;
    var S_TAG_CLOSE = 7;
    function ParseError(message, locator) {
      this.message = message;
      this.locator = locator;
      if (Error.captureStackTrace) Error.captureStackTrace(this, ParseError);
    }
    ParseError.prototype = new Error();
    ParseError.prototype.name = ParseError.name;
    function XMLReader() {
    }
    XMLReader.prototype = {
      parse: function(source, defaultNSMap, entityMap) {
        var domBuilder = this.domBuilder;
        domBuilder.startDocument();
        _copy(defaultNSMap, defaultNSMap = {});
        parse3(
          source,
          defaultNSMap,
          entityMap,
          domBuilder,
          this.errorHandler
        );
        domBuilder.endDocument();
      }
    };
    function parse3(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
      function fixedFromCharCode(code) {
        if (code > 65535) {
          code -= 65536;
          var surrogate1 = 55296 + (code >> 10), surrogate2 = 56320 + (code & 1023);
          return String.fromCharCode(surrogate1, surrogate2);
        } else {
          return String.fromCharCode(code);
        }
      }
      function entityReplacer(a2) {
        var k = a2.slice(1, -1);
        if (Object.hasOwnProperty.call(entityMap, k)) {
          return entityMap[k];
        } else if (k.charAt(0) === "#") {
          return fixedFromCharCode(parseInt(k.substr(1).replace("x", "0x")));
        } else {
          errorHandler.error("entity not found:" + a2);
          return a2;
        }
      }
      function appendText(end2) {
        if (end2 > start) {
          var xt = source.substring(start, end2).replace(/&#?\w+;/g, entityReplacer);
          locator && position(start);
          domBuilder.characters(xt, 0, end2 - start);
          start = end2;
        }
      }
      function position(p, m) {
        while (p >= lineEnd && (m = linePattern.exec(source))) {
          lineStart = m.index;
          lineEnd = lineStart + m[0].length;
          locator.lineNumber++;
        }
        locator.columnNumber = p - lineStart + 1;
      }
      var lineStart = 0;
      var lineEnd = 0;
      var linePattern = /.*(?:\r\n?|\n)|.*$/g;
      var locator = domBuilder.locator;
      var parseStack = [{ currentNSMap: defaultNSMapCopy }];
      var closeMap = {};
      var start = 0;
      while (true) {
        try {
          var tagStart = source.indexOf("<", start);
          if (tagStart < 0) {
            if (!source.substr(start).match(/^\s*$/)) {
              var doc = domBuilder.doc;
              var text = doc.createTextNode(source.substr(start));
              doc.appendChild(text);
              domBuilder.currentElement = text;
            }
            return;
          }
          if (tagStart > start) {
            appendText(tagStart);
          }
          switch (source.charAt(tagStart + 1)) {
            case "/":
              var end = source.indexOf(">", tagStart + 3);
              var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, "");
              var config = parseStack.pop();
              if (end < 0) {
                tagName = source.substring(tagStart + 2).replace(/[\s<].*/, "");
                errorHandler.error("end tag name: " + tagName + " is not complete:" + config.tagName);
                end = tagStart + 1 + tagName.length;
              } else if (tagName.match(/\s</)) {
                tagName = tagName.replace(/[\s<].*/, "");
                errorHandler.error("end tag name: " + tagName + " maybe not complete");
                end = tagStart + 1 + tagName.length;
              }
              var localNSMap = config.localNSMap;
              var endMatch = config.tagName == tagName;
              var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
              if (endIgnoreCaseMach) {
                domBuilder.endElement(config.uri, config.localName, tagName);
                if (localNSMap) {
                  for (var prefix in localNSMap) {
                    if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
                      domBuilder.endPrefixMapping(prefix);
                    }
                  }
                }
                if (!endMatch) {
                  errorHandler.fatalError("end tag name: " + tagName + " is not match the current start tagName:" + config.tagName);
                }
              } else {
                parseStack.push(config);
              }
              end++;
              break;
            // end elment
            case "?":
              locator && position(tagStart);
              end = parseInstruction(source, tagStart, domBuilder);
              break;
            case "!":
              locator && position(tagStart);
              end = parseDCC(source, tagStart, domBuilder, errorHandler);
              break;
            default:
              locator && position(tagStart);
              var el = new ElementAttributes();
              var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
              var end = parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
              var len = el.length;
              if (!el.closed && fixSelfClosed(source, end, el.tagName, closeMap)) {
                el.closed = true;
                if (!entityMap.nbsp) {
                  errorHandler.warning("unclosed xml attribute");
                }
              }
              if (locator && len) {
                var locator2 = copyLocator(locator, {});
                for (var i = 0; i < len; i++) {
                  var a = el[i];
                  position(a.offset);
                  a.locator = copyLocator(locator, {});
                }
                domBuilder.locator = locator2;
                if (appendElement(el, domBuilder, currentNSMap)) {
                  parseStack.push(el);
                }
                domBuilder.locator = locator;
              } else {
                if (appendElement(el, domBuilder, currentNSMap)) {
                  parseStack.push(el);
                }
              }
              if (NAMESPACE.isHTML(el.uri) && !el.closed) {
                end = parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
              } else {
                end++;
              }
          }
        } catch (e) {
          if (e instanceof ParseError) {
            throw e;
          }
          errorHandler.error("element parse error: " + e);
          end = -1;
        }
        if (end > start) {
          start = end;
        } else {
          appendText(Math.max(tagStart, start) + 1);
        }
      }
    }
    function copyLocator(f, t) {
      t.lineNumber = f.lineNumber;
      t.columnNumber = f.columnNumber;
      return t;
    }
    function parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
      function addAttribute(qname, value2, startIndex) {
        if (el.attributeNames.hasOwnProperty(qname)) {
          errorHandler.fatalError("Attribute " + qname + " redefined");
        }
        el.addValue(
          qname,
          // @see https://www.w3.org/TR/xml/#AVNormalize
          // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
          // - recursive replacement of (DTD) entity references
          // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
          value2.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, entityReplacer),
          startIndex
        );
      }
      var attrName;
      var value;
      var p = ++start;
      var s = S_TAG;
      while (true) {
        var c = source.charAt(p);
        switch (c) {
          case "=":
            if (s === S_ATTR) {
              attrName = source.slice(start, p);
              s = S_EQ;
            } else if (s === S_ATTR_SPACE) {
              s = S_EQ;
            } else {
              throw new Error("attribute equal must after attrName");
            }
            break;
          case "'":
          case '"':
            if (s === S_EQ || s === S_ATTR) {
              if (s === S_ATTR) {
                errorHandler.warning('attribute value must after "="');
                attrName = source.slice(start, p);
              }
              start = p + 1;
              p = source.indexOf(c, start);
              if (p > 0) {
                value = source.slice(start, p);
                addAttribute(attrName, value, start - 1);
                s = S_ATTR_END;
              } else {
                throw new Error("attribute value no end '" + c + "' match");
              }
            } else if (s == S_ATTR_NOQUOT_VALUE) {
              value = source.slice(start, p);
              addAttribute(attrName, value, start);
              errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ")!!");
              start = p + 1;
              s = S_ATTR_END;
            } else {
              throw new Error('attribute value must after "="');
            }
            break;
          case "/":
            switch (s) {
              case S_TAG:
                el.setTagName(source.slice(start, p));
              case S_ATTR_END:
              case S_TAG_SPACE:
              case S_TAG_CLOSE:
                s = S_TAG_CLOSE;
                el.closed = true;
              case S_ATTR_NOQUOT_VALUE:
              case S_ATTR:
                break;
              case S_ATTR_SPACE:
                el.closed = true;
                break;
              //case S_EQ:
              default:
                throw new Error("attribute invalid close char('/')");
            }
            break;
          case "":
            errorHandler.error("unexpected end of input");
            if (s == S_TAG) {
              el.setTagName(source.slice(start, p));
            }
            return p;
          case ">":
            switch (s) {
              case S_TAG:
                el.setTagName(source.slice(start, p));
              case S_ATTR_END:
              case S_TAG_SPACE:
              case S_TAG_CLOSE:
                break;
              //normal
              case S_ATTR_NOQUOT_VALUE:
              //Compatible state
              case S_ATTR:
                value = source.slice(start, p);
                if (value.slice(-1) === "/") {
                  el.closed = true;
                  value = value.slice(0, -1);
                }
              case S_ATTR_SPACE:
                if (s === S_ATTR_SPACE) {
                  value = attrName;
                }
                if (s == S_ATTR_NOQUOT_VALUE) {
                  errorHandler.warning('attribute "' + value + '" missed quot(")!');
                  addAttribute(attrName, value, start);
                } else {
                  if (!NAMESPACE.isHTML(currentNSMap[""]) || !value.match(/^(?:disabled|checked|selected)$/i)) {
                    errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
                  }
                  addAttribute(value, value, start);
                }
                break;
              case S_EQ:
                throw new Error("attribute value missed!!");
            }
            return p;
          /*xml space '\x20' | #x9 | #xD | #xA; */
          case "\x80":
            c = " ";
          default:
            if (c <= " ") {
              switch (s) {
                case S_TAG:
                  el.setTagName(source.slice(start, p));
                  s = S_TAG_SPACE;
                  break;
                case S_ATTR:
                  attrName = source.slice(start, p);
                  s = S_ATTR_SPACE;
                  break;
                case S_ATTR_NOQUOT_VALUE:
                  var value = source.slice(start, p);
                  errorHandler.warning('attribute "' + value + '" missed quot(")!!');
                  addAttribute(attrName, value, start);
                case S_ATTR_END:
                  s = S_TAG_SPACE;
                  break;
              }
            } else {
              switch (s) {
                //case S_TAG:void();break;
                //case S_ATTR:void();break;
                //case S_ATTR_NOQUOT_VALUE:void();break;
                case S_ATTR_SPACE:
                  var tagName = el.tagName;
                  if (!NAMESPACE.isHTML(currentNSMap[""]) || !attrName.match(/^(?:disabled|checked|selected)$/i)) {
                    errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
                  }
                  addAttribute(attrName, attrName, start);
                  start = p;
                  s = S_ATTR;
                  break;
                case S_ATTR_END:
                  errorHandler.warning('attribute space is required"' + attrName + '"!!');
                case S_TAG_SPACE:
                  s = S_ATTR;
                  start = p;
                  break;
                case S_EQ:
                  s = S_ATTR_NOQUOT_VALUE;
                  start = p;
                  break;
                case S_TAG_CLOSE:
                  throw new Error("elements closed character '/' and '>' must be connected to");
              }
            }
        }
        p++;
      }
    }
    function appendElement(el, domBuilder, currentNSMap) {
      var tagName = el.tagName;
      var localNSMap = null;
      var i = el.length;
      while (i--) {
        var a = el[i];
        var qName = a.qName;
        var value = a.value;
        var nsp = qName.indexOf(":");
        if (nsp > 0) {
          var prefix = a.prefix = qName.slice(0, nsp);
          var localName = qName.slice(nsp + 1);
          var nsPrefix = prefix === "xmlns" && localName;
        } else {
          localName = qName;
          prefix = null;
          nsPrefix = qName === "xmlns" && "";
        }
        a.localName = localName;
        if (nsPrefix !== false) {
          if (localNSMap == null) {
            localNSMap = {};
            _copy(currentNSMap, currentNSMap = {});
          }
          currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
          a.uri = NAMESPACE.XMLNS;
          domBuilder.startPrefixMapping(nsPrefix, value);
        }
      }
      var i = el.length;
      while (i--) {
        a = el[i];
        var prefix = a.prefix;
        if (prefix) {
          if (prefix === "xml") {
            a.uri = NAMESPACE.XML;
          }
          if (prefix !== "xmlns") {
            a.uri = currentNSMap[prefix || ""];
          }
        }
      }
      var nsp = tagName.indexOf(":");
      if (nsp > 0) {
        prefix = el.prefix = tagName.slice(0, nsp);
        localName = el.localName = tagName.slice(nsp + 1);
      } else {
        prefix = null;
        localName = el.localName = tagName;
      }
      var ns3 = el.uri = currentNSMap[prefix || ""];
      domBuilder.startElement(ns3, localName, tagName, el);
      if (el.closed) {
        domBuilder.endElement(ns3, localName, tagName);
        if (localNSMap) {
          for (prefix in localNSMap) {
            if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
              domBuilder.endPrefixMapping(prefix);
            }
          }
        }
      } else {
        el.currentNSMap = currentNSMap;
        el.localNSMap = localNSMap;
        return true;
      }
    }
    function parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
      if (/^(?:script|textarea)$/i.test(tagName)) {
        var elEndStart = source.indexOf("</" + tagName + ">", elStartEnd);
        var text = source.substring(elStartEnd + 1, elEndStart);
        if (/[&<]/.test(text)) {
          if (/^script$/i.test(tagName)) {
            domBuilder.characters(text, 0, text.length);
            return elEndStart;
          }
          text = text.replace(/&#?\w+;/g, entityReplacer);
          domBuilder.characters(text, 0, text.length);
          return elEndStart;
        }
      }
      return elStartEnd + 1;
    }
    function fixSelfClosed(source, elStartEnd, tagName, closeMap) {
      var pos = closeMap[tagName];
      if (pos == null) {
        pos = source.lastIndexOf("</" + tagName + ">");
        if (pos < elStartEnd) {
          pos = source.lastIndexOf("</" + tagName);
        }
        closeMap[tagName] = pos;
      }
      return pos < elStartEnd;
    }
    function _copy(source, target) {
      for (var n in source) {
        if (Object.prototype.hasOwnProperty.call(source, n)) {
          target[n] = source[n];
        }
      }
    }
    function parseDCC(source, start, domBuilder, errorHandler) {
      var next = source.charAt(start + 2);
      switch (next) {
        case "-":
          if (source.charAt(start + 3) === "-") {
            var end = source.indexOf("-->", start + 4);
            if (end > start) {
              domBuilder.comment(source, start + 4, end - start - 4);
              return end + 3;
            } else {
              errorHandler.error("Unclosed comment");
              return -1;
            }
          } else {
            return -1;
          }
        default:
          if (source.substr(start + 3, 6) == "CDATA[") {
            var end = source.indexOf("]]>", start + 9);
            domBuilder.startCDATA();
            domBuilder.characters(source, start + 9, end - start - 9);
            domBuilder.endCDATA();
            return end + 3;
          }
          var matchs = split(source, start);
          var len = matchs.length;
          if (len > 1 && /!doctype/i.test(matchs[0][0])) {
            var name = matchs[1][0];
            var pubid = false;
            var sysid = false;
            if (len > 3) {
              if (/^public$/i.test(matchs[2][0])) {
                pubid = matchs[3][0];
                sysid = len > 4 && matchs[4][0];
              } else if (/^system$/i.test(matchs[2][0])) {
                sysid = matchs[3][0];
              }
            }
            var lastMatch = matchs[len - 1];
            domBuilder.startDTD(name, pubid, sysid);
            domBuilder.endDTD();
            return lastMatch.index + lastMatch[0].length;
          }
      }
      return -1;
    }
    function parseInstruction(source, start, domBuilder) {
      var end = source.indexOf("?>", start);
      if (end) {
        var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
        if (match) {
          var len = match[0].length;
          domBuilder.processingInstruction(match[1], match[2]);
          return end + 2;
        } else {
          return -1;
        }
      }
      return -1;
    }
    function ElementAttributes() {
      this.attributeNames = {};
    }
    ElementAttributes.prototype = {
      setTagName: function(tagName) {
        if (!tagNamePattern.test(tagName)) {
          throw new Error("invalid tagName:" + tagName);
        }
        this.tagName = tagName;
      },
      addValue: function(qName, value, offset) {
        if (!tagNamePattern.test(qName)) {
          throw new Error("invalid attribute:" + qName);
        }
        this.attributeNames[qName] = this.length;
        this[this.length++] = { qName, value, offset };
      },
      length: 0,
      getLocalName: function(i) {
        return this[i].localName;
      },
      getLocator: function(i) {
        return this[i].locator;
      },
      getQName: function(i) {
        return this[i].qName;
      },
      getURI: function(i) {
        return this[i].uri;
      },
      getValue: function(i) {
        return this[i].value;
      }
      //	,getIndex:function(uri, localName)){
      //		if(localName){
      //
      //		}else{
      //			var qName = uri
      //		}
      //	},
      //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
      //	getType:function(uri,localName){}
      //	getType:function(i){},
    };
    function split(source, start) {
      var match;
      var buf = [];
      var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
      reg.lastIndex = start;
      reg.exec(source);
      while (match = reg.exec(source)) {
        buf.push(match);
        if (match[1]) return buf;
      }
    }
    exports.XMLReader = XMLReader;
    exports.ParseError = ParseError;
  }
});

// ../node_modules/@xmldom/xmldom/lib/dom-parser.js
var require_dom_parser = __commonJS({
  "../node_modules/@xmldom/xmldom/lib/dom-parser.js"(exports) {
    var conventions = require_conventions();
    var dom = require_dom();
    var entities = require_entities();
    var sax = require_sax();
    var DOMImplementation = dom.DOMImplementation;
    var NAMESPACE = conventions.NAMESPACE;
    var ParseError = sax.ParseError;
    var XMLReader = sax.XMLReader;
    function normalizeLineEndings(input) {
      return input.replace(/\r[\n\u0085]/g, "\n").replace(/[\r\u0085\u2028]/g, "\n");
    }
    function DOMParser2(options) {
      this.options = options || { locator: {} };
    }
    DOMParser2.prototype.parseFromString = function(source, mimeType) {
      var options = this.options;
      var sax2 = new XMLReader();
      var domBuilder = options.domBuilder || new DOMHandler();
      var errorHandler = options.errorHandler;
      var locator = options.locator;
      var defaultNSMap = options.xmlns || {};
      var isHTML = /\/x?html?$/.test(mimeType);
      var entityMap = isHTML ? entities.HTML_ENTITIES : entities.XML_ENTITIES;
      if (locator) {
        domBuilder.setDocumentLocator(locator);
      }
      sax2.errorHandler = buildErrorHandler(errorHandler, domBuilder, locator);
      sax2.domBuilder = options.domBuilder || domBuilder;
      if (isHTML) {
        defaultNSMap[""] = NAMESPACE.HTML;
      }
      defaultNSMap.xml = defaultNSMap.xml || NAMESPACE.XML;
      var normalize = options.normalizeLineEndings || normalizeLineEndings;
      if (source && typeof source === "string") {
        sax2.parse(
          normalize(source),
          defaultNSMap,
          entityMap
        );
      } else {
        sax2.errorHandler.error("invalid doc source");
      }
      return domBuilder.doc;
    };
    function buildErrorHandler(errorImpl, domBuilder, locator) {
      if (!errorImpl) {
        if (domBuilder instanceof DOMHandler) {
          return domBuilder;
        }
        errorImpl = domBuilder;
      }
      var errorHandler = {};
      var isCallback = errorImpl instanceof Function;
      locator = locator || {};
      function build(key) {
        var fn = errorImpl[key];
        if (!fn && isCallback) {
          fn = errorImpl.length == 2 ? function(msg2) {
            errorImpl(key, msg2);
          } : errorImpl;
        }
        errorHandler[key] = fn && function(msg2) {
          fn("[xmldom " + key + "]	" + msg2 + _locator(locator));
        } || function() {
        };
      }
      build("warning");
      build("error");
      build("fatalError");
      return errorHandler;
    }
    function DOMHandler() {
      this.cdata = false;
    }
    function position(locator, node) {
      node.lineNumber = locator.lineNumber;
      node.columnNumber = locator.columnNumber;
    }
    DOMHandler.prototype = {
      startDocument: function() {
        this.doc = new DOMImplementation().createDocument(null, null, null);
        if (this.locator) {
          this.doc.documentURI = this.locator.systemId;
        }
      },
      startElement: function(namespaceURI, localName, qName, attrs) {
        var doc = this.doc;
        var el = doc.createElementNS(namespaceURI, qName || localName);
        var len = attrs.length;
        appendElement(this, el);
        this.currentElement = el;
        this.locator && position(this.locator, el);
        for (var i = 0; i < len; i++) {
          var namespaceURI = attrs.getURI(i);
          var value = attrs.getValue(i);
          var qName = attrs.getQName(i);
          var attr = doc.createAttributeNS(namespaceURI, qName);
          this.locator && position(attrs.getLocator(i), attr);
          attr.value = attr.nodeValue = value;
          el.setAttributeNode(attr);
        }
      },
      endElement: function(namespaceURI, localName, qName) {
        var current = this.currentElement;
        var tagName = current.tagName;
        this.currentElement = current.parentNode;
      },
      startPrefixMapping: function(prefix, uri) {
      },
      endPrefixMapping: function(prefix) {
      },
      processingInstruction: function(target, data) {
        var ins = this.doc.createProcessingInstruction(target, data);
        this.locator && position(this.locator, ins);
        appendElement(this, ins);
      },
      ignorableWhitespace: function(ch, start, length) {
      },
      characters: function(chars, start, length) {
        chars = _toString.apply(this, arguments);
        if (chars) {
          if (this.cdata) {
            var charNode = this.doc.createCDATASection(chars);
          } else {
            var charNode = this.doc.createTextNode(chars);
          }
          if (this.currentElement) {
            this.currentElement.appendChild(charNode);
          } else if (/^\s*$/.test(chars)) {
            this.doc.appendChild(charNode);
          }
          this.locator && position(this.locator, charNode);
        }
      },
      skippedEntity: function(name) {
      },
      endDocument: function() {
        this.doc.normalize();
      },
      setDocumentLocator: function(locator) {
        if (this.locator = locator) {
          locator.lineNumber = 0;
        }
      },
      //LexicalHandler
      comment: function(chars, start, length) {
        chars = _toString.apply(this, arguments);
        var comm = this.doc.createComment(chars);
        this.locator && position(this.locator, comm);
        appendElement(this, comm);
      },
      startCDATA: function() {
        this.cdata = true;
      },
      endCDATA: function() {
        this.cdata = false;
      },
      startDTD: function(name, publicId, systemId) {
        var impl = this.doc.implementation;
        if (impl && impl.createDocumentType) {
          var dt = impl.createDocumentType(name, publicId, systemId);
          this.locator && position(this.locator, dt);
          appendElement(this, dt);
          this.doc.doctype = dt;
        }
      },
      /**
       * @see org.xml.sax.ErrorHandler
       * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
       */
      warning: function(error2) {
        console.warn("[xmldom warning]	" + error2, _locator(this.locator));
      },
      error: function(error2) {
        console.error("[xmldom error]	" + error2, _locator(this.locator));
      },
      fatalError: function(error2) {
        throw new ParseError(error2, this.locator);
      }
    };
    function _locator(l) {
      if (l) {
        return "\n@" + (l.systemId || "") + "#[line:" + l.lineNumber + ",col:" + l.columnNumber + "]";
      }
    }
    function _toString(chars, start, length) {
      if (typeof chars == "string") {
        return chars.substr(start, length);
      } else {
        if (chars.length >= start + length || start) {
          return new java.lang.String(chars, start, length) + "";
        }
        return chars;
      }
    }
    "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(key) {
      DOMHandler.prototype[key] = function() {
        return null;
      };
    });
    function appendElement(hander, node) {
      if (!hander.currentElement) {
        hander.doc.appendChild(node);
      } else {
        hander.currentElement.appendChild(node);
      }
    }
    exports.__DOMHandler = DOMHandler;
    exports.normalizeLineEndings = normalizeLineEndings;
    exports.DOMParser = DOMParser2;
  }
});

// ../node_modules/@xmldom/xmldom/lib/index.js
var require_lib = __commonJS({
  "../node_modules/@xmldom/xmldom/lib/index.js"(exports) {
    var dom = require_dom();
    exports.DOMImplementation = dom.DOMImplementation;
    exports.XMLSerializer = dom.XMLSerializer;
    exports.DOMParser = require_dom_parser().DOMParser;
  }
});

// ../node_modules/solid-namespace/index.js
var require_solid_namespace = __commonJS({
  "../node_modules/solid-namespace/index.js"(exports, module2) {
    var aliases = {
      acl: "http://www.w3.org/ns/auth/acl#",
      arg: "http://www.w3.org/ns/pim/arg#",
      as: "https://www.w3.org/ns/activitystreams#",
      cal: "http://www.w3.org/2002/12/cal/ical#",
      cert: "http://www.w3.org/ns/auth/cert#",
      contact: "http://www.w3.org/2000/10/swap/pim/contact#",
      dc: "http://purl.org/dc/elements/1.1/",
      dct: "http://purl.org/dc/terms/",
      doap: "http://usefulinc.com/ns/doap#",
      foaf: "http://xmlns.com/foaf/0.1/",
      geo: "http://www.w3.org/2003/01/geo/wgs84_pos#",
      gpx: "http://www.w3.org/ns/pim/gpx#",
      http: "http://www.w3.org/2007/ont/http#",
      httph: "http://www.w3.org/2007/ont/httph#",
      icalTZ: "http://www.w3.org/2002/12/cal/icaltzd#",
      // Beware: not cal:
      ldp: "http://www.w3.org/ns/ldp#",
      link: "http://www.w3.org/2007/ont/link#",
      log: "http://www.w3.org/2000/10/swap/log#",
      meeting: "http://www.w3.org/ns/pim/meeting#",
      mo: "http://purl.org/ontology/mo/",
      org: "http://www.w3.org/ns/org#",
      owl: "http://www.w3.org/2002/07/owl#",
      pad: "http://www.w3.org/ns/pim/pad#",
      patch: "http://www.w3.org/ns/pim/patch#",
      prov: "http://www.w3.org/ns/prov#",
      qu: "http://www.w3.org/2000/10/swap/pim/qif#",
      trip: "http://www.w3.org/ns/pim/trip#",
      rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
      rdfs: "http://www.w3.org/2000/01/rdf-schema#",
      rss: "http://purl.org/rss/1.0/",
      sched: "http://www.w3.org/ns/pim/schedule#",
      schema: "http://schema.org/",
      // @@ beware confusion with documents no 303
      sioc: "http://rdfs.org/sioc/ns#",
      solid: "http://www.w3.org/ns/solid/terms#",
      space: "http://www.w3.org/ns/pim/space#",
      stat: "http://www.w3.org/ns/posix/stat#",
      tab: "http://www.w3.org/2007/ont/link#",
      tabont: "http://www.w3.org/2007/ont/link#",
      ui: "http://www.w3.org/ns/ui#",
      vcard: "http://www.w3.org/2006/vcard/ns#",
      wf: "http://www.w3.org/2005/01/wf/flow#",
      xsd: "http://www.w3.org/2001/XMLSchema#",
      cco: "http://www.ontologyrepository.com/CommonCoreOntologies/",
      skos: "http://www.w3.org/2004/02/skos/core#",
      bookmark: "http://www.w3.org/2002/01/bookmark#",
      vann: "http://purl.org/vocab/vann/"
    };
    function vocab(rdf3 = { namedNode: (u) => u }) {
      const namespaces = {};
      for (const alias in aliases) {
        const expansion = aliases[alias];
        namespaces[alias] = function(localName = "") {
          return rdf3.namedNode(expansion + localName);
        };
      }
      ;
      return namespaces;
    }
    module2.exports = vocab;
  }
});

// ../node_modules/url/node_modules/punycode/punycode.js
var require_punycode = __commonJS({
  "../node_modules/url/node_modules/punycode/punycode.js"(exports, module2) {
    (function(root) {
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = typeof module2 == "object" && module2 && !module2.nodeType && module2;
      var freeGlobal = typeof global == "object" && global;
      if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
        root = freeGlobal;
      }
      var punycode, maxInt = 2147483647, base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
      }, baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode3 = String.fromCharCode, key;
      function error2(type) {
        throw new RangeError(errors[type]);
      }
      function map(array, fn) {
        var length = array.length;
        var result = [];
        while (length--) {
          result[length] = fn(array[length]);
        }
        return result;
      }
      function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
          result = parts[0] + "@";
          string = parts[1];
        }
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
      }
      function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while (counter < length) {
          value = string.charCodeAt(counter++);
          if (value >= 55296 && value <= 56319 && counter < length) {
            extra = string.charCodeAt(counter++);
            if ((extra & 64512) == 56320) {
              output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
            } else {
              output.push(value);
              counter--;
            }
          } else {
            output.push(value);
          }
        }
        return output;
      }
      function ucs2encode(array) {
        return map(array, function(value) {
          var output = "";
          if (value > 65535) {
            value -= 65536;
            output += stringFromCharCode3(value >>> 10 & 1023 | 55296);
            value = 56320 | value & 1023;
          }
          output += stringFromCharCode3(value);
          return output;
        }).join("");
      }
      function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) {
          return codePoint - 22;
        }
        if (codePoint - 65 < 26) {
          return codePoint - 65;
        }
        if (codePoint - 97 < 26) {
          return codePoint - 97;
        }
        return base;
      }
      function digitToBasic(digit, flag) {
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
      }
      function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for (; delta > baseMinusTMin * tMax >> 1; k += base) {
          delta = floor(delta / baseMinusTMin);
        }
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
      }
      function decode2(input) {
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, baseMinusT;
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) {
          basic = 0;
        }
        for (j = 0; j < basic; ++j) {
          if (input.charCodeAt(j) >= 128) {
            error2("not-basic");
          }
          output.push(input.charCodeAt(j));
        }
        for (index = basic > 0 ? basic + 1 : 0; index < inputLength; ) {
          for (oldi = i, w = 1, k = base; ; k += base) {
            if (index >= inputLength) {
              error2("invalid-input");
            }
            digit = basicToDigit(input.charCodeAt(index++));
            if (digit >= base || digit > floor((maxInt - i) / w)) {
              error2("overflow");
            }
            i += digit * w;
            t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
            if (digit < t) {
              break;
            }
            baseMinusT = base - t;
            if (w > floor(maxInt / baseMinusT)) {
              error2("overflow");
            }
            w *= baseMinusT;
          }
          out = output.length + 1;
          bias = adapt(i - oldi, out, oldi == 0);
          if (floor(i / out) > maxInt - n) {
            error2("overflow");
          }
          n += floor(i / out);
          i %= out;
          output.splice(i++, 0, n);
        }
        return ucs2encode(output);
      }
      function encode2(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], inputLength, handledCPCountPlusOne, baseMinusT, qMinusT;
        input = ucs2decode(input);
        inputLength = input.length;
        n = initialN;
        delta = 0;
        bias = initialBias;
        for (j = 0; j < inputLength; ++j) {
          currentValue = input[j];
          if (currentValue < 128) {
            output.push(stringFromCharCode3(currentValue));
          }
        }
        handledCPCount = basicLength = output.length;
        if (basicLength) {
          output.push(delimiter);
        }
        while (handledCPCount < inputLength) {
          for (m = maxInt, j = 0; j < inputLength; ++j) {
            currentValue = input[j];
            if (currentValue >= n && currentValue < m) {
              m = currentValue;
            }
          }
          handledCPCountPlusOne = handledCPCount + 1;
          if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
            error2("overflow");
          }
          delta += (m - n) * handledCPCountPlusOne;
          n = m;
          for (j = 0; j < inputLength; ++j) {
            currentValue = input[j];
            if (currentValue < n && ++delta > maxInt) {
              error2("overflow");
            }
            if (currentValue == n) {
              for (q = delta, k = base; ; k += base) {
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (q < t) {
                  break;
                }
                qMinusT = q - t;
                baseMinusT = base - t;
                output.push(
                  stringFromCharCode3(digitToBasic(t + qMinusT % baseMinusT, 0))
                );
                q = floor(qMinusT / baseMinusT);
              }
              output.push(stringFromCharCode3(digitToBasic(q, 0)));
              bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
              delta = 0;
              ++handledCPCount;
            }
          }
          ++delta;
          ++n;
        }
        return output.join("");
      }
      function toUnicode(input) {
        return mapDomain(input, function(string) {
          return regexPunycode.test(string) ? decode2(string.slice(4).toLowerCase()) : string;
        });
      }
      function toASCII(input) {
        return mapDomain(input, function(string) {
          return regexNonASCII.test(string) ? "xn--" + encode2(string) : string;
        });
      }
      punycode = {
        /**
         * A string representing the current Punycode.js version number.
         * @memberOf punycode
         * @type String
         */
        "version": "1.4.1",
        /**
         * An object of methods to convert from JavaScript's internal character
         * representation (UCS-2) to Unicode code points, and back.
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode
         * @type Object
         */
        "ucs2": {
          "decode": ucs2decode,
          "encode": ucs2encode
        },
        "decode": decode2,
        "encode": encode2,
        "toASCII": toASCII,
        "toUnicode": toUnicode
      };
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        define("punycode", function() {
          return punycode;
        });
      } else if (freeExports && freeModule) {
        if (module2.exports == freeExports) {
          freeModule.exports = punycode;
        } else {
          for (key in punycode) {
            punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
          }
        }
      } else {
        root.punycode = punycode;
      }
    })(exports);
  }
});

// ../node_modules/es-errors/index.js
var require_es_errors = __commonJS({
  "../node_modules/es-errors/index.js"(exports, module2) {
    "use strict";
    module2.exports = Error;
  }
});

// ../node_modules/es-errors/eval.js
var require_eval = __commonJS({
  "../node_modules/es-errors/eval.js"(exports, module2) {
    "use strict";
    module2.exports = EvalError;
  }
});

// ../node_modules/es-errors/range.js
var require_range = __commonJS({
  "../node_modules/es-errors/range.js"(exports, module2) {
    "use strict";
    module2.exports = RangeError;
  }
});

// ../node_modules/es-errors/ref.js
var require_ref = __commonJS({
  "../node_modules/es-errors/ref.js"(exports, module2) {
    "use strict";
    module2.exports = ReferenceError;
  }
});

// ../node_modules/es-errors/syntax.js
var require_syntax = __commonJS({
  "../node_modules/es-errors/syntax.js"(exports, module2) {
    "use strict";
    module2.exports = SyntaxError;
  }
});

// ../node_modules/es-errors/type.js
var require_type = __commonJS({
  "../node_modules/es-errors/type.js"(exports, module2) {
    "use strict";
    module2.exports = TypeError;
  }
});

// ../node_modules/es-errors/uri.js
var require_uri = __commonJS({
  "../node_modules/es-errors/uri.js"(exports, module2) {
    "use strict";
    module2.exports = URIError;
  }
});

// ../node_modules/has-symbols/shams.js
var require_shams = __commonJS({
  "../node_modules/has-symbols/shams.js"(exports, module2) {
    "use strict";
    module2.exports = function hasSymbols() {
      if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
        return false;
      }
      if (typeof Symbol.iterator === "symbol") {
        return true;
      }
      var obj = {};
      var sym = Symbol("test");
      var symObj = Object(sym);
      if (typeof sym === "string") {
        return false;
      }
      if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
        return false;
      }
      if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
        return false;
      }
      var symVal = 42;
      obj[sym] = symVal;
      for (sym in obj) {
        return false;
      }
      if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
        return false;
      }
      if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
        return false;
      }
      var syms = Object.getOwnPropertySymbols(obj);
      if (syms.length !== 1 || syms[0] !== sym) {
        return false;
      }
      if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
        return false;
      }
      if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) {
          return false;
        }
      }
      return true;
    };
  }
});

// ../node_modules/has-symbols/index.js
var require_has_symbols = __commonJS({
  "../node_modules/has-symbols/index.js"(exports, module2) {
    "use strict";
    var origSymbol = typeof Symbol !== "undefined" && Symbol;
    var hasSymbolSham = require_shams();
    module2.exports = function hasNativeSymbols() {
      if (typeof origSymbol !== "function") {
        return false;
      }
      if (typeof Symbol !== "function") {
        return false;
      }
      if (typeof origSymbol("foo") !== "symbol") {
        return false;
      }
      if (typeof Symbol("bar") !== "symbol") {
        return false;
      }
      return hasSymbolSham();
    };
  }
});

// ../node_modules/has-proto/index.js
var require_has_proto = __commonJS({
  "../node_modules/has-proto/index.js"(exports, module2) {
    "use strict";
    var test = {
      __proto__: null,
      foo: {}
    };
    var $Object = Object;
    module2.exports = function hasProto() {
      return { __proto__: test }.foo === test.foo && !(test instanceof $Object);
    };
  }
});

// ../node_modules/function-bind/implementation.js
var require_implementation = __commonJS({
  "../node_modules/function-bind/implementation.js"(exports, module2) {
    "use strict";
    var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
    var toStr = Object.prototype.toString;
    var max = Math.max;
    var funcType = "[object Function]";
    var concatty = function concatty2(a, b) {
      var arr = [];
      for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
      }
      for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
      }
      return arr;
    };
    var slicy = function slicy2(arrLike, offset) {
      var arr = [];
      for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
      }
      return arr;
    };
    var joiny = function(arr, joiner) {
      var str = "";
      for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
          str += joiner;
        }
      }
      return str;
    };
    module2.exports = function bind(that) {
      var target = this;
      if (typeof target !== "function" || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
      }
      var args = slicy(arguments, 1);
      var bound;
      var binder = function() {
        if (this instanceof bound) {
          var result = target.apply(
            this,
            concatty(args, arguments)
          );
          if (Object(result) === result) {
            return result;
          }
          return this;
        }
        return target.apply(
          that,
          concatty(args, arguments)
        );
      };
      var boundLength = max(0, target.length - args.length);
      var boundArgs = [];
      for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = "$" + i;
      }
      bound = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
      if (target.prototype) {
        var Empty = function Empty2() {
        };
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
      }
      return bound;
    };
  }
});

// ../node_modules/function-bind/index.js
var require_function_bind = __commonJS({
  "../node_modules/function-bind/index.js"(exports, module2) {
    "use strict";
    var implementation = require_implementation();
    module2.exports = Function.prototype.bind || implementation;
  }
});

// ../node_modules/hasown/index.js
var require_hasown = __commonJS({
  "../node_modules/hasown/index.js"(exports, module2) {
    "use strict";
    var call = Function.prototype.call;
    var $hasOwn = Object.prototype.hasOwnProperty;
    var bind = require_function_bind();
    module2.exports = bind.call(call, $hasOwn);
  }
});

// ../node_modules/get-intrinsic/index.js
var require_get_intrinsic = __commonJS({
  "../node_modules/get-intrinsic/index.js"(exports, module2) {
    "use strict";
    var undefined2;
    var $Error = require_es_errors();
    var $EvalError = require_eval();
    var $RangeError = require_range();
    var $ReferenceError = require_ref();
    var $SyntaxError = require_syntax();
    var $TypeError = require_type();
    var $URIError = require_uri();
    var $Function = Function;
    var getEvalledConstructor = function(expressionSyntax) {
      try {
        return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
      } catch (e) {
      }
    };
    var $gOPD = Object.getOwnPropertyDescriptor;
    if ($gOPD) {
      try {
        $gOPD({}, "");
      } catch (e) {
        $gOPD = null;
      }
    }
    var throwTypeError = function() {
      throw new $TypeError();
    };
    var ThrowTypeError = $gOPD ? function() {
      try {
        arguments.callee;
        return throwTypeError;
      } catch (calleeThrows) {
        try {
          return $gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
          return throwTypeError;
        }
      }
    }() : throwTypeError;
    var hasSymbols = require_has_symbols()();
    var hasProto = require_has_proto()();
    var getProto = Object.getPrototypeOf || (hasProto ? function(x) {
      return x.__proto__;
    } : null);
    var needsEval = {};
    var TypedArray = typeof Uint8Array === "undefined" || !getProto ? undefined2 : getProto(Uint8Array);
    var INTRINSICS = {
      __proto__: null,
      "%AggregateError%": typeof AggregateError === "undefined" ? undefined2 : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined2 : ArrayBuffer,
      "%ArrayIteratorPrototype%": hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined2,
      "%AsyncFromSyncIteratorPrototype%": undefined2,
      "%AsyncFunction%": needsEval,
      "%AsyncGenerator%": needsEval,
      "%AsyncGeneratorFunction%": needsEval,
      "%AsyncIteratorPrototype%": needsEval,
      "%Atomics%": typeof Atomics === "undefined" ? undefined2 : Atomics,
      "%BigInt%": typeof BigInt === "undefined" ? undefined2 : BigInt,
      "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined2 : BigInt64Array,
      "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined2 : BigUint64Array,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView === "undefined" ? undefined2 : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": $Error,
      "%eval%": eval,
      // eslint-disable-line no-eval
      "%EvalError%": $EvalError,
      "%Float32Array%": typeof Float32Array === "undefined" ? undefined2 : Float32Array,
      "%Float64Array%": typeof Float64Array === "undefined" ? undefined2 : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined2 : FinalizationRegistry,
      "%Function%": $Function,
      "%GeneratorFunction%": needsEval,
      "%Int8Array%": typeof Int8Array === "undefined" ? undefined2 : Int8Array,
      "%Int16Array%": typeof Int16Array === "undefined" ? undefined2 : Int16Array,
      "%Int32Array%": typeof Int32Array === "undefined" ? undefined2 : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined2,
      "%JSON%": typeof JSON === "object" ? JSON : undefined2,
      "%Map%": typeof Map === "undefined" ? undefined2 : Map,
      "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols || !getProto ? undefined2 : getProto((/* @__PURE__ */ new Map())[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise === "undefined" ? undefined2 : Promise,
      "%Proxy%": typeof Proxy === "undefined" ? undefined2 : Proxy,
      "%RangeError%": $RangeError,
      "%ReferenceError%": $ReferenceError,
      "%Reflect%": typeof Reflect === "undefined" ? undefined2 : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set === "undefined" ? undefined2 : Set,
      "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols || !getProto ? undefined2 : getProto((/* @__PURE__ */ new Set())[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined2 : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": hasSymbols && getProto ? getProto(""[Symbol.iterator]()) : undefined2,
      "%Symbol%": hasSymbols ? Symbol : undefined2,
      "%SyntaxError%": $SyntaxError,
      "%ThrowTypeError%": ThrowTypeError,
      "%TypedArray%": TypedArray,
      "%TypeError%": $TypeError,
      "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined2 : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined2 : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined2 : Uint16Array,
      "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined2 : Uint32Array,
      "%URIError%": $URIError,
      "%WeakMap%": typeof WeakMap === "undefined" ? undefined2 : WeakMap,
      "%WeakRef%": typeof WeakRef === "undefined" ? undefined2 : WeakRef,
      "%WeakSet%": typeof WeakSet === "undefined" ? undefined2 : WeakSet
    };
    if (getProto) {
      try {
        null.error;
      } catch (e) {
        errorProto = getProto(getProto(e));
        INTRINSICS["%Error.prototype%"] = errorProto;
      }
    }
    var errorProto;
    var doEval = function doEval2(name) {
      var value;
      if (name === "%AsyncFunction%") {
        value = getEvalledConstructor("async function () {}");
      } else if (name === "%GeneratorFunction%") {
        value = getEvalledConstructor("function* () {}");
      } else if (name === "%AsyncGeneratorFunction%") {
        value = getEvalledConstructor("async function* () {}");
      } else if (name === "%AsyncGenerator%") {
        var fn = doEval2("%AsyncGeneratorFunction%");
        if (fn) {
          value = fn.prototype;
        }
      } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval2("%AsyncGenerator%");
        if (gen && getProto) {
          value = getProto(gen.prototype);
        }
      }
      INTRINSICS[name] = value;
      return value;
    };
    var LEGACY_ALIASES = {
      __proto__: null,
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    };
    var bind = require_function_bind();
    var hasOwn = require_hasown();
    var $concat = bind.call(Function.call, Array.prototype.concat);
    var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
    var $replace = bind.call(Function.call, String.prototype.replace);
    var $strSlice = bind.call(Function.call, String.prototype.slice);
    var $exec = bind.call(Function.call, RegExp.prototype.exec);
    var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
    var reEscapeChar = /\\(\\)?/g;
    var stringToPath = function stringToPath2(string) {
      var first = $strSlice(string, 0, 1);
      var last = $strSlice(string, -1);
      if (first === "%" && last !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
      } else if (last === "%" && first !== "%") {
        throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
      }
      var result = [];
      $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, "$1") : number || match;
      });
      return result;
    };
    var getBaseIntrinsic = function getBaseIntrinsic2(name, allowMissing) {
      var intrinsicName = name;
      var alias;
      if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
      }
      if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) {
          value = doEval(intrinsicName);
        }
        if (typeof value === "undefined" && !allowMissing) {
          throw new $TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        }
        return {
          alias,
          name: intrinsicName,
          value
        };
      }
      throw new $SyntaxError("intrinsic " + name + " does not exist!");
    };
    module2.exports = function GetIntrinsic(name, allowMissing) {
      if (typeof name !== "string" || name.length === 0) {
        throw new $TypeError("intrinsic name must be a non-empty string");
      }
      if (arguments.length > 1 && typeof allowMissing !== "boolean") {
        throw new $TypeError('"allowMissing" argument must be a boolean');
      }
      if ($exec(/^%?[^%]*%?$/, name) === null) {
        throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
      }
      var parts = stringToPath(name);
      var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
      var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
      var intrinsicRealName = intrinsic.name;
      var value = intrinsic.value;
      var skipFurtherCaching = false;
      var alias = intrinsic.alias;
      if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([0, 1], alias));
      }
      for (var i = 1, isOwn = true; i < parts.length; i += 1) {
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
          throw new $SyntaxError("property names with quotes must have matching quotes");
        }
        if (part === "constructor" || !isOwn) {
          skipFurtherCaching = true;
        }
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if (hasOwn(INTRINSICS, intrinsicRealName)) {
          value = INTRINSICS[intrinsicRealName];
        } else if (value != null) {
          if (!(part in value)) {
            if (!allowMissing) {
              throw new $TypeError("base intrinsic for " + name + " exists, but the property is not available.");
            }
            return void 0;
          }
          if ($gOPD && i + 1 >= parts.length) {
            var desc = $gOPD(value, part);
            isOwn = !!desc;
            if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
              value = desc.get;
            } else {
              value = value[part];
            }
          } else {
            isOwn = hasOwn(value, part);
            value = value[part];
          }
          if (isOwn && !skipFurtherCaching) {
            INTRINSICS[intrinsicRealName] = value;
          }
        }
      }
      return value;
    };
  }
});

// ../node_modules/es-define-property/index.js
var require_es_define_property = __commonJS({
  "../node_modules/es-define-property/index.js"(exports, module2) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var $defineProperty = GetIntrinsic("%Object.defineProperty%", true) || false;
    if ($defineProperty) {
      try {
        $defineProperty({}, "a", { value: 1 });
      } catch (e) {
        $defineProperty = false;
      }
    }
    module2.exports = $defineProperty;
  }
});

// ../node_modules/gopd/index.js
var require_gopd = __commonJS({
  "../node_modules/gopd/index.js"(exports, module2) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
    if ($gOPD) {
      try {
        $gOPD([], "length");
      } catch (e) {
        $gOPD = null;
      }
    }
    module2.exports = $gOPD;
  }
});

// ../node_modules/define-data-property/index.js
var require_define_data_property = __commonJS({
  "../node_modules/define-data-property/index.js"(exports, module2) {
    "use strict";
    var $defineProperty = require_es_define_property();
    var $SyntaxError = require_syntax();
    var $TypeError = require_type();
    var gopd = require_gopd();
    module2.exports = function defineDataProperty(obj, property, value) {
      if (!obj || typeof obj !== "object" && typeof obj !== "function") {
        throw new $TypeError("`obj` must be an object or a function`");
      }
      if (typeof property !== "string" && typeof property !== "symbol") {
        throw new $TypeError("`property` must be a string or a symbol`");
      }
      if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) {
        throw new $TypeError("`nonEnumerable`, if provided, must be a boolean or null");
      }
      if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) {
        throw new $TypeError("`nonWritable`, if provided, must be a boolean or null");
      }
      if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) {
        throw new $TypeError("`nonConfigurable`, if provided, must be a boolean or null");
      }
      if (arguments.length > 6 && typeof arguments[6] !== "boolean") {
        throw new $TypeError("`loose`, if provided, must be a boolean");
      }
      var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
      var nonWritable = arguments.length > 4 ? arguments[4] : null;
      var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
      var loose = arguments.length > 6 ? arguments[6] : false;
      var desc = !!gopd && gopd(obj, property);
      if ($defineProperty) {
        $defineProperty(obj, property, {
          configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
          enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
          value,
          writable: nonWritable === null && desc ? desc.writable : !nonWritable
        });
      } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
        obj[property] = value;
      } else {
        throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
      }
    };
  }
});

// ../node_modules/has-property-descriptors/index.js
var require_has_property_descriptors = __commonJS({
  "../node_modules/has-property-descriptors/index.js"(exports, module2) {
    "use strict";
    var $defineProperty = require_es_define_property();
    var hasPropertyDescriptors = function hasPropertyDescriptors2() {
      return !!$defineProperty;
    };
    hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
      if (!$defineProperty) {
        return null;
      }
      try {
        return $defineProperty([], "length", { value: 1 }).length !== 1;
      } catch (e) {
        return true;
      }
    };
    module2.exports = hasPropertyDescriptors;
  }
});

// ../node_modules/set-function-length/index.js
var require_set_function_length = __commonJS({
  "../node_modules/set-function-length/index.js"(exports, module2) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var define2 = require_define_data_property();
    var hasDescriptors = require_has_property_descriptors()();
    var gOPD = require_gopd();
    var $TypeError = require_type();
    var $floor = GetIntrinsic("%Math.floor%");
    module2.exports = function setFunctionLength(fn, length) {
      if (typeof fn !== "function") {
        throw new $TypeError("`fn` is not a function");
      }
      if (typeof length !== "number" || length < 0 || length > 4294967295 || $floor(length) !== length) {
        throw new $TypeError("`length` must be a positive 32-bit integer");
      }
      var loose = arguments.length > 2 && !!arguments[2];
      var functionLengthIsConfigurable = true;
      var functionLengthIsWritable = true;
      if ("length" in fn && gOPD) {
        var desc = gOPD(fn, "length");
        if (desc && !desc.configurable) {
          functionLengthIsConfigurable = false;
        }
        if (desc && !desc.writable) {
          functionLengthIsWritable = false;
        }
      }
      if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if (hasDescriptors) {
          define2(
            /** @type {Parameters<define>[0]} */
            fn,
            "length",
            length,
            true,
            true
          );
        } else {
          define2(
            /** @type {Parameters<define>[0]} */
            fn,
            "length",
            length
          );
        }
      }
      return fn;
    };
  }
});

// ../node_modules/call-bind/index.js
var require_call_bind = __commonJS({
  "../node_modules/call-bind/index.js"(exports, module2) {
    "use strict";
    var bind = require_function_bind();
    var GetIntrinsic = require_get_intrinsic();
    var setFunctionLength = require_set_function_length();
    var $TypeError = require_type();
    var $apply = GetIntrinsic("%Function.prototype.apply%");
    var $call = GetIntrinsic("%Function.prototype.call%");
    var $reflectApply = GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
    var $defineProperty = require_es_define_property();
    var $max = GetIntrinsic("%Math.max%");
    module2.exports = function callBind(originalFunction) {
      if (typeof originalFunction !== "function") {
        throw new $TypeError("a function is required");
      }
      var func = $reflectApply(bind, $call, arguments);
      return setFunctionLength(
        func,
        1 + $max(0, originalFunction.length - (arguments.length - 1)),
        true
      );
    };
    var applyBind = function applyBind2() {
      return $reflectApply(bind, $apply, arguments);
    };
    if ($defineProperty) {
      $defineProperty(module2.exports, "apply", { value: applyBind });
    } else {
      module2.exports.apply = applyBind;
    }
  }
});

// ../node_modules/call-bind/callBound.js
var require_callBound = __commonJS({
  "../node_modules/call-bind/callBound.js"(exports, module2) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var callBind = require_call_bind();
    var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
    module2.exports = function callBoundIntrinsic(name, allowMissing) {
      var intrinsic = GetIntrinsic(name, !!allowMissing);
      if (typeof intrinsic === "function" && $indexOf(name, ".prototype.") > -1) {
        return callBind(intrinsic);
      }
      return intrinsic;
    };
  }
});

// (disabled):../node_modules/object-inspect/util.inspect
var require_util = __commonJS({
  "(disabled):../node_modules/object-inspect/util.inspect"() {
  }
});

// ../node_modules/object-inspect/index.js
var require_object_inspect = __commonJS({
  "../node_modules/object-inspect/index.js"(exports, module2) {
    var hasMap = typeof Map === "function" && Map.prototype;
    var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
    var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
    var mapForEach = hasMap && Map.prototype.forEach;
    var hasSet = typeof Set === "function" && Set.prototype;
    var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
    var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
    var setForEach = hasSet && Set.prototype.forEach;
    var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
    var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
    var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
    var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
    var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
    var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
    var booleanValueOf = Boolean.prototype.valueOf;
    var objectToString = Object.prototype.toString;
    var functionToString = Function.prototype.toString;
    var $match = String.prototype.match;
    var $slice = String.prototype.slice;
    var $replace = String.prototype.replace;
    var $toUpperCase = String.prototype.toUpperCase;
    var $toLowerCase = String.prototype.toLowerCase;
    var $test = RegExp.prototype.test;
    var $concat = Array.prototype.concat;
    var $join = Array.prototype.join;
    var $arrSlice = Array.prototype.slice;
    var $floor = Math.floor;
    var bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
    var gOPS = Object.getOwnPropertySymbols;
    var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
    var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
    var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O) {
      return O.__proto__;
    } : null);
    function addNumericSeparator(num, str) {
      if (num === Infinity || num === -Infinity || num !== num || num && num > -1e3 && num < 1e3 || $test.call(/e/, str)) {
        return str;
      }
      var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
      if (typeof num === "number") {
        var int = num < 0 ? -$floor(-num) : $floor(num);
        if (int !== num) {
          var intStr = String(int);
          var dec = $slice.call(str, intStr.length + 1);
          return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
      }
      return $replace.call(str, sepRegex, "$&_");
    }
    var utilInspect = require_util();
    var inspectCustom = utilInspect.custom;
    var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
    module2.exports = function inspect_(obj, options, depth, seen) {
      var opts = options || {};
      if (has(opts, "quoteStyle") && (opts.quoteStyle !== "single" && opts.quoteStyle !== "double")) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
      }
      if (has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
      }
      var customInspect = has(opts, "customInspect") ? opts.customInspect : true;
      if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
        throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
      }
      if (has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
      }
      if (has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
      }
      var numericSeparator = opts.numericSeparator;
      if (typeof obj === "undefined") {
        return "undefined";
      }
      if (obj === null) {
        return "null";
      }
      if (typeof obj === "boolean") {
        return obj ? "true" : "false";
      }
      if (typeof obj === "string") {
        return inspectString(obj, opts);
      }
      if (typeof obj === "number") {
        if (obj === 0) {
          return Infinity / obj > 0 ? "0" : "-0";
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
      }
      if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
      }
      var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
      if (typeof depth === "undefined") {
        depth = 0;
      }
      if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") {
        return isArray(obj) ? "[Array]" : "[Object]";
      }
      var indent = getIndent(opts, depth);
      if (typeof seen === "undefined") {
        seen = [];
      } else if (indexOf(seen, obj) >= 0) {
        return "[Circular]";
      }
      function inspect(value, from, noIndent) {
        if (from) {
          seen = $arrSlice.call(seen);
          seen.push(from);
        }
        if (noIndent) {
          var newOpts = {
            depth: opts.depth
          };
          if (has(opts, "quoteStyle")) {
            newOpts.quoteStyle = opts.quoteStyle;
          }
          return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
      }
      if (typeof obj === "function" && !isRegExp(obj)) {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $join.call(keys, ", ") + " }" : "");
      }
      if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
        return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
      }
      if (isElement(obj)) {
        var s = "<" + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
          s += " " + attrs[i].name + "=" + wrapQuotes(quote(attrs[i].value), "double", opts);
        }
        s += ">";
        if (obj.childNodes && obj.childNodes.length) {
          s += "...";
        }
        s += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
      }
      if (isArray(obj)) {
        if (obj.length === 0) {
          return "[]";
        }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
          return "[" + indentedJoin(xs, indent) + "]";
        }
        return "[ " + $join.call(xs, ", ") + " ]";
      }
      if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) {
          return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        }
        if (parts.length === 0) {
          return "[" + String(obj) + "]";
        }
        return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
      }
      if (typeof obj === "object" && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) {
          return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
          return obj.inspect();
        }
      }
      if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
          mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
          });
        }
        return collectionOf("Map", mapSize.call(obj), mapParts, indent);
      }
      if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
          setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
          });
        }
        return collectionOf("Set", setSize.call(obj), setParts, indent);
      }
      if (isWeakMap(obj)) {
        return weakCollectionOf("WeakMap");
      }
      if (isWeakSet(obj)) {
        return weakCollectionOf("WeakSet");
      }
      if (isWeakRef(obj)) {
        return weakCollectionOf("WeakRef");
      }
      if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
      }
      if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
      }
      if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
      }
      if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
      }
      if (typeof window !== "undefined" && obj === window) {
        return "{ [object Window] }";
      }
      if (obj === global) {
        return "{ [object globalThis] }";
      }
      if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $join.call($concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) {
          return tag + "{}";
        }
        if (indent) {
          return tag + "{" + indentedJoin(ys, indent) + "}";
        }
        return tag + "{ " + $join.call(ys, ", ") + " }";
      }
      return String(obj);
    };
    function wrapQuotes(s, defaultStyle, opts) {
      var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
      return quoteChar + s + quoteChar;
    }
    function quote(s) {
      return $replace.call(String(s), /"/g, "&quot;");
    }
    function isArray(obj) {
      return toStr(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isDate(obj) {
      return toStr(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isRegExp(obj) {
      return toStr(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isError(obj) {
      return toStr(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isString(obj) {
      return toStr(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isNumber(obj) {
      return toStr(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isBoolean(obj) {
      return toStr(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
    }
    function isSymbol(obj) {
      if (hasShammedSymbols) {
        return obj && typeof obj === "object" && obj instanceof Symbol;
      }
      if (typeof obj === "symbol") {
        return true;
      }
      if (!obj || typeof obj !== "object" || !symToString) {
        return false;
      }
      try {
        symToString.call(obj);
        return true;
      } catch (e) {
      }
      return false;
    }
    function isBigInt(obj) {
      if (!obj || typeof obj !== "object" || !bigIntValueOf) {
        return false;
      }
      try {
        bigIntValueOf.call(obj);
        return true;
      } catch (e) {
      }
      return false;
    }
    var hasOwn = Object.prototype.hasOwnProperty || function(key) {
      return key in this;
    };
    function has(obj, key) {
      return hasOwn.call(obj, key);
    }
    function toStr(obj) {
      return objectToString.call(obj);
    }
    function nameOf(f) {
      if (f.name) {
        return f.name;
      }
      var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
      if (m) {
        return m[1];
      }
      return null;
    }
    function indexOf(xs, x) {
      if (xs.indexOf) {
        return xs.indexOf(x);
      }
      for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) {
          return i;
        }
      }
      return -1;
    }
    function isMap(x) {
      if (!mapSize || !x || typeof x !== "object") {
        return false;
      }
      try {
        mapSize.call(x);
        try {
          setSize.call(x);
        } catch (s) {
          return true;
        }
        return x instanceof Map;
      } catch (e) {
      }
      return false;
    }
    function isWeakMap(x) {
      if (!weakMapHas || !x || typeof x !== "object") {
        return false;
      }
      try {
        weakMapHas.call(x, weakMapHas);
        try {
          weakSetHas.call(x, weakSetHas);
        } catch (s) {
          return true;
        }
        return x instanceof WeakMap;
      } catch (e) {
      }
      return false;
    }
    function isWeakRef(x) {
      if (!weakRefDeref || !x || typeof x !== "object") {
        return false;
      }
      try {
        weakRefDeref.call(x);
        return true;
      } catch (e) {
      }
      return false;
    }
    function isSet(x) {
      if (!setSize || !x || typeof x !== "object") {
        return false;
      }
      try {
        setSize.call(x);
        try {
          mapSize.call(x);
        } catch (m) {
          return true;
        }
        return x instanceof Set;
      } catch (e) {
      }
      return false;
    }
    function isWeakSet(x) {
      if (!weakSetHas || !x || typeof x !== "object") {
        return false;
      }
      try {
        weakSetHas.call(x, weakSetHas);
        try {
          weakMapHas.call(x, weakMapHas);
        } catch (s) {
          return true;
        }
        return x instanceof WeakSet;
      } catch (e) {
      }
      return false;
    }
    function isElement(x) {
      if (!x || typeof x !== "object") {
        return false;
      }
      if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) {
        return true;
      }
      return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
    }
    function inspectString(str, opts) {
      if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
      }
      var s = $replace.call($replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
      return wrapQuotes(s, "single", opts);
    }
    function lowbyte(c) {
      var n = c.charCodeAt(0);
      var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
      }[n];
      if (x) {
        return "\\" + x;
      }
      return "\\x" + (n < 16 ? "0" : "") + $toUpperCase.call(n.toString(16));
    }
    function markBoxed(str) {
      return "Object(" + str + ")";
    }
    function weakCollectionOf(type) {
      return type + " { ? }";
    }
    function collectionOf(type, size, entries, indent) {
      var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ", ");
      return type + " (" + size + ") {" + joinedEntries + "}";
    }
    function singleLineValues(xs) {
      for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], "\n") >= 0) {
          return false;
        }
      }
      return true;
    }
    function getIndent(opts, depth) {
      var baseIndent;
      if (opts.indent === "	") {
        baseIndent = "	";
      } else if (typeof opts.indent === "number" && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), " ");
      } else {
        return null;
      }
      return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
      };
    }
    function indentedJoin(xs, indent) {
      if (xs.length === 0) {
        return "";
      }
      var lineJoiner = "\n" + indent.prev + indent.base;
      return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
    }
    function arrObjKeys(obj, inspect) {
      var isArr = isArray(obj);
      var xs = [];
      if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
          xs[i] = has(obj, i) ? inspect(obj[i], obj) : "";
        }
      }
      var syms = typeof gOPS === "function" ? gOPS(obj) : [];
      var symMap;
      if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
          symMap["$" + syms[k]] = syms[k];
        }
      }
      for (var key in obj) {
        if (!has(obj, key)) {
          continue;
        }
        if (isArr && String(Number(key)) === key && key < obj.length) {
          continue;
        }
        if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) {
          continue;
        } else if ($test.call(/[^\w$]/, key)) {
          xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        } else {
          xs.push(key + ": " + inspect(obj[key], obj));
        }
      }
      if (typeof gOPS === "function") {
        for (var j = 0; j < syms.length; j++) {
          if (isEnumerable.call(obj, syms[j])) {
            xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
          }
        }
      }
      return xs;
    }
  }
});

// ../node_modules/side-channel/index.js
var require_side_channel = __commonJS({
  "../node_modules/side-channel/index.js"(exports, module2) {
    "use strict";
    var GetIntrinsic = require_get_intrinsic();
    var callBound = require_callBound();
    var inspect = require_object_inspect();
    var $TypeError = require_type();
    var $WeakMap = GetIntrinsic("%WeakMap%", true);
    var $Map = GetIntrinsic("%Map%", true);
    var $weakMapGet = callBound("WeakMap.prototype.get", true);
    var $weakMapSet = callBound("WeakMap.prototype.set", true);
    var $weakMapHas = callBound("WeakMap.prototype.has", true);
    var $mapGet = callBound("Map.prototype.get", true);
    var $mapSet = callBound("Map.prototype.set", true);
    var $mapHas = callBound("Map.prototype.has", true);
    var listGetNode = function(list, key) {
      var prev = list;
      var curr;
      for (; (curr = prev.next) !== null; prev = curr) {
        if (curr.key === key) {
          prev.next = curr.next;
          curr.next = /** @type {NonNullable<typeof list.next>} */
          list.next;
          list.next = curr;
          return curr;
        }
      }
    };
    var listGet = function(objects, key) {
      var node = listGetNode(objects, key);
      return node && node.value;
    };
    var listSet = function(objects, key, value) {
      var node = listGetNode(objects, key);
      if (node) {
        node.value = value;
      } else {
        objects.next = /** @type {import('.').ListNode<typeof value>} */
        {
          // eslint-disable-line no-param-reassign, no-extra-parens
          key,
          next: objects.next,
          value
        };
      }
    };
    var listHas = function(objects, key) {
      return !!listGetNode(objects, key);
    };
    module2.exports = function getSideChannel() {
      var $wm;
      var $m;
      var $o;
      var channel = {
        assert: function(key) {
          if (!channel.has(key)) {
            throw new $TypeError("Side channel does not contain " + inspect(key));
          }
        },
        get: function(key) {
          if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
            if ($wm) {
              return $weakMapGet($wm, key);
            }
          } else if ($Map) {
            if ($m) {
              return $mapGet($m, key);
            }
          } else {
            if ($o) {
              return listGet($o, key);
            }
          }
        },
        has: function(key) {
          if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
            if ($wm) {
              return $weakMapHas($wm, key);
            }
          } else if ($Map) {
            if ($m) {
              return $mapHas($m, key);
            }
          } else {
            if ($o) {
              return listHas($o, key);
            }
          }
          return false;
        },
        set: function(key, value) {
          if ($WeakMap && key && (typeof key === "object" || typeof key === "function")) {
            if (!$wm) {
              $wm = new $WeakMap();
            }
            $weakMapSet($wm, key, value);
          } else if ($Map) {
            if (!$m) {
              $m = new $Map();
            }
            $mapSet($m, key, value);
          } else {
            if (!$o) {
              $o = { key: {}, next: null };
            }
            listSet($o, key, value);
          }
        }
      };
      return channel;
    };
  }
});

// ../node_modules/qs/lib/formats.js
var require_formats = __commonJS({
  "../node_modules/qs/lib/formats.js"(exports, module2) {
    "use strict";
    var replace = String.prototype.replace;
    var percentTwenties = /%20/g;
    var Format = {
      RFC1738: "RFC1738",
      RFC3986: "RFC3986"
    };
    module2.exports = {
      "default": Format.RFC3986,
      formatters: {
        RFC1738: function(value) {
          return replace.call(value, percentTwenties, "+");
        },
        RFC3986: function(value) {
          return String(value);
        }
      },
      RFC1738: Format.RFC1738,
      RFC3986: Format.RFC3986
    };
  }
});

// ../node_modules/qs/lib/utils.js
var require_utils = __commonJS({
  "../node_modules/qs/lib/utils.js"(exports, module2) {
    "use strict";
    var formats = require_formats();
    var has = Object.prototype.hasOwnProperty;
    var isArray = Array.isArray;
    var hexTable = function() {
      var array = [];
      for (var i = 0; i < 256; ++i) {
        array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
      }
      return array;
    }();
    var compactQueue = function compactQueue2(queue) {
      while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if (isArray(obj)) {
          var compacted = [];
          for (var j = 0; j < obj.length; ++j) {
            if (typeof obj[j] !== "undefined") {
              compacted.push(obj[j]);
            }
          }
          item.obj[item.prop] = compacted;
        }
      }
    };
    var arrayToObject = function arrayToObject2(source, options) {
      var obj = options && options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== "undefined") {
          obj[i] = source[i];
        }
      }
      return obj;
    };
    var merge = function merge2(target, source, options) {
      if (!source) {
        return target;
      }
      if (typeof source !== "object") {
        if (isArray(target)) {
          target.push(source);
        } else if (target && typeof target === "object") {
          if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) {
            target[source] = true;
          }
        } else {
          return [target, source];
        }
        return target;
      }
      if (!target || typeof target !== "object") {
        return [target].concat(source);
      }
      var mergeTarget = target;
      if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
      }
      if (isArray(target) && isArray(source)) {
        source.forEach(function(item, i) {
          if (has.call(target, i)) {
            var targetItem = target[i];
            if (targetItem && typeof targetItem === "object" && item && typeof item === "object") {
              target[i] = merge2(targetItem, item, options);
            } else {
              target.push(item);
            }
          } else {
            target[i] = item;
          }
        });
        return target;
      }
      return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if (has.call(acc, key)) {
          acc[key] = merge2(acc[key], value, options);
        } else {
          acc[key] = value;
        }
        return acc;
      }, mergeTarget);
    };
    var assign = function assignSingleSource(target, source) {
      return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
      }, target);
    };
    var decode2 = function(str, decoder, charset) {
      var strWithoutPlus = str.replace(/\+/g, " ");
      if (charset === "iso-8859-1") {
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
      }
      try {
        return decodeURIComponent(strWithoutPlus);
      } catch (e) {
        return strWithoutPlus;
      }
    };
    var limit = 1024;
    var encode2 = function encode3(str, defaultEncoder, charset, kind, format) {
      if (str.length === 0) {
        return str;
      }
      var string = str;
      if (typeof str === "symbol") {
        string = Symbol.prototype.toString.call(str);
      } else if (typeof str !== "string") {
        string = String(str);
      }
      if (charset === "iso-8859-1") {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
          return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
        });
      }
      var out = "";
      for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];
        for (var i = 0; i < segment.length; ++i) {
          var c = segment.charCodeAt(i);
          if (c === 45 || c === 46 || c === 95 || c === 126 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || format === formats.RFC1738 && (c === 40 || c === 41)) {
            arr[arr.length] = segment.charAt(i);
            continue;
          }
          if (c < 128) {
            arr[arr.length] = hexTable[c];
            continue;
          }
          if (c < 2048) {
            arr[arr.length] = hexTable[192 | c >> 6] + hexTable[128 | c & 63];
            continue;
          }
          if (c < 55296 || c >= 57344) {
            arr[arr.length] = hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
            continue;
          }
          i += 1;
          c = 65536 + ((c & 1023) << 10 | segment.charCodeAt(i) & 1023);
          arr[arr.length] = hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
        }
        out += arr.join("");
      }
      return out;
    };
    var compact = function compact2(value) {
      var queue = [{ obj: { o: value }, prop: "o" }];
      var refs = [];
      for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
          var key = keys[j];
          var val = obj[key];
          if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
            queue.push({ obj, prop: key });
            refs.push(val);
          }
        }
      }
      compactQueue(queue);
      return value;
    };
    var isRegExp = function isRegExp2(obj) {
      return Object.prototype.toString.call(obj) === "[object RegExp]";
    };
    var isBuffer = function isBuffer2(obj) {
      if (!obj || typeof obj !== "object") {
        return false;
      }
      return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
    };
    var combine = function combine2(a, b) {
      return [].concat(a, b);
    };
    var maybeMap = function maybeMap2(val, fn) {
      if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
          mapped.push(fn(val[i]));
        }
        return mapped;
      }
      return fn(val);
    };
    module2.exports = {
      arrayToObject,
      assign,
      combine,
      compact,
      decode: decode2,
      encode: encode2,
      isBuffer,
      isRegExp,
      maybeMap,
      merge
    };
  }
});

// ../node_modules/qs/lib/stringify.js
var require_stringify = __commonJS({
  "../node_modules/qs/lib/stringify.js"(exports, module2) {
    "use strict";
    var getSideChannel = require_side_channel();
    var utils = require_utils();
    var formats = require_formats();
    var has = Object.prototype.hasOwnProperty;
    var arrayPrefixGenerators = {
      brackets: function brackets(prefix) {
        return prefix + "[]";
      },
      comma: "comma",
      indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
      },
      repeat: function repeat(prefix) {
        return prefix;
      }
    };
    var isArray = Array.isArray;
    var push = Array.prototype.push;
    var pushToArray = function(arr, valueOrArray) {
      push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
    };
    var toISO = Date.prototype.toISOString;
    var defaultFormat = formats["default"];
    var defaults = {
      addQueryPrefix: false,
      allowDots: false,
      allowEmptyArrays: false,
      arrayFormat: "indices",
      charset: "utf-8",
      charsetSentinel: false,
      delimiter: "&",
      encode: true,
      encodeDotInKeys: false,
      encoder: utils.encode,
      encodeValuesOnly: false,
      format: defaultFormat,
      formatter: formats.formatters[defaultFormat],
      // deprecated
      indices: false,
      serializeDate: function serializeDate(date) {
        return toISO.call(date);
      },
      skipNulls: false,
      strictNullHandling: false
    };
    var isNonNullishPrimitive = function isNonNullishPrimitive2(v) {
      return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
    };
    var sentinel = {};
    var stringify = function stringify2(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
      var obj = object;
      var tmpSc = sideChannel;
      var step = 0;
      var findFlag = false;
      while ((tmpSc = tmpSc.get(sentinel)) !== void 0 && !findFlag) {
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
          if (pos === step) {
            throw new RangeError("Cyclic object value");
          } else {
            findFlag = true;
          }
        }
        if (typeof tmpSc.get(sentinel) === "undefined") {
          step = 0;
        }
      }
      if (typeof filter === "function") {
        obj = filter(prefix, obj);
      } else if (obj instanceof Date) {
        obj = serializeDate(obj);
      } else if (generateArrayPrefix === "comma" && isArray(obj)) {
        obj = utils.maybeMap(obj, function(value2) {
          if (value2 instanceof Date) {
            return serializeDate(value2);
          }
          return value2;
        });
      }
      if (obj === null) {
        if (strictNullHandling) {
          return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, "key", format) : prefix;
        }
        obj = "";
      }
      if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
          var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, "key", format);
          return [formatter(keyValue) + "=" + formatter(encoder(obj, defaults.encoder, charset, "value", format))];
        }
        return [formatter(prefix) + "=" + formatter(String(obj))];
      }
      var values = [];
      if (typeof obj === "undefined") {
        return values;
      }
      var objKeys;
      if (generateArrayPrefix === "comma" && isArray(obj)) {
        if (encodeValuesOnly && encoder) {
          obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(",") || null : void 0 }];
      } else if (isArray(filter)) {
        objKeys = filter;
      } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
      }
      var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
      var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
      if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + "[]";
      }
      for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) {
          continue;
        }
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify2(
          value,
          keyPrefix,
          generateArrayPrefix,
          commaRoundTrip,
          allowEmptyArrays,
          strictNullHandling,
          skipNulls,
          encodeDotInKeys,
          generateArrayPrefix === "comma" && encodeValuesOnly && isArray(obj) ? null : encoder,
          filter,
          sort,
          allowDots,
          serializeDate,
          format,
          formatter,
          encodeValuesOnly,
          charset,
          valueSideChannel
        ));
      }
      return values;
    };
    var normalizeStringifyOptions = function normalizeStringifyOptions2(opts) {
      if (!opts) {
        return defaults;
      }
      if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") {
        throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
      }
      if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") {
        throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
      }
      if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") {
        throw new TypeError("Encoder has to be a function.");
      }
      var charset = opts.charset || defaults.charset;
      if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
        throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
      }
      var format = formats["default"];
      if (typeof opts.format !== "undefined") {
        if (!has.call(formats.formatters, opts.format)) {
          throw new TypeError("Unknown format option provided.");
        }
        format = opts.format;
      }
      var formatter = formats.formatters[format];
      var filter = defaults.filter;
      if (typeof opts.filter === "function" || isArray(opts.filter)) {
        filter = opts.filter;
      }
      var arrayFormat;
      if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
      } else if ("indices" in opts) {
        arrayFormat = opts.indices ? "indices" : "repeat";
      } else {
        arrayFormat = defaults.arrayFormat;
      }
      if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") {
        throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
      }
      var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
      return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat,
        charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter,
        format,
        formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
      };
    };
    module2.exports = function(object, opts) {
      var obj = object;
      var options = normalizeStringifyOptions(opts);
      var objKeys;
      var filter;
      if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
      } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
      }
      var keys = [];
      if (typeof obj !== "object" || obj === null) {
        return "";
      }
      var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
      var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
      if (!objKeys) {
        objKeys = Object.keys(obj);
      }
      if (options.sort) {
        objKeys.sort(options.sort);
      }
      var sideChannel = getSideChannel();
      for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) {
          continue;
        }
        pushToArray(keys, stringify(
          obj[key],
          key,
          generateArrayPrefix,
          commaRoundTrip,
          options.allowEmptyArrays,
          options.strictNullHandling,
          options.skipNulls,
          options.encodeDotInKeys,
          options.encode ? options.encoder : null,
          options.filter,
          options.sort,
          options.allowDots,
          options.serializeDate,
          options.format,
          options.formatter,
          options.encodeValuesOnly,
          options.charset,
          sideChannel
        ));
      }
      var joined = keys.join(options.delimiter);
      var prefix = options.addQueryPrefix === true ? "?" : "";
      if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") {
          prefix += "utf8=%26%2310003%3B&";
        } else {
          prefix += "utf8=%E2%9C%93&";
        }
      }
      return joined.length > 0 ? prefix + joined : "";
    };
  }
});

// ../node_modules/qs/lib/parse.js
var require_parse = __commonJS({
  "../node_modules/qs/lib/parse.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var has = Object.prototype.hasOwnProperty;
    var isArray = Array.isArray;
    var defaults = {
      allowDots: false,
      allowEmptyArrays: false,
      allowPrototypes: false,
      allowSparse: false,
      arrayLimit: 20,
      charset: "utf-8",
      charsetSentinel: false,
      comma: false,
      decodeDotInKeys: false,
      decoder: utils.decode,
      delimiter: "&",
      depth: 5,
      duplicates: "combine",
      ignoreQueryPrefix: false,
      interpretNumericEntities: false,
      parameterLimit: 1e3,
      parseArrays: true,
      plainObjects: false,
      strictDepth: false,
      strictNullHandling: false
    };
    var interpretNumericEntities = function(str) {
      return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
      });
    };
    var parseArrayValue = function(val, options) {
      if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) {
        return val.split(",");
      }
      return val;
    };
    var isoSentinel = "utf8=%26%2310003%3B";
    var charsetSentinel = "utf8=%E2%9C%93";
    var parseValues = function parseQueryStringValues(str, options) {
      var obj = { __proto__: null };
      var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
      cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
      var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
      var parts = cleanStr.split(options.delimiter, limit);
      var skipIndex = -1;
      var i;
      var charset = options.charset;
      if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
          if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === charsetSentinel) {
              charset = "utf-8";
            } else if (parts[i] === isoSentinel) {
              charset = "iso-8859-1";
            }
            skipIndex = i;
            i = parts.length;
          }
        }
      }
      for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
          continue;
        }
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
          key = options.decoder(part, defaults.decoder, charset, "key");
          val = options.strictNullHandling ? null : "";
        } else {
          key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
          val = utils.maybeMap(
            parseArrayValue(part.slice(pos + 1), options),
            function(encodedVal) {
              return options.decoder(encodedVal, defaults.decoder, charset, "value");
            }
          );
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") {
          val = interpretNumericEntities(val);
        }
        if (part.indexOf("[]=") > -1) {
          val = isArray(val) ? [val] : val;
        }
        var existing = has.call(obj, key);
        if (existing && options.duplicates === "combine") {
          obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === "last") {
          obj[key] = val;
        }
      }
      return obj;
    };
    var parseObject = function(chain, val, options, valuesParsed) {
      var leaf = valuesParsed ? val : parseArrayValue(val, options);
      for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) {
          obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
        } else {
          obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
          var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
          var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
          var index = parseInt(decodedRoot, 10);
          if (!options.parseArrays && decodedRoot === "") {
            obj = { 0: leaf };
          } else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && (options.parseArrays && index <= options.arrayLimit)) {
            obj = [];
            obj[index] = leaf;
          } else if (decodedRoot !== "__proto__") {
            obj[decodedRoot] = leaf;
          }
        }
        leaf = obj;
      }
      return leaf;
    };
    var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
      if (!givenKey) {
        return;
      }
      var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
      var brackets = /(\[[^[\]]*])/;
      var child = /(\[[^[\]]*])/g;
      var segment = options.depth > 0 && brackets.exec(key);
      var parent = segment ? key.slice(0, segment.index) : key;
      var keys = [];
      if (parent) {
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
          if (!options.allowPrototypes) {
            return;
          }
        }
        keys.push(parent);
      }
      var i = 0;
      while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
          if (!options.allowPrototypes) {
            return;
          }
        }
        keys.push(segment[1]);
      }
      if (segment) {
        if (options.strictDepth === true) {
          throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
        }
        keys.push("[" + key.slice(segment.index) + "]");
      }
      return parseObject(keys, val, options, valuesParsed);
    };
    var normalizeParseOptions = function normalizeParseOptions2(opts) {
      if (!opts) {
        return defaults;
      }
      if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") {
        throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
      }
      if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") {
        throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
      }
      if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") {
        throw new TypeError("Decoder has to be a function.");
      }
      if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
        throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
      }
      var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
      var duplicates = typeof opts.duplicates === "undefined" ? defaults.duplicates : opts.duplicates;
      if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") {
        throw new TypeError("The duplicates option must be either combine, first, or last");
      }
      var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
      return {
        allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
        charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
        duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === "boolean" ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
      };
    };
    module2.exports = function(str, opts) {
      var options = normalizeParseOptions(opts);
      if (str === "" || str === null || typeof str === "undefined") {
        return options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      }
      var tempObj = typeof str === "string" ? parseValues(str, options) : str;
      var obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var keys = Object.keys(tempObj);
      for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = utils.merge(obj, newObj, options);
      }
      if (options.allowSparse === true) {
        return obj;
      }
      return utils.compact(obj);
    };
  }
});

// ../node_modules/qs/lib/index.js
var require_lib2 = __commonJS({
  "../node_modules/qs/lib/index.js"(exports, module2) {
    "use strict";
    var stringify = require_stringify();
    var parse3 = require_parse();
    var formats = require_formats();
    module2.exports = {
      formats,
      parse: parse3,
      stringify
    };
  }
});

// ../node_modules/url/url.js
var require_url = __commonJS({
  "../node_modules/url/url.js"(exports) {
    "use strict";
    var punycode = require_punycode();
    function Url() {
      this.protocol = null;
      this.slashes = null;
      this.auth = null;
      this.host = null;
      this.port = null;
      this.hostname = null;
      this.hash = null;
      this.search = null;
      this.query = null;
      this.pathname = null;
      this.path = null;
      this.href = null;
    }
    var protocolPattern = /^([a-z0-9.+-]+:)/i;
    var portPattern = /:[0-9]*$/;
    var simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/;
    var delims = [
      "<",
      ">",
      '"',
      "`",
      " ",
      "\r",
      "\n",
      "	"
    ];
    var unwise = [
      "{",
      "}",
      "|",
      "\\",
      "^",
      "`"
    ].concat(delims);
    var autoEscape = ["'"].concat(unwise);
    var nonHostChars = [
      "%",
      "/",
      "?",
      ";",
      "#"
    ].concat(autoEscape);
    var hostEndingChars = [
      "/",
      "?",
      "#"
    ];
    var hostnameMaxLen = 255;
    var hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/;
    var hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/;
    var unsafeProtocol = {
      javascript: true,
      "javascript:": true
    };
    var hostlessProtocol = {
      javascript: true,
      "javascript:": true
    };
    var slashedProtocol = {
      http: true,
      https: true,
      ftp: true,
      gopher: true,
      file: true,
      "http:": true,
      "https:": true,
      "ftp:": true,
      "gopher:": true,
      "file:": true
    };
    var querystring = require_lib2();
    function urlParse(url, parseQueryString, slashesDenoteHost) {
      if (url && typeof url === "object" && url instanceof Url) {
        return url;
      }
      var u = new Url();
      u.parse(url, parseQueryString, slashesDenoteHost);
      return u;
    }
    Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
      if (typeof url !== "string") {
        throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
      }
      var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
      uSplit[0] = uSplit[0].replace(slashRegex, "/");
      url = uSplit.join(splitter);
      var rest = url;
      rest = rest.trim();
      if (!slashesDenoteHost && url.split("#").length === 1) {
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
          this.path = rest;
          this.href = rest;
          this.pathname = simplePath[1];
          if (simplePath[2]) {
            this.search = simplePath[2];
            if (parseQueryString) {
              this.query = querystring.parse(this.search.substr(1));
            } else {
              this.query = this.search.substr(1);
            }
          } else if (parseQueryString) {
            this.search = "";
            this.query = {};
          }
          return this;
        }
      }
      var proto = protocolPattern.exec(rest);
      if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
      }
      if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
          rest = rest.substr(2);
          this.slashes = true;
        }
      }
      if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        var hostEnd = -1;
        for (var i = 0; i < hostEndingChars.length; i++) {
          var hec = rest.indexOf(hostEndingChars[i]);
          if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
            hostEnd = hec;
          }
        }
        var auth, atSign;
        if (hostEnd === -1) {
          atSign = rest.lastIndexOf("@");
        } else {
          atSign = rest.lastIndexOf("@", hostEnd);
        }
        if (atSign !== -1) {
          auth = rest.slice(0, atSign);
          rest = rest.slice(atSign + 1);
          this.auth = decodeURIComponent(auth);
        }
        hostEnd = -1;
        for (var i = 0; i < nonHostChars.length; i++) {
          var hec = rest.indexOf(nonHostChars[i]);
          if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) {
            hostEnd = hec;
          }
        }
        if (hostEnd === -1) {
          hostEnd = rest.length;
        }
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        this.parseHost();
        this.hostname = this.hostname || "";
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        if (!ipv6Hostname) {
          var hostparts = this.hostname.split(/\./);
          for (var i = 0, l = hostparts.length; i < l; i++) {
            var part = hostparts[i];
            if (!part) {
              continue;
            }
            if (!part.match(hostnamePartPattern)) {
              var newpart = "";
              for (var j = 0, k = part.length; j < k; j++) {
                if (part.charCodeAt(j) > 127) {
                  newpart += "x";
                } else {
                  newpart += part[j];
                }
              }
              if (!newpart.match(hostnamePartPattern)) {
                var validParts = hostparts.slice(0, i);
                var notHost = hostparts.slice(i + 1);
                var bit = part.match(hostnamePartStart);
                if (bit) {
                  validParts.push(bit[1]);
                  notHost.unshift(bit[2]);
                }
                if (notHost.length) {
                  rest = "/" + notHost.join(".") + rest;
                }
                this.hostname = validParts.join(".");
                break;
              }
            }
          }
        }
        if (this.hostname.length > hostnameMaxLen) {
          this.hostname = "";
        } else {
          this.hostname = this.hostname.toLowerCase();
        }
        if (!ipv6Hostname) {
          this.hostname = punycode.toASCII(this.hostname);
        }
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        if (ipv6Hostname) {
          this.hostname = this.hostname.substr(1, this.hostname.length - 2);
          if (rest[0] !== "/") {
            rest = "/" + rest;
          }
        }
      }
      if (!unsafeProtocol[lowerProto]) {
        for (var i = 0, l = autoEscape.length; i < l; i++) {
          var ae = autoEscape[i];
          if (rest.indexOf(ae) === -1) {
            continue;
          }
          var esc = encodeURIComponent(ae);
          if (esc === ae) {
            esc = escape(ae);
          }
          rest = rest.split(ae).join(esc);
        }
      }
      var hash = rest.indexOf("#");
      if (hash !== -1) {
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
      }
      var qm = rest.indexOf("?");
      if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) {
          this.query = querystring.parse(this.query);
        }
        rest = rest.slice(0, qm);
      } else if (parseQueryString) {
        this.search = "";
        this.query = {};
      }
      if (rest) {
        this.pathname = rest;
      }
      if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
        this.pathname = "/";
      }
      if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
      }
      this.href = this.format();
      return this;
    };
    function urlFormat(obj) {
      if (typeof obj === "string") {
        obj = urlParse(obj);
      }
      if (!(obj instanceof Url)) {
        return Url.prototype.format.call(obj);
      }
      return obj.format();
    }
    Url.prototype.format = function() {
      var auth = this.auth || "";
      if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
      }
      var protocol2 = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
      if (this.host) {
        host = auth + this.host;
      } else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) {
          host += ":" + this.port;
        }
      }
      if (this.query && typeof this.query === "object" && Object.keys(this.query).length) {
        query = querystring.stringify(this.query, {
          arrayFormat: "repeat",
          addQueryPrefix: false
        });
      }
      var search = this.search || query && "?" + query || "";
      if (protocol2 && protocol2.substr(-1) !== ":") {
        protocol2 += ":";
      }
      if (this.slashes || (!protocol2 || slashedProtocol[protocol2]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") {
          pathname = "/" + pathname;
        }
      } else if (!host) {
        host = "";
      }
      if (hash && hash.charAt(0) !== "#") {
        hash = "#" + hash;
      }
      if (search && search.charAt(0) !== "?") {
        search = "?" + search;
      }
      pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
      });
      search = search.replace("#", "%23");
      return protocol2 + host + pathname + search + hash;
    };
    function urlResolve(source, relative) {
      return urlParse(source, false, true).resolve(relative);
    }
    Url.prototype.resolve = function(relative) {
      return this.resolveObject(urlParse(relative, false, true)).format();
    };
    function urlResolveObject(source, relative) {
      if (!source) {
        return relative;
      }
      return urlParse(source, false, true).resolveObject(relative);
    }
    Url.prototype.resolveObject = function(relative) {
      if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
      }
      var result = new Url();
      var tkeys = Object.keys(this);
      for (var tk = 0; tk < tkeys.length; tk++) {
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
      }
      result.hash = relative.hash;
      if (relative.href === "") {
        result.href = result.format();
        return result;
      }
      if (relative.slashes && !relative.protocol) {
        var rkeys = Object.keys(relative);
        for (var rk = 0; rk < rkeys.length; rk++) {
          var rkey = rkeys[rk];
          if (rkey !== "protocol") {
            result[rkey] = relative[rkey];
          }
        }
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
          result.pathname = "/";
          result.path = result.pathname;
        }
        result.href = result.format();
        return result;
      }
      if (relative.protocol && relative.protocol !== result.protocol) {
        if (!slashedProtocol[relative.protocol]) {
          var keys = Object.keys(relative);
          for (var v = 0; v < keys.length; v++) {
            var k = keys[v];
            result[k] = relative[k];
          }
          result.href = result.format();
          return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
          var relPath = (relative.pathname || "").split("/");
          while (relPath.length && !(relative.host = relPath.shift())) {
          }
          if (!relative.host) {
            relative.host = "";
          }
          if (!relative.hostname) {
            relative.hostname = "";
          }
          if (relPath[0] !== "") {
            relPath.unshift("");
          }
          if (relPath.length < 2) {
            relPath.unshift("");
          }
          result.pathname = relPath.join("/");
        } else {
          result.pathname = relative.pathname;
        }
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        if (result.pathname || result.search) {
          var p = result.pathname || "";
          var s = result.search || "";
          result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
      }
      var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
      if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
          if (srcPath[0] === "") {
            srcPath[0] = result.host;
          } else {
            srcPath.unshift(result.host);
          }
        }
        result.host = "";
        if (relative.protocol) {
          relative.hostname = null;
          relative.port = null;
          if (relative.host) {
            if (relPath[0] === "") {
              relPath[0] = relative.host;
            } else {
              relPath.unshift(relative.host);
            }
          }
          relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
      }
      if (isRelAbs) {
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
      } else if (relPath.length) {
        if (!srcPath) {
          srcPath = [];
        }
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
      } else if (relative.search != null) {
        if (psychotic) {
          result.host = srcPath.shift();
          result.hostname = result.host;
          var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
          if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
          }
        }
        result.search = relative.search;
        result.query = relative.query;
        if (result.pathname !== null || result.search !== null) {
          result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        }
        result.href = result.format();
        return result;
      }
      if (!srcPath.length) {
        result.pathname = null;
        if (result.search) {
          result.path = "/" + result.search;
        } else {
          result.path = null;
        }
        result.href = result.format();
        return result;
      }
      var last = srcPath.slice(-1)[0];
      var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
      var up = 0;
      for (var i = srcPath.length; i >= 0; i--) {
        last = srcPath[i];
        if (last === ".") {
          srcPath.splice(i, 1);
        } else if (last === "..") {
          srcPath.splice(i, 1);
          up++;
        } else if (up) {
          srcPath.splice(i, 1);
          up--;
        }
      }
      if (!mustEndAbs && !removeAllDots) {
        for (; up--; up) {
          srcPath.unshift("..");
        }
      }
      if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) {
        srcPath.unshift("");
      }
      if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") {
        srcPath.push("");
      }
      var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
      if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
          result.auth = authInHost.shift();
          result.hostname = authInHost.shift();
          result.host = result.hostname;
        }
      }
      mustEndAbs = mustEndAbs || result.host && srcPath.length;
      if (mustEndAbs && !isAbsolute) {
        srcPath.unshift("");
      }
      if (srcPath.length > 0) {
        result.pathname = srcPath.join("/");
      } else {
        result.pathname = null;
        result.path = null;
      }
      if (result.pathname !== null || result.search !== null) {
        result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
      }
      result.auth = relative.auth || result.auth;
      result.slashes = result.slashes || relative.slashes;
      result.href = result.format();
      return result;
    };
    Url.prototype.parseHost = function() {
      var host = this.host;
      var port = portPattern.exec(host);
      if (port) {
        port = port[0];
        if (port !== ":") {
          this.port = port.substr(1);
        }
        host = host.substr(0, host.length - port.length);
      }
      if (host) {
        this.hostname = host;
      }
    };
    exports.parse = urlParse;
    exports.resolve = urlResolve;
    exports.resolveObject = urlResolveObject;
    exports.format = urlFormat;
    exports.Url = Url;
  }
});

// ../node_modules/@frogcat/ttl2jsonld/ttl2jsonld.js
var require_ttl2jsonld = __commonJS({
  "../node_modules/@frogcat/ttl2jsonld/ttl2jsonld.js"(exports, module2) {
    (function(root, factory) {
      if (typeof define === "function" && define.amd) {
        define([], factory);
      } else if (typeof module2 === "object" && module2.exports) {
        module2.exports = factory();
      } else {
        root.ttl2jsonld = factory();
      }
    })(exports, function() {
      "use strict";
      function peg$subclass(child, parent) {
        function ctor() {
          this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
      }
      function peg$SyntaxError(message, expected, found, location) {
        this.message = message;
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = "SyntaxError";
        if (typeof Error.captureStackTrace === "function") {
          Error.captureStackTrace(this, peg$SyntaxError);
        }
      }
      peg$subclass(peg$SyntaxError, Error);
      peg$SyntaxError.buildMessage = function(expected, found) {
        var DESCRIBE_EXPECTATION_FNS = {
          literal: function(expectation) {
            return '"' + literalEscape(expectation.text) + '"';
          },
          "class": function(expectation) {
            var escapedParts = "", i;
            for (i = 0; i < expectation.parts.length; i++) {
              escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
            }
            return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
          },
          any: function(expectation) {
            return "any character";
          },
          end: function(expectation) {
            return "end of input";
          },
          other: function(expectation) {
            return expectation.description;
          }
        };
        function hex(ch) {
          return ch.charCodeAt(0).toString(16).toUpperCase();
        }
        function literalEscape(s) {
          return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
            return "\\x0" + hex(ch);
          }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
            return "\\x" + hex(ch);
          });
        }
        function classEscape(s) {
          return s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
            return "\\x0" + hex(ch);
          }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
            return "\\x" + hex(ch);
          });
        }
        function describeExpectation(expectation) {
          return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }
        function describeExpected(expected2) {
          var descriptions = new Array(expected2.length), i, j;
          for (i = 0; i < expected2.length; i++) {
            descriptions[i] = describeExpectation(expected2[i]);
          }
          descriptions.sort();
          if (descriptions.length > 0) {
            for (i = 1, j = 1; i < descriptions.length; i++) {
              if (descriptions[i - 1] !== descriptions[i]) {
                descriptions[j] = descriptions[i];
                j++;
              }
            }
            descriptions.length = j;
          }
          switch (descriptions.length) {
            case 1:
              return descriptions[0];
            case 2:
              return descriptions[0] + " or " + descriptions[1];
            default:
              return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
          }
        }
        function describeFound(found2) {
          return found2 ? '"' + literalEscape(found2) + '"' : "end of input";
        }
        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
      };
      function peg$parse(input, options) {
        options = options !== void 0 ? options : {};
        var peg$FAILED = {}, peg$startRuleFunctions = { turtleDoc: peg$parseturtleDoc }, peg$startRuleFunction = peg$parseturtleDoc, peg$c0 = function(statements) {
          var jsonld = context.toJSON();
          jsonld["@graph"] = [];
          statements.filter((a) => Array.isArray(a)).forEach((a) => {
            a.forEach((b) => {
              jsonld["@graph"].push(b);
            });
          });
          if (jsonld["@graph"].length === 1) {
            Object.assign(jsonld, jsonld["@graph"][0]);
            delete jsonld["@graph"];
          }
          return jsonld;
        }, peg$c1 = ".", peg$c2 = peg$literalExpectation(".", false), peg$c3 = function(a) {
          return a;
        }, peg$c4 = "#", peg$c5 = peg$literalExpectation("#", false), peg$c6 = /^[^\n]/, peg$c7 = peg$classExpectation(["\n"], true, false), peg$c8 = "\n", peg$c9 = peg$literalExpectation("\n", false), peg$c10 = function(a) {
          return a.join("");
        }, peg$c11 = "@prefix", peg$c12 = peg$literalExpectation("@prefix", false), peg$c13 = function(a, b) {
          context.addPrefix(a === "" ? "0" : a, b);
          return {};
        }, peg$c14 = "@base", peg$c15 = peg$literalExpectation("@base", false), peg$c16 = function(a) {
          context.addBase(a);
          return {};
        }, peg$c17 = /^[Bb]/, peg$c18 = peg$classExpectation(["B", "b"], false, false), peg$c19 = /^[Aa]/, peg$c20 = peg$classExpectation(["A", "a"], false, false), peg$c21 = /^[Ss]/, peg$c22 = peg$classExpectation(["S", "s"], false, false), peg$c23 = /^[Ee]/, peg$c24 = peg$classExpectation(["E", "e"], false, false), peg$c25 = /^[Pp]/, peg$c26 = peg$classExpectation(["P", "p"], false, false), peg$c27 = /^[Rr]/, peg$c28 = peg$classExpectation(["R", "r"], false, false), peg$c29 = /^[Ff]/, peg$c30 = peg$classExpectation(["F", "f"], false, false), peg$c31 = /^[Ii]/, peg$c32 = peg$classExpectation(["I", "i"], false, false), peg$c33 = /^[Xx]/, peg$c34 = peg$classExpectation(["X", "x"], false, false), peg$c35 = function(s, p) {
          var x = {};
          if (typeof s === "string" && s !== "[]") x["@id"] = s;
          else if (typeof s === "object") Object.assign(x, s);
          if (p) Object.assign(x, p);
          return [x];
        }, peg$c36 = function(s, p) {
          var x = {};
          if (s) Object.assign(x, s);
          if (p) Object.assign(x, p);
          return [x];
        }, peg$c37 = ";", peg$c38 = peg$literalExpectation(";", false), peg$c39 = function(a, b, e, f) {
          var x = {};
          x[e] = f;
          return x;
        }, peg$c40 = function(a, b, d) {
          return d;
        }, peg$c41 = function(a, b, c) {
          var x = {};
          c.unshift(createObject(a, b));
          c.forEach((t) => {
            if (!t) return;
            Object.keys(t).forEach((key) => {
              t[key].forEach((val) => {
                if (key === "@type" && val["@id"] !== void 0) val = val["@id"];
                if (x[key] === void 0) x[key] = val;
                else if (Array.isArray(x[key])) x[key].push(val);
                else x[key] = [x[key], val];
              });
            });
          });
          return x;
        }, peg$c42 = ",", peg$c43 = peg$literalExpectation(",", false), peg$c44 = function(a, c) {
          return c;
        }, peg$c45 = function(a, b) {
          b.unshift(a);
          return b;
        }, peg$c46 = "a", peg$c47 = peg$literalExpectation("a", false), peg$c48 = function() {
          return "@type";
        }, peg$c49 = function(a) {
          return expandList(a, true);
        }, peg$c50 = function(a) {
          return expandList(a, false);
        }, peg$c51 = function(a) {
          return a === "[]" ? {} : { "@id": a };
        }, peg$c52 = function(a) {
          return { "@id": a };
        }, peg$c53 = "[", peg$c54 = peg$literalExpectation("[", false), peg$c55 = "]", peg$c56 = peg$literalExpectation("]", false), peg$c57 = "(", peg$c58 = peg$literalExpectation("(", false), peg$c59 = ")", peg$c60 = peg$literalExpectation(")", false), peg$c61 = function(a) {
          return { "@list": a };
        }, peg$c62 = function(a, b) {
          return { "@value": a, "@language": b };
        }, peg$c63 = "^^", peg$c64 = peg$literalExpectation("^^", false), peg$c65 = function(a, b) {
          if (b === "http://www.w3.org/2001/XMLSchema#boolean" && a === "true") return true;
          if (b === "http://www.w3.org/2001/XMLSchema#boolean" && a === "false") return false;
          if (b === "http://www.w3.org/2001/XMLSchema#integer") return parseInt(a);
          if (b === "http://www.w3.org/2001/XMLSchema#double") return parseFloat(a);
          const uri = context.resolve(b, true);
          if (uri) {
            const prefix = b.split(":")[0];
            if (uri === "http://www.w3.org/2001/XMLSchema#boolean" && a === "true") {
              context.decrement(prefix);
              return true;
            }
            if (uri === "http://www.w3.org/2001/XMLSchema#boolean" && a === "false") {
              context.decrement(prefix);
              return false;
            }
            if (uri === "http://www.w3.org/2001/XMLSchema#integer") {
              context.decrement(prefix);
              return parseInt(a);
            }
            if (uri === "http://www.w3.org/2001/XMLSchema#double") {
              context.decrement(prefix);
              return parseFloat(a);
            }
          }
          return { "@value": a, "@type": b };
        }, peg$c66 = "true", peg$c67 = peg$literalExpectation("true", false), peg$c68 = function() {
          return true;
        }, peg$c69 = "false", peg$c70 = peg$literalExpectation("false", false), peg$c71 = function() {
          return false;
        }, peg$c72 = function(a) {
          return a + ":";
        }, peg$c73 = "<", peg$c74 = peg$literalExpectation("<", false), peg$c75 = /^[^\0- <>"{}|\^`\\]/, peg$c76 = peg$classExpectation([["\0", " "], "<", ">", '"', "{", "}", "|", "^", "`", "\\"], true, false), peg$c77 = ">", peg$c78 = peg$literalExpectation(">", false), peg$c79 = function(a) {
          const decoded = a.map((s) => {
            if (65536 <= s.codePointAt(0) && s.codePointAt(0) <= 983039) return "a";
            if (s.length === 1) return s;
            if (s.length === 6) return String.fromCharCode("0x" + s.substring(2));
            if (s.length === 10) return String.fromCodePoint("0x" + s.substring(2));
            return s;
          }).join("");
          if (decoded.match(/^[^\u0000-\u0020<>"{}|^`\\]*$/)) {
            var join2 = a.join("");
            try {
              return context.resolve(join2);
            } catch (e) {
              error2("Invalid IRIREF " + join2);
            }
          } else error2("Invalid IRIREF " + a.join("") + " / " + decoded);
        }, peg$c80 = ":", peg$c81 = peg$literalExpectation(":", false), peg$c82 = function(a) {
          a = a || "0";
          if (context.hasPrefix(a) === false)
            error2("undefined prefix " + a);
          return a;
        }, peg$c83 = function(a) {
          return a || "";
        }, peg$c84 = function(a, b) {
          context.increment(a);
          return context.resolve(a + ":" + b);
        }, peg$c85 = "_:", peg$c86 = peg$literalExpectation("_:", false), peg$c87 = /^[0-9]/, peg$c88 = peg$classExpectation([["0", "9"]], false, false), peg$c89 = "@", peg$c90 = peg$literalExpectation("@", false), peg$c91 = /^[a-zA-Z]/, peg$c92 = peg$classExpectation([["a", "z"], ["A", "Z"]], false, false), peg$c93 = "-", peg$c94 = peg$literalExpectation("-", false), peg$c95 = /^[a-zA-Z0-9]/, peg$c96 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"]], false, false), peg$c97 = function(a, s) {
          return "-" + s.join("");
        }, peg$c98 = function(a, b) {
          return a.join("") + b.join("");
        }, peg$c99 = /^[+\-]/, peg$c100 = peg$classExpectation(["+", "-"], false, false), peg$c101 = function(a) {
          if (a.match(/^[0+][0-9]+$/))
            return {
              "@value": a,
              "@type": "http://www.w3.org/2001/XMLSchema#integer"
            };
          return parseInt(a);
        }, peg$c102 = function(a) {
          return {
            "@value": a,
            "@type": "http://www.w3.org/2001/XMLSchema#decimal"
          };
        }, peg$c103 = function(a) {
          return {
            "@value": a,
            "@type": "http://www.w3.org/2001/XMLSchema#double"
          };
        }, peg$c104 = /^[eE]/, peg$c105 = peg$classExpectation(["e", "E"], false, false), peg$c106 = '"', peg$c107 = peg$literalExpectation('"', false), peg$c108 = /^[^"\\\n\r]/, peg$c109 = peg$classExpectation(['"', "\\", "\n", "\r"], true, false), peg$c110 = "'", peg$c111 = peg$literalExpectation("'", false), peg$c112 = /^[^'\\\n\r]/, peg$c113 = peg$classExpectation(["'", "\\", "\n", "\r"], true, false), peg$c114 = "'''", peg$c115 = peg$literalExpectation("'''", false), peg$c116 = /^[^'\\]/, peg$c117 = peg$classExpectation(["'", "\\"], true, false), peg$c118 = "''", peg$c119 = peg$literalExpectation("''", false), peg$c120 = function(head, a) {
          return "''" + a.join("");
        }, peg$c121 = function(head, a) {
          return "'" + a.join("");
        }, peg$c122 = function(head, body) {
          return head.join("") + body.join("");
        }, peg$c123 = '"""', peg$c124 = peg$literalExpectation('"""', false), peg$c125 = /^[^"\\]/, peg$c126 = peg$classExpectation(['"', "\\"], true, false), peg$c127 = '""', peg$c128 = peg$literalExpectation('""', false), peg$c129 = function(head, a) {
          return '""' + a.join("");
        }, peg$c130 = function(head, a) {
          return '"' + a.join("");
        }, peg$c131 = "\\U", peg$c132 = peg$literalExpectation("\\U", false), peg$c133 = function(hex) {
          return String.fromCodePoint(parseInt(hex.join(""), 16));
        }, peg$c134 = "\\u", peg$c135 = peg$literalExpectation("\\u", false), peg$c136 = function(hex) {
          return String.fromCharCode(parseInt(hex.join(""), 16));
        }, peg$c137 = "\\t", peg$c138 = peg$literalExpectation("\\t", false), peg$c139 = function() {
          return "	";
        }, peg$c140 = "\\b", peg$c141 = peg$literalExpectation("\\b", false), peg$c142 = function() {
          return "\b";
        }, peg$c143 = "\\n", peg$c144 = peg$literalExpectation("\\n", false), peg$c145 = function() {
          return "\n";
        }, peg$c146 = "\\r", peg$c147 = peg$literalExpectation("\\r", false), peg$c148 = function() {
          return "\r";
        }, peg$c149 = "\\f", peg$c150 = peg$literalExpectation("\\f", false), peg$c151 = function() {
          return "\f";
        }, peg$c152 = '\\"', peg$c153 = peg$literalExpectation('\\"', false), peg$c154 = function() {
          return '"';
        }, peg$c155 = "\\'", peg$c156 = peg$literalExpectation("\\'", false), peg$c157 = function() {
          return "'";
        }, peg$c158 = "\\\\", peg$c159 = peg$literalExpectation("\\\\", false), peg$c160 = function() {
          return "\\";
        }, peg$c161 = /^[ \t\r\n]/, peg$c162 = peg$classExpectation([" ", "	", "\r", "\n"], false, false), peg$c163 = function() {
          return "[]";
        }, peg$c164 = /^[\uD800-\uDBFF]/, peg$c165 = peg$classExpectation([["\uD800", "\uDBFF"]], false, false), peg$c166 = /^[\uDC00-\uDFFF]/, peg$c167 = peg$classExpectation([["\uDC00", "\uDFFF"]], false, false), peg$c168 = function(a, b) {
          return a + b;
        }, peg$c169 = /^[A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, peg$c170 = peg$classExpectation([["A", "Z"], ["a", "z"], ["\xC0", "\xD6"], ["\xD8", "\xF6"], ["\xF8", "\u02FF"], ["\u0370", "\u037D"], ["\u037F", "\u1FFF"], ["\u200C", "\u200D"], ["\u2070", "\u218F"], ["\u2C00", "\u2FEF"], ["\u3001", "\uD7FF"], ["\uF900", "\uFDCF"], ["\uFDF0", "\uFFFD"]], false, false), peg$c171 = "_", peg$c172 = peg$literalExpectation("_", false), peg$c173 = "\xB7", peg$c174 = peg$literalExpectation("\xB7", false), peg$c175 = /^[\u0300-\u036F]/, peg$c176 = peg$classExpectation([["\u0300", "\u036F"]], false, false), peg$c177 = /^[\u203F-\u2040]/, peg$c178 = peg$classExpectation([["\u203F", "\u2040"]], false, false), peg$c179 = function(head, body, a, b) {
          return a.join("") + b.join("");
        }, peg$c180 = function(head, body, tail) {
          return head + body.join("") + tail.join("");
        }, peg$c181 = "%", peg$c182 = peg$literalExpectation("%", false), peg$c183 = /^[0-9A-Fa-f]/, peg$c184 = peg$classExpectation([["0", "9"], ["A", "F"], ["a", "f"]], false, false), peg$c185 = "\\", peg$c186 = peg$literalExpectation("\\", false), peg$c187 = /^[_~.!$&'()*+,;=\/?#@%\-]/, peg$c188 = peg$classExpectation(["_", "~", ".", "!", "$", "&", "'", "(", ")", "*", "+", ",", ";", "=", "/", "?", "#", "@", "%", "-"], false, false), peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [{ line: 1, column: 1 }], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
        if ("startRule" in options) {
          if (!(options.startRule in peg$startRuleFunctions)) {
            throw new Error(`Can't start parsing from rule "` + options.startRule + '".');
          }
          peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
        }
        function text() {
          return input.substring(peg$savedPos, peg$currPos);
        }
        function location() {
          return peg$computeLocation(peg$savedPos, peg$currPos);
        }
        function expected(description, location2) {
          location2 = location2 !== void 0 ? location2 : peg$computeLocation(peg$savedPos, peg$currPos);
          throw peg$buildStructuredError(
            [peg$otherExpectation(description)],
            input.substring(peg$savedPos, peg$currPos),
            location2
          );
        }
        function error2(message, location2) {
          location2 = location2 !== void 0 ? location2 : peg$computeLocation(peg$savedPos, peg$currPos);
          throw peg$buildSimpleError(message, location2);
        }
        function peg$literalExpectation(text2, ignoreCase) {
          return { type: "literal", text: text2, ignoreCase };
        }
        function peg$classExpectation(parts, inverted, ignoreCase) {
          return { type: "class", parts, inverted, ignoreCase };
        }
        function peg$anyExpectation() {
          return { type: "any" };
        }
        function peg$endExpectation() {
          return { type: "end" };
        }
        function peg$otherExpectation(description) {
          return { type: "other", description };
        }
        function peg$computePosDetails(pos) {
          var details = peg$posDetailsCache[pos], p;
          if (details) {
            return details;
          } else {
            p = pos - 1;
            while (!peg$posDetailsCache[p]) {
              p--;
            }
            details = peg$posDetailsCache[p];
            details = {
              line: details.line,
              column: details.column
            };
            while (p < pos) {
              if (input.charCodeAt(p) === 10) {
                details.line++;
                details.column = 1;
              } else {
                details.column++;
              }
              p++;
            }
            peg$posDetailsCache[pos] = details;
            return details;
          }
        }
        function peg$computeLocation(startPos, endPos) {
          var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
          return {
            start: {
              offset: startPos,
              line: startPosDetails.line,
              column: startPosDetails.column
            },
            end: {
              offset: endPos,
              line: endPosDetails.line,
              column: endPosDetails.column
            }
          };
        }
        function peg$fail(expected2) {
          if (peg$currPos < peg$maxFailPos) {
            return;
          }
          if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
          }
          peg$maxFailExpected.push(expected2);
        }
        function peg$buildSimpleError(message, location2) {
          return new peg$SyntaxError(message, null, null, location2);
        }
        function peg$buildStructuredError(expected2, found, location2) {
          return new peg$SyntaxError(
            peg$SyntaxError.buildMessage(expected2, found),
            expected2,
            found,
            location2
          );
        }
        function peg$parseturtleDoc() {
          var s0, s1, s2, s3;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parsestatement();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parsestatement();
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parseIGNORE();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parseIGNORE();
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c0(s1);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsestatement() {
          var s0, s1, s2, s3;
          s0 = peg$parsedirective();
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsetriples();
            if (s1 !== peg$FAILED) {
              s2 = [];
              s3 = peg$parseIGNORE();
              while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$parseIGNORE();
              }
              if (s2 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 46) {
                  s3 = peg$c1;
                  peg$currPos++;
                } else {
                  s3 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c2);
                  }
                }
                if (s3 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c3(s1);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parseCOMMENT() {
          var s0, s1, s2, s3;
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 35) {
            s1 = peg$c4;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c5);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c6.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c7);
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              if (peg$c6.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c7);
                }
              }
            }
            if (s2 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 10) {
                s3 = peg$c8;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c9);
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c10(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseIGNORE() {
          var s0;
          s0 = peg$parseWS();
          if (s0 === peg$FAILED) {
            s0 = peg$parseCOMMENT();
          }
          return s0;
        }
        function peg$parsedirective() {
          var s0;
          s0 = peg$parseprefixID();
          if (s0 === peg$FAILED) {
            s0 = peg$parsebase();
            if (s0 === peg$FAILED) {
              s0 = peg$parsesparqlPrefix();
              if (s0 === peg$FAILED) {
                s0 = peg$parsesparqlBase();
              }
            }
          }
          return s0;
        }
        function peg$parseprefixID() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (input.substr(peg$currPos, 7) === peg$c11) {
              s2 = peg$c11;
              peg$currPos += 7;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c12);
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$parseIGNORE();
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$parseIGNORE();
              }
              if (s3 !== peg$FAILED) {
                s4 = peg$parsePNAME_NS_NO_CHECK();
                if (s4 !== peg$FAILED) {
                  s5 = [];
                  s6 = peg$parseIGNORE();
                  while (s6 !== peg$FAILED) {
                    s5.push(s6);
                    s6 = peg$parseIGNORE();
                  }
                  if (s5 !== peg$FAILED) {
                    s6 = peg$parseIRIREF();
                    if (s6 !== peg$FAILED) {
                      s7 = [];
                      s8 = peg$parseIGNORE();
                      while (s8 !== peg$FAILED) {
                        s7.push(s8);
                        s8 = peg$parseIGNORE();
                      }
                      if (s7 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 46) {
                          s8 = peg$c1;
                          peg$currPos++;
                        } else {
                          s8 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c2);
                          }
                        }
                        if (s8 !== peg$FAILED) {
                          peg$savedPos = s0;
                          s1 = peg$c13(s4, s6);
                          s0 = s1;
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsebase() {
          var s0, s1, s2, s3, s4, s5, s6;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (input.substr(peg$currPos, 5) === peg$c14) {
              s2 = peg$c14;
              peg$currPos += 5;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c15);
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$parseIGNORE();
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$parseIGNORE();
              }
              if (s3 !== peg$FAILED) {
                s4 = peg$parseIRIREF();
                if (s4 !== peg$FAILED) {
                  s5 = [];
                  s6 = peg$parseIGNORE();
                  while (s6 !== peg$FAILED) {
                    s5.push(s6);
                    s6 = peg$parseIGNORE();
                  }
                  if (s5 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 46) {
                      s6 = peg$c1;
                      peg$currPos++;
                    } else {
                      s6 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c2);
                      }
                    }
                    if (s6 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c16(s4);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsesparqlBase() {
          var s0, s1, s2, s3, s4, s5, s6, s7;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (peg$c17.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c18);
              }
            }
            if (s2 !== peg$FAILED) {
              if (peg$c19.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c20);
                }
              }
              if (s3 !== peg$FAILED) {
                if (peg$c21.test(input.charAt(peg$currPos))) {
                  s4 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s4 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c22);
                  }
                }
                if (s4 !== peg$FAILED) {
                  if (peg$c23.test(input.charAt(peg$currPos))) {
                    s5 = input.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c24);
                    }
                  }
                  if (s5 !== peg$FAILED) {
                    s6 = [];
                    s7 = peg$parseIGNORE();
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      s7 = peg$parseIGNORE();
                    }
                    if (s6 !== peg$FAILED) {
                      s7 = peg$parseIRIREF();
                      if (s7 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c16(s7);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsesparqlPrefix() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (peg$c25.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c26);
              }
            }
            if (s2 !== peg$FAILED) {
              if (peg$c27.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c28);
                }
              }
              if (s3 !== peg$FAILED) {
                if (peg$c23.test(input.charAt(peg$currPos))) {
                  s4 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s4 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c24);
                  }
                }
                if (s4 !== peg$FAILED) {
                  if (peg$c29.test(input.charAt(peg$currPos))) {
                    s5 = input.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c30);
                    }
                  }
                  if (s5 !== peg$FAILED) {
                    if (peg$c31.test(input.charAt(peg$currPos))) {
                      s6 = input.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s6 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c32);
                      }
                    }
                    if (s6 !== peg$FAILED) {
                      if (peg$c33.test(input.charAt(peg$currPos))) {
                        s7 = input.charAt(peg$currPos);
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c34);
                        }
                      }
                      if (s7 !== peg$FAILED) {
                        s8 = [];
                        s9 = peg$parseIGNORE();
                        while (s9 !== peg$FAILED) {
                          s8.push(s9);
                          s9 = peg$parseIGNORE();
                        }
                        if (s8 !== peg$FAILED) {
                          s9 = peg$parsePNAME_NS_NO_CHECK();
                          if (s9 !== peg$FAILED) {
                            s10 = [];
                            s11 = peg$parseIGNORE();
                            while (s11 !== peg$FAILED) {
                              s10.push(s11);
                              s11 = peg$parseIGNORE();
                            }
                            if (s10 !== peg$FAILED) {
                              s11 = peg$parseIRIREF();
                              if (s11 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c13(s9, s11);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsetriples() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = peg$parsesubject();
          if (s1 !== peg$FAILED) {
            s2 = peg$parsepredicateObjectList();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c35(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseblankNodePropertyList();
            if (s1 !== peg$FAILED) {
              s2 = peg$parsepredicateObjectList();
              if (s2 === peg$FAILED) {
                s2 = null;
              }
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c36(s1, s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parsepredicateObjectList() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
          s0 = peg$currPos;
          s1 = peg$parseverb();
          if (s1 !== peg$FAILED) {
            s2 = peg$parseobjectList();
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$currPos;
              s5 = [];
              s6 = peg$parseIGNORE();
              while (s6 !== peg$FAILED) {
                s5.push(s6);
                s6 = peg$parseIGNORE();
              }
              if (s5 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 59) {
                  s6 = peg$c37;
                  peg$currPos++;
                } else {
                  s6 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c38);
                  }
                }
                if (s6 !== peg$FAILED) {
                  s7 = peg$currPos;
                  s8 = peg$parseverb();
                  if (s8 !== peg$FAILED) {
                    s9 = peg$parseobjectList();
                    if (s9 !== peg$FAILED) {
                      peg$savedPos = s7;
                      s8 = peg$c39(s1, s2, s8, s9);
                      s7 = s8;
                    } else {
                      peg$currPos = s7;
                      s7 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s7;
                    s7 = peg$FAILED;
                  }
                  if (s7 === peg$FAILED) {
                    s7 = null;
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c40(s1, s2, s7);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$currPos;
                s5 = [];
                s6 = peg$parseIGNORE();
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseIGNORE();
                }
                if (s5 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 59) {
                    s6 = peg$c37;
                    peg$currPos++;
                  } else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c38);
                    }
                  }
                  if (s6 !== peg$FAILED) {
                    s7 = peg$currPos;
                    s8 = peg$parseverb();
                    if (s8 !== peg$FAILED) {
                      s9 = peg$parseobjectList();
                      if (s9 !== peg$FAILED) {
                        peg$savedPos = s7;
                        s8 = peg$c39(s1, s2, s8, s9);
                        s7 = s8;
                      } else {
                        peg$currPos = s7;
                        s7 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s7;
                      s7 = peg$FAILED;
                    }
                    if (s7 === peg$FAILED) {
                      s7 = null;
                    }
                    if (s7 !== peg$FAILED) {
                      peg$savedPos = s4;
                      s5 = peg$c40(s1, s2, s7);
                      s4 = s5;
                    } else {
                      peg$currPos = s4;
                      s4 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c41(s1, s2, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseobjectList() {
          var s0, s1, s2, s3, s4, s5, s6;
          s0 = peg$currPos;
          s1 = peg$parseobject();
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = [];
            s5 = peg$parseIGNORE();
            while (s5 !== peg$FAILED) {
              s4.push(s5);
              s5 = peg$parseIGNORE();
            }
            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 44) {
                s5 = peg$c42;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c43);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parseobject();
                if (s6 !== peg$FAILED) {
                  peg$savedPos = s3;
                  s4 = peg$c44(s1, s6);
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$currPos;
              s4 = [];
              s5 = peg$parseIGNORE();
              while (s5 !== peg$FAILED) {
                s4.push(s5);
                s5 = peg$parseIGNORE();
              }
              if (s4 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 44) {
                  s5 = peg$c42;
                  peg$currPos++;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c43);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = peg$parseobject();
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s3;
                    s4 = peg$c44(s1, s6);
                    s3 = s4;
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c45(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseverb() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = peg$parsepredicate();
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c3(s1);
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while (s2 !== peg$FAILED) {
              s1.push(s2);
              s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 97) {
                s2 = peg$c46;
                peg$currPos++;
              } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c47);
                }
              }
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c48();
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parsesubject() {
          var s0, s1;
          s0 = peg$currPos;
          s1 = peg$parsecollection();
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c49(s1);
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$parseBlankNode();
            if (s0 === peg$FAILED) {
              s0 = peg$parseiri();
            }
          }
          return s0;
        }
        function peg$parsepredicate() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseiri();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c3(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseobject() {
          var s0, s1;
          s0 = peg$parseliteral();
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsecollection();
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c50(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = peg$parseBlankNode();
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c51(s1);
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseblankNodePropertyList();
                if (s1 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c3(s1);
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  s1 = peg$parseiri();
                  if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c52(s1);
                  }
                  s0 = s1;
                }
              }
            }
          }
          return s0;
        }
        function peg$parseliteral() {
          var s0;
          s0 = peg$parseRDFLiteral();
          if (s0 === peg$FAILED) {
            s0 = peg$parseNumericLiteral();
            if (s0 === peg$FAILED) {
              s0 = peg$parseBooleanLiteral();
            }
          }
          return s0;
        }
        function peg$parseblankNodePropertyList() {
          var s0, s1, s2, s3, s4, s5;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 91) {
              s2 = peg$c53;
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c54);
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsepredicateObjectList();
              if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parseIGNORE();
                while (s5 !== peg$FAILED) {
                  s4.push(s5);
                  s5 = peg$parseIGNORE();
                }
                if (s4 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 93) {
                    s5 = peg$c55;
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c56);
                    }
                  }
                  if (s5 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s3);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsecollection() {
          var s0, s1, s2, s3, s4, s5;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 40) {
              s2 = peg$c57;
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c58);
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$parseobject();
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$parseobject();
              }
              if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parseIGNORE();
                while (s5 !== peg$FAILED) {
                  s4.push(s5);
                  s5 = peg$parseIGNORE();
                }
                if (s4 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 41) {
                    s5 = peg$c59;
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c60);
                    }
                  }
                  if (s5 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c61(s3);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseNumericLiteral() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseDOUBLE();
            if (s2 === peg$FAILED) {
              s2 = peg$parseDECIMAL();
              if (s2 === peg$FAILED) {
                s2 = peg$parseINTEGER();
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c3(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseRDFLiteral() {
          var s0, s1, s2, s3, s4, s5, s6;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseString();
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$parseIGNORE();
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$parseIGNORE();
              }
              if (s3 !== peg$FAILED) {
                s4 = peg$parseLANGTAG();
                if (s4 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c62(s2, s4);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while (s2 !== peg$FAILED) {
              s1.push(s2);
              s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
              s2 = peg$parseString();
              if (s2 !== peg$FAILED) {
                s3 = [];
                s4 = peg$parseIGNORE();
                while (s4 !== peg$FAILED) {
                  s3.push(s4);
                  s4 = peg$parseIGNORE();
                }
                if (s3 !== peg$FAILED) {
                  if (input.substr(peg$currPos, 2) === peg$c63) {
                    s4 = peg$c63;
                    peg$currPos += 2;
                  } else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c64);
                    }
                  }
                  if (s4 !== peg$FAILED) {
                    s5 = [];
                    s6 = peg$parseIGNORE();
                    while (s6 !== peg$FAILED) {
                      s5.push(s6);
                      s6 = peg$parseIGNORE();
                    }
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parseiri();
                      if (s6 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c65(s2, s6);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = [];
              s2 = peg$parseIGNORE();
              while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parseIGNORE();
              }
              if (s1 !== peg$FAILED) {
                s2 = peg$parseString();
                if (s2 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c3(s2);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            }
          }
          return s0;
        }
        function peg$parseBooleanLiteral() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (input.substr(peg$currPos, 4) === peg$c66) {
              s2 = peg$c66;
              peg$currPos += 4;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c67);
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c68();
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while (s2 !== peg$FAILED) {
              s1.push(s2);
              s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
              if (input.substr(peg$currPos, 5) === peg$c69) {
                s2 = peg$c69;
                peg$currPos += 5;
              } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c70);
                }
              }
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c71();
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parseString() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseSTRING_LITERAL_LONG_SINGLE_QUOTE();
            if (s2 === peg$FAILED) {
              s2 = peg$parseSTRING_LITERAL_LONG_QUOTE();
              if (s2 === peg$FAILED) {
                s2 = peg$parseSTRING_LITERAL_SINGLE_QUOTE();
                if (s2 === peg$FAILED) {
                  s2 = peg$parseSTRING_LITERAL_QUOTE();
                }
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c3(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseiri() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseIRIREF();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c3(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while (s2 !== peg$FAILED) {
              s1.push(s2);
              s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
              s2 = peg$parsePrefixedName();
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c3(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parsePrefixedName() {
          var s0, s1;
          s0 = peg$parsePNAME_LN();
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsePNAME_NS();
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c72(s1);
            }
            s0 = s1;
          }
          return s0;
        }
        function peg$parseBlankNode() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseBLANK_NODE_LABEL();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c3(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while (s2 !== peg$FAILED) {
              s1.push(s2);
              s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
              s2 = peg$parseANON();
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c3(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parseIRIREF() {
          var s0, s1, s2, s3;
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 60) {
            s1 = peg$c73;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c74);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c75.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c76);
              }
            }
            if (s3 === peg$FAILED) {
              s3 = peg$parseUCHAR();
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              if (peg$c75.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c76);
                }
              }
              if (s3 === peg$FAILED) {
                s3 = peg$parseUCHAR();
              }
            }
            if (s2 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 62) {
                s3 = peg$c77;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c78);
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c79(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsePNAME_NS() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = peg$parsePN_PREFIX();
          if (s1 === peg$FAILED) {
            s1 = null;
          }
          if (s1 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 58) {
              s2 = peg$c80;
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c81);
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c82(s1);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsePNAME_NS_NO_CHECK() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = peg$parsePN_PREFIX();
          if (s1 === peg$FAILED) {
            s1 = null;
          }
          if (s1 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 58) {
              s2 = peg$c80;
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c81);
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c83(s1);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsePNAME_LN() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = peg$parsePNAME_NS();
          if (s1 !== peg$FAILED) {
            s2 = peg$parsePN_LOCAL();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c84(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseBLANK_NODE_LABEL() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
          s0 = peg$currPos;
          s1 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c85) {
            s2 = peg$c85;
            peg$currPos += 2;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c86);
            }
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parsePN_CHARS_U();
            if (s3 === peg$FAILED) {
              if (peg$c87.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c88);
                }
              }
            }
            if (s3 !== peg$FAILED) {
              s4 = [];
              s5 = peg$parsePN_CHARS();
              while (s5 !== peg$FAILED) {
                s4.push(s5);
                s5 = peg$parsePN_CHARS();
              }
              if (s4 !== peg$FAILED) {
                s5 = [];
                s6 = peg$currPos;
                s7 = [];
                if (input.charCodeAt(peg$currPos) === 46) {
                  s8 = peg$c1;
                  peg$currPos++;
                } else {
                  s8 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c2);
                  }
                }
                if (s8 !== peg$FAILED) {
                  while (s8 !== peg$FAILED) {
                    s7.push(s8);
                    if (input.charCodeAt(peg$currPos) === 46) {
                      s8 = peg$c1;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c2);
                      }
                    }
                  }
                } else {
                  s7 = peg$FAILED;
                }
                if (s7 !== peg$FAILED) {
                  s8 = [];
                  s9 = peg$parsePN_CHARS();
                  if (s9 !== peg$FAILED) {
                    while (s9 !== peg$FAILED) {
                      s8.push(s9);
                      s9 = peg$parsePN_CHARS();
                    }
                  } else {
                    s8 = peg$FAILED;
                  }
                  if (s8 !== peg$FAILED) {
                    s7 = [s7, s8];
                    s6 = s7;
                  } else {
                    peg$currPos = s6;
                    s6 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s6;
                  s6 = peg$FAILED;
                }
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$currPos;
                  s7 = [];
                  if (input.charCodeAt(peg$currPos) === 46) {
                    s8 = peg$c1;
                    peg$currPos++;
                  } else {
                    s8 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c2);
                    }
                  }
                  if (s8 !== peg$FAILED) {
                    while (s8 !== peg$FAILED) {
                      s7.push(s8);
                      if (input.charCodeAt(peg$currPos) === 46) {
                        s8 = peg$c1;
                        peg$currPos++;
                      } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c2);
                        }
                      }
                    }
                  } else {
                    s7 = peg$FAILED;
                  }
                  if (s7 !== peg$FAILED) {
                    s8 = [];
                    s9 = peg$parsePN_CHARS();
                    if (s9 !== peg$FAILED) {
                      while (s9 !== peg$FAILED) {
                        s8.push(s9);
                        s9 = peg$parsePN_CHARS();
                      }
                    } else {
                      s8 = peg$FAILED;
                    }
                    if (s8 !== peg$FAILED) {
                      s7 = [s7, s8];
                      s6 = s7;
                    } else {
                      peg$currPos = s6;
                      s6 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s6;
                    s6 = peg$FAILED;
                  }
                }
                if (s5 !== peg$FAILED) {
                  s2 = [s2, s3, s4, s5];
                  s1 = s2;
                } else {
                  peg$currPos = s1;
                  s1 = peg$FAILED;
                }
              } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
              }
            } else {
              peg$currPos = s1;
              s1 = peg$FAILED;
            }
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
          if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
          } else {
            s0 = s1;
          }
          return s0;
        }
        function peg$parseLANGTAG() {
          var s0, s1, s2, s3, s4, s5, s6, s7;
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 64) {
            s1 = peg$c89;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c90);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c91.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c92);
              }
            }
            if (s3 !== peg$FAILED) {
              while (s3 !== peg$FAILED) {
                s2.push(s3);
                if (peg$c91.test(input.charAt(peg$currPos))) {
                  s3 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s3 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c92);
                  }
                }
              }
            } else {
              s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 45) {
                s5 = peg$c93;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c94);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = [];
                if (peg$c95.test(input.charAt(peg$currPos))) {
                  s7 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c96);
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    if (peg$c95.test(input.charAt(peg$currPos))) {
                      s7 = input.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c96);
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  peg$savedPos = s4;
                  s5 = peg$c97(s2, s6);
                  s4 = s5;
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$currPos;
                if (input.charCodeAt(peg$currPos) === 45) {
                  s5 = peg$c93;
                  peg$currPos++;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c94);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = [];
                  if (peg$c95.test(input.charAt(peg$currPos))) {
                    s7 = input.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c96);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      if (peg$c95.test(input.charAt(peg$currPos))) {
                        s7 = input.charAt(peg$currPos);
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c96);
                        }
                      }
                    }
                  } else {
                    s6 = peg$FAILED;
                  }
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c97(s2, s6);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c98(s2, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseINTEGER() {
          var s0, s1, s2, s3, s4, s5;
          s0 = peg$currPos;
          s1 = peg$currPos;
          s2 = peg$currPos;
          if (peg$c99.test(input.charAt(peg$currPos))) {
            s3 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c100);
            }
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            s4 = [];
            if (peg$c87.test(input.charAt(peg$currPos))) {
              s5 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c88);
              }
            }
            if (s5 !== peg$FAILED) {
              while (s5 !== peg$FAILED) {
                s4.push(s5);
                if (peg$c87.test(input.charAt(peg$currPos))) {
                  s5 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c88);
                  }
                }
              }
            } else {
              s4 = peg$FAILED;
            }
            if (s4 !== peg$FAILED) {
              s3 = [s3, s4];
              s2 = s3;
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
          if (s2 !== peg$FAILED) {
            s1 = input.substring(s1, peg$currPos);
          } else {
            s1 = s2;
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c101(s1);
          }
          s0 = s1;
          return s0;
        }
        function peg$parseDECIMAL() {
          var s0, s1, s2, s3, s4, s5, s6, s7;
          s0 = peg$currPos;
          s1 = peg$currPos;
          s2 = peg$currPos;
          if (peg$c99.test(input.charAt(peg$currPos))) {
            s3 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c100);
            }
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            s4 = [];
            if (peg$c87.test(input.charAt(peg$currPos))) {
              s5 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c88);
              }
            }
            while (s5 !== peg$FAILED) {
              s4.push(s5);
              if (peg$c87.test(input.charAt(peg$currPos))) {
                s5 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c88);
                }
              }
            }
            if (s4 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 46) {
                s5 = peg$c1;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c2);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = [];
                if (peg$c87.test(input.charAt(peg$currPos))) {
                  s7 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c88);
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                      s7 = input.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c88);
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  s3 = [s3, s4, s5, s6];
                  s2 = s3;
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
          if (s2 !== peg$FAILED) {
            s1 = input.substring(s1, peg$currPos);
          } else {
            s1 = s2;
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c102(s1);
          }
          s0 = s1;
          return s0;
        }
        function peg$parseDOUBLE() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8;
          s0 = peg$currPos;
          s1 = peg$currPos;
          s2 = peg$currPos;
          if (peg$c99.test(input.charAt(peg$currPos))) {
            s3 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c100);
            }
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$currPos;
            s5 = [];
            if (peg$c87.test(input.charAt(peg$currPos))) {
              s6 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s6 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c88);
              }
            }
            if (s6 !== peg$FAILED) {
              while (s6 !== peg$FAILED) {
                s5.push(s6);
                if (peg$c87.test(input.charAt(peg$currPos))) {
                  s6 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s6 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c88);
                  }
                }
              }
            } else {
              s5 = peg$FAILED;
            }
            if (s5 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 46) {
                s6 = peg$c1;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c2);
                }
              }
              if (s6 !== peg$FAILED) {
                s7 = [];
                if (peg$c87.test(input.charAt(peg$currPos))) {
                  s8 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s8 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c88);
                  }
                }
                while (s8 !== peg$FAILED) {
                  s7.push(s8);
                  if (peg$c87.test(input.charAt(peg$currPos))) {
                    s8 = input.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s8 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c88);
                    }
                  }
                }
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseEXPONENT();
                  if (s8 !== peg$FAILED) {
                    s5 = [s5, s6, s7, s8];
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
            if (s4 === peg$FAILED) {
              s4 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 46) {
                s5 = peg$c1;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c2);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = [];
                if (peg$c87.test(input.charAt(peg$currPos))) {
                  s7 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c88);
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                      s7 = input.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c88);
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  s7 = peg$parseEXPONENT();
                  if (s7 !== peg$FAILED) {
                    s5 = [s5, s6, s7];
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
              if (s4 === peg$FAILED) {
                s4 = peg$currPos;
                s5 = [];
                if (peg$c87.test(input.charAt(peg$currPos))) {
                  s6 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s6 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c88);
                  }
                }
                if (s6 !== peg$FAILED) {
                  while (s6 !== peg$FAILED) {
                    s5.push(s6);
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                      s6 = input.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s6 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c88);
                      }
                    }
                  }
                } else {
                  s5 = peg$FAILED;
                }
                if (s5 !== peg$FAILED) {
                  s6 = peg$parseEXPONENT();
                  if (s6 !== peg$FAILED) {
                    s5 = [s5, s6];
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              }
            }
            if (s4 !== peg$FAILED) {
              s3 = [s3, s4];
              s2 = s3;
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
          if (s2 !== peg$FAILED) {
            s1 = input.substring(s1, peg$currPos);
          } else {
            s1 = s2;
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c103(s1);
          }
          s0 = s1;
          return s0;
        }
        function peg$parseEXPONENT() {
          var s0, s1, s2, s3, s4, s5;
          s0 = peg$currPos;
          s1 = peg$currPos;
          if (peg$c104.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c105);
            }
          }
          if (s2 !== peg$FAILED) {
            if (peg$c99.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c100);
              }
            }
            if (s3 === peg$FAILED) {
              s3 = null;
            }
            if (s3 !== peg$FAILED) {
              s4 = [];
              if (peg$c87.test(input.charAt(peg$currPos))) {
                s5 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c88);
                }
              }
              if (s5 !== peg$FAILED) {
                while (s5 !== peg$FAILED) {
                  s4.push(s5);
                  if (peg$c87.test(input.charAt(peg$currPos))) {
                    s5 = input.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c88);
                    }
                  }
                }
              } else {
                s4 = peg$FAILED;
              }
              if (s4 !== peg$FAILED) {
                s2 = [s2, s3, s4];
                s1 = s2;
              } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
              }
            } else {
              peg$currPos = s1;
              s1 = peg$FAILED;
            }
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
          if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
          } else {
            s0 = s1;
          }
          return s0;
        }
        function peg$parseSTRING_LITERAL_QUOTE() {
          var s0, s1, s2, s3;
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 34) {
            s1 = peg$c106;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c107);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c108.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c109);
              }
            }
            if (s3 === peg$FAILED) {
              s3 = peg$parseECHAR();
              if (s3 === peg$FAILED) {
                s3 = peg$parseUCHAR();
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              if (peg$c108.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c109);
                }
              }
              if (s3 === peg$FAILED) {
                s3 = peg$parseECHAR();
                if (s3 === peg$FAILED) {
                  s3 = peg$parseUCHAR();
                }
              }
            }
            if (s2 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 34) {
                s3 = peg$c106;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c107);
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c10(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseSTRING_LITERAL_SINGLE_QUOTE() {
          var s0, s1, s2, s3;
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 39) {
            s1 = peg$c110;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c111);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c112.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c113);
              }
            }
            if (s3 === peg$FAILED) {
              s3 = peg$parseECHAR();
              if (s3 === peg$FAILED) {
                s3 = peg$parseUCHAR();
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              if (peg$c112.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c113);
                }
              }
              if (s3 === peg$FAILED) {
                s3 = peg$parseECHAR();
                if (s3 === peg$FAILED) {
                  s3 = peg$parseUCHAR();
                }
              }
            }
            if (s2 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 39) {
                s3 = peg$c110;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c111);
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c10(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseSTRING_LITERAL_LONG_SINGLE_QUOTE() {
          var s0, s1, s2, s3, s4, s5, s6, s7;
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 3) === peg$c114) {
            s1 = peg$c114;
            peg$currPos += 3;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c115);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c116.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c117);
              }
            }
            if (s3 === peg$FAILED) {
              s3 = peg$parseECHAR();
              if (s3 === peg$FAILED) {
                s3 = peg$parseUCHAR();
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              if (peg$c116.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c117);
                }
              }
              if (s3 === peg$FAILED) {
                s3 = peg$parseECHAR();
                if (s3 === peg$FAILED) {
                  s3 = peg$parseUCHAR();
                }
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c118) {
                s5 = peg$c118;
                peg$currPos += 2;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c119);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = [];
                if (peg$c116.test(input.charAt(peg$currPos))) {
                  s7 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c117);
                  }
                }
                if (s7 === peg$FAILED) {
                  s7 = peg$parseECHAR();
                  if (s7 === peg$FAILED) {
                    s7 = peg$parseUCHAR();
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    if (peg$c116.test(input.charAt(peg$currPos))) {
                      s7 = input.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c117);
                      }
                    }
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseECHAR();
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseUCHAR();
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  peg$savedPos = s4;
                  s5 = peg$c120(s2, s6);
                  s4 = s5;
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
              if (s4 === peg$FAILED) {
                s4 = peg$currPos;
                if (input.charCodeAt(peg$currPos) === 39) {
                  s5 = peg$c110;
                  peg$currPos++;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c111);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = [];
                  if (peg$c116.test(input.charAt(peg$currPos))) {
                    s7 = input.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c117);
                    }
                  }
                  if (s7 === peg$FAILED) {
                    s7 = peg$parseECHAR();
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseUCHAR();
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      if (peg$c116.test(input.charAt(peg$currPos))) {
                        s7 = input.charAt(peg$currPos);
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c117);
                        }
                      }
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseECHAR();
                        if (s7 === peg$FAILED) {
                          s7 = peg$parseUCHAR();
                        }
                      }
                    }
                  } else {
                    s6 = peg$FAILED;
                  }
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c121(s2, s6);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              }
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c118) {
                  s5 = peg$c118;
                  peg$currPos += 2;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c119);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = [];
                  if (peg$c116.test(input.charAt(peg$currPos))) {
                    s7 = input.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c117);
                    }
                  }
                  if (s7 === peg$FAILED) {
                    s7 = peg$parseECHAR();
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseUCHAR();
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      if (peg$c116.test(input.charAt(peg$currPos))) {
                        s7 = input.charAt(peg$currPos);
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c117);
                        }
                      }
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseECHAR();
                        if (s7 === peg$FAILED) {
                          s7 = peg$parseUCHAR();
                        }
                      }
                    }
                  } else {
                    s6 = peg$FAILED;
                  }
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c120(s2, s6);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
                if (s4 === peg$FAILED) {
                  s4 = peg$currPos;
                  if (input.charCodeAt(peg$currPos) === 39) {
                    s5 = peg$c110;
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c111);
                    }
                  }
                  if (s5 !== peg$FAILED) {
                    s6 = [];
                    if (peg$c116.test(input.charAt(peg$currPos))) {
                      s7 = input.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c117);
                      }
                    }
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseECHAR();
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseUCHAR();
                      }
                    }
                    if (s7 !== peg$FAILED) {
                      while (s7 !== peg$FAILED) {
                        s6.push(s7);
                        if (peg$c116.test(input.charAt(peg$currPos))) {
                          s7 = input.charAt(peg$currPos);
                          peg$currPos++;
                        } else {
                          s7 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c117);
                          }
                        }
                        if (s7 === peg$FAILED) {
                          s7 = peg$parseECHAR();
                          if (s7 === peg$FAILED) {
                            s7 = peg$parseUCHAR();
                          }
                        }
                      }
                    } else {
                      s6 = peg$FAILED;
                    }
                    if (s6 !== peg$FAILED) {
                      peg$savedPos = s4;
                      s5 = peg$c121(s2, s6);
                      s4 = s5;
                    } else {
                      peg$currPos = s4;
                      s4 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                }
              }
              if (s3 !== peg$FAILED) {
                if (input.substr(peg$currPos, 3) === peg$c114) {
                  s4 = peg$c114;
                  peg$currPos += 3;
                } else {
                  s4 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c115);
                  }
                }
                if (s4 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c122(s2, s3);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseSTRING_LITERAL_LONG_QUOTE() {
          var s0, s1, s2, s3, s4, s5, s6, s7;
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 3) === peg$c123) {
            s1 = peg$c123;
            peg$currPos += 3;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c124);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c125.test(input.charAt(peg$currPos))) {
              s3 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c126);
              }
            }
            if (s3 === peg$FAILED) {
              s3 = peg$parseECHAR();
              if (s3 === peg$FAILED) {
                s3 = peg$parseUCHAR();
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              if (peg$c125.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c126);
                }
              }
              if (s3 === peg$FAILED) {
                s3 = peg$parseECHAR();
                if (s3 === peg$FAILED) {
                  s3 = peg$parseUCHAR();
                }
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c127) {
                s5 = peg$c127;
                peg$currPos += 2;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c128);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = [];
                if (peg$c125.test(input.charAt(peg$currPos))) {
                  s7 = input.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c126);
                  }
                }
                if (s7 === peg$FAILED) {
                  s7 = peg$parseECHAR();
                  if (s7 === peg$FAILED) {
                    s7 = peg$parseUCHAR();
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    if (peg$c125.test(input.charAt(peg$currPos))) {
                      s7 = input.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c126);
                      }
                    }
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseECHAR();
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseUCHAR();
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  peg$savedPos = s4;
                  s5 = peg$c129(s2, s6);
                  s4 = s5;
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
              if (s4 === peg$FAILED) {
                s4 = peg$currPos;
                if (input.charCodeAt(peg$currPos) === 34) {
                  s5 = peg$c106;
                  peg$currPos++;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c107);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = [];
                  if (peg$c125.test(input.charAt(peg$currPos))) {
                    s7 = input.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c126);
                    }
                  }
                  if (s7 === peg$FAILED) {
                    s7 = peg$parseECHAR();
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseUCHAR();
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      if (peg$c125.test(input.charAt(peg$currPos))) {
                        s7 = input.charAt(peg$currPos);
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c126);
                        }
                      }
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseECHAR();
                        if (s7 === peg$FAILED) {
                          s7 = peg$parseUCHAR();
                        }
                      }
                    }
                  } else {
                    s6 = peg$FAILED;
                  }
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c130(s2, s6);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              }
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c127) {
                  s5 = peg$c127;
                  peg$currPos += 2;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c128);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = [];
                  if (peg$c125.test(input.charAt(peg$currPos))) {
                    s7 = input.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c126);
                    }
                  }
                  if (s7 === peg$FAILED) {
                    s7 = peg$parseECHAR();
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseUCHAR();
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      if (peg$c125.test(input.charAt(peg$currPos))) {
                        s7 = input.charAt(peg$currPos);
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c126);
                        }
                      }
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseECHAR();
                        if (s7 === peg$FAILED) {
                          s7 = peg$parseUCHAR();
                        }
                      }
                    }
                  } else {
                    s6 = peg$FAILED;
                  }
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c129(s2, s6);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
                if (s4 === peg$FAILED) {
                  s4 = peg$currPos;
                  if (input.charCodeAt(peg$currPos) === 34) {
                    s5 = peg$c106;
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c107);
                    }
                  }
                  if (s5 !== peg$FAILED) {
                    s6 = [];
                    if (peg$c125.test(input.charAt(peg$currPos))) {
                      s7 = input.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c126);
                      }
                    }
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseECHAR();
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseUCHAR();
                      }
                    }
                    if (s7 !== peg$FAILED) {
                      while (s7 !== peg$FAILED) {
                        s6.push(s7);
                        if (peg$c125.test(input.charAt(peg$currPos))) {
                          s7 = input.charAt(peg$currPos);
                          peg$currPos++;
                        } else {
                          s7 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c126);
                          }
                        }
                        if (s7 === peg$FAILED) {
                          s7 = peg$parseECHAR();
                          if (s7 === peg$FAILED) {
                            s7 = peg$parseUCHAR();
                          }
                        }
                      }
                    } else {
                      s6 = peg$FAILED;
                    }
                    if (s6 !== peg$FAILED) {
                      peg$savedPos = s4;
                      s5 = peg$c130(s2, s6);
                      s4 = s5;
                    } else {
                      peg$currPos = s4;
                      s4 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                }
              }
              if (s3 !== peg$FAILED) {
                if (input.substr(peg$currPos, 3) === peg$c123) {
                  s4 = peg$c123;
                  peg$currPos += 3;
                } else {
                  s4 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c124);
                  }
                }
                if (s4 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c122(s2, s3);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseUCHAR() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c131) {
            s1 = peg$c131;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c132);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$parseHEX();
            if (s3 !== peg$FAILED) {
              s4 = peg$parseHEX();
              if (s4 !== peg$FAILED) {
                s5 = peg$parseHEX();
                if (s5 !== peg$FAILED) {
                  s6 = peg$parseHEX();
                  if (s6 !== peg$FAILED) {
                    s7 = peg$parseHEX();
                    if (s7 !== peg$FAILED) {
                      s8 = peg$parseHEX();
                      if (s8 !== peg$FAILED) {
                        s9 = peg$parseHEX();
                        if (s9 !== peg$FAILED) {
                          s10 = peg$parseHEX();
                          if (s10 !== peg$FAILED) {
                            s3 = [s3, s4, s5, s6, s7, s8, s9, s10];
                            s2 = s3;
                          } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s2;
                          s2 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s2;
                      s2 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c133(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c134) {
              s1 = peg$c134;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c135);
              }
            }
            if (s1 !== peg$FAILED) {
              s2 = peg$currPos;
              s3 = peg$parseHEX();
              if (s3 !== peg$FAILED) {
                s4 = peg$parseHEX();
                if (s4 !== peg$FAILED) {
                  s5 = peg$parseHEX();
                  if (s5 !== peg$FAILED) {
                    s6 = peg$parseHEX();
                    if (s6 !== peg$FAILED) {
                      s3 = [s3, s4, s5, s6];
                      s2 = s3;
                    } else {
                      peg$currPos = s2;
                      s2 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c136(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parseECHAR() {
          var s0, s1;
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c137) {
            s1 = peg$c137;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c138);
            }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c139();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c140) {
              s1 = peg$c140;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c141);
              }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c142();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c143) {
                s1 = peg$c143;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c144);
                }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c145();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c146) {
                  s1 = peg$c146;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c147);
                  }
                }
                if (s1 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c148();
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  if (input.substr(peg$currPos, 2) === peg$c149) {
                    s1 = peg$c149;
                    peg$currPos += 2;
                  } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c150);
                    }
                  }
                  if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c151();
                  }
                  s0 = s1;
                  if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c152) {
                      s1 = peg$c152;
                      peg$currPos += 2;
                    } else {
                      s1 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c153);
                      }
                    }
                    if (s1 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c154();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                      s0 = peg$currPos;
                      if (input.substr(peg$currPos, 2) === peg$c155) {
                        s1 = peg$c155;
                        peg$currPos += 2;
                      } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c156);
                        }
                      }
                      if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c157();
                      }
                      s0 = s1;
                      if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c158) {
                          s1 = peg$c158;
                          peg$currPos += 2;
                        } else {
                          s1 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c159);
                          }
                        }
                        if (s1 !== peg$FAILED) {
                          peg$savedPos = s0;
                          s1 = peg$c160();
                        }
                        s0 = s1;
                      }
                    }
                  }
                }
              }
            }
          }
          return s0;
        }
        function peg$parseWS() {
          var s0;
          if (peg$c161.test(input.charAt(peg$currPos))) {
            s0 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c162);
            }
          }
          return s0;
        }
        function peg$parseANON() {
          var s0, s1, s2, s3;
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 91) {
            s1 = peg$c53;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c54);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parseIGNORE();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parseIGNORE();
            }
            if (s2 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 93) {
                s3 = peg$c55;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c56);
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c163();
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsePN_CHARS_BASE() {
          var s0, s1, s2;
          s0 = peg$currPos;
          if (peg$c164.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c165);
            }
          }
          if (s1 !== peg$FAILED) {
            if (peg$c166.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c167);
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c168(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            if (peg$c169.test(input.charAt(peg$currPos))) {
              s0 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c170);
              }
            }
          }
          return s0;
        }
        function peg$parsePN_CHARS_U() {
          var s0;
          s0 = peg$parsePN_CHARS_BASE();
          if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 95) {
              s0 = peg$c171;
              peg$currPos++;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c172);
              }
            }
          }
          return s0;
        }
        function peg$parsePN_CHARS() {
          var s0;
          s0 = peg$parsePN_CHARS_U();
          if (s0 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 45) {
              s0 = peg$c93;
              peg$currPos++;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c94);
              }
            }
            if (s0 === peg$FAILED) {
              if (peg$c87.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c88);
                }
              }
              if (s0 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 183) {
                  s0 = peg$c173;
                  peg$currPos++;
                } else {
                  s0 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c174);
                  }
                }
                if (s0 === peg$FAILED) {
                  if (peg$c175.test(input.charAt(peg$currPos))) {
                    s0 = input.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c176);
                    }
                  }
                  if (s0 === peg$FAILED) {
                    if (peg$c177.test(input.charAt(peg$currPos))) {
                      s0 = input.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s0 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c178);
                      }
                    }
                  }
                }
              }
            }
          }
          return s0;
        }
        function peg$parsePN_PREFIX() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8;
          s0 = peg$currPos;
          s1 = peg$currPos;
          s2 = peg$parsePN_CHARS_BASE();
          if (s2 !== peg$FAILED) {
            s3 = [];
            s4 = peg$parsePN_CHARS();
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parsePN_CHARS();
            }
            if (s3 !== peg$FAILED) {
              s4 = [];
              s5 = peg$currPos;
              s6 = [];
              if (input.charCodeAt(peg$currPos) === 46) {
                s7 = peg$c1;
                peg$currPos++;
              } else {
                s7 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c2);
                }
              }
              if (s7 !== peg$FAILED) {
                while (s7 !== peg$FAILED) {
                  s6.push(s7);
                  if (input.charCodeAt(peg$currPos) === 46) {
                    s7 = peg$c1;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c2);
                    }
                  }
                }
              } else {
                s6 = peg$FAILED;
              }
              if (s6 !== peg$FAILED) {
                s7 = [];
                s8 = peg$parsePN_CHARS();
                if (s8 !== peg$FAILED) {
                  while (s8 !== peg$FAILED) {
                    s7.push(s8);
                    s8 = peg$parsePN_CHARS();
                  }
                } else {
                  s7 = peg$FAILED;
                }
                if (s7 !== peg$FAILED) {
                  s6 = [s6, s7];
                  s5 = s6;
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              while (s5 !== peg$FAILED) {
                s4.push(s5);
                s5 = peg$currPos;
                s6 = [];
                if (input.charCodeAt(peg$currPos) === 46) {
                  s7 = peg$c1;
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c2);
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    if (input.charCodeAt(peg$currPos) === 46) {
                      s7 = peg$c1;
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c2);
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  s7 = [];
                  s8 = peg$parsePN_CHARS();
                  if (s8 !== peg$FAILED) {
                    while (s8 !== peg$FAILED) {
                      s7.push(s8);
                      s8 = peg$parsePN_CHARS();
                    }
                  } else {
                    s7 = peg$FAILED;
                  }
                  if (s7 !== peg$FAILED) {
                    s6 = [s6, s7];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              }
              if (s4 !== peg$FAILED) {
                s2 = [s2, s3, s4];
                s1 = s2;
              } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
              }
            } else {
              peg$currPos = s1;
              s1 = peg$FAILED;
            }
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
          if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
          } else {
            s0 = s1;
          }
          return s0;
        }
        function peg$parsePN_LOCAL() {
          var s0, s1, s2, s3, s4, s5, s6, s7;
          s0 = peg$currPos;
          s1 = peg$parsePN_CHARS_U();
          if (s1 === peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 58) {
              s1 = peg$c80;
              peg$currPos++;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c81);
              }
            }
            if (s1 === peg$FAILED) {
              if (peg$c87.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c88);
                }
              }
              if (s1 === peg$FAILED) {
                s1 = peg$parsePLX();
              }
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsePN_CHARS();
            if (s3 === peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 58) {
                s3 = peg$c80;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c81);
                }
              }
              if (s3 === peg$FAILED) {
                s3 = peg$parsePLX();
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parsePN_CHARS();
              if (s3 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 58) {
                  s3 = peg$c80;
                  peg$currPos++;
                } else {
                  s3 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c81);
                  }
                }
                if (s3 === peg$FAILED) {
                  s3 = peg$parsePLX();
                }
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$currPos;
              s5 = [];
              if (input.charCodeAt(peg$currPos) === 46) {
                s6 = peg$c1;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c2);
                }
              }
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  if (input.charCodeAt(peg$currPos) === 46) {
                    s6 = peg$c1;
                    peg$currPos++;
                  } else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c2);
                    }
                  }
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                s6 = [];
                s7 = peg$parsePN_CHARS();
                if (s7 === peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 58) {
                    s7 = peg$c80;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c81);
                    }
                  }
                  if (s7 === peg$FAILED) {
                    s7 = peg$parsePLX();
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    s7 = peg$parsePN_CHARS();
                    if (s7 === peg$FAILED) {
                      if (input.charCodeAt(peg$currPos) === 58) {
                        s7 = peg$c80;
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c81);
                        }
                      }
                      if (s7 === peg$FAILED) {
                        s7 = peg$parsePLX();
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  peg$savedPos = s4;
                  s5 = peg$c179(s1, s2, s5, s6);
                  s4 = s5;
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$currPos;
                s5 = [];
                if (input.charCodeAt(peg$currPos) === 46) {
                  s6 = peg$c1;
                  peg$currPos++;
                } else {
                  s6 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c2);
                  }
                }
                if (s6 !== peg$FAILED) {
                  while (s6 !== peg$FAILED) {
                    s5.push(s6);
                    if (input.charCodeAt(peg$currPos) === 46) {
                      s6 = peg$c1;
                      peg$currPos++;
                    } else {
                      s6 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c2);
                      }
                    }
                  }
                } else {
                  s5 = peg$FAILED;
                }
                if (s5 !== peg$FAILED) {
                  s6 = [];
                  s7 = peg$parsePN_CHARS();
                  if (s7 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 58) {
                      s7 = peg$c80;
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c81);
                      }
                    }
                    if (s7 === peg$FAILED) {
                      s7 = peg$parsePLX();
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      s7 = peg$parsePN_CHARS();
                      if (s7 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 58) {
                          s7 = peg$c80;
                          peg$currPos++;
                        } else {
                          s7 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c81);
                          }
                        }
                        if (s7 === peg$FAILED) {
                          s7 = peg$parsePLX();
                        }
                      }
                    }
                  } else {
                    s6 = peg$FAILED;
                  }
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c179(s1, s2, s5, s6);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c180(s1, s2, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsePLX() {
          var s0;
          s0 = peg$parsePERCENT();
          if (s0 === peg$FAILED) {
            s0 = peg$parsePN_LOCAL_ESC();
          }
          return s0;
        }
        function peg$parsePERCENT() {
          var s0, s1, s2, s3, s4;
          s0 = peg$currPos;
          s1 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 37) {
            s2 = peg$c181;
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c182);
            }
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parseHEX();
            if (s3 !== peg$FAILED) {
              s4 = peg$parseHEX();
              if (s4 !== peg$FAILED) {
                s2 = [s2, s3, s4];
                s1 = s2;
              } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
              }
            } else {
              peg$currPos = s1;
              s1 = peg$FAILED;
            }
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
          if (s1 !== peg$FAILED) {
            s0 = input.substring(s0, peg$currPos);
          } else {
            s0 = s1;
          }
          return s0;
        }
        function peg$parseHEX() {
          var s0;
          if (peg$c183.test(input.charAt(peg$currPos))) {
            s0 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c184);
            }
          }
          return s0;
        }
        function peg$parsePN_LOCAL_ESC() {
          var s0, s1, s2;
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 92) {
            s1 = peg$c185;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c186);
            }
          }
          if (s1 !== peg$FAILED) {
            if (peg$c187.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c188);
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c3(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        var isBrowser = new Function("try {return this===window;}catch(e){ return false;}");
        var URL = isBrowser() ? window.URL : require_url().URL;
        var isIRI = function(a) {
          return a.match(/^[a-z](.*?):(.+?)/g);
        };
        function createObject(property, value) {
          var a = {};
          a[property] = value;
          return a;
        }
        var context = {
          base: [],
          data: {},
          addBase: function(uri) {
            if (context.base.length === 0) {
              context.base.push(uri);
              return;
            }
            const last = context.base[context.base.length - 1];
            if (last !== uri) context.base.push(new URL(uri, last).toString());
          },
          addPrefix: function(prefix, uri) {
            const list = context.data[prefix];
            if (list === void 0) {
              context.data[prefix] = [{ uri, count: 0 }];
            } else if (list[list.length - 1].uri !== uri) {
              list.push({ uri, count: 0 });
            }
          },
          hasPrefix: function(prefix) {
            return this.data[prefix] !== void 0;
          },
          resolve: function(pname, force) {
            const prefix = Object.keys(context.data).find((key) => pname.indexOf(key + ":") === 0);
            if (prefix !== void 0) {
              const list = context.data[prefix];
              if (list.length === 1 && force !== true && isIRI(list[0].uri)) return pname;
              const uri = list[list.length - 1].uri;
              return pname.replace(prefix + ":", uri);
            } else {
              var base = context.base.length === 0 ? options.baseIRI : context.base[context.base.length - 1];
              if (!base || pname.match(/^(http:|https:|urn:|file:)/)) return pname;
              if (pname.indexOf("//") === 0 && base) return base.split("//")[0] + pname;
              return new URL(pname, base).toString();
            }
          },
          increment: function(prefix) {
            const list = context.data[prefix];
            if (list !== void 0) list[list.length - 1].count++;
          },
          decrement: function(prefix) {
            const list = context.data[prefix];
            if (list !== void 0) list[list.length - 1].count--;
          },
          toJSON: function() {
            const root = {};
            if (context.base.length > 0) {
              if (root["@context"] === void 0) root["@context"] = {};
              root["@context"]["@base"] = context.base[0];
            }
            Object.keys(context.data).forEach((key) => {
              const head = context.data[key][0];
              if (head.uri === "http://www.w3.org/2001/XMLSchema#" && head.count < 1) return;
              if (!isIRI(head.uri)) return;
              if (root["@context"] === void 0) root["@context"] = {};
              root["@context"][key] = head.uri;
            });
            return root;
          }
        };
        function expandList(container, force) {
          if (container["@list"] === void 0) return container;
          if (!force && !container["@list"].find((x) => x["@list"] !== void 0)) return container;
          if (container["@list"].length === 0)
            return { "@id": "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil" };
          var root = {};
          var focus = null;
          container["@list"].forEach((b) => {
            if (focus === null) focus = root;
            else {
              focus["http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"] = {};
              focus = focus["http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"];
            }
            focus["http://www.w3.org/1999/02/22-rdf-syntax-ns#first"] = expandList(b, true);
            focus["http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"] = {
              "@id": "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
            };
          });
          return root;
        }
        peg$result = peg$startRuleFunction();
        if (peg$result !== peg$FAILED && peg$currPos === input.length) {
          return peg$result;
        } else {
          if (peg$result !== peg$FAILED && peg$currPos < input.length) {
            peg$fail(peg$endExpectation());
          }
          throw peg$buildStructuredError(
            peg$maxFailExpected,
            peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
            peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
          );
        }
      }
      return {
        SyntaxError: peg$SyntaxError,
        parse: peg$parse
      };
    });
  }
});

// ../node_modules/queue-microtask/index.js
var require_queue_microtask = __commonJS({
  "../node_modules/queue-microtask/index.js"(exports, module2) {
    var promise;
    module2.exports = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : global) : (cb) => (promise || (promise = Promise.resolve())).then(cb).catch((err) => setTimeout(() => {
      throw err;
    }, 0));
  }
});

// ../node_modules/rdflib/node_modules/cross-fetch/dist/browser-ponyfill.js
var require_browser_ponyfill = __commonJS({
  "../node_modules/rdflib/node_modules/cross-fetch/dist/browser-ponyfill.js"(exports, module2) {
    var global2 = typeof self !== "undefined" ? self : exports;
    var __self__ = function() {
      function F() {
        this.fetch = false;
        this.DOMException = global2.DOMException;
      }
      F.prototype = global2;
      return new F();
    }();
    (function(self2) {
      var irrelevant = function(exports2) {
        var support = {
          searchParams: "URLSearchParams" in self2,
          iterable: "Symbol" in self2 && "iterator" in Symbol,
          blob: "FileReader" in self2 && "Blob" in self2 && function() {
            try {
              new Blob();
              return true;
            } catch (e) {
              return false;
            }
          }(),
          formData: "FormData" in self2,
          arrayBuffer: "ArrayBuffer" in self2
        };
        function isDataView(obj) {
          return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
          var viewClasses = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ];
          var isArrayBufferView = ArrayBuffer.isView || function(obj) {
            return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
          };
        }
        function normalizeName(name) {
          if (typeof name !== "string") {
            name = String(name);
          }
          if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
            throw new TypeError("Invalid character in header field name");
          }
          return name.toLowerCase();
        }
        function normalizeValue(value) {
          if (typeof value !== "string") {
            value = String(value);
          }
          return value;
        }
        function iteratorFor(items) {
          var iterator = {
            next: function() {
              var value = items.shift();
              return { done: value === void 0, value };
            }
          };
          if (support.iterable) {
            iterator[Symbol.iterator] = function() {
              return iterator;
            };
          }
          return iterator;
        }
        function Headers2(headers) {
          this.map = {};
          if (headers instanceof Headers2) {
            headers.forEach(function(value, name) {
              this.append(name, value);
            }, this);
          } else if (Array.isArray(headers)) {
            headers.forEach(function(header) {
              this.append(header[0], header[1]);
            }, this);
          } else if (headers) {
            Object.getOwnPropertyNames(headers).forEach(function(name) {
              this.append(name, headers[name]);
            }, this);
          }
        }
        Headers2.prototype.append = function(name, value) {
          name = normalizeName(name);
          value = normalizeValue(value);
          var oldValue = this.map[name];
          this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers2.prototype["delete"] = function(name) {
          delete this.map[normalizeName(name)];
        };
        Headers2.prototype.get = function(name) {
          name = normalizeName(name);
          return this.has(name) ? this.map[name] : null;
        };
        Headers2.prototype.has = function(name) {
          return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers2.prototype.set = function(name, value) {
          this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers2.prototype.forEach = function(callback, thisArg) {
          for (var name in this.map) {
            if (this.map.hasOwnProperty(name)) {
              callback.call(thisArg, this.map[name], name, this);
            }
          }
        };
        Headers2.prototype.keys = function() {
          var items = [];
          this.forEach(function(value, name) {
            items.push(name);
          });
          return iteratorFor(items);
        };
        Headers2.prototype.values = function() {
          var items = [];
          this.forEach(function(value) {
            items.push(value);
          });
          return iteratorFor(items);
        };
        Headers2.prototype.entries = function() {
          var items = [];
          this.forEach(function(value, name) {
            items.push([name, value]);
          });
          return iteratorFor(items);
        };
        if (support.iterable) {
          Headers2.prototype[Symbol.iterator] = Headers2.prototype.entries;
        }
        function consumed(body) {
          if (body.bodyUsed) {
            return Promise.reject(new TypeError("Already read"));
          }
          body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
          return new Promise(function(resolve, reject) {
            reader.onload = function() {
              resolve(reader.result);
            };
            reader.onerror = function() {
              reject(reader.error);
            };
          });
        }
        function readBlobAsArrayBuffer(blob) {
          var reader = new FileReader();
          var promise = fileReaderReady(reader);
          reader.readAsArrayBuffer(blob);
          return promise;
        }
        function readBlobAsText(blob) {
          var reader = new FileReader();
          var promise = fileReaderReady(reader);
          reader.readAsText(blob);
          return promise;
        }
        function readArrayBufferAsText(buf) {
          var view = new Uint8Array(buf);
          var chars = new Array(view.length);
          for (var i = 0; i < view.length; i++) {
            chars[i] = String.fromCharCode(view[i]);
          }
          return chars.join("");
        }
        function bufferClone(buf) {
          if (buf.slice) {
            return buf.slice(0);
          } else {
            var view = new Uint8Array(buf.byteLength);
            view.set(new Uint8Array(buf));
            return view.buffer;
          }
        }
        function Body() {
          this.bodyUsed = false;
          this._initBody = function(body) {
            this._bodyInit = body;
            if (!body) {
              this._bodyText = "";
            } else if (typeof body === "string") {
              this._bodyText = body;
            } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
              this._bodyBlob = body;
            } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
              this._bodyFormData = body;
            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
              this._bodyText = body.toString();
            } else if (support.arrayBuffer && support.blob && isDataView(body)) {
              this._bodyArrayBuffer = bufferClone(body.buffer);
              this._bodyInit = new Blob([this._bodyArrayBuffer]);
            } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
              this._bodyArrayBuffer = bufferClone(body);
            } else {
              this._bodyText = body = Object.prototype.toString.call(body);
            }
            if (!this.headers.get("content-type")) {
              if (typeof body === "string") {
                this.headers.set("content-type", "text/plain;charset=UTF-8");
              } else if (this._bodyBlob && this._bodyBlob.type) {
                this.headers.set("content-type", this._bodyBlob.type);
              } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
              }
            }
          };
          if (support.blob) {
            this.blob = function() {
              var rejected = consumed(this);
              if (rejected) {
                return rejected;
              }
              if (this._bodyBlob) {
                return Promise.resolve(this._bodyBlob);
              } else if (this._bodyArrayBuffer) {
                return Promise.resolve(new Blob([this._bodyArrayBuffer]));
              } else if (this._bodyFormData) {
                throw new Error("could not read FormData body as blob");
              } else {
                return Promise.resolve(new Blob([this._bodyText]));
              }
            };
            this.arrayBuffer = function() {
              if (this._bodyArrayBuffer) {
                return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
              } else {
                return this.blob().then(readBlobAsArrayBuffer);
              }
            };
          }
          this.text = function() {
            var rejected = consumed(this);
            if (rejected) {
              return rejected;
            }
            if (this._bodyBlob) {
              return readBlobAsText(this._bodyBlob);
            } else if (this._bodyArrayBuffer) {
              return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
            } else if (this._bodyFormData) {
              throw new Error("could not read FormData body as text");
            } else {
              return Promise.resolve(this._bodyText);
            }
          };
          if (support.formData) {
            this.formData = function() {
              return this.text().then(decode2);
            };
          }
          this.json = function() {
            return this.text().then(JSON.parse);
          };
          return this;
        }
        var methods = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function normalizeMethod(method) {
          var upcased = method.toUpperCase();
          return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
          options = options || {};
          var body = options.body;
          if (input instanceof Request) {
            if (input.bodyUsed) {
              throw new TypeError("Already read");
            }
            this.url = input.url;
            this.credentials = input.credentials;
            if (!options.headers) {
              this.headers = new Headers2(input.headers);
            }
            this.method = input.method;
            this.mode = input.mode;
            this.signal = input.signal;
            if (!body && input._bodyInit != null) {
              body = input._bodyInit;
              input.bodyUsed = true;
            }
          } else {
            this.url = String(input);
          }
          this.credentials = options.credentials || this.credentials || "same-origin";
          if (options.headers || !this.headers) {
            this.headers = new Headers2(options.headers);
          }
          this.method = normalizeMethod(options.method || this.method || "GET");
          this.mode = options.mode || this.mode || null;
          this.signal = options.signal || this.signal;
          this.referrer = null;
          if ((this.method === "GET" || this.method === "HEAD") && body) {
            throw new TypeError("Body not allowed for GET or HEAD requests");
          }
          this._initBody(body);
        }
        Request.prototype.clone = function() {
          return new Request(this, { body: this._bodyInit });
        };
        function decode2(body) {
          var form = new FormData();
          body.trim().split("&").forEach(function(bytes) {
            if (bytes) {
              var split = bytes.split("=");
              var name = split.shift().replace(/\+/g, " ");
              var value = split.join("=").replace(/\+/g, " ");
              form.append(decodeURIComponent(name), decodeURIComponent(value));
            }
          });
          return form;
        }
        function parseHeaders(rawHeaders) {
          var headers = new Headers2();
          var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
          preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
            var parts = line.split(":");
            var key = parts.shift().trim();
            if (key) {
              var value = parts.join(":").trim();
              headers.append(key, value);
            }
          });
          return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
          if (!options) {
            options = {};
          }
          this.type = "default";
          this.status = options.status === void 0 ? 200 : options.status;
          this.ok = this.status >= 200 && this.status < 300;
          this.statusText = "statusText" in options ? options.statusText : "OK";
          this.headers = new Headers2(options.headers);
          this.url = options.url || "";
          this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
          return new Response(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new Headers2(this.headers),
            url: this.url
          });
        };
        Response.error = function() {
          var response = new Response(null, { status: 0, statusText: "" });
          response.type = "error";
          return response;
        };
        var redirectStatuses = [301, 302, 303, 307, 308];
        Response.redirect = function(url, status) {
          if (redirectStatuses.indexOf(status) === -1) {
            throw new RangeError("Invalid status code");
          }
          return new Response(null, { status, headers: { location: url } });
        };
        exports2.DOMException = self2.DOMException;
        try {
          new exports2.DOMException();
        } catch (err) {
          exports2.DOMException = function(message, name) {
            this.message = message;
            this.name = name;
            var error2 = Error(message);
            this.stack = error2.stack;
          };
          exports2.DOMException.prototype = Object.create(Error.prototype);
          exports2.DOMException.prototype.constructor = exports2.DOMException;
        }
        function fetch(input, init) {
          return new Promise(function(resolve, reject) {
            var request = new Request(input, init);
            if (request.signal && request.signal.aborted) {
              return reject(new exports2.DOMException("Aborted", "AbortError"));
            }
            var xhr = new XMLHttpRequest();
            function abortXhr() {
              xhr.abort();
            }
            xhr.onload = function() {
              var options = {
                status: xhr.status,
                statusText: xhr.statusText,
                headers: parseHeaders(xhr.getAllResponseHeaders() || "")
              };
              options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
              var body = "response" in xhr ? xhr.response : xhr.responseText;
              resolve(new Response(body, options));
            };
            xhr.onerror = function() {
              reject(new TypeError("Network request failed"));
            };
            xhr.ontimeout = function() {
              reject(new TypeError("Network request failed"));
            };
            xhr.onabort = function() {
              reject(new exports2.DOMException("Aborted", "AbortError"));
            };
            xhr.open(request.method, request.url, true);
            if (request.credentials === "include") {
              xhr.withCredentials = true;
            } else if (request.credentials === "omit") {
              xhr.withCredentials = false;
            }
            if ("responseType" in xhr && support.blob) {
              xhr.responseType = "blob";
            }
            request.headers.forEach(function(value, name) {
              xhr.setRequestHeader(name, value);
            });
            if (request.signal) {
              request.signal.addEventListener("abort", abortXhr);
              xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                  request.signal.removeEventListener("abort", abortXhr);
                }
              };
            }
            xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
          });
        }
        fetch.polyfill = true;
        if (!self2.fetch) {
          self2.fetch = fetch;
          self2.Headers = Headers2;
          self2.Request = Request;
          self2.Response = Response;
        }
        exports2.Headers = Headers2;
        exports2.Request = Request;
        exports2.Response = Response;
        exports2.fetch = fetch;
        Object.defineProperty(exports2, "__esModule", { value: true });
        return exports2;
      }({});
    })(__self__);
    __self__.fetch.ponyfill = true;
    delete __self__.fetch.polyfill;
    var ctx = __self__;
    exports = ctx.fetch;
    exports.default = ctx.fetch;
    exports.fetch = ctx.fetch;
    exports.Headers = ctx.Headers;
    exports.Request = ctx.Request;
    exports.Response = ctx.Response;
    module2.exports = exports;
  }
});

// ../node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}

// ../node_modules/rdflib/esm/types.js
var NamedNodeTermType = "NamedNode";
var BlankNodeTermType = "BlankNode";
var LiteralTermType = "Literal";
var VariableTermType = "Variable";
var DefaultGraphTermType = "DefaultGraph";
var CollectionTermType = "Collection";
var EmptyTermType = "Empty";
var GraphTermType = "Graph";
var HTMLContentType = "text/html";
var JSONLDContentType = "application/ld+json";
var N3ContentType = "text/n3";
var N3LegacyContentType = "application/n3";
var NQuadsAltContentType = "application/nquads";
var NQuadsContentType = "application/n-quads";
var NTriplesContentType = "application/n-triples";
var RDFXMLContentType = "application/rdf+xml";
var SPARQLUpdateContentType = "application/sparql-update";
var SPARQLUpdateSingleMatchContentType = "application/sparql-update-single-match";
var TurtleContentType = "text/turtle";
var TurtleLegacyContentType = "application/x-turtle";
var XHTMLContentType = "application/xhtml+xml";

// ../node_modules/rdflib/esm/utils/terms.js
function isStatement(obj) {
  return _typeof(obj) === "object" && obj !== null && "subject" in obj;
}
function isStore(obj) {
  return _typeof(obj) === "object" && obj !== null && "statements" in obj;
}
function isCollection(obj) {
  return isTerm(obj) && obj.termType === CollectionTermType;
}
function isRDFlibObject(obj) {
  return obj && Object.prototype.hasOwnProperty.call(obj, "termType") && (obj.termType === NamedNodeTermType || obj.termType === VariableTermType || obj.termType === BlankNodeTermType || obj.termType === CollectionTermType || obj.termType === LiteralTermType || obj.termType === GraphTermType);
}
function isRDFlibSubject(obj) {
  return obj && Object.prototype.hasOwnProperty.call(obj, "termType") && (obj.termType === NamedNodeTermType || obj.termType === VariableTermType || obj.termType === BlankNodeTermType || obj.termType === CollectionTermType || obj.termType === LiteralTermType || obj.termType === GraphTermType);
}
function isRDFlibPredicate(obj) {
  return isTerm(obj) && (obj.termType === NamedNodeTermType || obj.termType === BlankNodeTermType || obj.termType === VariableTermType);
}
function isVariable(obj) {
  return isTerm(obj) && obj.termType === VariableTermType;
}
function isTerm(obj) {
  return _typeof(obj) === "object" && obj !== null && "termType" in obj;
}
function isLiteral(value) {
  return value.termType === LiteralTermType;
}
function isQuad(obj) {
  return _typeof(obj) === "object" && obj !== null && "subject" in obj && "predicate" in obj && "object" in obj;
}
function isNamedNode(obj) {
  return isTerm(obj) && obj.termType === "NamedNode";
}
function isBlankNode(obj) {
  return isTerm(obj) && "termType" in obj && obj.termType === "BlankNode";
}
function isGraph(obj) {
  return isTerm(obj) && (obj.termType === NamedNodeTermType || obj.termType === VariableTermType || obj.termType === BlankNodeTermType || obj.termType === DefaultGraphTermType);
}

// ../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info2 = gen[key](arg);
    var value = info2.value;
  } catch (error2) {
    reject(error2);
    return;
  }
  if (info2.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}

// ../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

// ../node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

// ../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

// ../node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

// ../node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// ../node_modules/rdflib/esm/update-manager.js
var import_regenerator2 = __toESM(require_regenerator());

// ../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}

// ../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}

// ../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}

// ../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}

// ../node_modules/@babel/runtime/helpers/esm/inherits.js
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

// ../node_modules/rdflib/esm/class-order.js
var ClassOrder = {
  "Literal": 1,
  "Collection": 3,
  "Graph": 4,
  "NamedNode": 5,
  "BlankNode": 6,
  "Variable": 7
};
var class_order_default = ClassOrder;

// ../node_modules/rdflib/esm/node-internal.js
var Node2 = /* @__PURE__ */ function() {
  function Node3(value) {
    _classCallCheck(this, Node3);
    _defineProperty(this, "termType", void 0);
    _defineProperty(this, "classOrder", void 0);
    _defineProperty(this, "value", void 0);
    this.value = value;
  }
  return _createClass(Node3, [{
    key: "substitute",
    value: function substitute(bindings) {
      return this;
    }
    /**
     * Compares this node with another
     * @see {equals} to check if two nodes are equal
     * @param other - The other node
     */
  }, {
    key: "compareTerm",
    value: function compareTerm(other) {
      if (this.classOrder < other.classOrder) {
        return -1;
      }
      if (this.classOrder > other.classOrder) {
        return 1;
      }
      if (this.value < other.value) {
        return -1;
      }
      if (this.value > other.value) {
        return 1;
      }
      return 0;
    }
    /**
     * Compares whether the two nodes are equal
     * @param other The other node
     */
  }, {
    key: "equals",
    value: function equals2(other) {
      if (!other) {
        return false;
      }
      return this.termType === other.termType && this.value === other.value;
    }
    /**
     * Creates a hash for this node
     * @deprecated use {rdfFactory.id} instead if possible
     */
  }, {
    key: "hashString",
    value: function hashString() {
      return this.toCanonical();
    }
    /**
     * Compares whether this node is the same as the other one
     * @param other - Another node
     */
  }, {
    key: "sameTerm",
    value: function sameTerm(other) {
      return this.equals(other);
    }
    /**
     * Creates a canonical string representation of this node
     */
  }, {
    key: "toCanonical",
    value: function toCanonical() {
      return this.toNT();
    }
    /**
     * Creates a n-triples string representation of this node
     */
  }, {
    key: "toNT",
    value: function toNT() {
      return this.toString();
    }
    /**
     * Creates a n-quads string representation of this node
     */
  }, {
    key: "toNQ",
    value: function toNQ2() {
      return this.toNT();
    }
    /**
     * Creates a string representation of this node
     */
  }, {
    key: "toString",
    value: function toString() {
      throw new Error("Node.toString() is abstract - see the subclasses instead");
    }
  }]);
}();
_defineProperty(Node2, "fromValue", void 0);
_defineProperty(Node2, "toJS", void 0);

// ../node_modules/rdflib/esm/blank-node.js
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct10() {
    return !!t;
  })();
}
var BlankNode = /* @__PURE__ */ function(_Node) {
  function BlankNode3(id3) {
    var _this;
    _classCallCheck(this, BlankNode3);
    _this = _callSuper(this, BlankNode3, [BlankNode3.getId(id3)]);
    _defineProperty(_this, "termType", BlankNodeTermType);
    _defineProperty(_this, "classOrder", class_order_default.BlankNode);
    _defineProperty(_this, "isBlank", 1);
    _defineProperty(_this, "isVar", 1);
    return _this;
  }
  _inherits(BlankNode3, _Node);
  return _createClass(BlankNode3, [{
    key: "id",
    get: function get() {
      return this.value;
    },
    set: function set(value) {
      this.value = value;
    }
  }, {
    key: "compareTerm",
    value: function compareTerm(other) {
      if (this.classOrder < other.classOrder) {
        return -1;
      }
      if (this.classOrder > other.classOrder) {
        return 1;
      }
      if (this.id < other.id) {
        return -1;
      }
      if (this.id > other.id) {
        return 1;
      }
      return 0;
    }
    /**
     * Gets a copy of this blank node in the specified formula
     * @param formula The formula
     */
  }, {
    key: "copy",
    value: function copy(formula2) {
      var bnodeNew = new BlankNode3();
      formula2.copyTo(this, bnodeNew);
      return bnodeNew;
    }
  }, {
    key: "toCanonical",
    value: function toCanonical() {
      return BlankNode3.NTAnonymousNodePrefix + this.value;
    }
  }, {
    key: "toString",
    value: function toString() {
      return BlankNode3.NTAnonymousNodePrefix + this.id;
    }
  }], [{
    key: "getId",
    value: function getId(id3) {
      if (id3) {
        if (typeof id3 !== "string") {
          throw new Error("Bad id argument to new blank node: " + id3);
        }
        if (id3.includes("#")) {
          var fragments = id3.split("#");
          return fragments[fragments.length - 1];
        }
        return id3;
      }
      return "n" + BlankNode3.nextId++;
    }
  }]);
}(Node2);
_defineProperty(BlankNode, "nextId", 0);
_defineProperty(BlankNode, "NTAnonymousNodePrefix", "_:");

// ../node_modules/rdflib/esm/utils/termValue.js
function termValue(node) {
  if (typeof node === "string") {
    return node;
  }
  return node.value;
}

// ../node_modules/rdflib/esm/named-node.js
function _callSuper2(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct2() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct2 = function _isNativeReflectConstruct10() {
    return !!t;
  })();
}
var NamedNode = /* @__PURE__ */ function(_Node) {
  function NamedNode3(iri) {
    var _this;
    _classCallCheck(this, NamedNode3);
    _this = _callSuper2(this, NamedNode3, [termValue(iri)]);
    _defineProperty(_this, "termType", NamedNodeTermType);
    _defineProperty(_this, "classOrder", class_order_default.NamedNode);
    if (!_this.value) {
      throw new Error("Missing IRI for NamedNode");
    }
    if (!_this.value.includes(":")) {
      throw new Error('NamedNode IRI "' + iri + '" must be absolute.');
    }
    if (_this.value.includes(" ")) {
      var message = 'Error: NamedNode IRI "' + iri + '" must not contain unencoded spaces.';
      throw new Error(message);
    }
    return _this;
  }
  _inherits(NamedNode3, _Node);
  return _createClass(NamedNode3, [{
    key: "dir",
    value: function dir() {
      var str = this.value.split("#")[0];
      var p = str.slice(0, -1).lastIndexOf("/");
      var q = str.indexOf("//");
      if (q >= 0 && p < q + 2 || p < 0) return null;
      return new NamedNode3(str.slice(0, p + 1));
    }
    /**
     * Returns an NN for the whole web site, ending in slash.
     * Contrast with the "origin" which does NOT have a trailing slash
     */
  }, {
    key: "site",
    value: function site() {
      var str = this.value.split("#")[0];
      var p = str.indexOf("//");
      if (p < 0) throw new Error("This URI does not have a web site part (origin)");
      var q = str.indexOf("/", p + 2);
      if (q < 0) {
        return new NamedNode3(str.slice(0) + "/");
      } else {
        return new NamedNode3(str.slice(0, q + 1));
      }
    }
    /**
     * Creates the fetchable named node for the document.
     * Removes everything from the # anchor tag.
     */
  }, {
    key: "doc",
    value: function doc() {
      if (this.value.indexOf("#") < 0) {
        return this;
      } else {
        return new NamedNode3(this.value.split("#")[0]);
      }
    }
    /**
     * Returns the URI including <brackets>
     */
  }, {
    key: "toString",
    value: function toString() {
      return "<" + this.value + ">";
    }
    /** The local identifier with the document */
  }, {
    key: "id",
    value: function id3() {
      return this.value.split("#")[1];
    }
    /** Alias for value, favored by Tim */
  }, {
    key: "uri",
    get: function get() {
      return this.value;
    },
    set: function set(uri) {
      this.value = uri;
    }
    /**
     * Creates a named node from the specified input value
     * @param value - An input value
     */
  }], [{
    key: "fromValue",
    value: function fromValue2(value) {
      if (typeof value === "undefined" || value === null) {
        return value;
      }
      if (isTerm(value)) {
        return value;
      }
      return new NamedNode3(value);
    }
  }]);
}(Node2);

// ../node_modules/rdflib/esm/xsd-internal.js
var xsd_internal_default = {
  boolean: new NamedNode("http://www.w3.org/2001/XMLSchema#boolean"),
  dateTime: new NamedNode("http://www.w3.org/2001/XMLSchema#dateTime"),
  decimal: new NamedNode("http://www.w3.org/2001/XMLSchema#decimal"),
  double: new NamedNode("http://www.w3.org/2001/XMLSchema#double"),
  integer: new NamedNode("http://www.w3.org/2001/XMLSchema#integer"),
  langString: new NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString"),
  string: new NamedNode("http://www.w3.org/2001/XMLSchema#string")
};

// ../node_modules/rdflib/esm/literal.js
function _callSuper3(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct3() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct3() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct3 = function _isNativeReflectConstruct10() {
    return !!t;
  })();
}
var Literal = /* @__PURE__ */ function(_Node) {
  function Literal3(value, language, datatype) {
    var _this;
    _classCallCheck(this, Literal3);
    _this = _callSuper3(this, Literal3, [value]);
    _defineProperty(_this, "termType", LiteralTermType);
    _defineProperty(_this, "classOrder", class_order_default.Literal);
    _defineProperty(_this, "datatype", xsd_internal_default.string);
    _defineProperty(_this, "isVar", 0);
    _defineProperty(_this, "language", "");
    if (language) {
      _this.language = language;
      _this.datatype = xsd_internal_default.langString;
    } else if (datatype) {
      _this.datatype = NamedNode.fromValue(datatype);
    } else {
      _this.datatype = xsd_internal_default.string;
    }
    return _this;
  }
  _inherits(Literal3, _Node);
  return _createClass(Literal3, [{
    key: "copy",
    value: function copy() {
      return new Literal3(this.value, this.lang, this.datatype);
    }
    /**
     * Gets whether two literals are the same
     * @param other The other statement
     */
  }, {
    key: "equals",
    value: function equals2(other) {
      if (!other) {
        return false;
      }
      return this.termType === other.termType && this.value === other.value && this.language === other.language && (!this.datatype && !other.datatype || this.datatype && this.datatype.equals(other.datatype));
    }
    /**
     * The language for the literal
     * @deprecated use {language} instead
     */
  }, {
    key: "lang",
    get: function get() {
      return this.language;
    },
    set: function set(language) {
      this.language = language || "";
    }
  }, {
    key: "toNT",
    value: function toNT() {
      return Literal3.toNT(this);
    }
    /** Serializes a literal to an N-Triples string */
  }, {
    key: "toString",
    value: function toString() {
      return "" + this.value;
    }
    /**
     * Builds a literal node from a boolean value
     * @param value - The value
     */
  }], [{
    key: "toNT",
    value: function toNT(literal4) {
      if (typeof literal4.value === "number") {
        return "" + literal4.value;
      } else if (typeof literal4.value !== "string") {
        throw new Error("Value of RDF literal is not string or number: " + literal4.value);
      }
      var str = literal4.value;
      str = str.replace(/\\/g, "\\\\");
      str = str.replace(/\"/g, '\\"');
      str = str.replace(/\n/g, "\\n");
      str = str.replace(/\r/g, "\\r");
      str = '"' + str + '"';
      if (literal4.language) {
        str += "@" + literal4.language;
      } else if (!literal4.datatype.equals(xsd_internal_default.string)) {
        str += "^^" + literal4.datatype.toCanonical();
      }
      return str;
    }
  }, {
    key: "fromBoolean",
    value: function fromBoolean(value) {
      var strValue = value ? "1" : "0";
      return new Literal3(strValue, null, xsd_internal_default.boolean);
    }
    /**
     * Builds a literal node from a date value
     * @param value The value
     */
  }, {
    key: "fromDate",
    value: function fromDate(value) {
      if (!(value instanceof Date)) {
        throw new TypeError("Invalid argument to Literal.fromDate()");
      }
      var d2 = function d22(x) {
        return ("" + (100 + x)).slice(1, 3);
      };
      var date = "" + value.getUTCFullYear() + "-" + d2(value.getUTCMonth() + 1) + "-" + d2(value.getUTCDate()) + "T" + d2(value.getUTCHours()) + ":" + d2(value.getUTCMinutes()) + ":" + d2(value.getUTCSeconds()) + "Z";
      return new Literal3(date, null, xsd_internal_default.dateTime);
    }
    /**
     * Builds a literal node from a number value
     * @param value - The value
     */
  }, {
    key: "fromNumber",
    value: function fromNumber(value) {
      if (typeof value !== "number") {
        throw new TypeError("Invalid argument to Literal.fromNumber()");
      }
      var datatype;
      var strValue = value.toString();
      if (strValue.indexOf("e") < 0 && Math.abs(value) <= Number.MAX_SAFE_INTEGER) {
        datatype = Number.isInteger(value) ? xsd_internal_default.integer : xsd_internal_default.decimal;
      } else {
        datatype = xsd_internal_default.double;
      }
      return new Literal3(strValue, null, datatype);
    }
    /**
     * Builds a literal node from an input value
     * @param value - The input value
     */
  }, {
    key: "fromValue",
    value: function fromValue2(value) {
      if (isLiteral(value)) {
        return value;
      }
      switch (_typeof(value)) {
        case "object":
          if (value instanceof Date) {
            return Literal3.fromDate(value);
          }
        case "boolean":
          return Literal3.fromBoolean(value);
        case "number":
          return Literal3.fromNumber(value);
        case "string":
          return new Literal3(value);
      }
      throw new Error("Can't make literal from " + value + " of type " + _typeof(value));
    }
  }]);
}(Node2);

// ../node_modules/rdflib/esm/utils/default-graph-uri.js
var defaultGraphURI = "chrome:theSession";
var defaultGraphNode = new NamedNode(defaultGraphURI);

// ../node_modules/rdflib/esm/default-graph.js
function _callSuper4(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct4() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct4() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct4 = function _isNativeReflectConstruct10() {
    return !!t;
  })();
}
var DefaultGraph = /* @__PURE__ */ function(_Node) {
  function DefaultGraph3() {
    var _this;
    _classCallCheck(this, DefaultGraph3);
    _this = _callSuper4(this, DefaultGraph3, [""]);
    _defineProperty(_this, "value", "");
    _defineProperty(_this, "termType", DefaultGraphTermType);
    _defineProperty(_this, "uri", defaultGraphURI);
    return _this;
  }
  _inherits(DefaultGraph3, _Node);
  return _createClass(DefaultGraph3, [{
    key: "toCanonical",
    value: function toCanonical() {
      return this.value;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "DefaultGraph";
    }
  }]);
}(Node2);
function isDefaultGraph(object) {
  return !!object && object.termType === DefaultGraphTermType;
}

// ../node_modules/rdflib/esm/statement.js
var defaultGraph = new DefaultGraph();
var Statement = /* @__PURE__ */ function() {
  function Statement2(subject, predicate, object, graph3) {
    _classCallCheck(this, Statement2);
    _defineProperty(this, "subject", void 0);
    _defineProperty(this, "predicate", void 0);
    _defineProperty(this, "object", void 0);
    _defineProperty(this, "graph", void 0);
    this.subject = Node2.fromValue(subject);
    this.predicate = Node2.fromValue(predicate);
    this.object = Node2.fromValue(object);
    this.graph = graph3 == void 0 ? defaultGraph : Node2.fromValue(graph3);
  }
  return _createClass(Statement2, [{
    key: "why",
    get: function get() {
      return this.graph;
    },
    set: function set(g) {
      this.graph = g;
    }
    /**
     * Checks whether two statements are the same
     * @param other - The other statement
     */
  }, {
    key: "equals",
    value: function equals2(other) {
      return other.subject.equals(this.subject) && other.predicate.equals(this.predicate) && other.object.equals(this.object) && other.graph.equals(this.graph);
    }
    /**
     * Creates a statement with the bindings substituted
     * @param bindings The bindings
     */
  }, {
    key: "substitute",
    value: function substitute(bindings) {
      var y = new Statement2(this.subject.substitute(bindings), this.predicate.substitute(bindings), this.object.substitute(bindings), isDefaultGraph(this.graph) ? this.graph : this.graph.substitute(bindings));
      return y;
    }
    /** Creates a canonical string representation of this statement. */
  }, {
    key: "toCanonical",
    value: function toCanonical() {
      var terms = [this.subject.toCanonical(), this.predicate.toCanonical(), this.object.toCanonical()];
      if (this.graph && this.graph.termType !== DefaultGraphTermType) {
        terms.push(this.graph.toCanonical());
      }
      return terms.join(" ") + " .";
    }
    /** Creates a n-triples string representation of this statement */
  }, {
    key: "toNT",
    value: function toNT() {
      return [this.subject.toNT(), this.predicate.toNT(), this.object.toNT()].join(" ") + " .";
    }
    /** Creates a n-quads string representation of this statement */
  }, {
    key: "toNQ",
    value: function toNQ2() {
      return [this.subject.toNT(), this.predicate.toNT(), this.object.toNT(), isDefaultGraph(this.graph) ? "" : this.graph.toNT()].join(" ") + " .";
    }
    /** Creates a string representation of this statement */
  }, {
    key: "toString",
    value: function toString() {
      return this.toNT();
    }
  }]);
}();

// ../node_modules/rdflib/esm/uri.js
var uri_exports = {};
__export(uri_exports, {
  docpart: () => docpart,
  document: () => document2,
  hostpart: () => hostpart,
  join: () => join,
  protocol: () => protocol,
  refTo: () => refTo
});
var alert = alert || console.log;
function docpart(uri) {
  var i;
  i = uri.indexOf("#");
  if (i < 0) {
    return uri;
  } else {
    return uri.slice(0, i);
  }
}
function document2(x) {
  return new NamedNode(docpart(x));
}
function hostpart(u) {
  var m = /[^\/]*\/\/([^\/]*)\//.exec(u);
  if (m) {
    return m[1];
  } else {
    return "";
  }
}
function join(given, base) {
  var baseColon, baseScheme, baseSingle;
  var colon, lastSlash, path;
  var baseHash = base.indexOf("#");
  if (baseHash > 0) {
    base = base.slice(0, baseHash);
  }
  if (given.length === 0) {
    return base;
  }
  if (given.indexOf("#") === 0) {
    return base + given;
  }
  colon = given.indexOf(":");
  if (colon >= 0) {
    return given;
  }
  baseColon = base.indexOf(":");
  if (base.length === 0) {
    return given;
  }
  if (baseColon < 0) {
    alert("Invalid base: " + base + " in join with given: " + given);
    return given;
  }
  baseScheme = base.slice(0, +baseColon + 1 || 9e9);
  if (given.indexOf("//") === 0) {
    return baseScheme + given;
  }
  if (base.indexOf("//", baseColon) === baseColon + 1) {
    baseSingle = base.indexOf("/", baseColon + 3);
    if (baseSingle < 0) {
      if (base.length - baseColon - 3 > 0) {
        return base + "/" + given;
      } else {
        return baseScheme + given;
      }
    }
  } else {
    baseSingle = base.indexOf("/", baseColon + 1);
    if (baseSingle < 0) {
      if (base.length - baseColon - 1 > 0) {
        return base + "/" + given;
      } else {
        return baseScheme + given;
      }
    }
  }
  if (given.indexOf("/") === 0) {
    return base.slice(0, baseSingle) + given;
  }
  path = base.slice(baseSingle);
  lastSlash = path.lastIndexOf("/");
  if (lastSlash < 0) {
    return baseScheme + given;
  }
  if (lastSlash >= 0 && lastSlash < path.length - 1) {
    path = path.slice(0, +lastSlash + 1 || 9e9);
  }
  path += given;
  while (path.match(/[^\/]*\/\.\.\//)) {
    path = path.replace(/[^\/]*\/\.\.\//, "");
  }
  path = path.replace(/\.\//g, "");
  path = path.replace(/\/\.$/, "/");
  return base.slice(0, baseSingle) + path;
}
function protocol(uri) {
  var i = uri.indexOf(":");
  if (i < 0) {
    return null;
  } else {
    return uri.slice(0, i);
  }
}
function refTo(base, uri) {
  var c, i, k, l, len, len1, n, o, p, q, ref, ref1, s;
  var commonHost = new RegExp("^[-_a-zA-Z0-9.]+:(//[^/]*)?/[^/]*$");
  if (!base) {
    return uri;
  }
  if (base === uri) {
    return "";
  }
  for (i = o = 0, len = uri.length; o < len; i = ++o) {
    var _c = uri[i];
    if (_c !== base[i]) {
      break;
    }
  }
  if (base.slice(0, i).match(commonHost)) {
    k = uri.indexOf("//");
    if (k < 0) {
      k = -2;
    }
    l = uri.indexOf("/", k + 2);
    if (uri[l + 1] !== "/" && base[l + 1] !== "/" && uri.slice(0, l) === base.slice(0, l)) {
      return uri.slice(l);
    }
  }
  if (uri[i] === "#" && base.length === i) {
    return uri.slice(i);
  }
  while (i > 0 && uri[i - 1] !== "/") {
    i--;
  }
  if (i < 3) {
    return uri;
  }
  if (base.indexOf("//", i - 2) > 0 || uri.indexOf("//", i - 2) > 0) {
    return uri;
  }
  if (base.indexOf(":", i) > 0) {
    return uri;
  }
  n = 0;
  ref = base.slice(i);
  for (p = 0, len1 = ref.length; p < len1; p++) {
    c = ref[p];
    if (c === "/") {
      n++;
    }
  }
  if (n === 0 && i < uri.length && uri[i] === "#") {
    return "./" + uri.slice(i);
  }
  if (n === 0 && i === uri.length) {
    return "./";
  }
  s = "";
  if (n > 0) {
    for (q = 1, ref1 = n; ref1 >= 1 ? q <= ref1 : q >= ref1; ref1 >= 1 ? ++q : --q) {
      s += "../";
    }
  }
  return s + uri.slice(i);
}

// ../node_modules/rdflib/esm/variable.js
function _callSuper5(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct5() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct5() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct5 = function _isNativeReflectConstruct10() {
    return !!t;
  })();
}
var Variable = /* @__PURE__ */ function(_Node) {
  function Variable3() {
    var _this;
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    _classCallCheck(this, Variable3);
    _this = _callSuper5(this, Variable3, [name]);
    _defineProperty(_this, "termType", VariableTermType);
    _defineProperty(_this, "base", "varid:");
    _defineProperty(_this, "classOrder", class_order_default.Variable);
    _defineProperty(_this, "isVar", 1);
    _defineProperty(_this, "uri", void 0);
    _this.base = "varid:";
    _this.uri = join(name, _this.base);
    return _this;
  }
  _inherits(Variable3, _Node);
  return _createClass(Variable3, [{
    key: "equals",
    value: function equals2(other) {
      if (!other) {
        return false;
      }
      return this.termType === other.termType && this.value === other.value;
    }
  }, {
    key: "hashString",
    value: function hashString() {
      return this.toString();
    }
  }, {
    key: "substitute",
    value: function substitute(bindings) {
      var ref;
      return (ref = bindings[this.toNT()]) != null ? ref : this;
    }
  }, {
    key: "toString",
    value: function toString() {
      return Variable3.toString(this);
    }
  }], [{
    key: "toString",
    value: function toString(variable4) {
      if (variable4.uri.slice(0, variable4.base.length) === variable4.base) {
        return "?".concat(variable4.uri.slice(variable4.base.length));
      }
      return "?".concat(variable4.uri);
    }
  }]);
}(Node2);

// ../node_modules/rdflib/esm/factories/factory-types.js
var Feature = /* @__PURE__ */ function(Feature2) {
  Feature2["collections"] = "COLLECTIONS";
  Feature2["defaultGraphType"] = "DEFAULT_GRAPH_TYPE";
  Feature2["equalsMethod"] = "EQUALS_METHOD";
  Feature2["id"] = "ID";
  Feature2["identity"] = "IDENTITY";
  Feature2["reversibleId"] = "REVERSIBLE_ID";
  Feature2["variableType"] = "VARIABLE_TYPE";
  return Feature2;
}({});

// ../node_modules/rdflib/esm/factories/canonical-data-factory.js
var _defaultGraph = new DefaultGraph();
var CanonicalDataFactory = {
  supports: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Feature.collections, false), Feature.defaultGraphType, false), Feature.equalsMethod, true), Feature.identity, false), Feature.id, true), Feature.reversibleId, false), Feature.variableType, true),
  /**
   * Creates a new blank node
   * @param value - The blank node's identifier
   */
  blankNode: function blankNode(value) {
    return new BlankNode(value);
  },
  defaultGraph: function defaultGraph2() {
    return _defaultGraph;
  },
  /**
   * Compares to (rdf) objects for equality.
   */
  equals: function equals(a, b) {
    if (a === b || !a || !b) {
      return true;
    }
    if (isQuad(a) || isQuad(b)) {
      if (isQuad(a) && isQuad(b)) {
        return this.equals(a.subject, b.subject) && this.equals(a.predicate, b.predicate) && this.equals(a.object, b.object) && this.equals(a.graph, b.graph);
      }
      return false;
    }
    if (isTerm(a) && isTerm(b)) {
      return this.id(a) === this.id(b);
    }
    return false;
  },
  /**
   * Generates a uniquely identifiably *idempotent* string for the given {term}.
   *
   * Equivalent to [[Term.hashString]]
   *
   * @example Use this to associate data with a term in an object
   *   { obj[id(term)] = "myData" }
   */
  id: function id(term2) {
    if (!term2) {
      return "undefined";
    }
    if (isQuad(term2)) {
      return this.quadToNQ(term2);
    }
    switch (term2.termType) {
      case DefaultGraphTermType:
        return "defaultGraph";
      case VariableTermType:
        return Variable.toString(term2);
      default:
        var nq = this.termToNQ(term2);
        if (nq) {
          return nq;
        }
        throw new Error("Can't id term with type '".concat(term2.termType, "'"));
    }
  },
  isQuad: function isQuad2(obj) {
    return obj instanceof Statement;
  },
  /**
   * Creates a new literal node. Does some JS literal parsing for ease of use.
   * @param value - The lexical value
   * @param languageOrDatatype - Either the language or the datatype
   */
  literal: function literal(value, languageOrDatatype) {
    if (typeof value !== "string" && !languageOrDatatype) {
      return Literal.fromValue(value);
    }
    var strValue = typeof value === "string" ? value : "" + value;
    if (typeof languageOrDatatype === "string") {
      if (languageOrDatatype.indexOf(":") === -1) {
        return new Literal(strValue, languageOrDatatype);
      } else {
        return new Literal(strValue, null, this.namedNode(languageOrDatatype));
      }
    } else {
      return new Literal(strValue, null, languageOrDatatype);
    }
  },
  /**
   * Creates a new named node
   * @param value - The new named node
   */
  namedNode: function namedNode(value) {
    return new NamedNode(value);
  },
  /**
   * Creates a new statement
   * @param subject - The subject
   * @param predicate - The predicate
   * @param object - The object
   * @param graph - The containing graph
   */
  quad: function quad(subject, predicate, object, graph3) {
    return new Statement(subject, predicate, object, graph3 || _defaultGraph);
  },
  /**
   * Creates a new statement
   * @param subject - The subject
   * @param predicate - The predicate
   * @param object - The object
   * @param graph - The containing graph
   */
  triple: function triple(subject, predicate, object, graph3) {
    return this.quad(subject, predicate, object, graph3);
  },
  quadToNQ: function quadToNQ(q) {
    return "".concat(this.termToNQ(q.subject), " ").concat(this.termToNQ(q.predicate), " ").concat(this.termToNQ(q.object), " ").concat(this.termToNQ(q.graph), " .");
  },
  /** Stringify a {term} to n-quads serialization. */
  termToNQ: function termToNQ(term2) {
    var _this = this;
    switch (term2.termType) {
      case BlankNodeTermType:
        return "_:" + term2.value;
      case DefaultGraphTermType:
        return "";
      case EmptyTermType:
        return "<http://www.w3.org/1999/02/22-rdf-syntax-ns#nil>";
      case LiteralTermType:
        return Literal.toNT(term2);
      case GraphTermType:
      case NamedNodeTermType:
        return "<" + term2.value + ">";
      case CollectionTermType:
        return "(" + term2.elements.map(function(t) {
          return _this.termToNQ(t);
        }).join(" ") + ")";
      default:
        throw new Error("Can't serialize nonstandard term type (was '".concat(term2.termType, "')"));
    }
  },
  /** Convert an rdf object (term or quad) to n-quads serialization. */
  toNQ: function toNQ(term2) {
    if (this.isQuad(term2)) {
      return this.quadToNQ(term2);
    }
    return this.termToNQ(term2);
  },
  /**
   * Creates a new variable
   * @param name - The name for the variable
   */
  variable: function variable(name) {
    return new Variable(name);
  }
};
var canonical_data_factory_default = CanonicalDataFactory;

// ../node_modules/rdflib/esm/collection.js
function _callSuper6(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct6() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct6() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct6 = function _isNativeReflectConstruct10() {
    return !!t;
  })();
}
function fromValue(value) {
  if (typeof value === "undefined" || value === null) {
    return value;
  }
  if (isTerm(value)) {
    return value;
  }
  if (Array.isArray(value)) {
    return new Collection(value);
  }
  return Literal.fromValue(value);
}
var Collection = /* @__PURE__ */ function(_Node) {
  function Collection2(initial) {
    var _this;
    _classCallCheck(this, Collection2);
    _this = _callSuper6(this, Collection2, [(BlankNode.nextId++).toString()]);
    _defineProperty(_this, "termType", CollectionTermType);
    _defineProperty(_this, "classOrder", class_order_default.Collection);
    _defineProperty(_this, "closed", false);
    _defineProperty(_this, "compareTerm", BlankNode.prototype.compareTerm);
    _defineProperty(_this, "elements", []);
    _defineProperty(_this, "isVar", 0);
    if (initial && initial.length > 0) {
      initial.forEach(function(element) {
        _this.elements.push(fromValue(element));
      });
    }
    return _this;
  }
  _inherits(Collection2, _Node);
  return _createClass(Collection2, [{
    key: "id",
    get: function get() {
      return this.value;
    },
    set: function set(value) {
      this.value = value;
    }
    /**
     * Appends an element to this collection
     * @param element - The new element
     */
  }, {
    key: "append",
    value: function append(element) {
      return this.elements.push(element);
    }
    /**
     * Closes this collection
     */
  }, {
    key: "close",
    value: function close() {
      this.closed = true;
      return this.closed;
    }
    /**
     * Removes the first element from the collection (and return it)
     */
  }, {
    key: "shift",
    value: function shift() {
      return this.elements.shift();
    }
    /**
     * Creates a new Collection with the substituting bindings applied
     * @param bindings - The bindings to substitute
     */
  }, {
    key: "substitute",
    value: function substitute(bindings) {
      var elementsCopy = this.elements.map(function(ea) {
        return ea.substitute(bindings);
      });
      return new Collection2(elementsCopy);
    }
  }, {
    key: "toNT",
    value: function toNT() {
      return Collection2.toNT(this);
    }
  }, {
    key: "toString",
    value: (
      /**
       * Serializes the collection to a string.
       * Surrounded by (parentheses) and separated by spaces.
       */
      function toString() {
        return "(" + this.elements.join(" ") + ")";
      }
    )
    /**
     * Prepends the specified element to the collection's front
     * @param element - The element to prepend
     */
  }, {
    key: "unshift",
    value: function unshift(element) {
      return this.elements.unshift(element);
    }
  }], [{
    key: "toNT",
    value: function toNT(collection2) {
      return BlankNode.NTAnonymousNodePrefix + collection2.id;
    }
  }]);
}(Node2);
_defineProperty(Collection, "termType", CollectionTermType);

// ../node_modules/rdflib/esm/log.js
var log = {
  debug: function debug(x) {
  },
  warn: function warn(x) {
  },
  info: function info(x) {
  },
  error: function error(x) {
  },
  success: function success(x) {
  },
  msg: function msg(x) {
  }
};
var log_default = log;

// ../node_modules/rdflib/esm/namespace.js
function Namespace(nsuri, factory) {
  var dataFactory = factory || {
    namedNode: function namedNode4(value) {
      return new NamedNode(value);
    }
  };
  return function(ln) {
    return dataFactory.namedNode(nsuri + (ln || ""));
  };
}

// ../node_modules/rdflib/esm/utils-js.js
var import_xmldom = __toESM(require_lib());
function mediaTypeClass(mediaType) {
  mediaType = mediaType.split(";")[0].trim();
  return new NamedNode("http://www.w3.org/ns/iana/media-types/" + mediaType + "#Resource");
}
function callbackify(obj, callbacks) {
  obj.callbacks = {};
  for (var x = callbacks.length - 1; x >= 0; x--) {
    obj.callbacks[callbacks[x]] = [];
  }
  obj.addHook = function(hook) {
    if (!obj.callbacks[hook]) {
      obj.callbacks[hook] = [];
    }
  };
  obj.addCallback = function(hook, func) {
    obj.callbacks[hook].push(func);
  };
  obj.removeCallback = function(hook, funcName) {
    for (var i = 0; i < obj.callbacks[hook].length; i++) {
      if (obj.callbacks[hook][i].name === funcName) {
        obj.callbacks[hook].splice(i, 1);
        return true;
      }
    }
    return false;
  };
  obj.insertCallback = function(hook, func) {
    obj.callbacks[hook].unshift(func);
  };
  obj.fireCallbacks = function fireCallbacks(hook, args) {
    var newCallbacks = [];
    var replaceCallbacks = [];
    var len = obj.callbacks[hook].length;
    var x2;
    var callback;
    for (x2 = len - 1; x2 >= 0; x2--) {
      callback = obj.callbacks[hook][x2];
      if (callback && callback.apply(obj, args)) {
        newCallbacks.push(callback);
      }
    }
    for (x2 = newCallbacks.length - 1; x2 >= 0; x2--) {
      replaceCallbacks.push(newCallbacks[x2]);
    }
    for (x2 = len; x2 < obj.callbacks[hook].length; x2++) {
      replaceCallbacks.push(obj.callbacks[hook][x2]);
    }
    obj.callbacks[hook] = replaceCallbacks;
  };
}
function domToString(node, options) {
  options = options || {};
  var selfClosing = [];
  if (options && options.selfClosing) {
    options.selfClosing.split(" ").forEach(function(n) {
      selfClosing[n] = true;
    });
  }
  var skipAttributes = [];
  if (options && options.skipAttributes) {
    options.skipAttributes.split(" ").forEach(function(n) {
      skipAttributes[n] = true;
    });
  }
  return dumpNode(node, options, selfClosing, skipAttributes);
}
function dumpNode(node, options, selfClosing, skipAttributes) {
  var i;
  var out = "";
  var noEsc = [false];
  if (typeof node.nodeType === "undefined") return out;
  if (node.nodeType === 1) {
    if (node.hasAttribute("class") && options && options.classWithChildText && node.matches(options.classWithChildText.class)) {
      out += node.querySelector(options.classWithChildText.element).textContent;
    } else if (!(options && options.skipNodeWithClass && node.matches("." + options.skipNodeWithClass))) {
      var ename = node.nodeName.toLowerCase();
      out += "<" + ename;
      var attrList = [];
      for (i = node.attributes.length - 1; i >= 0; i--) {
        var atn = node.attributes[i];
        if (skipAttributes && skipAttributes.length > 0 && skipAttributes[atn.name]) continue;
        if (/^\d+$/.test(atn.name)) continue;
        if (atn.name === "class" && options && options.replaceClassItemWith && atn.value.split(" ").indexOf(options.replaceClassItemWith.source) > -1) {
          var re = new RegExp(options.replaceClassItemWith.source, "g");
          atn.value = atn.value.replace(re, options.replaceClassItemWith.target).trim();
        }
        if (!(atn.name === "class" && options && options.skipClassWithValue && options.skipClassWithValue === atn.value)) {
          attrList.push(atn.name + "='" + atn.value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&quot;") + "'");
        }
      }
      if (attrList.length > 0) {
        if (options && options.sortAttributes) {
          attrList.sort(function(a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
          });
        }
        out += " " + attrList.join(" ");
      }
      if (selfClosing && selfClosing.ename) {
        out += " />";
      } else {
        out += ">";
        out += ename === "html" ? "\n  " : "";
        noEsc.push(ename === "style" || ename === "script");
        for (i = 0; i < node.childNodes.length; i++) out += dumpNode(node.childNodes[i]);
        noEsc.pop();
        out += ename === "body" ? "</" + ename + ">\n" : "</" + ename + ">";
      }
    }
  } else if (node.nodeType === 8) {
    out += "<!--" + node.nodeValue + "-->";
  } else if (node.nodeType === 3 || node.nodeType === 4) {
    var nl = node.nodeValue.replace(/\n+$/, "");
    out += noEsc[noEsc.length - 1] ? nl : nl.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  } else {
    console.log("Warning; Cannot handle serialising nodes of type: " + node.nodeType);
    console.log(node);
  }
  return out;
}
function heavyCompare(x, y, g, uriMap) {
  var nonBlank = function nonBlank2(x2) {
    return x2.termType === "BlankNode" ? null : x2;
  };
  var signature = function signature2(x2) {
    var lis = g.statementsMatching(x2).map(function(st3) {
      return "" + nonBlank(st3.subject) + " " + nonBlank(st3.predicate) + " " + nonBlank(st3.object);
    }).concat(g.statementsMatching(void 0, void 0, x2).map(function(st3) {
      return "" + nonBlank(st3.subject) + " " + nonBlank(st3.predicate) + " " + nonBlank(st3.object);
    }));
    lis.sort();
    return lis.join("\n");
  };
  var comparison = Object.prototype.hasOwnProperty.call(g, "compareTerms") ? g.compareTerms(x, y) : x.compareTerm(y);
  if (x.termType === "BlankNode" && y.termType === "BlankNode") {
    if (comparison === 0) return 0;
    if (signature(x) > signature(y)) return 1;
    if (signature(x) < signature(y)) return -1;
    return comparison;
  } else {
    if (uriMap && x.uri && y.uri) {
      return (uriMap[x.uri] || x.uri).localeCompare(uriMap[y.uri] || y.uri);
    }
    return comparison;
  }
}
function heavyCompareSPO(x, y, g, uriMap) {
  return heavyCompare(x.subject, y.subject, g, uriMap) || heavyCompare(x.predicate, y.predicate, g, uriMap) || heavyCompare(x.object, y.object, g, uriMap);
}
function parseXML(str, options) {
  var dparser;
  options = options || {};
  if (typeof module !== "undefined" && module && module.exports) {
    var dom = new import_xmldom.DOMParser().parseFromString(str, options.contentType || "application/xhtml+xml");
    return dom;
  } else {
    if (typeof window !== "undefined" && window.DOMParser) {
      dparser = new window.DOMParser();
    } else {
      dparser = new import_xmldom.DOMParser();
    }
  }
  return dparser.parseFromString(str, "application/xml");
}
function RDFArrayRemove(a, x) {
  for (var i = 0; i < a.length; i++) {
    if (a[i].subject.equals(x.subject) && a[i].predicate.equals(x.predicate) && a[i].object.equals(x.object) && a[i].why.equals(x.why)) {
      a.splice(i, 1);
      return;
    }
  }
  throw new Error("RDFArrayRemove: Array did not contain " + x + " " + x.why);
}
function stackString(e) {
  var str = "" + e + "\n";
  if (!e.stack) {
    return str + "No stack available.\n";
  }
  var lines = e.stack.toString().split("\n");
  var toprint = [];
  for (var i = 0; i < lines.length; i++) {
    var line = lines[i];
    if (line.indexOf("ecmaunit.js") > -1) {
      break;
    }
    if (line.charAt(0) == "(") {
      line = "function" + line;
    }
    var chunks = line.split("@");
    toprint.push(chunks);
  }
  for (var i = 0; i < toprint.length; i++) {
    str += "  " + toprint[i][1] + "\n    " + toprint[i][0];
  }
  return str;
}

// ../node_modules/rdflib/esm/xsd.js
function createXSD() {
  var localFactory = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : canonical_data_factory_default;
  return {
    boolean: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#boolean"),
    dateTime: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#dateTime"),
    decimal: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#decimal"),
    double: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#double"),
    integer: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#integer"),
    langString: localFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString"),
    string: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#string")
  };
}
var defaultXSD = createXSD(canonical_data_factory_default);

// ../node_modules/rdflib/esm/serializer.js
var import_solid_namespace = __toESM(require_solid_namespace());
var ttl2jsonld = __toESM(require_ttl2jsonld());
function createSerializer(store) {
  return new Serializer(store);
}
var Serializer = /* @__PURE__ */ function() {
  function Serializer2(store) {
    _classCallCheck(this, Serializer2);
    _defineProperty(this, "_notQNameChars", "	\r\n !\"#$%&'()*.,+/;<=>?@[\\]^`{|}~");
    _defineProperty(this, "_notNameChars", this._notQNameChars + ":");
    _defineProperty(this, "validPrefix", new RegExp(/^[a-zA-Z][a-zA-Z0-9]*$/));
    _defineProperty(this, "forbidden1", new RegExp(/[\\"\b\f\r\v\t\n\u0080-\uffff]/gm));
    _defineProperty(this, "forbidden3", new RegExp(/[\\"\b\f\r\v\u0080-\uffff]/gm));
    this.flags = "";
    this.base = null;
    this.prefixes = [];
    this.namespaces = [];
    var nsKeys = Object.keys((0, import_solid_namespace.default)());
    for (var i in nsKeys) {
      var uri = (0, import_solid_namespace.default)()[nsKeys[i]]("");
      var prefix = nsKeys[i];
      this.prefixes[uri] = prefix;
      this.namespaces[prefix] = uri;
    }
    this.suggestPrefix("rdf", "http://www.w3.org/1999/02/22-rdf-syntax-ns#");
    this.suggestPrefix("xml", "reserved:reservedForFutureUse");
    this.namespacesUsed = [];
    this.keywords = ["a"];
    this.prefixchars = "abcdefghijklmnopqustuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    this.incoming = null;
    this.formulas = [];
    this.store = store;
    this.rdfFactory = store.rdfFactory || canonical_data_factory_default;
    this.xsd = createXSD(this.rdfFactory);
  }
  return _createClass(Serializer2, [{
    key: "setBase",
    value: function setBase(base) {
      this.base = base;
      return this;
    }
  }, {
    key: "setFlags",
    value: function setFlags(flags) {
      this.flags = flags || "";
      return this;
    }
  }, {
    key: "toStr",
    value: function toStr(x) {
      var s = x.toNT();
      if (x.termType === "Graph") {
        this.formulas[s] = x;
      }
      return s;
    }
  }, {
    key: "fromStr",
    value: function fromStr(s) {
      if (s[0] === "{") {
        var x = this.formulas[s];
        if (!x) console.log("No formula object for " + s);
        return x;
      }
      return this.store.fromNT(s);
    }
    /**
     * Defines a set of [prefix, namespace] pairs to be used by this Serializer instance.
     * Overrides previous prefixes if any
     * @param namespaces
     * @return {Serializer}
     */
  }, {
    key: "setNamespaces",
    value: function setNamespaces(namespaces) {
      for (var px in namespaces) {
        this.setPrefix(px, namespaces[px]);
      }
      return this;
    }
    /**
     * Defines a namespace prefix, overriding any existing prefix for that URI
     * @param prefix
     * @param uri
     */
  }, {
    key: "setPrefix",
    value: function setPrefix(prefix, uri) {
      if (prefix.slice(0, 7) === "default") return;
      if (prefix.slice(0, 2) === "ns") return;
      if (!prefix || !uri) return;
      for (var existingNs in this.prefixes) {
        if (this.prefixes[existingNs] == prefix) delete this.prefixes[existingNs];
      }
      this.prefixes[uri] = prefix;
      this.namespaces[prefix] = uri;
    }
    /* Accumulate Namespaces
    **
    ** These are only hints.  If two overlap, only one gets used
    ** There is therefore no guarantee in general.
    */
  }, {
    key: "suggestPrefix",
    value: function suggestPrefix(prefix, uri) {
      if (prefix.slice(0, 7) === "default") return;
      if (prefix.slice(0, 2) === "ns") return;
      if (!prefix || !uri) return;
      if (prefix in this.namespaces || uri in this.prefixes) return;
      this.prefixes[uri] = prefix;
      this.namespaces[prefix] = uri;
    }
    // Takes a namespace -> prefix map
  }, {
    key: "suggestNamespaces",
    value: function suggestNamespaces(namespaces) {
      for (var px in namespaces) {
        this.suggestPrefix(px, namespaces[px]);
      }
      return this;
    }
  }, {
    key: "checkIntegrity",
    value: function checkIntegrity() {
      var p, ns3;
      for (p in this.namespaces) {
        if (this.prefixes[this.namespaces[p]] !== p) {
          throw new Error("Serializer integity error 1: " + p + ", " + this.namespaces[p] + ", " + this.prefixes[this.namespaces[p]] + "!");
        }
      }
      for (ns3 in this.prefixes) {
        if (this.namespaces[this.prefixes[ns3]] !== ns3) {
          throw new Error("Serializer integity error 2: " + ns3 + ", " + this.prefixs[ns3] + ", " + this.namespaces[this.prefixes[ns3]] + "!");
        }
      }
    }
    // Make up an unused prefix for a random namespace
  }, {
    key: "makeUpPrefix",
    value: function makeUpPrefix(uri) {
      var p = uri;
      function canUseMethod(pp) {
        if (!this.validPrefix.test(pp)) return false;
        if (pp === "ns") return false;
        if (pp in this.namespaces) return false;
        this.prefixes[uri] = pp;
        this.namespaces[pp] = uri;
        return pp;
      }
      var canUse = canUseMethod.bind(this);
      if ("#/".indexOf(p[p.length - 1]) >= 0) p = p.slice(0, -1);
      var slash = p.lastIndexOf("/");
      if (slash >= 0) p = p.slice(slash + 1);
      var i = 0;
      while (i < p.length) {
        if (this.prefixchars.indexOf(p[i])) {
          i++;
        } else {
          break;
        }
      }
      p = p.slice(0, i);
      if (p.length < 6 && canUse(p)) return p;
      if (canUse(p.slice(0, 3))) return p.slice(0, 3);
      if (canUse(p.slice(0, 2))) return p.slice(0, 2);
      if (canUse(p.slice(0, 4))) return p.slice(0, 4);
      if (canUse(p.slice(0, 1))) return p.slice(0, 1);
      if (canUse(p.slice(0, 5))) return p.slice(0, 5);
      if (!this.validPrefix.test(p)) {
        p = "n";
      }
      for (var j = 0; ; j++) if (canUse(p.slice(0, 3) + j)) return p.slice(0, 3) + j;
    }
  }, {
    key: "rootSubjects",
    value: function rootSubjects(sts) {
      var incoming = {};
      var subjects = {};
      var allBnodes = {};
      for (var i = 0; i < sts.length; i++) {
        var st3 = sts[i];
        var checkMentions = function checkMentions2(x) {
          if (!incoming.hasOwnProperty(x)) incoming[x] = [];
          incoming[x].push(st3.subject);
        };
        var st22 = [st3.subject, st3.predicate, st3.object];
        st22.map(function(y2) {
          if (y2.termType === "BlankNode") {
            allBnodes[y2.toNT()] = true;
          } else if (y2.termType === "Collection") {
            y2.elements.forEach(function(z) {
              checkMentions(z);
            });
          }
        });
        checkMentions(sts[i].object);
        var ss = subjects[this.toStr(st3.subject)];
        if (!ss) ss = [];
        ss.push(st3);
        subjects[this.toStr(st3.subject)] = ss;
      }
      var roots = [];
      for (var xNT in subjects) {
        if (!subjects.hasOwnProperty(xNT)) continue;
        var y = this.fromStr(xNT);
        if (y.termType !== "BlankNode" || !incoming[y] || incoming[y].length !== 1) {
          roots.push(y);
          continue;
        }
      }
      this.incoming = incoming;
      var rootsHash = {};
      for (var k = 0; k < roots.length; k++) {
        rootsHash[roots[k].toNT()] = true;
      }
      return {
        "roots": roots,
        "subjects": subjects,
        "rootsHash": rootsHash,
        "incoming": incoming
      };
    }
    // //////////////////////////////////////////////////////
  }, {
    key: "toN3",
    value: function toN3(f) {
      return this.statementsToN3(f.statements);
    }
  }, {
    key: "explicitURI",
    value: function explicitURI(uri) {
      if (this.flags.indexOf("r") < 0 && this.base) {
        uri = refTo(this.base, uri);
      } else if (this.flags.indexOf("u") >= 0) {
        uri = backslashUify(uri);
      } else {
        uri = hexify(decodeURI(uri));
      }
      return "<" + uri + ">";
    }
  }, {
    key: "statementsToNTriples",
    value: function statementsToNTriples(sts) {
      var sorted = sts.slice();
      sorted.sort();
      var str = "";
      var rdfns = "http://www.w3.org/1999/02/22-rdf-syntax-ns#";
      var self2 = this;
      var kb = this.store;
      var factory = this.rdfFactory;
      var termToNT = function termToNT2(x) {
        if (x.termType !== "Collection") {
          return self2.atomicTermToN3(x);
        }
        var list = x.elements;
        var rest = kb.sym(rdfns + "nill");
        for (var i2 = list.length - 1; i2 >= 0; i2--) {
          var bnode = factory.blankNode();
          str += termToNT2(bnode) + " " + termToNT2(kb.sym(rdfns + "first")) + " " + termToNT2(list[i2]) + ".\n";
          str += termToNT2(bnode) + " " + termToNT2(kb.sym(rdfns + "rest")) + " " + termToNT2(rest) + ".\n";
          rest = bnode;
        }
        return self2.atomicTermToN3(rest);
      };
      for (var i = 0; i < sorted.length; i++) {
        var st3 = sorted[i];
        var s = "";
        s += termToNT(st3.subject) + " ";
        s += termToNT(st3.predicate) + " ";
        s += termToNT(st3.object) + " ";
        if (this.flags.indexOf("q") >= 0) {
          s += termToNT(st3.why) + " ";
        }
        s += ".\n";
        str += s;
      }
      return str;
    }
  }, {
    key: "statementsToN3",
    value: function statementsToN3(sts) {
      var indent = 4;
      var width = 80;
      var kb = this.store;
      var uriMap = {
        "http://www.w3.org/1999/02/22-rdf-syntax-ns#type": "aaa:00"
      };
      var SPO = function SPO2(x, y) {
        return heavyCompareSPO(x, y, kb, uriMap);
      };
      sts.sort(SPO);
      if (this.base && !this.defaultNamespace) {
        this.defaultNamespace = this.base + "#";
      }
      var predMap = {};
      if (this.flags.indexOf("s") < 0) {
        predMap["http://www.w3.org/2002/07/owl#sameAs"] = "=";
      }
      if (this.flags.indexOf("t") < 0) {
        predMap["http://www.w3.org/1999/02/22-rdf-syntax-ns#type"] = "a";
      }
      if (this.flags.indexOf("i") < 0) {
        predMap["http://www.w3.org/2000/10/swap/log#implies"] = "=>";
      }
      var spaces = function spaces2(n) {
        var s = "";
        for (var i = 0; i < n; i++) s += " ";
        return s;
      };
      var treeToLine = function treeToLine2(tree2) {
        var str = "";
        for (var i = 0; i < tree2.length; i++) {
          var branch = tree2[i];
          var s2 = typeof branch === "string" ? branch : treeToLine2(branch);
          if (i !== 0) {
            var ch = str.slice(-1) || " ";
            if (s2 === "," || s2 === ";") {
            } else if (s2 === "." && !"0123456789.:".includes(ch)) {
            } else {
              str += " ";
            }
          }
          str += s2;
        }
        return str;
      };
      var treeToString = function treeToString2(tree2, level) {
        var str = "";
        var lastLength = 1e5;
        if (level === void 0) level = -1;
        for (var i = 0; i < tree2.length; i++) {
          var branch = tree2[i];
          if (typeof branch !== "string") {
            var substr = treeToString2(branch, level + 1);
            if (substr.length < 10 * (width - indent * level) && substr.indexOf('"""') < 0) {
              var line = treeToLine(branch);
              if (line.length < width - indent * level) {
                branch = line;
                substr = "";
              }
            }
            if (substr) lastLength = 1e4;
            str += substr;
          }
          if (typeof branch === "string") {
            if (branch.length === 1 && str.slice(-1) === "\n") {
              if (",.;".indexOf(branch) >= 0) {
                str = str.slice(0, -1);
                if (branch == "." && "0123456789.:".includes(str.charAt(str.length - 1))) {
                  str += " ";
                  lastLength += 1;
                }
                str += branch + "\n";
                lastLength += 1;
                continue;
              }
            }
            if (lastLength < indent * level + 4 || // if new line not necessary
            lastLength + branch.length + 1 < width && ";.".indexOf(str[str.length - 2]) < 0) {
              str = str.slice(0, -1) + " " + branch + "\n";
              lastLength += branch.length + 1;
            } else {
              var _line = spaces(indent * level) + branch;
              str += _line + "\n";
              lastLength = _line.length;
              if (level < 0) {
                str += "\n";
                lastLength = 1e5;
              }
            }
          }
        }
        return str;
      };
      function statementListToTreeMethod(statements) {
        var stats = this.rootSubjects(statements);
        var roots = stats.roots;
        var results = [];
        for (var i = 0; i < roots.length; i++) {
          var root = roots[i];
          results.push(subjectTree(root, stats));
        }
        return results;
      }
      var statementListToTree = statementListToTreeMethod.bind(this);
      function subjectTree(subject, stats) {
        if (subject.termType === "BlankNode" && !stats.incoming[subject]) {
          return objectTree(subject, stats, true).concat(["."]);
        }
        return [termToN3(subject, stats)].concat([propertyTree(subject, stats)]).concat(["."]);
      }
      function propertyTreeMethod(subject, stats) {
        var results = [];
        var lastPred = null;
        var sts2 = stats.subjects[this.toStr(subject)] || [];
        if (typeof sts2 === "undefined") {
          throw new Error("Cant find statements for " + subject);
        }
        var objects = [];
        for (var i = 0; i < sts2.length; i++) {
          var st3 = sts2[i];
          if (st3.predicate.uri === lastPred) {
            objects.push(",");
          } else {
            if (lastPred) {
              results = results.concat([objects]).concat([";"]);
              objects = [];
            }
            results.push(predMap[st3.predicate.uri] ? predMap[st3.predicate.uri] : termToN3(st3.predicate, stats));
          }
          lastPred = st3.predicate.uri;
          objects.push(objectTree(st3.object, stats));
        }
        results = results.concat([objects]);
        return results;
      }
      var propertyTree = propertyTreeMethod.bind(this);
      function objectTreeMethod(obj, stats, force) {
        if (obj.termType === "BlankNode" && (force || stats.rootsHash[obj.toNT()] === void 0)) {
          if (stats.subjects[this.toStr(obj)]) {
            return ["[", propertyTree(obj, stats), "]"];
          } else {
            return "[]";
          }
        }
        return termToN3(obj, stats);
      }
      var objectTree = objectTreeMethod.bind(this);
      function termToN3Method(expr, stats) {
        var i, res;
        switch (expr.termType) {
          case "Graph":
            res = ["{"];
            res = res.concat(statementListToTree(expr.statements));
            return res.concat(["}"]);
          case "Collection":
            res = ["("];
            for (i = 0; i < expr.elements.length; i++) {
              res.push([objectTree(expr.elements[i], stats)]);
            }
            res.push(")");
            return res;
          default:
            return this.atomicTermToN3(expr);
        }
      }
      Serializer2.prototype.termToN3 = termToN3;
      var termToN3 = termToN3Method.bind(this);
      function prefixDirectivesMethod() {
        var str = "";
        if (this.flags.indexOf("d") < 0 && this.defaultNamespace) {
          str += "@prefix : " + this.explicitURI(this.defaultNamespace) + ".\n";
        }
        for (var ns3 in this.prefixes) {
          if (!this.prefixes.hasOwnProperty(ns3)) continue;
          if (!this.namespacesUsed[ns3]) continue;
          str += "@prefix " + this.prefixes[ns3] + ": " + this.explicitURI(ns3) + ".\n";
        }
        return str + "\n";
      }
      var prefixDirectives = prefixDirectivesMethod.bind(this);
      var tree = statementListToTree(sts);
      return prefixDirectives() + treeToString(tree);
    }
    // //////////////////////////////////////////// Atomic Terms
    //  Deal with term level things and nesting with no bnode structure
  }, {
    key: "atomicTermToN3",
    value: function atomicTermToN3(expr, stats) {
      switch (expr.termType) {
        case "BlankNode":
        case "Variable":
          return expr.toNT();
        case "Literal":
          var val = expr.value;
          if (typeof val !== "string") {
            throw new TypeError("Value of RDF literal node must be a string");
          }
          if (expr.datatype && this.flags.indexOf("x") < 0) {
            switch (expr.datatype.uri) {
              case "http://www.w3.org/2001/XMLSchema#integer":
                return val;
              case "http://www.w3.org/2001/XMLSchema#decimal":
                if (val.indexOf(".") < 0) val += ".0";
                return val;
              case "http://www.w3.org/2001/XMLSchema#double": {
                var eNotation = val.toLowerCase().indexOf("e") > 0;
                if (val.indexOf(".") < 0 && !eNotation) val += ".0";
                if (!eNotation) val += "e0";
                return val;
              }
              case "http://www.w3.org/2001/XMLSchema#boolean":
                return expr.value === "1" ? "true" : "false";
            }
          }
          var str = this.stringToN3(expr.value);
          if (expr.language) {
            str += "@" + expr.language;
          } else if (!expr.datatype.equals(this.xsd.string)) {
            str += "^^" + this.atomicTermToN3(expr.datatype, stats);
          }
          return str;
        case "NamedNode":
          return this.symbolToN3(expr);
        case "DefaultGraph":
          return "";
        default:
          throw new Error("Internal: atomicTermToN3 cannot handle " + expr + " of termType: " + expr.termType);
      }
    }
  }, {
    key: "stringToN3",
    value: function stringToN3(str, flags) {
      if (!flags) flags = "e";
      var res = "";
      var i, j, k;
      var delim;
      var forbidden;
      if (str.length > 20 && // Long enough to make sense
      str.slice(-1) !== '"' && // corner case'
      flags.indexOf("n") < 0 && // Force single line
      (str.indexOf("\n") > 0 || str.indexOf('"') > 0)) {
        delim = '"""';
        forbidden = this.forbidden3;
      } else {
        delim = '"';
        forbidden = this.forbidden1;
      }
      for (i = 0; i < str.length; ) {
        forbidden.lastIndex = 0;
        var m = forbidden.exec(str.slice(i));
        if (m == null) break;
        j = i + forbidden.lastIndex - 1;
        res += str.slice(i, j);
        var ch = str[j];
        if (ch === '"' && delim === '"""' && str.slice(j, j + 3) !== '"""') {
          res += ch;
        } else {
          k = '\b\f\r	\v\n\\"'.indexOf(ch);
          if (k >= 0) {
            res += "\\" + 'bfrtvn\\"'[k];
          } else {
            if (flags.indexOf("e") >= 0) {
              res += "\\u" + ("000" + ch.charCodeAt(0).toString(16).toLowerCase()).slice(-4);
            } else {
              res += ch;
            }
          }
        }
        i = j + 1;
      }
      return delim + res + str.slice(i) + delim;
    }
    //  A single symbol, either in  <> or namespace notation
  }, {
    key: "symbolToN3",
    value: function symbolToN3(x) {
      var uri = x.uri;
      var j = uri.indexOf("#");
      if (j < 0 && this.flags.indexOf("/") < 0) {
        j = uri.lastIndexOf("/");
      }
      if (j >= 0 && this.flags.indexOf("p") < 0 && // Can split at namespace but only if http[s]: URI or file: or ws[s] (why not others?)
      (uri.indexOf("http") === 0 || uri.indexOf("ws") === 0 || uri.indexOf("file") === 0)) {
        var canSplit = true;
        for (var k = j + 1; k < uri.length; k++) {
          if (this._notNameChars.indexOf(uri[k]) >= 0) {
            canSplit = false;
            break;
          }
        }
        if (canSplit) {
          var localid = uri.slice(j + 1);
          var namesp = uri.slice(0, j + 1);
          if (this.defaultNamespace && this.defaultNamespace === namesp && this.flags.indexOf("d") < 0) {
            if (this.flags.indexOf("k") >= 0 && this.keyords.indexOf(localid) < 0) {
              return localid;
            }
            return ":" + localid;
          }
          var prefix = this.prefixes[namesp];
          if (!prefix) prefix = this.makeUpPrefix(namesp);
          if (prefix) {
            this.namespacesUsed[namesp] = true;
            return prefix + ":" + localid;
          }
        }
      }
      return this.explicitURI(uri);
    }
    // /////////////////////////// Quad store serialization
    // @para. write  - a function taking a single string to be output
    //
  }, {
    key: "writeStore",
    value: function writeStore(write) {
      var kb = this.store;
      var fetcher3 = kb.fetcher;
      var session = fetcher3 && fetcher3.appNode;
      var sources = this.store.index[3];
      for (var s in sources) {
        var source = kb.fromNT(s);
        if (session && source.equals(session)) continue;
        write("\n" + this.atomicTermToN3(source) + " " + this.atomicTermToN3(kb.sym("http://www.w3.org/2000/10/swap/log#semantics")) + " { " + this.statementsToN3(kb.statementsMatching(void 0, void 0, void 0, source)) + " }.\n");
      }
      kb.statementsMatching(void 0, kb.sym("http://www.w3.org/2007/ont/link#requestedURI")).map(function(st3) {
        write("\n<" + st3.object.value + "> log:metadata {\n");
        var sts = kb.statementsMatching(void 0, void 0, void 0, st3.subject);
        write(this.statementsToN3(this.statementsToN3(sts)));
        write("}.\n");
      });
      var metaSources = [];
      if (session) metaSources.push(session);
      var metadata = [];
      metaSources.map(function(source2) {
        metadata = metadata.concat(kb.statementsMatching(void 0, void 0, void 0, source2));
      });
      write(this.statementsToN3(metadata));
    }
    // ////////////////////////////////////////////// XML serialization
  }, {
    key: "statementsToXML",
    value: function statementsToXML(sts) {
      var indent = 4;
      var width = 80;
      var namespaceCounts = [];
      namespaceCounts["http://www.w3.org/1999/02/22-rdf-syntax-ns#"] = true;
      var liPrefix = "http://www.w3.org/1999/02/22-rdf-syntax-ns#_";
      var spaces = function spaces2(n) {
        var s = "";
        for (var i = 0; i < n; i++) s += " ";
        return s;
      };
      var XMLtreeToLine = function XMLtreeToLine2(tree3) {
        var str2 = "";
        for (var i = 0; i < tree3.length; i++) {
          var branch = tree3[i];
          var s2 = typeof branch === "string" ? branch : XMLtreeToLine2(branch);
          str2 += s2;
        }
        return str2;
      };
      var XMLtreeToString = function XMLtreeToString2(tree3, level) {
        var str2 = "";
        var line;
        var lastLength = 1e5;
        if (!level) level = 0;
        for (var i = 0; i < tree3.length; i++) {
          var branch = tree3[i];
          if (typeof branch !== "string") {
            var substr = XMLtreeToString2(branch, level + 1);
            if (substr.length < 10 * (width - indent * level) && substr.indexOf('"""') < 0) {
              line = XMLtreeToLine(branch);
              if (line.length < width - indent * level) {
                branch = "   " + line;
                substr = "";
              }
            }
            if (substr) lastLength = 1e4;
            str2 += substr;
          }
          if (typeof branch === "string") {
            if (lastLength < indent * level + 4) {
              str2 = str2.slice(0, -1) + " " + branch + "\n";
              lastLength += branch.length + 1;
            } else {
              line = spaces(indent * level) + branch;
              str2 += line + "\n";
              lastLength = line.length;
            }
          } else {
          }
        }
        return str2;
      };
      function statementListToXMLTreeMethod(statements) {
        this.suggestPrefix("rdf", "http://www.w3.org/1999/02/22-rdf-syntax-ns#");
        var stats = this.rootSubjects(statements);
        var roots = stats.roots;
        var results = [];
        for (var i = 0; i < roots.length; i++) {
          var root = roots[i];
          results.push(subjectXMLTree(root, stats));
        }
        return results;
      }
      var statementListToXMLTree = statementListToXMLTreeMethod.bind(this);
      function escapeForXML(str2) {
        if (typeof str2 === "undefined") return "@@@undefined@@@@";
        return str2.replace(/[&<"]/g, function(m) {
          switch (m[0]) {
            case "&":
              return "&amp;";
            case "<":
              return "&lt;";
            case '"':
              return "&quot;";
          }
        });
      }
      function relURIMethod(term2) {
        return escapeForXML(this.base ? uri_exports.refTo(this.base, term2.uri) : term2.uri);
      }
      var relURI = relURIMethod.bind(this);
      function subjectXMLTreeMethod(subject, stats) {
        var results = [];
        var type, t, st3, pred;
        var sts2 = stats.subjects[this.toStr(subject)];
        if (typeof sts2 === "undefined") {
          return propertyXMLTree(subject, stats);
        }
        sts2.sort(function(a, b) {
          var ap = a.predicate.uri;
          var bp = b.predicate.uri;
          if (ap.substring(0, liPrefix.length) === liPrefix || bp.substring(0, liPrefix.length) === liPrefix) {
            return ap.localeCompare(bp);
          }
          var as = ap.substring(liPrefix.length);
          var bs = bp.substring(liPrefix.length);
          var an = parseInt(as, 10);
          var bn = parseInt(bs, 10);
          if (isNaN(an) || isNaN(bn) || an !== as || bn !== bs) {
            return ap.localeCompare(bp);
          }
          return an - bn;
        });
        for (var i = 0; i < sts2.length; i++) {
          st3 = sts2[i];
          if (st3.predicate.uri === "http://www.w3.org/1999/02/22-rdf-syntax-ns#type" && !type && st3.object.termType === "NamedNode") {
            type = st3.object;
            continue;
          }
          pred = st3.predicate;
          if (pred.uri.substr(0, liPrefix.length) === liPrefix) {
            var number = pred.uri.substr(liPrefix.length);
            var intNumber = parseInt(number, 10);
            if (number === intNumber.toString()) {
              pred = this.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#li");
            }
          }
          t = qname(pred);
          switch (st3.object.termType) {
            case "BlankNode":
              if (stats.incoming[st3.object].length === 1) {
                results = results.concat(["<" + t + ' rdf:parseType="Resource">', subjectXMLTree(st3.object, stats), "</" + t + ">"]);
              } else {
                results = results.concat(["<" + t + ' rdf:nodeID="' + st3.object.toNT().slice(2) + '"/>']);
              }
              break;
            case "NamedNode":
              results = results.concat(["<" + t + ' rdf:resource="' + relURI(st3.object) + '"/>']);
              break;
            case "Literal":
              results = results.concat(["<" + t + (st3.object.datatype.equals(this.xsd.string) ? "" : ' rdf:datatype="' + escapeForXML(st3.object.datatype.uri) + '"') + (st3.object.language ? ' xml:lang="' + st3.object.language + '"' : "") + ">" + escapeForXML(st3.object.value) + "</" + t + ">"]);
              break;
            case "Collection":
              results = results.concat(["<" + t + ' rdf:parseType="Collection">', collectionXMLTree(st3.object, stats), "</" + t + ">"]);
              break;
            default:
              throw new Error("Can't serialize object of type " + st3.object.termType + " into XML");
          }
        }
        var tag = type ? qname(type) : "rdf:Description";
        var attrs = "";
        if (subject.termType === "BlankNode") {
          if (!stats.incoming[subject] || stats.incoming[subject].length !== 1) {
            attrs = ' rdf:nodeID="' + subject.toNT().slice(2) + '"';
          }
        } else {
          attrs = ' rdf:about="' + relURI(subject) + '"';
        }
        return ["<" + tag + attrs + ">"].concat([results]).concat(["</" + tag + ">"]);
      }
      var subjectXMLTree = subjectXMLTreeMethod.bind(this);
      function collectionXMLTree(subject, stats) {
        var res = [];
        for (var i = 0; i < subject.elements.length; i++) {
          res.push(subjectXMLTree(subject.elements[i], stats));
        }
        return res;
      }
      function propertyXMLTreeMethod(subject, stats) {
        var results = [];
        var sts2 = stats.subjects[this.toStr(subject)];
        if (!sts2) return results;
        sts2.sort();
        for (var i = 0; i < sts2.length; i++) {
          var st3 = sts2[i];
          switch (st3.object.termType) {
            case "BlankNode":
              if (stats.rootsHash[st3.object.toNT()]) {
                results = results.concat(["<" + qname(st3.predicate) + ' rdf:nodeID="' + st3.object.toNT().slice(2) + '">', "</" + qname(st3.predicate) + ">"]);
              } else {
                results = results.concat(["<" + qname(st3.predicate) + ' rdf:parseType="Resource">', propertyXMLTree(st3.object, stats), "</" + qname(st3.predicate) + ">"]);
              }
              break;
            case "NamedNode":
              results = results.concat(["<" + qname(st3.predicate) + ' rdf:resource="' + relURI(st3.object) + '"/>']);
              break;
            case "Literal":
              results = results.concat(["<" + qname(st3.predicate) + (st3.object.datatype.equals(this.xsd.string) ? "" : ' rdf:datatype="' + escapeForXML(st3.object.datatype.value) + '"') + (st3.object.language ? ' xml:lang="' + st3.object.language + '"' : "") + ">" + escapeForXML(st3.object.value) + "</" + qname(st3.predicate) + ">"]);
              break;
            case "Collection":
              results = results.concat(["<" + qname(st3.predicate) + ' rdf:parseType="Collection">', collectionXMLTree(st3.object, stats), "</" + qname(st3.predicate) + ">"]);
              break;
            default:
              throw new Error("Can't serialize object of type " + st3.object.termType + " into XML");
          }
        }
        return results;
      }
      var propertyXMLTree = propertyXMLTreeMethod.bind(this);
      function qnameMethod(term2) {
        var uri = term2.uri;
        var j = uri.indexOf("#");
        if (j < 0 && this.flags.indexOf("/") < 0) {
          j = uri.lastIndexOf("/");
        }
        if (j < 0) throw new Error("Cannot make qname out of <" + uri + ">");
        for (var k = j + 1; k < uri.length; k++) {
          if (this._notNameChars.indexOf(uri[k]) >= 0) {
            throw new Error('Invalid character "' + uri[k] + '" cannot be in XML qname for URI: ' + uri);
          }
        }
        var localid = uri.slice(j + 1);
        var namesp = uri.slice(0, j + 1);
        if (this.defaultNamespace && this.defaultNamespace === namesp && this.flags.indexOf("d") < 0) {
          return localid;
        }
        var prefix = this.prefixes[namesp];
        if (!prefix) prefix = this.makeUpPrefix(namesp);
        namespaceCounts[namesp] = true;
        return prefix + ":" + localid;
      }
      var qname = qnameMethod.bind(this);
      var tree = statementListToXMLTree(sts);
      var str = "<rdf:RDF";
      if (this.defaultNamespace) {
        str += ' xmlns="' + escapeForXML(this.defaultNamespace) + '"';
      }
      for (var ns3 in namespaceCounts) {
        if (!namespaceCounts.hasOwnProperty(ns3)) continue;
        var ns22 = this.base && this.flags.includes("z") ? uri_exports.refTo(this.base, ns3) : ns3;
        str += "\n xmlns:" + this.prefixes[ns3] + '="' + escapeForXML(ns22) + '"';
      }
      str += ">";
      var tree2 = [str, tree, "</rdf:RDF>"];
      return XMLtreeToString(tree2, -1);
    }
    // End @@ body
  }, {
    key: "statementsToJsonld",
    value: function statementsToJsonld(sts) {
      var turtleDoc = this.statementsToN3(sts);
      var jsonldObj = ttl2jsonld.parse(turtleDoc);
      return JSON.stringify(jsonldObj, null, 2);
    }
  }]);
}();
function hexify(str) {
  return encodeURI(str);
}
function backslashUify(str) {
  var res = "";
  var k;
  for (var i = 0; i < str.length; i++) {
    k = str.charCodeAt(i);
    if (k > 65535) {
      res += "\\U" + ("00000000" + k.toString(16)).slice(-8);
    } else if (k > 126) {
      res += "\\u" + ("0000" + k.toString(16)).slice(-4);
    } else {
      res += str[i];
    }
  }
  return res;
}

// ../node_modules/rdflib/esm/serialize.js
function serialize(target, kb, base, contentType, callback, options) {
  base = base || (target === null || target === void 0 ? void 0 : target.value);
  var opts = options || {};
  contentType = contentType || TurtleContentType;
  var documentString = void 0;
  try {
    var sz = createSerializer(kb);
    if (opts.flags) sz.setFlags(opts.flags);
    var newSts = kb.statementsMatching(void 0, void 0, void 0, target);
    if ("namespaces" in kb) {
      sz.suggestNamespaces(kb.namespaces);
    }
    if (opts.namespaces) {
      sz.setNamespaces(opts.namespaces);
    }
    sz.setBase(base);
    switch (contentType) {
      case RDFXMLContentType:
        documentString = sz.statementsToXML(newSts);
        return executeCallback(null, documentString);
      case N3ContentType:
      case N3LegacyContentType:
        documentString = sz.statementsToN3(newSts);
        return executeCallback(null, documentString);
      case TurtleContentType:
      case TurtleLegacyContentType:
        sz.setFlags("si");
        documentString = sz.statementsToN3(newSts);
        return executeCallback(null, documentString);
      case NTriplesContentType:
        sz.setFlags("deinprstux");
        documentString = sz.statementsToNTriples(newSts);
        return executeCallback(null, documentString);
      case JSONLDContentType:
        sz.setFlags("si dr");
        documentString = sz.statementsToJsonld(newSts);
        return executeCallback(null, documentString);
      case NQuadsContentType:
      case NQuadsAltContentType:
        sz.setFlags("deinprstux q");
        documentString = sz.statementsToNTriples(newSts);
        return executeCallback(null, documentString);
      default:
        throw new Error("Serialize: Content-type " + contentType + " not supported for data write.");
    }
  } catch (err) {
    if (callback) {
      return callback(err, void 0);
    }
    throw err;
  }
  function executeCallback(err, result) {
    if (callback) {
      callback(err, result);
      return;
    } else {
      return result;
    }
  }
}

// ../node_modules/rdflib/esm/utils.js
var appliedFactoryMethods = ["blankNode", "defaultGraph", "literal", "namedNode", "quad", "variable", "supports"];
var rdf = {
  first: "http://www.w3.org/1999/02/22-rdf-syntax-ns#first",
  rest: "http://www.w3.org/1999/02/22-rdf-syntax-ns#rest",
  nil: "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
};
function arrayToStatements(rdfFactory, subject, data) {
  var statements = [];
  data.reduce(function(id3, _listObj, i, listData) {
    statements.push(rdfFactory.quad(id3, rdfFactory.namedNode(rdf.first), listData[i]));
    var nextNode;
    if (i < listData.length - 1) {
      nextNode = rdfFactory.blankNode();
      statements.push(rdfFactory.quad(id3, rdfFactory.namedNode(rdf.rest), nextNode));
    } else {
      statements.push(rdfFactory.quad(id3, rdfFactory.namedNode(rdf.rest), rdfFactory.namedNode(rdf.nil)));
    }
    return nextNode;
  }, subject);
  return statements;
}
function ArrayIndexOf(arr, item) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
  var length = arr.length;
  if (i < 0) i = length + i;
  for (; i < length; i++) {
    if (arr[i] === item) {
      return i;
    }
  }
  return -1;
}

// ../node_modules/rdflib/esm/formula.js
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length) return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null) it.return();
    } finally {
      if (didErr) throw err;
    }
  } };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _callSuper7(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct7() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct7() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct7 = function _isNativeReflectConstruct10() {
    return !!t;
  })();
}
var Formula = /* @__PURE__ */ function(_Node) {
  function Formula2() {
    var _this;
    var statements = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var constraints = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var initBindings = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var optional = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    var opts = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    _classCallCheck(this, Formula2);
    _this = _callSuper7(this, Formula2, [""]);
    _this.statements = statements;
    _this.constraints = constraints;
    _this.initBindings = initBindings;
    _this.optional = optional;
    _defineProperty(_this, "termType", GraphTermType);
    _defineProperty(_this, "classOrder", class_order_default.Graph);
    _defineProperty(_this, "fetcher", void 0);
    _defineProperty(_this, "isVar", 0);
    _defineProperty(_this, "ns", Namespace);
    _defineProperty(_this, "rdfFactory", void 0);
    _this.rdfFactory = opts && opts.rdfFactory || canonical_data_factory_default;
    var _iterator = _createForOfIteratorHelper(appliedFactoryMethods), _step;
    try {
      var _loop = function _loop2() {
        var factoryMethod = _step.value;
        _this[factoryMethod] = function() {
          var _this$rdfFactory;
          return (_this$rdfFactory = _this.rdfFactory)[factoryMethod].apply(_this$rdfFactory, arguments);
        };
      };
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return _this;
  }
  _inherits(Formula2, _Node);
  return _createClass(Formula2, [{
    key: "add",
    value: function add(subject, predicate, object, graph3) {
      var _this2 = this;
      if (arguments.length === 1) {
        subject.forEach(function(st3) {
          return _this2.add(st3.subject, st3.predicate, st3.object, st3.graph);
        });
      }
      return this.statements.push(this.rdfFactory.quad(subject, predicate, object, graph3));
    }
    /** Add a statment object
     * @param {Statement} statement - An existing constructed statement to add
     */
  }, {
    key: "addStatement",
    value: function addStatement(statement) {
      return this.add(statement);
    }
    /**
     * Shortcut for adding blankNodes
     * @param [id]
     */
  }, {
    key: "bnode",
    value: function bnode(id3) {
      return this.rdfFactory.blankNode(id3);
    }
    /**
     * Adds all the statements to this formula
     * @param statements - A collection of statements
     */
  }, {
    key: "addAll",
    value: function addAll(statements) {
      var _this3 = this;
      statements.forEach(function(quad4) {
        _this3.add(quad4.subject, quad4.predicate, quad4.object, quad4.graph);
      });
    }
    /** Follow link from one node, using one wildcard, looking for one
    *
    * For example, any(me, knows, null, profile)  - a person I know accoring to my profile .
    * any(me, knows, null, null)  - a person I know accoring to anything in store .
    * any(null, knows, me, null)  - a person who know me accoring to anything in store .
    *
    * @param s - A node to search for as subject, or if null, a wildcard
    * @param p - A node to search for as predicate, or if null, a wildcard
    * @param o - A node to search for as object, or if null, a wildcard
    * @param g - A node to search for as graph, or if null, a wildcard
    * @returns A node which match the wildcard position, or null
    */
  }, {
    key: "any",
    value: function any(s, p, o, g) {
      var st3 = this.anyStatementMatching(s, p, o, g);
      if (st3 == null) {
        return null;
      } else if (s == null) {
        return st3.subject;
      } else if (p == null) {
        return st3.predicate;
      } else if (o == null) {
        return st3.object;
      }
      return null;
    }
    /**
     * Gets the value of a node that matches the specified pattern
     * @param s The subject
     * @param p The predicate
     * @param o The object
     * @param g The graph that contains the statement
     */
  }, {
    key: "anyValue",
    value: function anyValue(s, p, o, g) {
      var y = this.any(s, p, o, g);
      return y ? y.value : void 0;
    }
    /**
     * Gets the first JavaScript object equivalent to a node based on the specified pattern
     * @param s The subject
     * @param p The predicate
     * @param o The object
     * @param g The graph that contains the statement
     */
  }, {
    key: "anyJS",
    value: function anyJS(s, p, o, g) {
      var y = this.any(s, p, o, g);
      return y ? Node2.toJS(y) : void 0;
    }
    /**
     * Gets the first statement that matches the specified pattern
     */
  }, {
    key: "anyStatementMatching",
    value: function anyStatementMatching(s, p, o, g) {
      var x = this.statementsMatching(s, p, o, g, true);
      if (!x || x.length === 0) {
        return void 0;
      }
      return x[0];
    }
    /**
     * Returns a unique index-safe identifier for the given term.
     *
     * Falls back to the rdflib hashString implementation if the given factory doesn't support id.
     */
  }, {
    key: "id",
    value: function id3(term2) {
      return this.rdfFactory.id(term2);
    }
    /**
     * Search the Store
     * This is really a teaching method as to do this properly you would use IndexedFormula
     *
     * @param s - A node to search for as subject, or if null, a wildcard
     * @param p - A node to search for as predicate, or if null, a wildcard
     * @param o - A node to search for as object, or if null, a wildcard
     * @param g - A node to search for as graph, or if null, a wildcard
     * @param justOne - flag - stop when found one rather than get all of them?
     * @returns {Array<Node>} - An array of nodes which match the wildcard position
     */
  }, {
    key: "statementsMatching",
    value: function statementsMatching(s, p, o, g, justOne) {
      var sts = this.statements.filter(function(st3) {
        return (!s || s.equals(st3.subject)) && (!p || p.equals(st3.predicate)) && (!o || o.equals(st3.object)) && (!g || g.equals(st3.graph));
      });
      if (justOne) {
        return sts.length === 0 ? [] : [sts[0]];
      }
      return sts;
    }
    /**
     * Finds the types in the list which have no *stored* subtypes
     * These are a set of classes which provide by themselves complete
     * information -- the other classes are redundant for those who
     * know the class DAG.
     * @param types A map of the types
     */
  }, {
    key: "bottomTypeURIs",
    value: function bottomTypeURIs(types) {
      var bots;
      var bottom;
      var elt;
      var i;
      var len;
      var ref;
      var subs;
      var v;
      bots = [];
      for (var _k in types) {
        if (!types.hasOwnProperty(_k)) continue;
        v = types[_k];
        subs = this.each(void 0, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), this.rdfFactory.namedNode(_k));
        bottom = true;
        i = 0;
        for (len = subs.length; i < len; i++) {
          elt = subs[i];
          ref = elt.uri;
          if (ref in types) {
            bottom = false;
            break;
          }
        }
        if (bottom) {
          bots[_k] = v;
        }
      }
      return bots;
    }
    /** Creates a new collection */
  }, {
    key: "collection",
    value: function collection2() {
      return new Collection();
    }
    /** Follow links from one node, using one wildcard.
    *
    * For example, each(me, knows, null, profile)  - people I know accoring to my profile .
    * each(me, knows, null, null)  - people I know accoring to anything in store .
    * each(null, knows, me, null)  - people who know me accoring to anything in store .
    *
    * @param s - A node to search for as subject, or if null, a wildcard
    * @param p - A node to search for as predicate, or if null, a wildcard
    * @param o - A node to search for as object, or if null, a wildcard
    * @param g - A node to search for as graph, or if null, a wildcard
    * @returns {Array<Node>} - An array of nodes which match the wildcard position
    */
  }, {
    key: "each",
    value: function each(s, p, o, g) {
      var results = [];
      var sts = this.statementsMatching(s, p, o, g, false);
      if (s == null) {
        for (var i = 0, len = sts.length; i < len; i++) {
          results.push(sts[i].subject);
        }
      } else if (p == null) {
        for (var l = 0, len1 = sts.length; l < len1; l++) {
          results.push(sts[l].predicate);
        }
      } else if (o == null) {
        for (var m = 0, len2 = sts.length; m < len2; m++) {
          results.push(sts[m].object);
        }
      } else if (g == null) {
        for (var _q = 0, len3 = sts.length; _q < len3; _q++) {
          results.push(new NamedNode(sts[_q].graph.value));
        }
      }
      return results;
    }
    /**
     * Test whether this formula is equals to {other}
     * @param other - The other formula
     */
  }, {
    key: "equals",
    value: function equals2(other) {
      if (!other) {
        return false;
      }
      return this.hashString() === other.hashString();
    }
    /**
     * For thisClass or any subclass, anything which has it is its type
     * or is the object of something which has the type as its range, or subject
     * of something which has the type as its domain
     * We don't bother doing subproperty (yet?)as it doesn't seeem to be used
     * much.
     * Get all the Classes of which we can RDFS-infer the subject is a member
     * @return a hash of URIs
     */
  }, {
    key: "findMembersNT",
    value: function findMembersNT(thisClass) {
      var len2;
      var len4;
      var m;
      var members;
      var pred;
      var ref;
      var ref1;
      var ref2;
      var ref3;
      var ref4;
      var ref5;
      var seeds;
      var st3;
      var u;
      seeds = {};
      seeds[thisClass.toNT()] = true;
      members = {};
      ref = this.transitiveClosure(seeds, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), true);
      for (var t in ref) {
        if (!ref.hasOwnProperty(t)) continue;
        ref1 = this.statementsMatching(void 0, this.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"), this.fromNT(t));
        for (var i = 0, len = ref1.length; i < len; i++) {
          st3 = ref1[i];
          members[st3.subject.toNT()] = st3;
        }
        ref2 = this.each(void 0, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#domain"), this.fromNT(t));
        for (var l = 0, len1 = ref2.length; l < len1; l++) {
          pred = ref2[l];
          ref3 = this.statementsMatching(void 0, pred);
          for (m = 0, len2 = ref3.length; m < len2; m++) {
            st3 = ref3[m];
            members[st3.subject.toNT()] = st3;
          }
        }
        ref4 = this.each(void 0, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#range"), this.fromNT(t));
        for (var _q2 = 0, len3 = ref4.length; _q2 < len3; _q2++) {
          pred = ref4[_q2];
          ref5 = this.statementsMatching(void 0, pred);
          for (u = 0, len4 = ref5.length; u < len4; u++) {
            st3 = ref5[u];
            members[st3.object.toNT()] = st3;
          }
        }
      }
      return members;
    }
    /**
     * For thisClass or any subclass, anything which has it is its type
     * or is the object of something which has the type as its range, or subject
     * of something which has the type as its domain
     * We don't bother doing subproperty (yet?)as it doesn't seeem to be used
     * much.
     * Get all the Classes of which we can RDFS-infer the subject is a member
     * @param subject - A named node
     */
  }, {
    key: "findMemberURIs",
    value: function findMemberURIs(subject) {
      return this.NTtoURI(this.findMembersNT(subject));
    }
    /**
     * Get all the Classes of which we can RDFS-infer the subject is a superclass
     * Returns a hash table where key is NT of type and value is statement why we
     * think so.
     * Does NOT return terms, returns URI strings.
     * We use NT representations in this version because they handle blank nodes.
     */
  }, {
    key: "findSubClassesNT",
    value: function findSubClassesNT(subject) {
      var types = {};
      types[subject.toNT()] = true;
      return this.transitiveClosure(types, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), true);
    }
    /**
     * Get all the Classes of which we can RDFS-infer the subject is a subclass
     * @param {RDFlibNamedNode} subject - The thing whose classes are to be found
     * @returns a hash table where key is NT of type and value is statement why we
     * think so.
     * Does NOT return terms, returns URI strings.
     * We use NT representations in this version because they handle blank nodes.
     */
  }, {
    key: "findSuperClassesNT",
    value: function findSuperClassesNT(subject) {
      var types = {};
      types[subject.toNT()] = true;
      return this.transitiveClosure(types, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), false);
    }
    /**
     * Get all the Classes of which we can RDFS-infer the subject is a member
     * todo: This will loop is there is a class subclass loop (Sublass loops are
     * not illegal)
     * @param {RDFlibNamedNode} subject - The thing whose classes are to be found
     * @returns a hash table where key is NT of type and value is statement why we think so.
     * Does NOT return terms, returns URI strings.
     * We use NT representations in this version because they handle blank nodes.
     */
  }, {
    key: "findTypesNT",
    value: function findTypesNT(subject) {
      var domain;
      var range;
      var rdftype;
      var ref;
      var ref1;
      var ref2;
      var ref3;
      var st3;
      var types;
      rdftype = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
      types = [];
      ref = this.statementsMatching(subject, void 0, void 0);
      for (var i = 0, len = ref.length; i < len; i++) {
        st3 = ref[i];
        if (st3.predicate.uri === rdftype) {
          types[st3.object.toNT()] = st3;
        } else {
          ref1 = this.each(st3.predicate, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#domain"));
          for (var l = 0, len1 = ref1.length; l < len1; l++) {
            range = ref1[l];
            types[range.toNT()] = st3;
          }
        }
      }
      ref2 = this.statementsMatching(void 0, void 0, subject);
      for (var m = 0, len2 = ref2.length; m < len2; m++) {
        st3 = ref2[m];
        ref3 = this.each(st3.predicate, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#range"));
        for (var _q3 = 0, len3 = ref3.length; _q3 < len3; _q3++) {
          domain = ref3[_q3];
          types[domain.toNT()] = st3;
        }
      }
      return this.transitiveClosure(types, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), false);
    }
    /**
     * Get all the Classes of which we can RDFS-infer the subject is a member
     * todo: This will loop is there is a class subclass loop (Sublass loops are
     * not illegal)
     * Returns a hash table where key is NT of type and value is statement why we
     * think so.
     * Does NOT return terms, returns URI strings.
     * We use NT representations in this version because they handle blank nodes.
     * @param subject - A subject node
     */
  }, {
    key: "findTypeURIs",
    value: function findTypeURIs(subject) {
      return this.NTtoURI(this.findTypesNT(subject));
    }
    /** Trace statements which connect directly, or through bnodes
     *
     * @param subject - The node to start looking for statments
     * @param doc - The document to be searched, or null to search all documents
     * @returns an array of statements, duplicate statements are suppresssed.
     */
  }, {
    key: "connectedStatements",
    value: function connectedStatements(subject, doc, excludePredicateURIs) {
      excludePredicateURIs = excludePredicateURIs || [];
      var todo = [subject];
      var done = {};
      var doneArcs = {};
      var result = [];
      var self2 = this;
      var follow = function follow2(x) {
        var queue = function queue2(x2) {
          if (x2.termType === "BlankNode" && !done[x2.value]) {
            done[x2.value] = true;
            todo.push(x2);
          }
        };
        var sts = self2.statementsMatching(null, null, x, doc).concat(self2.statementsMatching(x, null, null, doc));
        sts = sts.filter(function(st3) {
          if (excludePredicateURIs[st3.predicate.value]) return false;
          var hash = st3.toNT();
          if (doneArcs[hash]) return false;
          doneArcs[hash] = true;
          return true;
        });
        sts.forEach(function(st3) {
          queue(st3.subject);
          queue(st3.object);
        });
        result = result.concat(sts);
      };
      while (todo.length) {
        follow(todo.shift());
      }
      return result;
    }
    /**
     * Creates a new empty formula
     *
     * @param _features - Not applicable, but necessary for typing to pass
     */
  }, {
    key: "formula",
    value: function formula2(_features) {
      return new Formula2();
    }
    /**
     * Transforms an NTriples string format into a Node.
     * The blank node bit should not be used on program-external values; designed
     * for internal work such as storing a blank node id in an HTML attribute.
     * This will only parse the strings generated by the various toNT() methods.
     */
  }, {
    key: "fromNT",
    value: function fromNT(str) {
      var dt, k, lang;
      switch (str[0]) {
        case "<":
          return this.sym(str.slice(1, -1));
        case '"':
          lang = void 0;
          dt = void 0;
          k = str.lastIndexOf('"');
          if (k < str.length - 1) {
            if (str[k + 1] === "@") {
              lang = str.slice(k + 2);
            } else if (str.slice(k + 1, k + 3) === "^^") {
              dt = this.fromNT(str.slice(k + 3));
            } else {
              throw new Error("Can't convert string from NT: " + str);
            }
          }
          str = str.slice(1, k);
          str = str.replace(/\\"/g, '"');
          str = str.replace(/\\n/g, "\n");
          str = str.replace(/\\\\/g, "\\");
          return this.rdfFactory.literal(str, lang || dt);
        case "_":
          return this.rdfFactory.blankNode(str.slice(2));
        case "?":
          return new Variable(str.slice(1));
      }
      throw new Error("Can't convert from NT: " + str);
    }
    /** Returns true if this formula holds the specified statement(s) */
  }, {
    key: "holds",
    value: function holds(s, p, o, g) {
      var i;
      if (arguments.length === 1) {
        if (!s) {
          return true;
        }
        if (s instanceof Array) {
          for (i = 0; i < s.length; i++) {
            if (!this.holds(s[i])) {
              return false;
            }
          }
          return true;
        } else if (isStatement(s)) {
          return this.holds(s.subject, s.predicate, s.object, s.graph);
        } else if (s.statements) {
          return this.holds(s.statements);
        }
      }
      var st3 = this.anyStatementMatching(s, p, o, g);
      return st3 != null;
    }
    /**
     * Returns true if this formula holds the specified {statement}
     */
  }, {
    key: "holdsStatement",
    value: function holdsStatement(statement) {
      return this.holds(statement.subject, statement.predicate, statement.object, statement.graph);
    }
    /**
     * Used by the n3parser to generate list elements
     * @param values - The values of the collection
     * @param context - The store
     * @return {BlankNode|Collection} - The term for the statement
     */
  }, {
    key: "list",
    value: function list(values, context) {
      if (context.rdfFactory.supports["COLLECTIONS"]) {
        var collection2 = context.rdfFactory.collection();
        values.forEach(function(val) {
          collection2.append(val);
        });
        return collection2;
      } else {
        var node = context.rdfFactory.blankNode();
        var statements = arrayToStatements(context.rdfFactory, node, values);
        context.addAll(statements);
        return node;
      }
    }
    /**
     * Transform a collection of NTriple URIs into their URI strings
     * @param t - Some iterable collection of NTriple URI strings
     * @return A collection of the URIs as strings
     * todo: explain why it is important to go through NT
     */
  }, {
    key: "NTtoURI",
    value: function NTtoURI(t) {
      var k, v;
      var uris = {};
      for (k in t) {
        if (!t.hasOwnProperty(k)) continue;
        v = t[k];
        if (k[0] === "<") {
          uris[k.slice(1, -1)] = v;
        }
      }
      return uris;
    }
    /**
     * Serializes this formula
     * @param base - The base string
     * @param contentType - The content type of the syntax to use
     * @param provenance - The provenance URI
     * @param options  - options to pass to the serializer, as defined in serialize method
     */
  }, {
    key: "serialize",
    value: function serialize2(base, contentType, provenance, options) {
      return serialize(provenance, this, base, contentType, void 0, options);
    }
    /**
     * Creates a new formula with the substituting bindings applied
     * @param bindings - The bindings to substitute
     */
  }, {
    key: "substitute",
    value: function substitute(bindings) {
      var statementsCopy = this.statements.map(function(ea) {
        return ea.substitute(bindings);
      });
      var y = new Formula2();
      y.addAll(statementsCopy);
      return y;
    }
  }, {
    key: "sym",
    value: function sym(uri, name) {
      if (name) {
        throw new Error("This feature (kb.sym with 2 args) is removed. Do not assume prefix mappings.");
      }
      return this.rdfFactory.namedNode(uri);
    }
    /**
     * Gets the node matching the specified pattern. Throws when no match could be made.
     * @param s - The subject
     * @param p - The predicate
     * @param o - The object
     * @param g - The graph that contains the statement
     */
  }, {
    key: "the",
    value: function the(s, p, o, g) {
      var x = this.any(s, p, o, g);
      if (x == null) {
        log_default.error("No value found for the() {" + s + " " + p + " " + o + "}.");
      }
      return x;
    }
    /**
     * RDFS Inference
     * These are hand-written implementations of a backward-chaining reasoner
     * over the RDFS axioms.
     * @param seeds - A hash of NTs of classes to start with
     * @param predicate - The property to trace though
     * @param inverse - Trace inverse direction
     */
  }, {
    key: "transitiveClosure",
    value: function transitiveClosure(seeds, predicate, inverse) {
      var elt, i, len, s, sups, t;
      var agenda = {};
      Object.assign(agenda, seeds);
      var done = {};
      while (true) {
        t = function() {
          for (var p in agenda) {
            if (!agenda.hasOwnProperty(p)) continue;
            return p;
          }
        }();
        if (t == null) {
          return done;
        }
        sups = inverse ? this.each(void 0, predicate, this.fromNT(t)) : this.each(this.fromNT(t), predicate);
        for (i = 0, len = sups.length; i < len; i++) {
          elt = sups[i];
          s = elt.toNT();
          if (s in done) {
            continue;
          }
          if (s in agenda) {
            continue;
          }
          agenda[s] = agenda[t];
        }
        done[t] = agenda[t];
        delete agenda[t];
      }
    }
    /**
     * Finds the types in the list which have no *stored* supertypes
     * We exclude the universal class, owl:Things and rdf:Resource, as it is
     * information-free.
     * @param types - The types
     */
  }, {
    key: "topTypeURIs",
    value: function topTypeURIs(types) {
      var i;
      var j;
      var k;
      var len;
      var n;
      var ref;
      var tops;
      var v;
      tops = [];
      for (k in types) {
        if (!types.hasOwnProperty(k)) continue;
        v = types[k];
        n = 0;
        ref = this.each(this.rdfFactory.namedNode(k), this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"));
        for (i = 0, len = ref.length; i < len; i++) {
          j = ref[i];
          if (j.uri !== "http://www.w3.org/2000/01/rdf-schema#Resource") {
            n++;
            break;
          }
        }
        if (!n) {
          tops[k] = v;
        }
      }
      if (tops["http://www.w3.org/2000/01/rdf-schema#Resource"]) {
        delete tops["http://www.w3.org/2000/01/rdf-schema#Resource"];
      }
      if (tops["http://www.w3.org/2002/07/owl#Thing"]) {
        delete tops["http://www.w3.org/2002/07/owl#Thing"];
      }
      return tops;
    }
    /**
     * Serializes this formula to a string
     */
  }, {
    key: "toString",
    value: function toString() {
      return "{" + this.statements.join("\n") + "}";
    }
    /**
     * Gets a new variable
     * @param name - The variable's name
     */
  }, {
    key: "variable",
    value: function variable4(name) {
      return new Variable(name);
    }
    /**
     * Gets the number of statements in this formula that matches the specified pattern
     * @param s - The subject
     * @param p - The predicate
     * @param o - The object
     * @param g - The graph that contains the statement
     */
  }, {
    key: "whether",
    value: function whether(s, p, o, g) {
      return this.statementsMatching(s, p, o, g, false).length;
    }
  }]);
}(Node2);

// ../node_modules/rdflib/esm/node.js
Node2.fromValue = fromValue;
var node_default = Node2;
var ns = {
  xsd: Namespace("http://www.w3.org/2001/XMLSchema#")
};
Node2.toJS = function(term2) {
  if (isCollection(term2)) {
    return term2.elements.map(Node2.toJS);
  }
  if (!isLiteral(term2)) return term2;
  if (term2.datatype.equals(ns.xsd("boolean"))) {
    return term2.value === "1" || term2.value === "true";
  }
  if (term2.datatype.equals(ns.xsd("dateTime")) || term2.datatype.equals(ns.xsd("date"))) {
    return new Date(term2.value);
  }
  if (term2.datatype.equals(ns.xsd("integer")) || term2.datatype.equals(ns.xsd("float")) || term2.datatype.equals(ns.xsd("decimal"))) {
    return Number(term2.value);
  }
  return term2.value;
};

// ../node_modules/rdflib/esm/query.js
var Query = /* @__PURE__ */ _createClass(function Query2(name, id3) {
  _classCallCheck(this, Query2);
  this.pat = new IndexedFormula();
  this.vars = [];
  this.name = name;
  this.id = id3;
});
function indexedFormulaQuery(myQuery, callback, fetcher3, onDone) {
  function bindingDebug(b) {
    var str = "";
    var v;
    for (v in b) {
      if (b.hasOwnProperty(v)) {
        str += "    " + v + " -> " + b[v];
      }
    }
    return str;
  }
  function bindingsDebug(nbs) {
    var str = "Bindings: ";
    var i;
    var n = nbs.length;
    for (i = 0; i < n; i++) {
      str += bindingDebug(nbs[i][0]) + ";\n	";
    }
    return str;
  }
  function unifyTerm(self2, other, bindings, formula2) {
    var actual = bindings[self2];
    if (actual === void 0) {
      if (self2.isVar) {
        var b = [];
        b[self2] = other;
        return [[b, null]];
      }
      actual = self2;
    }
    if (!actual.complexType) {
      if (formula2.redirections[actual]) {
        actual = formula2.redirections[actual];
      }
      if (formula2.redirections[other]) {
        other = formula2.redirections[other];
      }
      if (actual.equals(other) || actual.uri && actual.uri === defaultGraphURI) {
        return [[[], null]];
      }
      return [];
    }
    if (self2 instanceof Array) {
      if (!(other instanceof Array)) {
        return [];
      }
      return unifyContents(self2, other, bindings);
    }
    throw new Error("query.js: oops - code not written yet");
  }
  function unifyContents(self2, other, bindings, formula2) {
    var nbs2;
    if (self2.length !== other.length) {
      return [];
    }
    if (!self2.length) {
      return [[[], null]];
    }
    var nbs = unifyTerm(self2[0], other[0], bindings, formula2);
    if (nbs.length === 0) {
      return nbs;
    }
    var res = [];
    var i;
    var n = nbs.length;
    var nb;
    var j;
    var m;
    var v;
    var nb2;
    var bindings2;
    for (i = 0; i < n; i++) {
      nb = nbs[i][0];
      bindings2 = [];
      for (v in nb) {
        if (nb.hasOwnProperty(v)) {
          bindings2[v] = nb[v];
        }
      }
      for (v in bindings) {
        if (bindings.hasOwnProperty(v)) {
          bindings2[v] = bindings[v];
        }
      }
      nbs2 = unifyContents(self2.slice(1), other.slice(1), bindings2, formula2);
      m = nbs2.length;
      for (j = 0; j < m; j++) {
        nb2 = nbs2[j][0];
        for (v in nb) {
          if (nb.hasOwnProperty(v)) {
            nb2[v] = nb[v];
          }
        }
        res.push([nb2, null]);
      }
    }
    return res;
  }
  function bind(x, binding) {
    var y = binding[x];
    if (y === void 0) {
      return x;
    }
    return y;
  }
  function union(a, b) {
    var c = {};
    var x;
    for (x in a) {
      if (a.hasOwnProperty(x)) {
        c[x] = a[x];
      }
    }
    for (x in b) {
      if (b.hasOwnProperty(x)) {
        c[x] = b[x];
      }
    }
    return c;
  }
  function OptionalBranchJunction(originalCallback, trunkBindings) {
    this.trunkBindings = trunkBindings;
    this.originalCallback = originalCallback;
    this.branches = [];
    return this;
  }
  OptionalBranchJunction.prototype.checkAllDone = function() {
    var i;
    for (i = 0; i < this.branches.length; i++) {
      if (!this.branches[i].done) {
        return;
      }
    }
    log_default.debug("OPTIONAL BIDNINGS ALL DONE:");
    this.doCallBacks(this.branches.length - 1, this.trunkBindings);
  };
  OptionalBranchJunction.prototype.doCallBacks = function(b, bindings) {
    var j;
    if (b < 0) {
      return this.originalCallback(bindings);
    }
    for (j = 0; j < this.branches[b].results.length; j++) {
      this.doCallBacks(b - 1, union(bindings, this.branches[b].results[j]));
    }
  };
  function MandatoryBranch(callback2, onDone2) {
    this.count = 0;
    this.success = false;
    this.done = false;
    this.callback = callback2;
    this.onDone = onDone2;
    return this;
  }
  MandatoryBranch.prototype.reportMatch = function(bindings) {
    this.callback(bindings);
    this.success = true;
  };
  MandatoryBranch.prototype.reportDone = function() {
    this.done = true;
    log_default.info("Mandatory query branch finished.***");
    if (this.onDone !== void 0) {
      this.onDone();
    }
  };
  var OptionalBranch = function OptionalBranch2(junction) {
    this.count = 0;
    this.done = false;
    this.results = [];
    this.junction = junction;
    junction.branches.push(this);
    return this;
  };
  OptionalBranch.prototype.reportMatch = function(bindings) {
    this.results.push(bindings);
  };
  OptionalBranch.prototype.reportDone = function() {
    log_default.debug("Optional branch finished - results.length = " + this.results.length);
    if (this.results.length === 0) {
      this.results.push({});
      log_default.debug("Optional branch FAILED - that's OK.");
    }
    this.done = true;
    this.junction.checkAllDone();
  };
  function prepare(f2, item, bindings) {
    var terms, termIndex, i, ind;
    item.nvars = 0;
    item.index = null;
    terms = [item.subject, item.predicate, item.object, item.why];
    ind = [f2.subjectIndex, f2.predicateIndex, f2.objectIndex, f2.whyIndex];
    for (i = 0; i < 4; i++) {
      var t = terms[i];
      if (t.uri && t.uri === defaultGraphURI) {
      } else if (t.isVar && !(bindings[t] !== void 0)) {
        item.nvars++;
      } else {
        t = bind(terms[i], bindings);
        if (f2.redirections[f2.id(t)]) {
          t = f2.redirections[f2.id(t)];
        }
        termIndex = ind[i][f2.id(t)];
        if (!termIndex) {
          item.index = [];
          return false;
        }
        if (item.index === null || item.index.length > termIndex.length) {
          item.index = termIndex;
        }
      }
    }
    if (item.index === null) {
      item.index = f2.statements;
    }
    return true;
  }
  function easiestQuery(self2, other) {
    if (self2.nvars !== other.nvars) {
      return self2.nvars - other.nvars;
    }
    return self2.index.length - other.index.length;
  }
  var matchIndex = 0;
  var match = function match3(f2, g, bindingsSoFar, level, fetcher4, localCallback, branch) {
    log_default.debug("Match begins, Branch count now: " + branch.count + " for " + branch.pattern_debug);
    var pattern = g.statements;
    if (pattern.length === 0) {
      log_default.debug("FOUND MATCH WITH BINDINGS:" + bindingDebug(bindingsSoFar));
      if (g.optional.length === 0) {
        branch.reportMatch(bindingsSoFar);
      } else {
        log_default.debug("OPTIONAL: " + g.optional);
        var junction = new OptionalBranchJunction(callback, bindingsSoFar);
        var br = [];
        var b;
        for (b = 0; b < g.optional.length; b++) {
          br[b] = new OptionalBranch(junction);
          br[b].pattern_debug = g.optional[b];
        }
        for (b = 0; b < g.optional.length; b++) {
          br[b].count = br[b].count + 1;
          match3(f2, g.optional[b], bindingsSoFar, "", fetcher4, callback, br[b]);
        }
      }
      branch.count--;
      log_default.debug("Match ends -- success , Branch count now: " + branch.count + " for " + branch.pattern_debug);
      return;
    }
    var item;
    var i;
    var n = pattern.length;
    if (fetcher4) {
      var id3 = "match" + matchIndex++;
      var fetchResource = function fetchResource2(requestedTerm, id4) {
        var docuri = requestedTerm.uri.split("#")[0];
        fetcher4.nowOrWhenFetched(docuri, void 0, function(ok, body, xhr) {
          if (!ok) {
            console.log("Error following link to <" + requestedTerm.uri + "> in query: " + body);
          }
          match3(
            f2,
            g,
            bindingsSoFar,
            level,
            fetcher4,
            // match not match2 to look up any others necessary.
            localCallback,
            branch
          );
        });
      };
      for (i = 0; i < n; i++) {
        item = pattern[i];
        if (bindingsSoFar[item.subject] !== void 0 && bindingsSoFar[item.subject].uri && fetcher4 && fetcher4.getState(docpart(bindingsSoFar[item.subject].uri)) === "unrequested") {
          fetchResource(bindingsSoFar[item.subject], id3);
          return;
        }
        if (bindingsSoFar[item.object] !== void 0 && bindingsSoFar[item.object].uri && fetcher4 && fetcher4.getState(docpart(bindingsSoFar[item.object].uri)) === "unrequested") {
          fetchResource(bindingsSoFar[item.object], id3);
          return;
        }
      }
    }
    match2(f2, g, bindingsSoFar, level, fetcher4, localCallback, branch);
  };
  var constraintsSatisfied = function constraintsSatisfied2(bindings, constraints) {
    var res = true;
    var x;
    var test;
    for (x in bindings) {
      if (bindings.hasOwnProperty(x)) {
        if (constraints[x]) {
          test = constraints[x].test;
          if (test && !test(bindings[x])) {
            res = false;
          }
        }
      }
    }
    return res;
  };
  var match2 = function match22(f2, g, bindingsSoFar, level, fetcher4, callback2, branch) {
    var pattern = g.statements;
    var n = pattern.length;
    var i;
    var k;
    var nk;
    var v;
    var bindings2;
    var newBindings1;
    var item;
    for (i = 0; i < n; i++) {
      item = pattern[i];
      prepare(f2, item, bindingsSoFar);
    }
    pattern.sort(easiestQuery);
    item = pattern[0];
    var rest = f2.formula();
    rest.optional = g.optional;
    rest.constraints = g.constraints;
    rest.statements = pattern.slice(1);
    log_default.debug(level + "match2 searching " + item.index.length + " for " + item + "; bindings so far=" + bindingDebug(bindingsSoFar));
    var c;
    var nc = item.index.length;
    var nbs1;
    var st3;
    var onward = 0;
    for (c = 0; c < nc; c++) {
      st3 = item.index[c];
      nbs1 = unifyContents([item.subject, item.predicate, item.object, item.why], [st3.subject, st3.predicate, st3.object, st3.why], bindingsSoFar, f2);
      log_default.info(level + " From first: " + nbs1.length + ": " + bindingsDebug(nbs1));
      nk = nbs1.length;
      for (k = 0; k < nk; k++) {
        bindings2 = [];
        newBindings1 = nbs1[k][0];
        if (!constraintsSatisfied(newBindings1, g.constraints)) {
          log_default.debug("Branch count CS: " + branch.count);
        } else {
          for (v in newBindings1) {
            if (newBindings1.hasOwnProperty(v)) {
              bindings2[v] = newBindings1[v];
            }
          }
          for (v in bindingsSoFar) {
            if (bindingsSoFar.hasOwnProperty(v)) {
              bindings2[v] = bindingsSoFar[v];
            }
          }
          branch.count++;
          onward++;
          match(f2, rest, bindings2, level + "  ", fetcher4, callback2, branch);
        }
      }
    }
    branch.count--;
    if (onward === 0) {
      log_default.debug("Match2 fails completely on " + item);
    }
    log_default.debug("Match2 ends, Branch count: " + branch.count + " for " + branch.pattern_debug);
    if (branch.count === 0) {
      log_default.debug("Branch finished.");
      branch.reportDone();
    }
  };
  var f = this;
  log_default.debug("Query on " + this.statements.length);
  var trunck = new MandatoryBranch(callback, onDone);
  trunck.count++;
  if (myQuery.sync) {
    match(f, myQuery.pat, myQuery.pat.initBindings, "", fetcher3, callback, trunck);
  } else {
    setTimeout(function() {
      match(f, myQuery.pat, myQuery.pat.initBindings, "", fetcher3, callback, trunck);
    }, 0);
  }
}

// ../node_modules/rdflib/esm/fetcher.js
var import_regenerator = __toESM(require_regenerator());

// ../node_modules/rdflib/esm/lists.js
function _createForOfIteratorHelper2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length) return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null) it.return();
    } finally {
      if (didErr) throw err;
    }
  } };
}
function _unsupportedIterableToArray2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen);
}
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var RDF = Namespace("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
function substituteInDoc(store, x, y, doc) {
  var _iterator = _createForOfIteratorHelper2(store.statementsMatching(y, null, null, doc)), _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var quad4 = _step.value;
      var newStatement = new Statement(x, quad4.predicate, quad4.object, doc);
      store.remove(quad4);
      store.add(newStatement);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper2(store.statementsMatching(null, y, null, doc)), _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
      var _quad = _step2.value;
      store.remove(_quad);
      store.add(new Statement(_quad.subject, x, _quad.object, doc));
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var _iterator3 = _createForOfIteratorHelper2(store.statementsMatching(null, null, y, doc)), _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
      var _quad2 = _step3.value;
      store.remove(_quad2);
      store.add(new Statement(_quad2.subject, _quad2.predicate, x, doc));
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}
function substituteNillsInDoc(store, doc) {
  var x = RDF("nil");
  var _iterator4 = _createForOfIteratorHelper2(store.statementsMatching(x, null, null, doc)), _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
      var quad4 = _step4.value;
      store.remove(quad4);
      var y = new Collection();
      store.add(new Statement(y, quad4.predicate, quad4.object, doc));
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  var _iterator5 = _createForOfIteratorHelper2(store.statementsMatching(null, null, x, doc)), _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done; ) {
      var _quad3 = _step5.value;
      if (!_quad3.predicate.sameTerm(RDF("rest"))) {
        store.remove(_quad3);
        var _y = new Collection();
        store.add(new Statement(_quad3.subject, _quad3.predicate, _y, doc));
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
}
function convertFirstRestNil(store, doc) {
  function preceding(ele, listSoFar, trash) {
    var rests = store.statementsMatching(ele, RDF("rest"), null, doc);
    if (rests.length !== 1) throw new Error("Bad list structure: no rest at ".concat(ele));
    var firsts = store.statementsMatching(ele, RDF("first"), null, doc);
    if (firsts.length !== 1) throw new Error("Bad list structure: rest but ".concat(firsts.length, " firsts at ").concat(ele));
    var value = firsts[0].object;
    var total = [value].concat(listSoFar);
    var totalTrash = trash.concat(rests).concat(firsts);
    var pres = store.statementsMatching(null, RDF("rest"), ele, doc);
    if (pres.length === 0) {
      var newList = new Collection(total);
      store.remove(totalTrash);
      substituteInDoc(store, newList, ele, doc);
      return;
    }
    if (pres.length !== 1) throw new Error("Bad list structure: ".concat(pres.length, " pres at ").concat(ele));
    var pre = pres[0].subject;
    if (pre.termType !== "BlankNode") throw new Error("Bad list element node ".concat(pre, " type: ").concat(pre.termType, " "));
    preceding(pre, total, totalTrash);
    return;
  }
  substituteNillsInDoc(store, doc);
  var tails = store.statementsMatching(null, RDF("rest"), RDF("nil"), doc);
  tails.forEach(function(tail) {
    if (tail.subject.termType !== "BlankNode") throw new Error("Bad list element node ".concat(tail.subject, " type: ").concat(tail.subject.termType, " "));
    preceding(tail.subject, [], []);
  });
}

// ../node_modules/rdflib/esm/n3parser.js
function hexify2(str) {
  return encodeURI(str);
}
var Utf8 = {
  // public method for url encoding
  encode: function encode(string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode(c >> 6 | 192);
        utftext += String.fromCharCode(c & 63 | 128);
      } else {
        utftext += String.fromCharCode(c >> 12 | 224);
        utftext += String.fromCharCode(c >> 6 & 63 | 128);
        utftext += String.fromCharCode(c & 63 | 128);
      }
    }
    return utftext;
  },
  // public method for url decoding
  decode: function decode(utftext) {
    var string = "";
    var i = 0;
    while (i < utftext.length) {
      var c = utftext.charCodeAt(i);
      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        string += String.fromCharCode((c & 31) << 6 | utftext.charCodeAt(i + 1) & 63);
        i += 2;
      } else {
        string += String.fromCharCode((c & 15) << 12 | (utftext.charCodeAt(i + 1) & 63) << 6 | utftext.charCodeAt(i + 2) & 63);
        i += 3;
      }
    }
    return string;
  }
};
var Logic_NS = "http://www.w3.org/2000/10/swap/log#";
var pyjslib_Tuple = function pyjslib_Tuple2(theList) {
  return theList;
};
var pyjslib_List = function pyjslib_List2(theList) {
  return theList;
};
var pyjslib_Dict = function pyjslib_Dict2(listOfPairs) {
  if (listOfPairs.length > 0) throw "missing.js: oops nnonempty dict not imp";
  return [];
};
var pyjslib_len = function pyjslib_len2(s) {
  return s.length;
};
var pyjslib_slice = function pyjslib_slice2(str, i, j) {
  if (typeof str.slice == "undefined") throw "@@ mising.js: No .slice function for " + str + " of type " + _typeof(str);
  if (typeof j == "undefined" || j == null) return str.slice(i);
  return str.slice(i, j);
};
var StopIteration = Error("dummy error stop iteration");
var pyjslib_Iterator = function pyjslib_Iterator2(theList) {
  this.last = 0;
  this.li = theList;
  this.next = function() {
    if (this.last == this.li.length) throw StopIteration;
    return this.li[this.last++];
  };
  return this;
};
var string_find = function string_find2(str, s) {
  return str.indexOf(s);
};
var assertFudge = function assertFudge2(condition, desc) {
  if (condition) return;
  if (desc) throw "python Assertion failed: " + desc;
  throw "(python) Assertion failed.";
};
var stringFromCharCode = function stringFromCharCode2(uesc) {
  return String.fromCharCode(uesc);
};
String.prototype.encode = function(encoding) {
  if (encoding != "utf-8") throw "UTF8_converter: can only do utf-8";
  return Utf8.encode(this);
};
String.prototype.decode = function(encoding) {
  if (encoding != "utf-8") throw "UTF8_converter: can only do utf-8";
  return this;
};
var uripath_join = function uripath_join2(base, given) {
  return join(given, base);
};
var becauseSubexpression = null;
var diag_tracking = 0;
var diag_chatty_flag = 0;
var diag_progress = function diag_progress2(str) {
};
var RDF_type_URI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
var RDF_nil_URI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil";
var DAML_sameAs_URI = "http://www.w3.org/2002/07/owl#sameAs";
var ADDED_HASH = "#";
var INTEGER_DATATYPE = "http://www.w3.org/2001/XMLSchema#integer";
var FLOAT_DATATYPE = "http://www.w3.org/2001/XMLSchema#double";
var DECIMAL_DATATYPE = "http://www.w3.org/2001/XMLSchema#decimal";
var DATE_DATATYPE = "http://www.w3.org/2001/XMLSchema#date";
var DATETIME_DATATYPE = "http://www.w3.org/2001/XMLSchema#dateTime";
var _notQNameChars = "	\r\n !\"#$%&'()*.,+/;<=>?@[\\]^`{|}~";
var _notNameChars = _notQNameChars + ":";
var eol = new RegExp("^[ \\t]*(#[^\\n]*)?\\r?\\n", "g");
var eof = new RegExp("^[ \\t]*(#[^\\n]*)?$", "g");
var ws = new RegExp("^[ \\t]*", "g");
var signed_integer = new RegExp("^[-+]?[0-9]+", "g");
var number_syntax = new RegExp("^([-+]?[0-9]+)(\\.[0-9]+)?(e[-+]?[0-9]+)?", "g");
var datetime_syntax = new RegExp("^[0-9][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9](T[0-9][0-9]:[0-9][0-9](:[0-9][0-9](\\.[0-9]*)?)?)?Z?");
var digitstring = new RegExp("^[0-9]+", "g");
var interesting = new RegExp('[\\\\\\r\\n\\"]', "g");
var langcode = new RegExp("^[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*", "g");
function createSinkParser(store, openFormula, thisDoc, baseURI, genPrefix, metaURI, flags, why) {
  return new SinkParser(store, openFormula, thisDoc, baseURI, genPrefix, metaURI, flags, why);
}
var n3parser_default = createSinkParser;
var SinkParser = /* @__PURE__ */ function() {
  function SinkParser2(store, openFormula, thisDoc, baseURI, genPrefix, metaURI, flags, why) {
    _classCallCheck(this, SinkParser2);
    if (typeof openFormula == "undefined") openFormula = null;
    if (typeof thisDoc == "undefined") thisDoc = "";
    if (typeof baseURI == "undefined") baseURI = null;
    if (typeof genPrefix == "undefined") genPrefix = "";
    if (typeof metaURI == "undefined") metaURI = null;
    if (typeof flags == "undefined") flags = "";
    if (typeof why == "undefined") why = null;
    this._bindings = new pyjslib_Dict([]);
    this._flags = flags;
    if (thisDoc != "") {
      assertFudge(thisDoc.indexOf(":") >= 0, "Document URI not absolute: " + thisDoc);
      this._bindings[""] = thisDoc + "#";
    }
    this._store = store;
    if (genPrefix) {
      store.setGenPrefix(genPrefix);
    }
    this._thisDoc = thisDoc;
    this.source = store.sym(thisDoc);
    this.lines = 0;
    this.statementCount = 0;
    this.hasNil = false;
    this.startOfLine = 0;
    this.previousLine = 0;
    this._genPrefix = genPrefix;
    this.keywords = new pyjslib_List(["a", "this", "bind", "has", "is", "of", "true", "false"]);
    this.keywordsSet = 0;
    this._anonymousNodes = new pyjslib_Dict([]);
    this._variables = new pyjslib_Dict([]);
    this._parentVariables = new pyjslib_Dict([]);
    this._reason = why;
    this._reason2 = null;
    if (diag_tracking) {
      this._reason2 = why_BecauseOfData(store.sym(thisDoc), this._reason);
    }
    if (baseURI) {
      this._baseURI = baseURI;
    } else {
      if (thisDoc) {
        this._baseURI = thisDoc;
      } else {
        this._baseURI = null;
      }
    }
    assertFudge(!this._baseURI || this._baseURI.indexOf(":") >= 0);
    if (!this._genPrefix) {
      if (this._thisDoc) {
        this._genPrefix = this._thisDoc + "#_g";
      } else {
        this._genPrefix = RDFSink_uniqueURI();
      }
    }
    if (openFormula == null) {
      if (this._thisDoc) {
        this._formula = store.formula(thisDoc + "#_formula");
      } else {
        this._formula = store.formula();
      }
    } else {
      this._formula = openFormula;
    }
    this._context = this._formula;
    this._parentContext = null;
  }
  return _createClass(SinkParser2, [{
    key: "here",
    value: function here(i) {
      return this._genPrefix + "_L" + this.lines + "C" + (i - this.startOfLine + 1);
    }
  }, {
    key: "formula",
    value: function formula2() {
      return this._formula;
    }
  }, {
    key: "loadStream",
    value: function loadStream(stream) {
      return this.loadBuf(stream.read());
    }
  }, {
    key: "loadBuf",
    value: function loadBuf(buf) {
      this.startDoc();
      this.feed(buf);
      return this.endDoc();
    }
  }, {
    key: "feed",
    value: function feed(octets) {
      var str = octets.decode("utf-8");
      var i = 0;
      while (i >= 0) {
        var j = this.skipSpace(str, i);
        if (j < 0) {
          return;
        }
        var i = this.directiveOrStatement(str, j);
        if (i < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, j, "expected directive or statement");
        }
      }
    }
  }, {
    key: "directiveOrStatement",
    value: function directiveOrStatement(str, h) {
      var i = this.skipSpace(str, h);
      if (i < 0) {
        return i;
      }
      var j = this.directive(str, i);
      if (j >= 0) {
        return this.checkDot(str, j);
      }
      var j = this.statement(str, i);
      if (j >= 0) {
        return this.checkDot(str, j);
      }
      return j;
    }
  }, {
    key: "tok",
    value: function tok(_tok, str, i) {
      var whitespace = "	\n\v\f\r ";
      if (str.slice(i, i + 1) == "@") {
        var i = i + 1;
      } else {
        if (ArrayIndexOf(this.keywords, _tok) < 0) {
          return -1;
        }
      }
      var k = i + pyjslib_len(_tok);
      if (str.slice(i, k) == _tok && _notQNameChars.indexOf(str.charAt(k)) >= 0) {
        return k;
      } else {
        return -1;
      }
    }
  }, {
    key: "directive",
    value: function directive(str, i) {
      var j = this.skipSpace(str, i);
      if (j < 0) {
        return j;
      }
      var res = new pyjslib_List([]);
      var j = this.tok("bind", str, i);
      if (j > 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "keyword bind is obsolete: use @prefix");
      }
      var j = this.tok("keywords", str, i);
      if (j > 0) {
        var i = this.commaSeparatedList(str, j, res, false);
        if (i < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "'@keywords' needs comma separated list of words");
        }
        this.setKeywords(pyjslib_slice(res, null, null));
        if (diag_chatty_flag > 80) {
          diag_progress("Keywords ", this.keywords);
        }
        return i;
      }
      var j = this.tok("forAll", str, i);
      if (j > 0) {
        var i = this.commaSeparatedList(str, j, res, true);
        if (i < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "Bad variable list after @forAll");
        }
        var __x = new pyjslib_Iterator(res);
        try {
          while (true) {
            var x = __x.next();
            if (ArrayIndexOf(this._variables, x) < 0 || ArrayIndexOf(this._parentVariables, x) >= 0) {
              this._variables[x] = this._context.newUniversal(x);
            }
          }
        } catch (e) {
          if (e != StopIteration) {
            throw e;
          }
        }
        return i;
      }
      var j = this.tok("forSome", str, i);
      if (j > 0) {
        var i = this.commaSeparatedList(str, j, res, this.uri_ref2);
        if (i < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "Bad variable list after @forSome");
        }
        var __x = new pyjslib_Iterator(res);
        try {
          while (true) {
            var x = __x.next();
            this._context.declareExistential(x);
          }
        } catch (e) {
          if (e != StopIteration) {
            throw e;
          }
        }
        return i;
      }
      var j = this.tok("prefix", str, i);
      if (j >= 0) {
        var t = new pyjslib_List([]);
        var i = this.qname(str, j, t);
        if (i < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, j, "expected qname after @prefix");
        }
        var j = this.uri_ref2(str, i, t);
        if (j < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "expected <uriref> after @prefix _qname_");
        }
        var ns3 = t[1].uri;
        if (this._baseURI) {
          var ns3 = uripath_join(this._baseURI, ns3);
        } else {
          assertFudge(ns3.indexOf(":") >= 0, "With no base URI, cannot handle relative URI for NS");
        }
        assertFudge(ns3.indexOf(":") >= 0);
        this._bindings[t[0][0]] = ns3;
        this.bind(t[0][0], hexify2(ns3));
        return j;
      }
      var j = this.tok("base", str, i);
      if (j >= 0) {
        var t = new pyjslib_List([]);
        var i = this.uri_ref2(str, j, t);
        if (i < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, j, "expected <uri> after @base ");
        }
        var ns3 = t[0].uri;
        if (this._baseURI) {
          var ns3 = uripath_join(this._baseURI, ns3);
        } else {
          throw BadSyntax(this._thisDoc, this.lines, str, j, "With no previous base URI, cannot use relative URI in @base  <" + ns3 + ">");
        }
        assertFudge(ns3.indexOf(":") >= 0);
        this._baseURI = ns3;
        return i;
      }
      return -1;
    }
  }, {
    key: "bind",
    value: function bind(qn, uri) {
      if (qn == "") {
      } else {
        this._store.setPrefixForURI(qn, uri);
      }
    }
  }, {
    key: "setKeywords",
    value: function setKeywords(k) {
      if (k == null) {
        this.keywordsSet = 0;
      } else {
        this.keywords = k;
        this.keywordsSet = 1;
      }
    }
  }, {
    key: "startDoc",
    value: function startDoc() {
    }
  }, {
    key: "endDoc",
    value: (
      /* Signal end of document and stop parsing. returns formula */
      function endDoc() {
        if (this.hasNil && this._store.rdfFactory.supports["COLLECTIONS"]) {
          convertFirstRestNil(this._store, this.source);
        }
        return this._formula;
      }
    )
  }, {
    key: "makeStatement",
    value: function makeStatement(quad4) {
      quad4[0].add(quad4[2], quad4[1], quad4[3], this.source);
      if (quad4[2].uri && quad4[2].uri === RDF_nil_URI || quad4[3].uri && quad4[3].uri === RDF_nil_URI) {
        this.hasNil = true;
      }
      this.statementCount += 1;
    }
  }, {
    key: "statement",
    value: function statement(str, i) {
      var r = new pyjslib_List([]);
      var i = this.object(str, i, r);
      if (i < 0) {
        return i;
      }
      var j = this.property_list(str, i, r[0]);
      if (j < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "expected propertylist");
      }
      return j;
    }
  }, {
    key: "subject",
    value: function subject(str, i, res) {
      return this.item(str, i, res);
    }
  }, {
    key: "verb",
    value: function verb(str, i, res) {
      var j = this.skipSpace(str, i);
      if (j < 0) {
        return j;
      }
      var r = new pyjslib_List([]);
      var j = this.tok("has", str, i);
      if (j >= 0) {
        var i = this.prop(str, j, r);
        if (i < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, j, "expected property after 'has'");
        }
        res.push(new pyjslib_Tuple(["->", r[0]]));
        return i;
      }
      var j = this.tok("is", str, i);
      if (j >= 0) {
        var i = this.prop(str, j, r);
        if (i < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, j, "expected <property> after 'is'");
        }
        var j = this.skipSpace(str, i);
        if (j < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "End of file found, expected property after 'is'");
          return j;
        }
        var i = j;
        var j = this.tok("of", str, i);
        if (j < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "expected 'of' after 'is' <prop>");
        }
        res.push(new pyjslib_Tuple(["<-", r[0]]));
        return j;
      }
      var j = this.tok("a", str, i);
      if (j >= 0) {
        res.push(new pyjslib_Tuple(["->", this._store.sym(RDF_type_URI)]));
        return j;
      }
      if (str.slice(i, i + 2) == "<=") {
        res.push(new pyjslib_Tuple(["<-", this._store.sym(Logic_NS + "implies")]));
        return i + 2;
      }
      if (str.slice(i, i + 1) == "=") {
        if (str.slice(i + 1, i + 2) == ">") {
          res.push(new pyjslib_Tuple(["->", this._store.sym(Logic_NS + "implies")]));
          return i + 2;
        }
        res.push(new pyjslib_Tuple(["->", this._store.sym(DAML_sameAs_URI)]));
        return i + 1;
      }
      if (str.slice(i, i + 2) == ":=") {
        res.push(new pyjslib_Tuple(["->", Logic_NS + "becomes"]));
        return i + 2;
      }
      var j = this.prop(str, i, r);
      if (j >= 0) {
        res.push(new pyjslib_Tuple(["->", r[0]]));
        return j;
      }
      if (str.slice(i, i + 2) == ">-" || str.slice(i, i + 2) == "<-") {
        throw BadSyntax(this._thisDoc, this.lines, str, j, ">- ... -> syntax is obsolete.");
      }
      return -1;
    }
  }, {
    key: "prop",
    value: function prop(str, i, res) {
      return this.item(str, i, res);
    }
  }, {
    key: "item",
    value: function item(str, i, res) {
      return this.path(str, i, res);
    }
  }, {
    key: "blankNode",
    value: function blankNode4(uri) {
      return this._context.bnode(uri, this._reason2);
    }
  }, {
    key: "path",
    value: function path(str, i, res) {
      var j = this.nodeOrLiteral(str, i, res);
      if (j < 0) {
        return j;
      }
      while ("!^.".indexOf(str.slice(j, j + 1)) >= 0) {
        var ch = str.slice(j, j + 1);
        if (ch == ".") {
          var ahead = str.slice(j + 1, j + 2);
          if (!ahead || _notNameChars.indexOf(ahead) >= 0 && ":?<[{(".indexOf(ahead) < 0) {
            break;
          }
        }
        var subj = res.pop();
        var obj = this.blankNode(this.here(j));
        var j = this.node(str, j + 1, res);
        if (j < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, j, "EOF found in middle of path syntax");
        }
        var pred = res.pop();
        if (ch == "^") {
          this.makeStatement(new pyjslib_Tuple([this._context, pred, obj, subj]));
        } else {
          this.makeStatement(new pyjslib_Tuple([this._context, pred, subj, obj]));
        }
        res.push(obj);
      }
      return j;
    }
  }, {
    key: "anonymousNode",
    value: function anonymousNode(ln) {
      var term2 = this._anonymousNodes[ln];
      if (term2) {
        return term2;
      }
      var term2 = this._store.bnode(ln);
      this._anonymousNodes[ln] = term2;
      return term2;
    }
  }, {
    key: "node",
    value: function node(str, i, res, subjectAlready) {
      if (typeof subjectAlready == "undefined") subjectAlready = null;
      var subj = subjectAlready;
      var j = this.skipSpace(str, i);
      if (j < 0) {
        return j;
      }
      var i = j;
      var ch = str.slice(i, i + 1);
      if (ch == "[") {
        var bnodeID = this.here(i);
        var j = this.skipSpace(str, i + 1);
        if (j < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "EOF after '['");
        }
        if (str.slice(j, j + 1) == "=") {
          var i = j + 1;
          var objs = new pyjslib_List([]);
          var j = this.objectList(str, i, objs);
          if (j >= 0) {
            var subj = objs[0];
            if (pyjslib_len(objs) > 1) {
              var __obj = new pyjslib_Iterator(objs);
              try {
                while (true) {
                  var obj = __obj.next();
                  this.makeStatement(new pyjslib_Tuple([this._context, this._store.sym(DAML_sameAs_URI), subj, obj]));
                }
              } catch (e) {
                if (e != StopIteration) {
                  throw e;
                }
              }
            }
            var j = this.skipSpace(str, j);
            if (j < 0) {
              throw BadSyntax(this._thisDoc, this.lines, str, i, "EOF when objectList expected after [ = ");
            }
            if (str.slice(j, j + 1) == ";") {
              var j = j + 1;
            }
          } else {
            throw BadSyntax(this._thisDoc, this.lines, str, i, "objectList expected after [= ");
          }
        }
        if (subj == null) {
          var subj = this.blankNode(bnodeID);
        }
        var i = this.property_list(str, j, subj);
        if (i < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, j, "property_list expected");
        }
        var j = this.skipSpace(str, i);
        if (j < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "EOF when ']' expected after [ <propertyList>");
        }
        if (str.slice(j, j + 1) != "]") {
          throw BadSyntax(this._thisDoc, this.lines, str, j, "']' expected");
        }
        res.push(subj);
        return j + 1;
      }
      if (ch == "{") {
        var ch2 = str.slice(i + 1, i + 2);
        if (ch2 == "$") {
          i += 1;
          var j = i + 1;
          var mylist = new pyjslib_List([]);
          var first_run = true;
          while (1) {
            var i = this.skipSpace(str, j);
            if (i < 0) {
              throw BadSyntax(this._thisDoc, this.lines, str, i, "needed '$}', found end.");
            }
            if (str.slice(i, i + 2) == "$}") {
              var j = i + 2;
              break;
            }
            if (!first_run) {
              if (str.slice(i, i + 1) == ",") {
                i += 1;
              } else {
                throw BadSyntax(this._thisDoc, this.lines, str, i, "expected: ','");
              }
            } else {
              var first_run = false;
            }
            var item = new pyjslib_List([]);
            var j = this.item(str, i, item);
            if (j < 0) {
              throw BadSyntax(this._thisDoc, this.lines, str, i, "expected item in set or '$}'");
            }
            mylist.push(item[0]);
          }
          res.push(this._store.newSet(mylist, this._context));
          return j;
        } else {
          var j = i + 1;
          var oldParentContext = this._parentContext;
          this._parentContext = this._context;
          var parentAnonymousNodes = this._anonymousNodes;
          var grandParentVariables = this._parentVariables;
          this._parentVariables = this._variables;
          this._anonymousNodes = new pyjslib_Dict([]);
          this._variables = this._variables.slice();
          var reason2 = this._reason2;
          this._reason2 = becauseSubexpression;
          if (subj == null) {
            var subj = this._store.formula();
          }
          this._context = subj;
          while (1) {
            var i = this.skipSpace(str, j);
            if (i < 0) {
              throw BadSyntax(this._thisDoc, this.lines, str, i, "needed '}', found end.");
            }
            if (str.slice(i, i + 1) == "}") {
              var j = i + 1;
              break;
            }
            var j = this.directiveOrStatement(str, i);
            if (j < 0) {
              throw BadSyntax(this._thisDoc, this.lines, str, i, "expected statement or '}'");
            }
          }
          this._anonymousNodes = parentAnonymousNodes;
          this._variables = this._parentVariables;
          this._parentVariables = grandParentVariables;
          this._context = this._parentContext;
          this._reason2 = reason2;
          this._parentContext = oldParentContext;
          res.push(subj.close());
          return j;
        }
      }
      if (ch == "(") {
        var thing_type = this._store.list;
        var ch2 = str.slice(i + 1, i + 2);
        if (ch2 == "$") {
          var thing_type = this._store.newSet;
          i += 1;
        }
        var j = i + 1;
        var mylist = new pyjslib_List([]);
        while (1) {
          var i = this.skipSpace(str, j);
          if (i < 0) {
            throw BadSyntax(this._thisDoc, this.lines, str, i, "needed ')', found end.");
          }
          if (str.slice(i, i + 1) == ")") {
            var j = i + 1;
            break;
          }
          var item = new pyjslib_List([]);
          var j = this.item(str, i, item);
          if (j < 0) {
            throw BadSyntax(this._thisDoc, this.lines, str, i, "expected item in list or ')'");
          }
          mylist.push(item[0]);
        }
        res.push(thing_type(mylist, this._context));
        return j;
      }
      var j = this.tok("this", str, i);
      if (j >= 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "Keyword 'this' was ancient N3. Now use @forSome and @forAll keywords.");
        res.push(this._context);
        return j;
      }
      var j = this.tok("true", str, i);
      if (j >= 0) {
        res.push(true);
        return j;
      }
      var j = this.tok("false", str, i);
      if (j >= 0) {
        res.push(false);
        return j;
      }
      if (subj == null) {
        var j = this.uri_ref2(str, i, res);
        if (j >= 0) {
          return j;
        }
      }
      return -1;
    }
  }, {
    key: "property_list",
    value: function property_list(str, i, subj) {
      while (1) {
        var j = this.skipSpace(str, i);
        if (j < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "EOF found when expected verb in property list");
          return j;
        }
        if (str.slice(j, j + 2) == ":-") {
          var i = j + 2;
          var res = new pyjslib_List([]);
          var j = this.node(str, i, res, subj);
          if (j < 0) {
            throw BadSyntax(this._thisDoc, this.lines, str, i, "bad {} or () or [] node after :- ");
          }
          var i = j;
          continue;
        }
        var i = j;
        var v = new pyjslib_List([]);
        var j = this.verb(str, i, v);
        if (j <= 0) {
          return i;
        }
        var objs = new pyjslib_List([]);
        var i = this.objectList(str, j, objs);
        if (i < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, j, "objectList expected");
        }
        var __obj = new pyjslib_Iterator(objs);
        try {
          while (true) {
            var obj = __obj.next();
            var pairFudge = v[0];
            var dir = pairFudge[0];
            var sym = pairFudge[1];
            if (dir == "->") {
              this.makeStatement(new pyjslib_Tuple([this._context, sym, subj, obj]));
            } else {
              this.makeStatement(new pyjslib_Tuple([this._context, sym, obj, subj]));
            }
          }
        } catch (e) {
          if (e != StopIteration) {
            throw e;
          }
        }
        var j = this.skipSpace(str, i);
        if (j < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, j, "EOF found in list of objects");
          return j;
        }
        if (str.slice(i, i + 1) != ";") {
          return i;
        }
        var i = i + 1;
      }
    }
  }, {
    key: "commaSeparatedList",
    value: function commaSeparatedList(str, j, res, ofUris) {
      var i = this.skipSpace(str, j);
      if (i < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "EOF found expecting comma sep list");
        return i;
      }
      if (str.charAt(i) == ".") {
        return j;
      }
      if (ofUris) {
        var i = this.uri_ref2(str, i, res);
      } else {
        var i = this.bareWord(str, i, res);
      }
      if (i < 0) {
        return -1;
      }
      while (1) {
        var j = this.skipSpace(str, i);
        if (j < 0) {
          return j;
        }
        var ch = str.slice(j, j + 1);
        if (ch != ",") {
          if (ch != ".") {
            return -1;
          }
          return j;
        }
        if (ofUris) {
          var i = this.uri_ref2(str, j + 1, res);
        } else {
          var i = this.bareWord(str, j + 1, res);
        }
        if (i < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "bad list content");
          return i;
        }
      }
    }
  }, {
    key: "objectList",
    value: function objectList(str, i, res) {
      var i = this.object(str, i, res);
      if (i < 0) {
        return -1;
      }
      while (1) {
        var j = this.skipSpace(str, i);
        if (j < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, j, "EOF found after object");
          return j;
        }
        if (str.slice(j, j + 1) != ",") {
          return j;
        }
        var i = this.object(str, j + 1, res);
        if (i < 0) {
          return i;
        }
      }
    }
  }, {
    key: "checkDot",
    value: function checkDot(str, i) {
      var j = this.skipSpace(str, i);
      if (j < 0) {
        return j;
      }
      if (str.slice(j, j + 1) == ".") {
        return j + 1;
      }
      if (str.slice(j, j + 1) == "}") {
        return j;
      }
      if (str.slice(j, j + 1) == "]") {
        return j;
      }
      throw BadSyntax(this._thisDoc, this.lines, str, j, "expected '.' or '}' or ']' at end of statement");
      return i;
    }
  }, {
    key: "uri_ref2",
    value: function uri_ref2(str, i, res) {
      var qn = new pyjslib_List([]);
      var j = this.qname(str, i, qn);
      if (j >= 0) {
        var pairFudge = qn[0];
        var pfx = pairFudge[0];
        var ln = pairFudge[1];
        if (pfx == null) {
          assertFudge(0, "not used?");
          var ns3 = this._baseURI + ADDED_HASH;
        } else {
          var ns3 = this._bindings[pfx];
          if (!ns3) {
            if (pfx == "_") {
              res.push(this.anonymousNode(ln));
              return j;
            }
            throw BadSyntax(this._thisDoc, this.lines, str, i, "Prefix " + pfx + " not bound.");
          }
        }
        var symb = this._store.sym(ns3 + ln);
        if (ArrayIndexOf(this._variables, symb) >= 0) {
          res.push(this._variables[symb]);
        } else {
          res.push(symb);
        }
        return j;
      }
      var i = this.skipSpace(str, i);
      if (i < 0) {
        return -1;
      }
      if (str.charAt(i) == "?") {
        var v = new pyjslib_List([]);
        var j = this.variable(str, i, v);
        if (j > 0) {
          res.push(v[0]);
          return j;
        }
        return -1;
      } else if (str.charAt(i) == "<") {
        var i = i + 1;
        var st3 = i;
        while (i < pyjslib_len(str)) {
          if (str.charAt(i) == ">") {
            var uref = str.slice(st3, i);
            if (this._baseURI) {
              var uref = uripath_join(this._baseURI, uref);
            } else {
              assertFudge(uref.indexOf(":") >= 0, "With no base URI, cannot deal with relative URIs");
            }
            if (str.slice(i - 1, i) == "#" && !(pyjslib_slice(uref, -1, null) == "#")) {
              var uref = uref + "#";
            }
            var symb = this._store.sym(uref);
            if (ArrayIndexOf(this._variables, symb) >= 0) {
              res.push(this._variables[symb]);
            } else {
              res.push(symb);
            }
            return i + 1;
          }
          var i = i + 1;
        }
        throw BadSyntax(this._thisDoc, this.lines, str, j, "unterminated URI reference");
      } else if (this.keywordsSet) {
        var v = new pyjslib_List([]);
        var j = this.bareWord(str, i, v);
        if (j < 0) {
          return -1;
        }
        if (ArrayIndexOf(this.keywords, v[0]) >= 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, 'Keyword "' + v[0] + '" not allowed here.');
        }
        res.push(this._store.sym(this._bindings[""] + v[0]));
        return j;
      } else {
        return -1;
      }
    }
  }, {
    key: "skipSpace",
    value: function skipSpace(str, i) {
      var whitespace = " \n\r	\f\v\xA0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u200B\u2028\u2029\u3000";
      for (var j = i ? i : 0; j < str.length; j++) {
        var ch = str.charAt(j);
        if (whitespace.indexOf(ch) < 0) {
          if (str.charAt(j) === "#") {
            for (; ; j++) {
              if (j === str.length) {
                return -1;
              }
              if (str.charAt(j) === "\n") {
                this.lines = this.lines + 1;
                break;
              }
            }
            ;
          } else {
            return j;
          }
        } else {
          if (str.charAt(j) === "\n") {
            this.lines = this.lines + 1;
          }
        }
      }
      return -1;
    }
  }, {
    key: "variable",
    value: function variable4(str, i, res) {
      var j = this.skipSpace(str, i);
      if (j < 0) {
        return -1;
      }
      if (str.slice(j, j + 1) != "?") {
        return -1;
      }
      var j = j + 1;
      var i = j;
      if ("0123456789-".indexOf(str.charAt(j)) >= 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "Varible name can't start with '" + str.charAt(j) + "s'");
        return -1;
      }
      while (i < pyjslib_len(str) && _notNameChars.indexOf(str.charAt(i)) < 0) {
        var i = i + 1;
      }
      if (this._parentContext == null) {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "Can't use ?xxx syntax for variable in outermost level: " + str.slice(j - 1, i));
      }
      res.push(this._store.variable(str.slice(j, i)));
      return i;
    }
  }, {
    key: "bareWord",
    value: function bareWord(str, i, res) {
      var j = this.skipSpace(str, i);
      if (j < 0) {
        return -1;
      }
      var ch = str.charAt(j);
      if ("0123456789-".indexOf(ch) >= 0) {
        return -1;
      }
      if (_notNameChars.indexOf(ch) >= 0) {
        return -1;
      }
      var i = j;
      while (i < pyjslib_len(str) && _notNameChars.indexOf(str.charAt(i)) < 0) {
        var i = i + 1;
      }
      res.push(str.slice(j, i));
      return i;
    }
  }, {
    key: "qname",
    value: function qname(str, i, res) {
      var i = this.skipSpace(str, i);
      if (i < 0) {
        return -1;
      }
      var c = str.charAt(i);
      if ("0123456789-+".indexOf(c) >= 0) {
        return -1;
      }
      if (_notNameChars.indexOf(c) < 0) {
        var ln = c;
        var i = i + 1;
        while (i < pyjslib_len(str)) {
          var c = str.charAt(i);
          if (_notNameChars.indexOf(c) < 0) {
            var ln = ln + c;
            var i = i + 1;
          } else {
            break;
          }
        }
      } else {
        var ln = "";
      }
      if (i < pyjslib_len(str) && str.charAt(i) == ":") {
        var pfx = ln;
        var i = i + 1;
        var ln = "";
        while (i < pyjslib_len(str)) {
          var c = str.charAt(i);
          if (_notNameChars.indexOf(c) < 0) {
            var ln = ln + c;
            var i = i + 1;
          } else {
            break;
          }
        }
        res.push(new pyjslib_Tuple([pfx, ln]));
        return i;
      } else {
        if (ln && this.keywordsSet && ArrayIndexOf(this.keywords, ln) < 0) {
          res.push(new pyjslib_Tuple(["", ln]));
          return i;
        }
        return -1;
      }
    }
  }, {
    key: "object",
    value: function object(str, i, res) {
      var j = this.subject(str, i, res);
      if (j >= 0) {
        return j;
      } else {
        var j = this.skipSpace(str, i);
        if (j < 0) {
          return -1;
        } else {
          var i = j;
        }
        var delim = null;
        var ch = str.charAt(i);
        if (ch == '"' || ch == "'") {
          if (str.slice(i, i + 3 == ch + ch)) {
            delim = ch + ch + ch;
          } else {
            delim = ch;
          }
          var i = i + pyjslib_len(delim);
          var pairFudge = this.strconst(str, i, delim);
          var j = pairFudge[0];
          var s = pairFudge[1];
          res.push(this._store.literal(s));
          diag_progress("New string const ", s, j);
          return j;
        } else {
          return -1;
        }
      }
    }
  }, {
    key: "nodeOrLiteral",
    value: function nodeOrLiteral(str, i, res) {
      var j = this.node(str, i, res);
      if (j >= 0) {
        return j;
      } else {
        var j = this.skipSpace(str, i);
        if (j < 0) {
          return -1;
        } else {
          var i = j;
        }
        var ch = str.charAt(i);
        if ("-+0987654321".indexOf(ch) >= 0) {
          datetime_syntax.lastIndex = 0;
          var m = datetime_syntax.exec(str.slice(i));
          if (m != null) {
            var val = m[0];
            j = i + val.length;
            if (val.indexOf("T") >= 0) {
              res.push(this._store.literal(val, this._store.sym(DATETIME_DATATYPE)));
            } else {
              res.push(this._store.literal(val, this._store.sym(DATE_DATATYPE)));
            }
          } else {
            number_syntax.lastIndex = 0;
            var m = number_syntax.exec(str.slice(i));
            if (m == null) {
              throw BadSyntax(this._thisDoc, this.lines, str, i, "Bad number or date syntax");
            }
            j = i + number_syntax.lastIndex;
            var val = str.slice(i, j);
            if (val.indexOf("e") >= 0) {
              res.push(this._store.literal(parseFloat(val), this._store.sym(FLOAT_DATATYPE)));
            } else if (str.slice(i, j).indexOf(".") >= 0) {
              res.push(this._store.literal(parseFloat(val), this._store.sym(DECIMAL_DATATYPE)));
            } else {
              res.push(this._store.literal(parseInt(val), this._store.sym(INTEGER_DATATYPE)));
            }
          }
          ;
          return j;
        }
        if (str.charAt(i) == '"') {
          if (str.slice(i, i + 3) == '"""') {
            var delim = '"""';
          } else {
            var delim = '"';
          }
          var i = i + pyjslib_len(delim);
          var dt = null;
          var pairFudge = this.strconst(str, i, delim);
          var j = pairFudge[0];
          var s = pairFudge[1];
          var lang = null;
          if (str.slice(j, j + 1) == "@") {
            langcode.lastIndex = 0;
            var m = langcode.exec(str.slice(j + 1));
            if (m == null) {
              throw BadSyntax(this._thisDoc, startline, str, i, "Bad language code syntax on string literal, after @");
            }
            var i = langcode.lastIndex + j + 1;
            var lang = str.slice(j + 1, i);
            var j = i;
          }
          if (str.slice(j, j + 2) == "^^") {
            var res2 = new pyjslib_List([]);
            var j = this.uri_ref2(str, j + 2, res2);
            var dt = res2[0];
          }
          res.push(this._store.literal(s, lang || dt));
          return j;
        } else {
          return -1;
        }
      }
    }
  }, {
    key: "strconst",
    value: function strconst(str, i, delim) {
      var j = i;
      var ustr = "";
      var startline2 = this.lines;
      while (j < pyjslib_len(str)) {
        var i = j + pyjslib_len(delim);
        if (str.slice(j, i) == delim) {
          return new pyjslib_Tuple([i, ustr]);
        }
        if (str.charAt(j) == '"') {
          var ustr = ustr + '"';
          var j = j + 1;
          continue;
        }
        interesting.lastIndex = 0;
        var m = interesting.exec(str.slice(j));
        if (!m) {
          throw BadSyntax(this._thisDoc, startline2, str, j, "Closing quote missing in string at ^ in " + str.slice(j - 20, j) + "^" + str.slice(j, j + 20));
        }
        var i = j + interesting.lastIndex - 1;
        var ustr = ustr + str.slice(j, i);
        var ch = str.charAt(i);
        if (ch == '"') {
          var j = i;
          continue;
        } else if (ch == "\r") {
          var j = i + 1;
          continue;
        } else if (ch == "\n") {
          if (delim == '"') {
            throw BadSyntax(this._thisDoc, startline2, str, i, "newline found in string literal");
          }
          this.lines = this.lines + 1;
          var ustr = ustr + ch;
          var j = i + 1;
          this.previousLine = this.startOfLine;
          this.startOfLine = j;
        } else if (ch == "\\") {
          var j = i + 1;
          var ch = str.slice(j, j + 1);
          if (!ch) {
            throw BadSyntax(this._thisDoc, startline2, str, i, "unterminated string literal (2)");
          }
          var k = string_find('abfrtvn\\"', ch);
          if (k >= 0) {
            var uch = 'a\b\f\r	\v\n\\"'.charAt(k);
            var ustr = ustr + uch;
            var j = j + 1;
          } else if (ch == "u") {
            var pairFudge = this.uEscape(str, j + 1, startline2);
            var j = pairFudge[0];
            var ch = pairFudge[1];
            var ustr = ustr + ch;
          } else if (ch == "U") {
            var pairFudge = this.UEscape(str, j + 1, startline2);
            var j = pairFudge[0];
            var ch = pairFudge[1];
            var ustr = ustr + ch;
          } else {
            throw BadSyntax(this._thisDoc, this.lines, str, i, "bad escape");
          }
        }
      }
      throw BadSyntax(this._thisDoc, this.lines, str, i, "unterminated string literal");
    }
  }, {
    key: "uEscape",
    value: function uEscape(str, i, startline2) {
      var j = i;
      var count = 0;
      var value = 0;
      while (count < 4) {
        var chFudge = str.slice(j, j + 1);
        var ch = chFudge.toLowerCase();
        var j = j + 1;
        if (ch == "") {
          throw BadSyntax(this._thisDoc, startline2, str, i, "unterminated string literal(3)");
        }
        var k = string_find("0123456789abcdef", ch);
        if (k < 0) {
          throw BadSyntax(this._thisDoc, startline2, str, i, "bad string literal hex escape");
        }
        var value = value * 16 + k;
        var count = count + 1;
      }
      var uch = String.fromCharCode(value);
      return new pyjslib_Tuple([j, uch]);
    }
  }, {
    key: "UEscape",
    value: function UEscape(str, i, startline2) {
      var j = i;
      var count = 0;
      var value = "\\U";
      while (count < 8) {
        var chFudge = str.slice(j, j + 1);
        var ch = chFudge.toLowerCase();
        var j = j + 1;
        if (ch == "") {
          throw BadSyntax(this._thisDoc, startline2, str, i, "unterminated string literal(3)");
        }
        var k = string_find("0123456789abcdef", ch);
        if (k < 0) {
          throw BadSyntax(this._thisDoc, startline2, str, i, "bad string literal hex escape");
        }
        var value = value + ch;
        var count = count + 1;
      }
      var uch = stringFromCharCode("0x" + pyjslib_slice(value, 2, 10) - 0);
      return new pyjslib_Tuple([j, uch]);
    }
  }]);
}();
function __OLD_BadSyntax(uri, lines, str, i, why) {
  this._str = str.encode("utf-8");
  this._str = str;
  this._i = i;
  this._why = why;
  this.lines = lines;
  this._uri = uri;
}
__OLD_BadSyntax.prototype.toString = function() {
  var str = this._str;
  var i = this._i;
  var st3 = 0;
  if (i > 60) {
    var pre = "...";
    var st3 = i - 60;
  } else {
    var pre = "";
  }
  if (pyjslib_len(str) - i > 60) {
    var post = "...";
  } else {
    var post = "";
  }
  return 'Line %i of <%s>: Bad syntax (%s) at ^ in:\n"%s%s^%s%s"' % new pyjslib_Tuple([this.lines + 1, this._uri, this._why, pre, str.slice(st3, i), str.slice(i, i + 60), post]);
};
function BadSyntax(uri, lines, str, i, why) {
  var lineNo = lines + 1;
  var msg2 = "Line " + lineNo + " of <" + uri + ">: Bad syntax: " + why + '\nat: "' + str.slice(i, i + 30) + '"';
  var e = new SyntaxError(msg2, uri, lineNo);
  e.lineNo = lineNo;
  e.characterInFile = i;
  e.syntaxProblem = why;
  return e;
}

// ../node_modules/rdflib/esm/factories/extended-term-factory.js
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
var ExtendedTermFactory = _objectSpread(_objectSpread({}, canonical_data_factory_default), {}, {
  supports: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Feature.collections, true), Feature.defaultGraphType, false), Feature.equalsMethod, true), Feature.identity, false), Feature.id, true), Feature.reversibleId, false), Feature.variableType, true),
  /**
   * Creates a new collection
   * @param elements - The initial element
   */
  collection: function collection(elements) {
    return new Collection(elements);
  },
  id: function id2(term2) {
    var _this = this;
    if (isCollection(term2)) {
      return "( ".concat(term2.elements.map(function(e) {
        return _this.id(e);
      }).join(", "), " )");
    }
    if (isVariable(term2)) {
      return Variable.toString(term2);
    }
    return canonical_data_factory_default.id(term2);
  },
  termToNQ: function termToNQ2(term2) {
    if (term2.termType === CollectionTermType) {
      return Collection.toNT(term2);
    }
    return canonical_data_factory_default.termToNQ(term2);
  }
});
var extended_term_factory_default = ExtendedTermFactory;

// ../node_modules/rdflib/esm/jsonldparser.js
function jsonldObjectToTerm(kb, obj) {
  if (typeof obj === "string") {
    return kb.rdfFactory.literal(obj);
  }
  if (Object.prototype.hasOwnProperty.call(obj, "@list")) {
    if (kb.rdfFactory.supports["COLLECTIONS"] === true) {
      return listToCollection(kb, obj["@list"]);
    }
    return listToStatements(kb, obj);
  }
  if (Object.prototype.hasOwnProperty.call(obj, "@id")) {
    return nodeType(kb, obj);
  }
  if (Object.prototype.hasOwnProperty.call(obj, "@language")) {
    return kb.rdfFactory.literal(obj["@value"], obj["@language"]);
  }
  if (Object.prototype.hasOwnProperty.call(obj, "@type")) {
    return kb.rdfFactory.literal(obj["@value"], kb.rdfFactory.namedNode(obj["@type"]));
  }
  if (Object.prototype.hasOwnProperty.call(obj, "@value")) {
    return kb.rdfFactory.literal(obj["@value"]);
  }
  return kb.rdfFactory.literal(obj);
}
function listToStatements(kb, obj) {
  var listId = obj["@id"] ? nodeType(kb, obj) : kb.rdfFactory.blankNode();
  var items = obj["@list"].map(function(listItem) {
    return jsonldObjectToTerm(kb, listItem);
  });
  var statements = arrayToStatements(kb.rdfFactory, listId, items);
  kb.addAll(statements);
  return listId;
}
function listToCollection(kb, obj) {
  if (!Array.isArray(obj)) {
    throw new TypeError("Object must be an array");
  }
  return kb.rdfFactory.collection(obj.map(function(o) {
    return jsonldObjectToTerm(kb, o);
  }));
}
function jsonldParser(str, kb, base, callback) {
  var baseString = base && Object.prototype.hasOwnProperty.call(base, "termType") ? base.value : base;
  return import("./jsonld-ECVURSS6.js").then(function(jsonld) {
    return jsonld.flatten(JSON.parse(str), null, {
      base: baseString
    });
  }).then(function(flattened) {
    return flattened.reduce(function(store, flatResource) {
      kb = processResource(kb, base, flatResource);
      return kb;
    }, kb);
  }).then(callback).catch(callback);
}
function nodeType(kb, obj) {
  if (obj["@id"].startsWith("_:")) {
    return kb.rdfFactory.blankNode(obj["@id"].substring(2));
  } else {
    return kb.rdfFactory.namedNode(obj["@id"]);
  }
}
function processResource(kb, base, flatResource) {
  var id3 = flatResource["@id"] ? nodeType(kb, flatResource) : kb.rdfFactory.blankNode();
  for (var _i = 0, _Object$keys = Object.keys(flatResource); _i < _Object$keys.length; _i++) {
    var property = _Object$keys[_i];
    if (property === "@id") {
      continue;
    } else if (property == "@graph") {
      var graphId = id3;
      var nestedFlatResources = flatResource[property];
      for (var i = 0; i < nestedFlatResources.length; i++) {
        kb = processResource(kb, graphId, nestedFlatResources[i]);
      }
    }
    var value = flatResource[property];
    if (Array.isArray(value)) {
      for (var _i2 = 0; _i2 < value.length; _i2++) {
        kb.addStatement(createStatement(kb, id3, property, value[_i2], base));
      }
    } else {
      kb.addStatement(createStatement(kb, id3, property, value, base));
    }
  }
  return kb;
}
function createStatement(kb, id3, property, value, base) {
  var predicate, object;
  if (property === "@type") {
    predicate = kb.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type");
    object = kb.rdfFactory.namedNode(value);
  } else {
    predicate = kb.rdfFactory.namedNode(property);
    object = jsonldObjectToTerm(kb, value);
  }
  return kb.rdfFactory.quad(id3, predicate, object, kb.rdfFactory.namedNode(base));
}

// ../node_modules/n3/src/N3Lexer.js
var import_queue_microtask = __toESM(require_queue_microtask());

// ../node_modules/n3/src/IRIs.js
var RDF2 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#";
var XSD = "http://www.w3.org/2001/XMLSchema#";
var SWAP = "http://www.w3.org/2000/10/swap/";
var IRIs_default = {
  xsd: {
    decimal: `${XSD}decimal`,
    boolean: `${XSD}boolean`,
    double: `${XSD}double`,
    integer: `${XSD}integer`,
    string: `${XSD}string`
  },
  rdf: {
    type: `${RDF2}type`,
    nil: `${RDF2}nil`,
    first: `${RDF2}first`,
    rest: `${RDF2}rest`,
    langString: `${RDF2}langString`
  },
  owl: {
    sameAs: "http://www.w3.org/2002/07/owl#sameAs"
  },
  r: {
    forSome: `${SWAP}reify#forSome`,
    forAll: `${SWAP}reify#forAll`
  },
  log: {
    implies: `${SWAP}log#implies`
  }
};

// ../node_modules/n3/src/N3Lexer.js
var { xsd } = IRIs_default;
var escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\([^])/g;
var escapeReplacements = {
  "\\": "\\",
  "'": "'",
  '"': '"',
  "n": "\n",
  "r": "\r",
  "t": "	",
  "f": "\f",
  "b": "\b",
  "_": "_",
  "~": "~",
  ".": ".",
  "-": "-",
  "!": "!",
  "$": "$",
  "&": "&",
  "(": "(",
  ")": ")",
  "*": "*",
  "+": "+",
  ",": ",",
  ";": ";",
  "=": "=",
  "/": "/",
  "?": "?",
  "#": "#",
  "@": "@",
  "%": "%"
};
var illegalIriChars = /[\x00-\x20<>\\"\{\}\|\^\`]/;
var lineModeRegExps = {
  _iri: true,
  _unescapedIri: true,
  _simpleQuotedString: true,
  _langcode: true,
  _blank: true,
  _newline: true,
  _comment: true,
  _whitespace: true,
  _endOfFile: true
};
var invalidRegExp = /$0^/;
var N3Lexer = class {
  constructor(options) {
    this._iri = /^<((?:[^ <>{}\\]|\\[uU])+)>[ \t]*/;
    this._unescapedIri = /^<([^\x00-\x20<>\\"\{\}\|\^\`]*)>[ \t]*/;
    this._simpleQuotedString = /^"([^"\\\r\n]*)"(?=[^"])/;
    this._simpleApostropheString = /^'([^'\\\r\n]*)'(?=[^'])/;
    this._langcode = /^@([a-z]+(?:-[a-z0-9]+)*)(?=[^a-z0-9\-])/i;
    this._prefix = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:(?=[#\s<])/;
    this._prefixed = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:((?:(?:[0-:A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])(?:(?:[\.\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])*(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~]))?)?)(?:[ \t]+|(?=\.?[,;!\^\s#()\[\]\{\}"'<>]))/;
    this._variable = /^\?(?:(?:[A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?=[.,;!\^\s#()\[\]\{\}"'<>])/;
    this._blank = /^_:((?:[0-9A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?:[ \t]+|(?=\.?[,;:\s#()\[\]\{\}"'<>]))/;
    this._number = /^[\-+]?(?:(\d+\.\d*|\.?\d+)[eE][\-+]?|\d*(\.)?)\d+(?=\.?[,;:\s#()\[\]\{\}"'<>])/;
    this._boolean = /^(?:true|false)(?=[.,;\s#()\[\]\{\}"'<>])/;
    this._keyword = /^@[a-z]+(?=[\s#<:])/i;
    this._sparqlKeyword = /^(?:PREFIX|BASE|GRAPH)(?=[\s#<])/i;
    this._shortPredicates = /^a(?=[\s#()\[\]\{\}"'<>])/;
    this._newline = /^[ \t]*(?:#[^\n\r]*)?(?:\r\n|\n|\r)[ \t]*/;
    this._comment = /#([^\n\r]*)/;
    this._whitespace = /^[ \t]+/;
    this._endOfFile = /^(?:#[^\n\r]*)?$/;
    options = options || {};
    if (this._lineMode = !!options.lineMode) {
      this._n3Mode = false;
      for (const key in this) {
        if (!(key in lineModeRegExps) && this[key] instanceof RegExp)
          this[key] = invalidRegExp;
      }
    } else {
      this._n3Mode = options.n3 !== false;
    }
    this._comments = !!options.comments;
    this._literalClosingPos = 0;
  }
  // ## Private methods
  // ### `_tokenizeToEnd` tokenizes as for as possible, emitting tokens through the callback
  _tokenizeToEnd(callback, inputFinished) {
    let input = this._input;
    let currentLineLength = input.length;
    while (true) {
      let whiteSpaceMatch, comment;
      while (whiteSpaceMatch = this._newline.exec(input)) {
        if (this._comments && (comment = this._comment.exec(whiteSpaceMatch[0])))
          emitToken("comment", comment[1], "", this._line, whiteSpaceMatch[0].length);
        input = input.substr(whiteSpaceMatch[0].length, input.length);
        currentLineLength = input.length;
        this._line++;
      }
      if (!whiteSpaceMatch && (whiteSpaceMatch = this._whitespace.exec(input)))
        input = input.substr(whiteSpaceMatch[0].length, input.length);
      if (this._endOfFile.test(input)) {
        if (inputFinished) {
          if (this._comments && (comment = this._comment.exec(input)))
            emitToken("comment", comment[1], "", this._line, input.length);
          input = null;
          emitToken("eof", "", "", this._line, 0);
        }
        return this._input = input;
      }
      const line = this._line, firstChar = input[0];
      let type = "", value = "", prefix = "", match = null, matchLength = 0, inconclusive = false;
      switch (firstChar) {
        case "^":
          if (input.length < 3)
            break;
          else if (input[1] === "^") {
            this._previousMarker = "^^";
            input = input.substr(2);
            if (input[0] !== "<") {
              inconclusive = true;
              break;
            }
          } else {
            if (this._n3Mode) {
              matchLength = 1;
              type = "^";
            }
            break;
          }
        // Fall through in case the type is an IRI
        case "<":
          if (match = this._unescapedIri.exec(input))
            type = "IRI", value = match[1];
          else if (match = this._iri.exec(input)) {
            value = this._unescape(match[1]);
            if (value === null || illegalIriChars.test(value))
              return reportSyntaxError(this);
            type = "IRI";
          } else if (input.length > 1 && input[1] === "<")
            type = "<<", matchLength = 2;
          else if (this._n3Mode && input.length > 1 && input[1] === "=")
            type = "inverse", matchLength = 2, value = ">";
          break;
        case ">":
          if (input.length > 1 && input[1] === ">")
            type = ">>", matchLength = 2;
          break;
        case "_":
          if ((match = this._blank.exec(input)) || inputFinished && (match = this._blank.exec(`${input} `)))
            type = "blank", prefix = "_", value = match[1];
          break;
        case '"':
          if (match = this._simpleQuotedString.exec(input))
            value = match[1];
          else {
            ({ value, matchLength } = this._parseLiteral(input));
            if (value === null)
              return reportSyntaxError(this);
          }
          if (match !== null || matchLength !== 0) {
            type = "literal";
            this._literalClosingPos = 0;
          }
          break;
        case "'":
          if (!this._lineMode) {
            if (match = this._simpleApostropheString.exec(input))
              value = match[1];
            else {
              ({ value, matchLength } = this._parseLiteral(input));
              if (value === null)
                return reportSyntaxError(this);
            }
            if (match !== null || matchLength !== 0) {
              type = "literal";
              this._literalClosingPos = 0;
            }
          }
          break;
        case "?":
          if (this._n3Mode && (match = this._variable.exec(input)))
            type = "var", value = match[0];
          break;
        case "@":
          if (this._previousMarker === "literal" && (match = this._langcode.exec(input)))
            type = "langcode", value = match[1];
          else if (match = this._keyword.exec(input))
            type = match[0];
          break;
        case ".":
          if (input.length === 1 ? inputFinished : input[1] < "0" || input[1] > "9") {
            type = ".";
            matchLength = 1;
            break;
          }
        // Fall through to numerical case (could be a decimal dot)
        case "0":
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
        case "+":
        case "-":
          if (match = this._number.exec(input) || inputFinished && (match = this._number.exec(`${input} `))) {
            type = "literal", value = match[0];
            prefix = typeof match[1] === "string" ? xsd.double : typeof match[2] === "string" ? xsd.decimal : xsd.integer;
          }
          break;
        case "B":
        case "b":
        case "p":
        case "P":
        case "G":
        case "g":
          if (match = this._sparqlKeyword.exec(input))
            type = match[0].toUpperCase();
          else
            inconclusive = true;
          break;
        case "f":
        case "t":
          if (match = this._boolean.exec(input))
            type = "literal", value = match[0], prefix = xsd.boolean;
          else
            inconclusive = true;
          break;
        case "a":
          if (match = this._shortPredicates.exec(input))
            type = "abbreviation", value = "a";
          else
            inconclusive = true;
          break;
        case "=":
          if (this._n3Mode && input.length > 1) {
            type = "abbreviation";
            if (input[1] !== ">")
              matchLength = 1, value = "=";
            else
              matchLength = 2, value = ">";
          }
          break;
        case "!":
          if (!this._n3Mode)
            break;
        case ",":
        case ";":
        case "[":
        case "]":
        case "(":
        case ")":
        case "}":
          if (!this._lineMode) {
            matchLength = 1;
            type = firstChar;
          }
          break;
        case "{":
          if (!this._lineMode && input.length >= 2) {
            if (input[1] === "|")
              type = "{|", matchLength = 2;
            else
              type = firstChar, matchLength = 1;
          }
          break;
        case "|":
          if (input.length >= 2 && input[1] === "}")
            type = "|}", matchLength = 2;
          break;
        default:
          inconclusive = true;
      }
      if (inconclusive) {
        if ((this._previousMarker === "@prefix" || this._previousMarker === "PREFIX") && (match = this._prefix.exec(input)))
          type = "prefix", value = match[1] || "";
        else if ((match = this._prefixed.exec(input)) || inputFinished && (match = this._prefixed.exec(`${input} `)))
          type = "prefixed", prefix = match[1] || "", value = this._unescape(match[2]);
      }
      if (this._previousMarker === "^^") {
        switch (type) {
          case "prefixed":
            type = "type";
            break;
          case "IRI":
            type = "typeIRI";
            break;
          default:
            type = "";
        }
      }
      if (!type) {
        if (inputFinished || !/^'''|^"""/.test(input) && /\n|\r/.test(input))
          return reportSyntaxError(this);
        else
          return this._input = input;
      }
      const length = matchLength || match[0].length;
      const token = emitToken(type, value, prefix, line, length);
      this.previousToken = token;
      this._previousMarker = type;
      input = input.substr(length, input.length);
    }
    function emitToken(type, value, prefix, line, length) {
      const start = input ? currentLineLength - input.length : currentLineLength;
      const end = start + length;
      const token = { type, value, prefix, line, start, end };
      callback(null, token);
      return token;
    }
    function reportSyntaxError(self2) {
      callback(self2._syntaxError(/^\S*/.exec(input)[0]));
    }
  }
  // ### `_unescape` replaces N3 escape codes by their corresponding characters
  _unescape(item) {
    let invalid = false;
    const replaced = item.replace(escapeSequence, (sequence, unicode4, unicode8, escapedChar) => {
      if (typeof unicode4 === "string")
        return String.fromCharCode(Number.parseInt(unicode4, 16));
      if (typeof unicode8 === "string") {
        let charCode = Number.parseInt(unicode8, 16);
        return charCode <= 65535 ? String.fromCharCode(Number.parseInt(unicode8, 16)) : String.fromCharCode(55296 + ((charCode -= 65536) >> 10), 56320 + (charCode & 1023));
      }
      if (escapedChar in escapeReplacements)
        return escapeReplacements[escapedChar];
      invalid = true;
      return "";
    });
    return invalid ? null : replaced;
  }
  // ### `_parseLiteral` parses a literal into an unescaped value
  _parseLiteral(input) {
    if (input.length >= 3) {
      const opening = input.match(/^(?:"""|"|'''|'|)/)[0];
      const openingLength = opening.length;
      let closingPos = Math.max(this._literalClosingPos, openingLength);
      while ((closingPos = input.indexOf(opening, closingPos)) > 0) {
        let backslashCount = 0;
        while (input[closingPos - backslashCount - 1] === "\\")
          backslashCount++;
        if (backslashCount % 2 === 0) {
          const raw = input.substring(openingLength, closingPos);
          const lines = raw.split(/\r\n|\r|\n/).length - 1;
          const matchLength = closingPos + openingLength;
          if (openingLength === 1 && lines !== 0 || openingLength === 3 && this._lineMode)
            break;
          this._line += lines;
          return { value: this._unescape(raw), matchLength };
        }
        closingPos++;
      }
      this._literalClosingPos = input.length - openingLength + 1;
    }
    return { value: "", matchLength: 0 };
  }
  // ### `_syntaxError` creates a syntax error for the given issue
  _syntaxError(issue) {
    this._input = null;
    const err = new Error(`Unexpected "${issue}" on line ${this._line}.`);
    err.context = {
      token: void 0,
      line: this._line,
      previousToken: this.previousToken
    };
    return err;
  }
  // ### Strips off any starting UTF BOM mark.
  _readStartingBom(input) {
    return input.startsWith("\uFEFF") ? input.substr(1) : input;
  }
  // ## Public methods
  // ### `tokenize` starts the transformation of an N3 document into an array of tokens.
  // The input can be a string or a stream.
  tokenize(input, callback) {
    this._line = 1;
    if (typeof input === "string") {
      this._input = this._readStartingBom(input);
      if (typeof callback === "function")
        (0, import_queue_microtask.default)(() => this._tokenizeToEnd(callback, true));
      else {
        const tokens = [];
        let error2;
        this._tokenizeToEnd((e, t) => e ? error2 = e : tokens.push(t), true);
        if (error2) throw error2;
        return tokens;
      }
    } else {
      this._pendingBuffer = null;
      if (typeof input.setEncoding === "function")
        input.setEncoding("utf8");
      input.on("data", (data) => {
        if (this._input !== null && data.length !== 0) {
          if (this._pendingBuffer) {
            data = Buffer.concat([this._pendingBuffer, data]);
            this._pendingBuffer = null;
          }
          if (data[data.length - 1] & 128) {
            this._pendingBuffer = data;
          } else {
            if (typeof this._input === "undefined")
              this._input = this._readStartingBom(typeof data === "string" ? data : data.toString());
            else
              this._input += data;
            this._tokenizeToEnd(callback, false);
          }
        }
      });
      input.on("end", () => {
        if (typeof this._input === "string")
          this._tokenizeToEnd(callback, true);
      });
      input.on("error", callback);
    }
  }
};

// ../node_modules/n3/src/N3DataFactory.js
var { rdf: rdf2, xsd: xsd2 } = IRIs_default;
var DEFAULTGRAPH;
var _blankNodeCounter = 0;
var DataFactory = {
  namedNode: namedNode2,
  blankNode: blankNode2,
  variable: variable2,
  literal: literal2,
  defaultGraph: defaultGraph3,
  quad: quad2,
  triple: quad2
};
var N3DataFactory_default = DataFactory;
var Term = class _Term {
  constructor(id3) {
    this.id = id3;
  }
  // ### The value of this term
  get value() {
    return this.id;
  }
  // ### Returns whether this object represents the same term as the other
  equals(other) {
    if (other instanceof _Term)
      return this.id === other.id;
    return !!other && this.termType === other.termType && this.value === other.value;
  }
  // ### Implement hashCode for Immutable.js, since we implement `equals`
  // https://immutable-js.com/docs/v4.0.0/ValueObject/#hashCode()
  hashCode() {
    return 0;
  }
  // ### Returns a plain object representation of this term
  toJSON() {
    return {
      termType: this.termType,
      value: this.value
    };
  }
};
var NamedNode2 = class extends Term {
  // ### The term type of this term
  get termType() {
    return "NamedNode";
  }
};
var Literal2 = class _Literal extends Term {
  // ### The term type of this term
  get termType() {
    return "Literal";
  }
  // ### The text value of this literal
  get value() {
    return this.id.substring(1, this.id.lastIndexOf('"'));
  }
  // ### The language of this literal
  get language() {
    const id3 = this.id;
    let atPos = id3.lastIndexOf('"') + 1;
    return atPos < id3.length && id3[atPos++] === "@" ? id3.substr(atPos).toLowerCase() : "";
  }
  // ### The datatype IRI of this literal
  get datatype() {
    return new NamedNode2(this.datatypeString);
  }
  // ### The datatype string of this literal
  get datatypeString() {
    const id3 = this.id, dtPos = id3.lastIndexOf('"') + 1;
    const char = dtPos < id3.length ? id3[dtPos] : "";
    return char === "^" ? id3.substr(dtPos + 2) : (
      // If "@" follows, return rdf:langString; xsd:string otherwise
      char !== "@" ? xsd2.string : rdf2.langString
    );
  }
  // ### Returns whether this object represents the same term as the other
  equals(other) {
    if (other instanceof _Literal)
      return this.id === other.id;
    return !!other && !!other.datatype && this.termType === other.termType && this.value === other.value && this.language === other.language && this.datatype.value === other.datatype.value;
  }
  toJSON() {
    return {
      termType: this.termType,
      value: this.value,
      language: this.language,
      datatype: { termType: "NamedNode", value: this.datatypeString }
    };
  }
};
var BlankNode2 = class extends Term {
  constructor(name) {
    super(`_:${name}`);
  }
  // ### The term type of this term
  get termType() {
    return "BlankNode";
  }
  // ### The name of this blank node
  get value() {
    return this.id.substr(2);
  }
};
var Variable2 = class extends Term {
  constructor(name) {
    super(`?${name}`);
  }
  // ### The term type of this term
  get termType() {
    return "Variable";
  }
  // ### The name of this variable
  get value() {
    return this.id.substr(1);
  }
};
var DefaultGraph2 = class extends Term {
  constructor() {
    super("");
    return DEFAULTGRAPH || this;
  }
  // ### The term type of this term
  get termType() {
    return "DefaultGraph";
  }
  // ### Returns whether this object represents the same term as the other
  equals(other) {
    return this === other || !!other && this.termType === other.termType;
  }
};
DEFAULTGRAPH = new DefaultGraph2();
var Quad = class extends Term {
  constructor(subject, predicate, object, graph3) {
    super("");
    this._subject = subject;
    this._predicate = predicate;
    this._object = object;
    this._graph = graph3 || DEFAULTGRAPH;
  }
  // ### The term type of this term
  get termType() {
    return "Quad";
  }
  get subject() {
    return this._subject;
  }
  get predicate() {
    return this._predicate;
  }
  get object() {
    return this._object;
  }
  get graph() {
    return this._graph;
  }
  // ### Returns a plain object representation of this quad
  toJSON() {
    return {
      termType: this.termType,
      subject: this._subject.toJSON(),
      predicate: this._predicate.toJSON(),
      object: this._object.toJSON(),
      graph: this._graph.toJSON()
    };
  }
  // ### Returns whether this object represents the same quad as the other
  equals(other) {
    return !!other && this._subject.equals(other.subject) && this._predicate.equals(other.predicate) && this._object.equals(other.object) && this._graph.equals(other.graph);
  }
};
function namedNode2(iri) {
  return new NamedNode2(iri);
}
function blankNode2(name) {
  return new BlankNode2(name || `n3-${_blankNodeCounter++}`);
}
function literal2(value, languageOrDataType) {
  if (typeof languageOrDataType === "string")
    return new Literal2(`"${value}"@${languageOrDataType.toLowerCase()}`);
  let datatype = languageOrDataType ? languageOrDataType.value : "";
  if (datatype === "") {
    if (typeof value === "boolean")
      datatype = xsd2.boolean;
    else if (typeof value === "number") {
      if (Number.isFinite(value))
        datatype = Number.isInteger(value) ? xsd2.integer : xsd2.double;
      else {
        datatype = xsd2.double;
        if (!Number.isNaN(value))
          value = value > 0 ? "INF" : "-INF";
      }
    }
  }
  return datatype === "" || datatype === xsd2.string ? new Literal2(`"${value}"`) : new Literal2(`"${value}"^^${datatype}`);
}
function variable2(name) {
  return new Variable2(name);
}
function defaultGraph3() {
  return DEFAULTGRAPH;
}
function quad2(subject, predicate, object, graph3) {
  return new Quad(subject, predicate, object, graph3);
}

// ../node_modules/n3/src/N3Parser.js
var blankNodePrefix = 0;
var N3Parser = class {
  constructor(options) {
    this._contextStack = [];
    this._graph = null;
    options = options || {};
    this._setBase(options.baseIRI);
    options.factory && initDataFactory(this, options.factory);
    const format = typeof options.format === "string" ? options.format.match(/\w*$/)[0].toLowerCase() : "", isTurtle = /turtle/.test(format), isTriG = /trig/.test(format), isNTriples = /triple/.test(format), isNQuads = /quad/.test(format), isN3 = this._n3Mode = /n3/.test(format), isLineMode = isNTriples || isNQuads;
    if (!(this._supportsNamedGraphs = !(isTurtle || isN3)))
      this._readPredicateOrNamedGraph = this._readPredicate;
    this._supportsQuads = !(isTurtle || isTriG || isNTriples || isN3);
    this._supportsRDFStar = format === "" || /star|\*$/.test(format);
    if (isLineMode)
      this._resolveRelativeIRI = (iri) => {
        return null;
      };
    this._blankNodePrefix = typeof options.blankNodePrefix !== "string" ? "" : options.blankNodePrefix.replace(/^(?!_:)/, "_:");
    this._lexer = options.lexer || new N3Lexer({ lineMode: isLineMode, n3: isN3 });
    this._explicitQuantifiers = !!options.explicitQuantifiers;
  }
  // ## Static class methods
  // ### `_resetBlankNodePrefix` restarts blank node prefix identification
  static _resetBlankNodePrefix() {
    blankNodePrefix = 0;
  }
  // ## Private methods
  // ### `_setBase` sets the base IRI to resolve relative IRIs
  _setBase(baseIRI) {
    if (!baseIRI) {
      this._base = "";
      this._basePath = "";
    } else {
      const fragmentPos = baseIRI.indexOf("#");
      if (fragmentPos >= 0)
        baseIRI = baseIRI.substr(0, fragmentPos);
      this._base = baseIRI;
      this._basePath = baseIRI.indexOf("/") < 0 ? baseIRI : baseIRI.replace(/[^\/?]*(?:\?.*)?$/, "");
      baseIRI = baseIRI.match(/^(?:([a-z][a-z0-9+.-]*:))?(?:\/\/[^\/]*)?/i);
      this._baseRoot = baseIRI[0];
      this._baseScheme = baseIRI[1];
    }
  }
  // ### `_saveContext` stores the current parsing context
  // when entering a new scope (list, blank node, formula)
  _saveContext(type, graph3, subject, predicate, object) {
    const n3Mode = this._n3Mode;
    this._contextStack.push({
      type,
      subject,
      predicate,
      object,
      graph: graph3,
      inverse: n3Mode ? this._inversePredicate : false,
      blankPrefix: n3Mode ? this._prefixes._ : "",
      quantified: n3Mode ? this._quantified : null
    });
    if (n3Mode) {
      this._inversePredicate = false;
      this._prefixes._ = this._graph ? `${this._graph.value}.` : ".";
      this._quantified = Object.create(this._quantified);
    }
  }
  // ### `_restoreContext` restores the parent context
  // when leaving a scope (list, blank node, formula)
  _restoreContext(type, token) {
    const context = this._contextStack.pop();
    if (!context || context.type !== type)
      return this._error(`Unexpected ${token.type}`, token);
    this._subject = context.subject;
    this._predicate = context.predicate;
    this._object = context.object;
    this._graph = context.graph;
    if (this._n3Mode) {
      this._inversePredicate = context.inverse;
      this._prefixes._ = context.blankPrefix;
      this._quantified = context.quantified;
    }
  }
  // ### `_readInTopContext` reads a token when in the top context
  _readInTopContext(token) {
    switch (token.type) {
      // If an EOF token arrives in the top context, signal that we're done
      case "eof":
        if (this._graph !== null)
          return this._error("Unclosed graph", token);
        delete this._prefixes._;
        return this._callback(null, null, this._prefixes);
      // It could be a prefix declaration
      case "PREFIX":
        this._sparqlStyle = true;
      case "@prefix":
        return this._readPrefix;
      // It could be a base declaration
      case "BASE":
        this._sparqlStyle = true;
      case "@base":
        return this._readBaseIRI;
      // It could be a graph
      case "{":
        if (this._supportsNamedGraphs) {
          this._graph = "";
          this._subject = null;
          return this._readSubject;
        }
      case "GRAPH":
        if (this._supportsNamedGraphs)
          return this._readNamedGraphLabel;
      // Otherwise, the next token must be a subject
      default:
        return this._readSubject(token);
    }
  }
  // ### `_readEntity` reads an IRI, prefixed name, blank node, or variable
  _readEntity(token, quantifier) {
    let value;
    switch (token.type) {
      // Read a relative or absolute IRI
      case "IRI":
      case "typeIRI":
        const iri = this._resolveIRI(token.value);
        if (iri === null)
          return this._error("Invalid IRI", token);
        value = this._namedNode(iri);
        break;
      // Read a prefixed name
      case "type":
      case "prefixed":
        const prefix = this._prefixes[token.prefix];
        if (prefix === void 0)
          return this._error(`Undefined prefix "${token.prefix}:"`, token);
        value = this._namedNode(prefix + token.value);
        break;
      // Read a blank node
      case "blank":
        value = this._blankNode(this._prefixes[token.prefix] + token.value);
        break;
      // Read a variable
      case "var":
        value = this._variable(token.value.substr(1));
        break;
      // Everything else is not an entity
      default:
        return this._error(`Expected entity but got ${token.type}`, token);
    }
    if (!quantifier && this._n3Mode && value.id in this._quantified)
      value = this._quantified[value.id];
    return value;
  }
  // ### `_readSubject` reads a quad's subject
  _readSubject(token) {
    this._predicate = null;
    switch (token.type) {
      case "[":
        this._saveContext(
          "blank",
          this._graph,
          this._subject = this._blankNode(),
          null,
          null
        );
        return this._readBlankNodeHead;
      case "(":
        this._saveContext("list", this._graph, this.RDF_NIL, null, null);
        this._subject = null;
        return this._readListItem;
      case "{":
        if (!this._n3Mode)
          return this._error("Unexpected graph", token);
        this._saveContext(
          "formula",
          this._graph,
          this._graph = this._blankNode(),
          null,
          null
        );
        return this._readSubject;
      case "}":
        return this._readPunctuation(token);
      case "@forSome":
        if (!this._n3Mode)
          return this._error('Unexpected "@forSome"', token);
        this._subject = null;
        this._predicate = this.N3_FORSOME;
        this._quantifier = this._blankNode;
        return this._readQuantifierList;
      case "@forAll":
        if (!this._n3Mode)
          return this._error('Unexpected "@forAll"', token);
        this._subject = null;
        this._predicate = this.N3_FORALL;
        this._quantifier = this._variable;
        return this._readQuantifierList;
      case "literal":
        if (!this._n3Mode)
          return this._error("Unexpected literal", token);
        if (token.prefix.length === 0) {
          this._literalValue = token.value;
          return this._completeSubjectLiteral;
        } else
          this._subject = this._literal(token.value, this._namedNode(token.prefix));
        break;
      case "<<":
        if (!this._supportsRDFStar)
          return this._error("Unexpected RDF* syntax", token);
        this._saveContext("<<", this._graph, null, null, null);
        this._graph = null;
        return this._readSubject;
      default:
        if ((this._subject = this._readEntity(token)) === void 0)
          return;
        if (this._n3Mode)
          return this._getPathReader(this._readPredicateOrNamedGraph);
    }
    return this._readPredicateOrNamedGraph;
  }
  // ### `_readPredicate` reads a quad's predicate
  _readPredicate(token) {
    const type = token.type;
    switch (type) {
      case "inverse":
        this._inversePredicate = true;
      case "abbreviation":
        this._predicate = this.ABBREVIATIONS[token.value];
        break;
      case ".":
      case "]":
      case "}":
        if (this._predicate === null)
          return this._error(`Unexpected ${type}`, token);
        this._subject = null;
        return type === "]" ? this._readBlankNodeTail(token) : this._readPunctuation(token);
      case ";":
        return this._predicate !== null ? this._readPredicate : this._error("Expected predicate but got ;", token);
      case "[":
        if (this._n3Mode) {
          this._saveContext(
            "blank",
            this._graph,
            this._subject,
            this._subject = this._blankNode(),
            null
          );
          return this._readBlankNodeHead;
        }
      case "blank":
        if (!this._n3Mode)
          return this._error("Disallowed blank node as predicate", token);
      default:
        if ((this._predicate = this._readEntity(token)) === void 0)
          return;
    }
    return this._readObject;
  }
  // ### `_readObject` reads a quad's object
  _readObject(token) {
    switch (token.type) {
      case "literal":
        if (token.prefix.length === 0) {
          this._literalValue = token.value;
          return this._readDataTypeOrLang;
        } else
          this._object = this._literal(token.value, this._namedNode(token.prefix));
        break;
      case "[":
        this._saveContext(
          "blank",
          this._graph,
          this._subject,
          this._predicate,
          this._subject = this._blankNode()
        );
        return this._readBlankNodeHead;
      case "(":
        this._saveContext("list", this._graph, this._subject, this._predicate, this.RDF_NIL);
        this._subject = null;
        return this._readListItem;
      case "{":
        if (!this._n3Mode)
          return this._error("Unexpected graph", token);
        this._saveContext(
          "formula",
          this._graph,
          this._subject,
          this._predicate,
          this._graph = this._blankNode()
        );
        return this._readSubject;
      case "<<":
        if (!this._supportsRDFStar)
          return this._error("Unexpected RDF* syntax", token);
        this._saveContext("<<", this._graph, this._subject, this._predicate, null);
        this._graph = null;
        return this._readSubject;
      default:
        if ((this._object = this._readEntity(token)) === void 0)
          return;
        if (this._n3Mode)
          return this._getPathReader(this._getContextEndReader());
    }
    return this._getContextEndReader();
  }
  // ### `_readPredicateOrNamedGraph` reads a quad's predicate, or a named graph
  _readPredicateOrNamedGraph(token) {
    return token.type === "{" ? this._readGraph(token) : this._readPredicate(token);
  }
  // ### `_readGraph` reads a graph
  _readGraph(token) {
    if (token.type !== "{")
      return this._error(`Expected graph but got ${token.type}`, token);
    this._graph = this._subject, this._subject = null;
    return this._readSubject;
  }
  // ### `_readBlankNodeHead` reads the head of a blank node
  _readBlankNodeHead(token) {
    if (token.type === "]") {
      this._subject = null;
      return this._readBlankNodeTail(token);
    } else {
      this._predicate = null;
      return this._readPredicate(token);
    }
  }
  // ### `_readBlankNodeTail` reads the end of a blank node
  _readBlankNodeTail(token) {
    if (token.type !== "]")
      return this._readBlankNodePunctuation(token);
    if (this._subject !== null)
      this._emit(this._subject, this._predicate, this._object, this._graph);
    const empty = this._predicate === null;
    this._restoreContext("blank", token);
    if (this._object !== null)
      return this._getContextEndReader();
    else if (this._predicate !== null)
      return this._readObject;
    else
      return empty ? this._readPredicateOrNamedGraph : this._readPredicateAfterBlank;
  }
  // ### `_readPredicateAfterBlank` reads a predicate after an anonymous blank node
  _readPredicateAfterBlank(token) {
    switch (token.type) {
      case ".":
      case "}":
        this._subject = null;
        return this._readPunctuation(token);
      default:
        return this._readPredicate(token);
    }
  }
  // ### `_readListItem` reads items from a list
  _readListItem(token) {
    let item = null, list = null, next = this._readListItem;
    const previousList = this._subject, stack = this._contextStack, parent = stack[stack.length - 1];
    switch (token.type) {
      case "[":
        this._saveContext(
          "blank",
          this._graph,
          list = this._blankNode(),
          this.RDF_FIRST,
          this._subject = item = this._blankNode()
        );
        next = this._readBlankNodeHead;
        break;
      case "(":
        this._saveContext(
          "list",
          this._graph,
          list = this._blankNode(),
          this.RDF_FIRST,
          this.RDF_NIL
        );
        this._subject = null;
        break;
      case ")":
        this._restoreContext("list", token);
        if (stack.length !== 0 && stack[stack.length - 1].type === "list")
          this._emit(this._subject, this._predicate, this._object, this._graph);
        if (this._predicate === null) {
          next = this._readPredicate;
          if (this._subject === this.RDF_NIL)
            return next;
        } else {
          next = this._getContextEndReader();
          if (this._object === this.RDF_NIL)
            return next;
        }
        list = this.RDF_NIL;
        break;
      case "literal":
        if (token.prefix.length === 0) {
          this._literalValue = token.value;
          next = this._readListItemDataTypeOrLang;
        } else {
          item = this._literal(token.value, this._namedNode(token.prefix));
          next = this._getContextEndReader();
        }
        break;
      case "{":
        if (!this._n3Mode)
          return this._error("Unexpected graph", token);
        this._saveContext(
          "formula",
          this._graph,
          this._subject,
          this._predicate,
          this._graph = this._blankNode()
        );
        return this._readSubject;
      default:
        if ((item = this._readEntity(token)) === void 0)
          return;
    }
    if (list === null)
      this._subject = list = this._blankNode();
    if (previousList === null) {
      if (parent.predicate === null)
        parent.subject = list;
      else
        parent.object = list;
    } else {
      this._emit(previousList, this.RDF_REST, list, this._graph);
    }
    if (item !== null) {
      if (this._n3Mode && (token.type === "IRI" || token.type === "prefixed")) {
        this._saveContext("item", this._graph, list, this.RDF_FIRST, item);
        this._subject = item, this._predicate = null;
        return this._getPathReader(this._readListItem);
      }
      this._emit(list, this.RDF_FIRST, item, this._graph);
    }
    return next;
  }
  // ### `_readDataTypeOrLang` reads an _optional_ datatype or language
  _readDataTypeOrLang(token) {
    return this._completeObjectLiteral(token, false);
  }
  // ### `_readListItemDataTypeOrLang` reads an _optional_ datatype or language in a list
  _readListItemDataTypeOrLang(token) {
    return this._completeObjectLiteral(token, true);
  }
  // ### `_completeLiteral` completes a literal with an optional datatype or language
  _completeLiteral(token) {
    let literal4 = this._literal(this._literalValue);
    switch (token.type) {
      // Create a datatyped literal
      case "type":
      case "typeIRI":
        const datatype = this._readEntity(token);
        if (datatype === void 0) return;
        literal4 = this._literal(this._literalValue, datatype);
        token = null;
        break;
      // Create a language-tagged string
      case "langcode":
        literal4 = this._literal(this._literalValue, token.value);
        token = null;
        break;
    }
    return { token, literal: literal4 };
  }
  // Completes a literal in subject position
  _completeSubjectLiteral(token) {
    this._subject = this._completeLiteral(token).literal;
    return this._readPredicateOrNamedGraph;
  }
  // Completes a literal in object position
  _completeObjectLiteral(token, listItem) {
    const completed = this._completeLiteral(token);
    if (!completed)
      return;
    this._object = completed.literal;
    if (listItem)
      this._emit(this._subject, this.RDF_FIRST, this._object, this._graph);
    if (completed.token === null)
      return this._getContextEndReader();
    else {
      this._readCallback = this._getContextEndReader();
      return this._readCallback(completed.token);
    }
  }
  // ### `_readFormulaTail` reads the end of a formula
  _readFormulaTail(token) {
    if (token.type !== "}")
      return this._readPunctuation(token);
    if (this._subject !== null)
      this._emit(this._subject, this._predicate, this._object, this._graph);
    this._restoreContext("formula", token);
    return this._object === null ? this._readPredicate : this._getContextEndReader();
  }
  // ### `_readPunctuation` reads punctuation between quads or quad parts
  _readPunctuation(token) {
    let next, graph3 = this._graph;
    const subject = this._subject, inversePredicate = this._inversePredicate;
    switch (token.type) {
      // A closing brace ends a graph
      case "}":
        if (this._graph === null)
          return this._error("Unexpected graph closing", token);
        if (this._n3Mode)
          return this._readFormulaTail(token);
        this._graph = null;
      // A dot just ends the statement, without sharing anything with the next
      case ".":
        this._subject = null;
        next = this._contextStack.length ? this._readSubject : this._readInTopContext;
        if (inversePredicate) this._inversePredicate = false;
        break;
      // Semicolon means the subject is shared; predicate and object are different
      case ";":
        next = this._readPredicate;
        break;
      // Comma means both the subject and predicate are shared; the object is different
      case ",":
        next = this._readObject;
        break;
      // {| means that the current triple is annotated with predicate-object pairs.
      case "{|":
        if (!this._supportsRDFStar)
          return this._error("Unexpected RDF* syntax", token);
        const predicate = this._predicate, object = this._object;
        this._subject = this._quad(subject, predicate, object, this.DEFAULTGRAPH);
        next = this._readPredicate;
        break;
      // |} means that the current quoted triple in annotation syntax is finalized.
      case "|}":
        if (this._subject.termType !== "Quad")
          return this._error("Unexpected asserted triple closing", token);
        this._subject = null;
        next = this._readPunctuation;
        break;
      default:
        if (this._supportsQuads && this._graph === null && (graph3 = this._readEntity(token)) !== void 0) {
          next = this._readQuadPunctuation;
          break;
        }
        return this._error(`Expected punctuation to follow "${this._object.id}"`, token);
    }
    if (subject !== null) {
      const predicate = this._predicate, object = this._object;
      if (!inversePredicate)
        this._emit(subject, predicate, object, graph3);
      else
        this._emit(object, predicate, subject, graph3);
    }
    return next;
  }
  // ### `_readBlankNodePunctuation` reads punctuation in a blank node
  _readBlankNodePunctuation(token) {
    let next;
    switch (token.type) {
      // Semicolon means the subject is shared; predicate and object are different
      case ";":
        next = this._readPredicate;
        break;
      // Comma means both the subject and predicate are shared; the object is different
      case ",":
        next = this._readObject;
        break;
      default:
        return this._error(`Expected punctuation to follow "${this._object.id}"`, token);
    }
    this._emit(this._subject, this._predicate, this._object, this._graph);
    return next;
  }
  // ### `_readQuadPunctuation` reads punctuation after a quad
  _readQuadPunctuation(token) {
    if (token.type !== ".")
      return this._error("Expected dot to follow quad", token);
    return this._readInTopContext;
  }
  // ### `_readPrefix` reads the prefix of a prefix declaration
  _readPrefix(token) {
    if (token.type !== "prefix")
      return this._error("Expected prefix to follow @prefix", token);
    this._prefix = token.value;
    return this._readPrefixIRI;
  }
  // ### `_readPrefixIRI` reads the IRI of a prefix declaration
  _readPrefixIRI(token) {
    if (token.type !== "IRI")
      return this._error(`Expected IRI to follow prefix "${this._prefix}:"`, token);
    const prefixNode = this._readEntity(token);
    this._prefixes[this._prefix] = prefixNode.value;
    this._prefixCallback(this._prefix, prefixNode);
    return this._readDeclarationPunctuation;
  }
  // ### `_readBaseIRI` reads the IRI of a base declaration
  _readBaseIRI(token) {
    const iri = token.type === "IRI" && this._resolveIRI(token.value);
    if (!iri)
      return this._error("Expected valid IRI to follow base declaration", token);
    this._setBase(iri);
    return this._readDeclarationPunctuation;
  }
  // ### `_readNamedGraphLabel` reads the label of a named graph
  _readNamedGraphLabel(token) {
    switch (token.type) {
      case "IRI":
      case "blank":
      case "prefixed":
        return this._readSubject(token), this._readGraph;
      case "[":
        return this._readNamedGraphBlankLabel;
      default:
        return this._error("Invalid graph label", token);
    }
  }
  // ### `_readNamedGraphLabel` reads a blank node label of a named graph
  _readNamedGraphBlankLabel(token) {
    if (token.type !== "]")
      return this._error("Invalid graph label", token);
    this._subject = this._blankNode();
    return this._readGraph;
  }
  // ### `_readDeclarationPunctuation` reads the punctuation of a declaration
  _readDeclarationPunctuation(token) {
    if (this._sparqlStyle) {
      this._sparqlStyle = false;
      return this._readInTopContext(token);
    }
    if (token.type !== ".")
      return this._error("Expected declaration to end with a dot", token);
    return this._readInTopContext;
  }
  // Reads a list of quantified symbols from a @forSome or @forAll statement
  _readQuantifierList(token) {
    let entity;
    switch (token.type) {
      case "IRI":
      case "prefixed":
        if ((entity = this._readEntity(token, true)) !== void 0)
          break;
      default:
        return this._error(`Unexpected ${token.type}`, token);
    }
    if (!this._explicitQuantifiers)
      this._quantified[entity.id] = this._quantifier(this._blankNode().value);
    else {
      if (this._subject === null)
        this._emit(
          this._graph || this.DEFAULTGRAPH,
          this._predicate,
          this._subject = this._blankNode(),
          this.QUANTIFIERS_GRAPH
        );
      else
        this._emit(
          this._subject,
          this.RDF_REST,
          this._subject = this._blankNode(),
          this.QUANTIFIERS_GRAPH
        );
      this._emit(this._subject, this.RDF_FIRST, entity, this.QUANTIFIERS_GRAPH);
    }
    return this._readQuantifierPunctuation;
  }
  // Reads punctuation from a @forSome or @forAll statement
  _readQuantifierPunctuation(token) {
    if (token.type === ",")
      return this._readQuantifierList;
    else {
      if (this._explicitQuantifiers) {
        this._emit(this._subject, this.RDF_REST, this.RDF_NIL, this.QUANTIFIERS_GRAPH);
        this._subject = null;
      }
      this._readCallback = this._getContextEndReader();
      return this._readCallback(token);
    }
  }
  // ### `_getPathReader` reads a potential path and then resumes with the given function
  _getPathReader(afterPath) {
    this._afterPath = afterPath;
    return this._readPath;
  }
  // ### `_readPath` reads a potential path
  _readPath(token) {
    switch (token.type) {
      // Forward path
      case "!":
        return this._readForwardPath;
      // Backward path
      case "^":
        return this._readBackwardPath;
      // Not a path; resume reading where we left off
      default:
        const stack = this._contextStack, parent = stack.length && stack[stack.length - 1];
        if (parent && parent.type === "item") {
          const item = this._subject;
          this._restoreContext("item", token);
          this._emit(this._subject, this.RDF_FIRST, item, this._graph);
        }
        return this._afterPath(token);
    }
  }
  // ### `_readForwardPath` reads a '!' path
  _readForwardPath(token) {
    let subject, predicate;
    const object = this._blankNode();
    if ((predicate = this._readEntity(token)) === void 0)
      return;
    if (this._predicate === null)
      subject = this._subject, this._subject = object;
    else
      subject = this._object, this._object = object;
    this._emit(subject, predicate, object, this._graph);
    return this._readPath;
  }
  // ### `_readBackwardPath` reads a '^' path
  _readBackwardPath(token) {
    const subject = this._blankNode();
    let predicate, object;
    if ((predicate = this._readEntity(token)) === void 0)
      return;
    if (this._predicate === null)
      object = this._subject, this._subject = subject;
    else
      object = this._object, this._object = subject;
    this._emit(subject, predicate, object, this._graph);
    return this._readPath;
  }
  // ### `_readRDFStarTailOrGraph` reads the graph of a nested RDF* quad or the end of a nested RDF* triple
  _readRDFStarTailOrGraph(token) {
    if (token.type !== ">>") {
      if (this._supportsQuads && this._graph === null && (this._graph = this._readEntity(token)) !== void 0)
        return this._readRDFStarTail;
      return this._error(`Expected >> to follow "${this._object.id}"`, token);
    }
    return this._readRDFStarTail(token);
  }
  // ### `_readRDFStarTail` reads the end of a nested RDF* triple
  _readRDFStarTail(token) {
    if (token.type !== ">>")
      return this._error(`Expected >> but got ${token.type}`, token);
    const quad4 = this._quad(
      this._subject,
      this._predicate,
      this._object,
      this._graph || this.DEFAULTGRAPH
    );
    this._restoreContext("<<", token);
    if (this._subject === null) {
      this._subject = quad4;
      return this._readPredicate;
    } else {
      this._object = quad4;
      return this._getContextEndReader();
    }
  }
  // ### `_getContextEndReader` gets the next reader function at the end of a context
  _getContextEndReader() {
    const contextStack = this._contextStack;
    if (!contextStack.length)
      return this._readPunctuation;
    switch (contextStack[contextStack.length - 1].type) {
      case "blank":
        return this._readBlankNodeTail;
      case "list":
        return this._readListItem;
      case "formula":
        return this._readFormulaTail;
      case "<<":
        return this._readRDFStarTailOrGraph;
    }
  }
  // ### `_emit` sends a quad through the callback
  _emit(subject, predicate, object, graph3) {
    this._callback(null, this._quad(subject, predicate, object, graph3 || this.DEFAULTGRAPH));
  }
  // ### `_error` emits an error message through the callback
  _error(message, token) {
    const err = new Error(`${message} on line ${token.line}.`);
    err.context = {
      token,
      line: token.line,
      previousToken: this._lexer.previousToken
    };
    this._callback(err);
    this._callback = noop;
  }
  // ### `_resolveIRI` resolves an IRI against the base path
  _resolveIRI(iri) {
    return /^[a-z][a-z0-9+.-]*:/i.test(iri) ? iri : this._resolveRelativeIRI(iri);
  }
  // ### `_resolveRelativeIRI` resolves an IRI against the base path,
  // assuming that a base path has been set and that the IRI is indeed relative
  _resolveRelativeIRI(iri) {
    if (!iri.length)
      return this._base;
    switch (iri[0]) {
      // Resolve relative fragment IRIs against the base IRI
      case "#":
        return this._base + iri;
      // Resolve relative query string IRIs by replacing the query string
      case "?":
        return this._base.replace(/(?:\?.*)?$/, iri);
      // Resolve root-relative IRIs at the root of the base IRI
      case "/":
        return (iri[1] === "/" ? this._baseScheme : this._baseRoot) + this._removeDotSegments(iri);
      // Resolve all other IRIs at the base IRI's path
      default:
        return /^[^/:]*:/.test(iri) ? null : this._removeDotSegments(this._basePath + iri);
    }
  }
  // ### `_removeDotSegments` resolves './' and '../' path segments in an IRI as per RFC3986
  _removeDotSegments(iri) {
    if (!/(^|\/)\.\.?($|[/#?])/.test(iri))
      return iri;
    const length = iri.length;
    let result = "", i = -1, pathStart = -1, segmentStart = 0, next = "/";
    while (i < length) {
      switch (next) {
        // The path starts with the first slash after the authority
        case ":":
          if (pathStart < 0) {
            if (iri[++i] === "/" && iri[++i] === "/")
              while ((pathStart = i + 1) < length && iri[pathStart] !== "/")
                i = pathStart;
          }
          break;
        // Don't modify a query string or fragment
        case "?":
        case "#":
          i = length;
          break;
        // Handle '/.' or '/..' path segments
        case "/":
          if (iri[i + 1] === ".") {
            next = iri[++i + 1];
            switch (next) {
              // Remove a '/.' segment
              case "/":
                result += iri.substring(segmentStart, i - 1);
                segmentStart = i + 1;
                break;
              // Remove a trailing '/.' segment
              case void 0:
              case "?":
              case "#":
                return result + iri.substring(segmentStart, i) + iri.substr(i + 1);
              // Remove a '/..' segment
              case ".":
                next = iri[++i + 1];
                if (next === void 0 || next === "/" || next === "?" || next === "#") {
                  result += iri.substring(segmentStart, i - 2);
                  if ((segmentStart = result.lastIndexOf("/")) >= pathStart)
                    result = result.substr(0, segmentStart);
                  if (next !== "/")
                    return `${result}/${iri.substr(i + 1)}`;
                  segmentStart = i + 1;
                }
            }
          }
      }
      next = iri[++i];
    }
    return result + iri.substring(segmentStart);
  }
  // ## Public methods
  // ### `parse` parses the N3 input and emits each parsed quad through the callback
  parse(input, quadCallback, prefixCallback) {
    this._readCallback = this._readInTopContext;
    this._sparqlStyle = false;
    this._prefixes = /* @__PURE__ */ Object.create(null);
    this._prefixes._ = this._blankNodePrefix ? this._blankNodePrefix.substr(2) : `b${blankNodePrefix++}_`;
    this._prefixCallback = prefixCallback || noop;
    this._inversePredicate = false;
    this._quantified = /* @__PURE__ */ Object.create(null);
    if (!quadCallback) {
      const quads = [];
      let error2;
      this._callback = (e, t) => {
        e ? error2 = e : t && quads.push(t);
      };
      this._lexer.tokenize(input).every((token) => {
        return this._readCallback = this._readCallback(token);
      });
      if (error2) throw error2;
      return quads;
    }
    this._callback = quadCallback;
    this._lexer.tokenize(input, (error2, token) => {
      if (error2 !== null)
        this._callback(error2), this._callback = noop;
      else if (this._readCallback)
        this._readCallback = this._readCallback(token);
    });
  }
};
function noop() {
}
function initDataFactory(parser, factory) {
  const namedNode4 = factory.namedNode;
  parser._namedNode = namedNode4;
  parser._blankNode = factory.blankNode;
  parser._literal = factory.literal;
  parser._variable = factory.variable;
  parser._quad = factory.quad;
  parser.DEFAULTGRAPH = factory.defaultGraph();
  parser.RDF_FIRST = namedNode4(IRIs_default.rdf.first);
  parser.RDF_REST = namedNode4(IRIs_default.rdf.rest);
  parser.RDF_NIL = namedNode4(IRIs_default.rdf.nil);
  parser.N3_FORALL = namedNode4(IRIs_default.r.forAll);
  parser.N3_FORSOME = namedNode4(IRIs_default.r.forSome);
  parser.ABBREVIATIONS = {
    "a": namedNode4(IRIs_default.rdf.type),
    "=": namedNode4(IRIs_default.owl.sameAs),
    ">": namedNode4(IRIs_default.log.implies)
  };
  parser.QUANTIFIERS_GRAPH = namedNode4("urn:n3:quantifiers");
}
initDataFactory(N3Parser.prototype, N3DataFactory_default);

// ../node_modules/rdflib/esm/rdfaparser.js
if (typeof Node3 === "undefined") {
  Node3 = {
    ELEMENT_NODE: 1,
    ATTRIBUTE_NODE: 2,
    TEXT_NODE: 3,
    CDATA_SECTION_NODE: 4,
    ENTITY_REFERENCE_NODE: 5,
    ENTITY_NODE: 6,
    PROCESSING_INSTRUCTION_NODE: 7,
    COMMENT_NODE: 8,
    DOCUMENT_NODE: 9,
    DOCUMENT_TYPE_NODE: 10,
    DOCUMENT_FRAGMENT_NODE: 11,
    NOTATION_NODE: 12
  };
}
var Node3;
var RDFaProcessor = /* @__PURE__ */ function() {
  function RDFaProcessor2(kb, options) {
    _classCallCheck(this, RDFaProcessor2);
    this.options = options || {};
    this.kb = kb;
    this.target = options.target || {
      graph: {
        subjects: {},
        prefixes: {},
        terms: {}
      }
    };
    this.blankNodes = [];
    this.htmlOptions = {
      "selfClosing": "br img input area base basefont col colgroup source wbr isindex link meta param hr"
    };
    this.theOne = "_:" + (/* @__PURE__ */ new Date()).getTime();
    this.language = null;
    this.vocabulary = null;
    this.blankCounter = 0;
    this.langAttributes = [{
      namespaceURI: "http://www.w3.org/XML/1998/namespace",
      localName: "lang"
    }];
    this.inXHTMLMode = false;
    this.absURIRE = /[\w\_\-]+:\S+/;
    this.finishedHandlers = [];
    this.init();
  }
  return _createClass(RDFaProcessor2, [{
    key: "addTriple",
    value: function addTriple(origin, subject, predicate, object) {
      var su, ob, pr, or;
      if (typeof subject === "undefined") {
        su = canonical_data_factory_default.namedNode(this.options.base);
      } else {
        su = this.toRDFNodeObject(subject);
      }
      pr = this.toRDFNodeObject(predicate);
      ob = this.toRDFNodeObject(object);
      or = canonical_data_factory_default.namedNode(this.options.base);
      this.kb.add(su, pr, ob, or);
    }
  }, {
    key: "ancestorPath",
    value: function ancestorPath(node) {
      var path = "";
      while (node && node.nodeType !== Node3.DOCUMENT_NODE) {
        path = "/" + node.localName + path;
        node = node.parentNode;
      }
      return path;
    }
  }, {
    key: "copyMappings",
    value: function copyMappings(mappings) {
      var newMappings = {};
      for (var k in mappings) {
        newMappings[k] = mappings[k];
      }
      return newMappings;
    }
  }, {
    key: "copyProperties",
    value: function copyProperties() {
    }
  }, {
    key: "deriveDateTimeType",
    value: function deriveDateTimeType(value) {
      for (var i = 0; i < RDFaProcessor2.dateTimeTypes.length; i++) {
        var matched = RDFaProcessor2.dateTimeTypes[i].pattern.exec(value);
        if (matched && matched[0].length === value.length) {
          return RDFaProcessor2.dateTimeTypes[i].type;
        }
      }
      return null;
    }
  }, {
    key: "init",
    value: function init() {
    }
  }, {
    key: "newBlankNode",
    value: function newBlankNode() {
      this.blankCounter++;
      return "_:" + this.blankCounter;
    }
  }, {
    key: "newSubjectOrigin",
    value: function newSubjectOrigin(origin, subject) {
    }
  }, {
    key: "parseCURIE",
    value: function parseCURIE(value, prefixes, base) {
      var colon = value.indexOf(":");
      var uri;
      if (colon >= 0) {
        var prefix = value.substring(0, colon);
        if (prefix === "") {
          uri = prefixes[""];
          return uri ? uri + value.substring(colon + 1) : null;
        } else if (prefix === "_") {
          return "_:" + value.substring(colon + 1);
        } else if (RDFaProcessor2.NCNAME.test(prefix)) {
          uri = prefixes[prefix];
          if (uri) {
            return uri + value.substring(colon + 1);
          }
        }
      }
      return null;
    }
  }, {
    key: "parseCURIEOrURI",
    value: function parseCURIEOrURI(value, prefixes, base) {
      var curie = this.parseCURIE(value, prefixes, base);
      if (curie) {
        return curie;
      }
      return this.resolveAndNormalize(base, value);
    }
  }, {
    key: "parsePredicate",
    value: function parsePredicate(value, defaultVocabulary, terms, prefixes, base, ignoreTerms) {
      if (value === "") {
        return null;
      }
      var predicate = this.parseTermOrCURIEOrAbsURI(value, defaultVocabulary, ignoreTerms ? null : terms, prefixes, base);
      if (predicate && predicate.indexOf("_:") === 0) {
        return null;
      }
      return predicate;
    }
  }, {
    key: "parsePrefixMappings",
    value: function parsePrefixMappings(str, target) {
      var values = this.tokenize(str);
      var prefix = null;
      for (var i = 0; i < values.length; i++) {
        if (values[i][values[i].length - 1] === ":") {
          prefix = values[i].substring(0, values[i].length - 1);
        } else if (prefix) {
          target[prefix] = this.options.base ? join(values[i], this.options.base) : values[i];
          prefix = null;
        }
      }
    }
  }, {
    key: "parseSafeCURIEOrCURIEOrURI",
    value: function parseSafeCURIEOrCURIEOrURI(value, prefixes, base) {
      value = this.trim(value);
      if (value.charAt(0) === "[" && value.charAt(value.length - 1) === "]") {
        value = value.substring(1, value.length - 1);
        value = value.trim(value);
        if (value.length === 0) {
          return null;
        }
        if (value === "_:") {
          return this.theOne;
        }
        return this.parseCURIE(value, prefixes, base);
      } else {
        return this.parseCURIEOrURI(value, prefixes, base);
      }
    }
  }, {
    key: "parseTermOrCURIEOrAbsURI",
    value: function parseTermOrCURIEOrAbsURI(value, defaultVocabulary, terms, prefixes, base) {
      value = this.trim(value);
      var curie = this.parseCURIE(value, prefixes, base);
      if (curie) {
        return curie;
      } else if (terms) {
        if (defaultVocabulary && !this.absURIRE.exec(value)) {
          return defaultVocabulary + value;
        }
        var term2 = terms[value];
        if (term2) {
          return term2;
        }
        var lcvalue = value.toLowerCase();
        term2 = terms[lcvalue];
        if (term2) {
          return term2;
        }
      }
      if (this.absURIRE.exec(value)) {
        return this.resolveAndNormalize(base, value);
      }
      return null;
    }
  }, {
    key: "parseTermOrCURIEOrURI",
    value: function parseTermOrCURIEOrURI(value, defaultVocabulary, terms, prefixes, base) {
      value = this.trim(value);
      var curie = this.parseCURIE(value, prefixes, base);
      if (curie) {
        return curie;
      } else {
        var term2 = terms[value];
        if (term2) {
          return term2;
        }
        var lcvalue = value.toLowerCase();
        term2 = terms[lcvalue];
        if (term2) {
          return term2;
        }
        if (defaultVocabulary && !this.absURIRE.exec(value)) {
          return defaultVocabulary + value;
        }
      }
      return this.resolveAndNormalize(base, value);
    }
  }, {
    key: "parseURI",
    value: function parseURI(uri) {
      return uri;
    }
  }, {
    key: "process",
    value: function process(node, options) {
      options = options || {};
      var base;
      if (node.nodeType === Node3.DOCUMENT_NODE) {
        if (node.baseURI && !options.baseURI) {
          options.baseURI = node.baseURI;
        }
        base = node.baseURI;
        node = node.documentElement;
        if (!node.baseURI) {
          node.baseURI = base;
        }
        this.setContext(node);
      } else if (node.parentNode.nodeType === Node3.DOCUMENT_NODE) {
        this.setContext(node);
      }
      var queue = [];
      var removeHash = function removeHash2(baseURI) {
        if (!baseURI && options && options.baseURI) {
          return options.baseURI;
        }
        var hash = baseURI.indexOf("#");
        if (hash >= 0) {
          baseURI = baseURI.substring(0, hash);
        }
        if (options && options.baseURIMap) {
          baseURI = options.baseURIMap(baseURI);
        }
        return baseURI;
      };
      queue.push({
        current: node,
        context: this.push(null, removeHash(node.baseURI))
      });
      while (queue.length > 0) {
        var item = queue.shift();
        if (item.parent) {
          if (item.context.parent && item.context.parent.listMapping === item.listMapping) {
            continue;
          }
          for (var _predicate in item.listMapping) {
            var list = item.listMapping[_predicate];
            if (list.length === 0) {
              this.addTriple(item.parent, item.subject, _predicate, {
                type: RDFaProcessor2.objectURI,
                value: "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
              });
              continue;
            }
            var bnodes = [];
            for (var _i = 0; _i < list.length; _i++) {
              bnodes.push(this.newBlankNode());
            }
            for (var _i2 = 0; _i2 < bnodes.length; _i2++) {
              this.addTriple(item.parent, bnodes[_i2], "http://www.w3.org/1999/02/22-rdf-syntax-ns#first", list[_i2]);
              this.addTriple(item.parent, bnodes[_i2], "http://www.w3.org/1999/02/22-rdf-syntax-ns#rest", {
                type: RDFaProcessor2.objectURI,
                value: _i2 + 1 < bnodes.length ? bnodes[_i2 + 1] : "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
              });
            }
            this.addTriple(item.parent, item.subject, _predicate, {
              type: RDFaProcessor2.objectURI,
              value: bnodes[0]
            });
          }
          continue;
        }
        var current = item.current;
        var context = item.context;
        var skip = false;
        var newSubject = null;
        var currentObjectResource = null;
        var typedResource = null;
        var prefixes = context.prefixes;
        var prefixesCopied = false;
        var incomplete = [];
        var listMapping = context.listMapping;
        var listMappingDifferent = !context.parent;
        var language = context.language;
        var vocabulary = context.vocabulary;
        base = this.parseURI(removeHash(current.baseURI));
        current.item = null;
        var vocabAtt = current.getAttributeNode("vocab");
        if (vocabAtt) {
          var value = this.trim(vocabAtt.value);
          if (value.length > 0) {
            vocabulary = value;
            var baseSubject = base.spec;
            this.addTriple(current, baseSubject, "http://www.w3.org/ns/rdfa#usesVocabulary", {
              type: RDFaProcessor2.objectURI,
              value: vocabulary
            });
          } else {
            vocabulary = this.vocabulary;
          }
        }
        for (var i = 0; i < current.attributes.length; i++) {
          var att = current.attributes[i];
          if (att.nodeName.charAt(0) === "x" && att.nodeName.indexOf("xmlns:") === 0) {
            if (!prefixesCopied) {
              prefixes = this.copyMappings(prefixes);
              prefixesCopied = true;
            }
            var prefix = att.nodeName.substring(6);
            var ref = RDFaProcessor2.trim(att.value);
            prefixes[prefix] = this.options.base ? join(ref, this.options.base) : ref;
          }
        }
        var prefixAtt = current.getAttributeNode("prefix");
        if (prefixAtt) {
          if (!prefixesCopied) {
            prefixes = this.copyMappings(prefixes);
            prefixesCopied = true;
          }
          this.parsePrefixMappings(prefixAtt.value, prefixes);
        }
        var xmlLangAtt = null;
        for (var _i3 = 0; !xmlLangAtt && _i3 < this.langAttributes.length; _i3++) {
          xmlLangAtt = current.getAttributeNodeNS(this.langAttributes[_i3].namespaceURI, this.langAttributes[_i3].localName);
        }
        if (xmlLangAtt) {
          var _value = RDFaProcessor2.trim(xmlLangAtt.value);
          if (_value.length > 0) {
            language = _value;
          } else {
            language = null;
          }
        }
        var relAtt = current.getAttributeNode("rel");
        var revAtt = current.getAttributeNode("rev");
        var typeofAtt = current.getAttributeNode("typeof");
        var propertyAtt = current.getAttributeNode("property");
        var datatypeAtt = current.getAttributeNode("datatype");
        var datetimeAtt = this.inHTMLMode ? current.getAttributeNode("datetime") : null;
        var contentAtt = current.getAttributeNode("content");
        var aboutAtt = current.getAttributeNode("about");
        var srcAtt = current.getAttributeNode("src");
        var resourceAtt = current.getAttributeNode("resource");
        var hrefAtt = current.getAttributeNode("href");
        var inlistAtt = current.getAttributeNode("inlist");
        var relAttPredicates = [];
        var predicate, values;
        if (relAtt) {
          values = this.tokenize(relAtt.value);
          for (var _i4 = 0; _i4 < values.length; _i4++) {
            predicate = this.parsePredicate(values[_i4], vocabulary, context.terms, prefixes, base, this.inHTMLMode && propertyAtt !== null);
            if (predicate) {
              relAttPredicates.push(predicate);
            }
          }
        }
        var revAttPredicates = [];
        if (revAtt) {
          values = this.tokenize(revAtt.value);
          for (var _i5 = 0; _i5 < values.length; _i5++) {
            predicate = this.parsePredicate(values[_i5], vocabulary, context.terms, prefixes, base, this.inHTMLMode && propertyAtt);
            if (predicate) {
              revAttPredicates.push(predicate);
            }
          }
        }
        if (this.inHTMLMode && (relAtt || revAtt) && propertyAtt) {
          if (relAttPredicates.length === 0) {
            relAtt = null;
          }
          if (revAttPredicates.length === 0) {
            revAtt = null;
          }
        }
        if (relAtt || revAtt) {
          if (aboutAtt) {
            newSubject = this.parseSafeCURIEOrCURIEOrURI(aboutAtt.value, prefixes, base);
          }
          if (typeofAtt) {
            typedResource = newSubject;
          }
          if (!newSubject) {
            if (current.parentNode.nodeType === Node3.DOCUMENT_NODE) {
              newSubject = removeHash(current.baseURI);
            } else if (context.parentObject) {
              newSubject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
            }
          }
          if (resourceAtt) {
            currentObjectResource = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes, base);
          }
          if (!currentObjectResource) {
            if (hrefAtt) {
              currentObjectResource = this.resolveAndNormalize(base, encodeURI(hrefAtt.value));
            } else if (srcAtt) {
              currentObjectResource = this.resolveAndNormalize(base, encodeURI(srcAtt.value));
            } else if (typeofAtt && !aboutAtt && !(this.inXHTMLMode && (current.localName === "head" || current.localName === "body"))) {
              currentObjectResource = this.newBlankNode();
            }
          }
          if (typeofAtt && !aboutAtt && this.inXHTMLMode && (current.localName === "head" || current.localName === "body")) {
            typedResource = newSubject;
          } else if (typeofAtt && !aboutAtt) {
            typedResource = currentObjectResource;
          }
        } else if (propertyAtt && !contentAtt && !datatypeAtt) {
          if (aboutAtt) {
            newSubject = this.parseSafeCURIEOrCURIEOrURI(aboutAtt.value, prefixes, base);
            if (typeofAtt) {
              typedResource = newSubject;
            }
          }
          if (!newSubject && current.parentNode.nodeType === Node3.DOCUMENT_NODE) {
            newSubject = removeHash(current.baseURI);
            if (typeofAtt) {
              typedResource = newSubject;
            }
          } else if (!newSubject && context.parentObject) {
            newSubject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
          }
          if (typeofAtt && !typedResource) {
            if (resourceAtt) {
              typedResource = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes, base);
            }
            if (!typedResource && hrefAtt) {
              typedResource = this.resolveAndNormalize(base, encodeURI(hrefAtt.value));
            }
            if (!typedResource && srcAtt) {
              typedResource = this.resolveAndNormalize(base, encodeURI(srcAtt.value));
            }
            if (!typedResource && (this.inXHTMLMode || this.inHTMLMode) && (current.localName === "head" || current.localName === "body")) {
              typedResource = newSubject;
            }
            if (!typedResource) {
              typedResource = this.newBlankNode();
            }
            currentObjectResource = typedResource;
          }
        } else {
          if (aboutAtt) {
            newSubject = this.parseSafeCURIEOrCURIEOrURI(aboutAtt.value, prefixes, base);
          }
          if (!newSubject && resourceAtt) {
            newSubject = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes, base);
          }
          if (!newSubject && hrefAtt) {
            newSubject = this.resolveAndNormalize(base, encodeURI(hrefAtt.value));
          }
          if (!newSubject && srcAtt) {
            newSubject = this.resolveAndNormalize(base, encodeURI(srcAtt.value));
          }
          if (!newSubject) {
            if (current.parentNode.nodeType === Node3.DOCUMENT_NODE) {
              newSubject = removeHash(current.baseURI);
            } else if ((this.inXHTMLMode || this.inHTMLMode) && (current.localName === "head" || current.localName === "body")) {
              newSubject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
            } else if (typeofAtt) {
              newSubject = this.newBlankNode();
            } else if (context.parentObject) {
              newSubject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
              if (!propertyAtt) {
                skip = true;
              }
            }
          }
          if (typeofAtt) {
            typedResource = newSubject;
          }
        }
        if (newSubject) {
          if (aboutAtt || resourceAtt || typedResource) {
            var id3 = newSubject;
            if (typeofAtt && !aboutAtt && !resourceAtt && currentObjectResource) {
              id3 = currentObjectResource;
            }
            this.newSubjectOrigin(current, id3);
          }
        }
        if (typedResource) {
          values = this.tokenize(typeofAtt.value);
          for (var _i6 = 0; _i6 < values.length; _i6++) {
            var object = this.parseTermOrCURIEOrAbsURI(values[_i6], vocabulary, context.terms, prefixes, base);
            if (object) {
              this.addTriple(current, typedResource, RDFaProcessor2.typeURI, {
                type: RDFaProcessor2.objectURI,
                value: object
              });
            }
          }
        }
        if (newSubject && newSubject !== context.parentObject) {
          listMapping = {};
          listMappingDifferent = true;
        }
        if (currentObjectResource) {
          if (relAtt && inlistAtt) {
            for (var _i7 = 0; _i7 < relAttPredicates.length; _i7++) {
              var _list = listMapping[relAttPredicates[_i7]];
              if (!_list) {
                _list = [];
                listMapping[relAttPredicates[_i7]] = _list;
              }
              _list.push({
                type: RDFaProcessor2.objectURI,
                value: currentObjectResource
              });
            }
          } else if (relAtt) {
            for (var _i8 = 0; _i8 < relAttPredicates.length; _i8++) {
              this.addTriple(current, newSubject, relAttPredicates[_i8], {
                type: RDFaProcessor2.objectURI,
                value: currentObjectResource
              });
            }
          }
          if (revAtt) {
            for (var _i9 = 0; _i9 < revAttPredicates.length; _i9++) {
              this.addTriple(current, currentObjectResource, revAttPredicates[_i9], {
                type: RDFaProcessor2.objectURI,
                value: newSubject
              });
            }
          }
        } else {
          if (newSubject && !currentObjectResource && (relAtt || revAtt)) {
            currentObjectResource = this.newBlankNode();
          }
          if (relAtt && inlistAtt) {
            for (var _i10 = 0; _i10 < relAttPredicates.length; _i10++) {
              var _list2 = listMapping[relAttPredicates[_i10]];
              if (!_list2) {
                _list2 = [];
                listMapping[predicate] = _list2;
              }
              incomplete.push({
                predicate: relAttPredicates[_i10],
                list: _list2
              });
            }
          } else if (relAtt) {
            for (var _i11 = 0; _i11 < relAttPredicates.length; _i11++) {
              incomplete.push({
                predicate: relAttPredicates[_i11],
                forward: true
              });
            }
          }
          if (revAtt) {
            for (var _i12 = 0; _i12 < revAttPredicates.length; _i12++) {
              incomplete.push({
                predicate: revAttPredicates[_i12],
                forward: false
              });
            }
          }
        }
        if (propertyAtt) {
          var datatype = null;
          var content = null;
          if (datatypeAtt) {
            datatype = datatypeAtt.value === "" ? RDFaProcessor2.PlainLiteralURI : this.parseTermOrCURIEOrAbsURI(datatypeAtt.value, vocabulary, context.terms, prefixes, base);
            if (datetimeAtt && !contentAtt) {
              content = datetimeAtt.value;
            } else {
              content = datatype === RDFaProcessor2.XMLLiteralURI || datatype === RDFaProcessor2.HTMLLiteralURI ? null : contentAtt ? contentAtt.value : current.textContent;
            }
          } else if (contentAtt) {
            datatype = RDFaProcessor2.PlainLiteralURI;
            content = contentAtt.value;
          } else if (datetimeAtt) {
            content = datetimeAtt.value;
            datatype = RDFaProcessor2.deriveDateTimeType(content);
            if (!datatype) {
              datatype = RDFaProcessor2.PlainLiteralURI;
            }
          } else if (!relAtt && !revAtt) {
            if (resourceAtt) {
              content = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes, base);
            }
            if (!content && hrefAtt) {
              content = this.resolveAndNormalize(base, encodeURI(hrefAtt.value));
            } else if (!content && srcAtt) {
              content = this.resolveAndNormalize(base, encodeURI(srcAtt.value));
            }
            if (content) {
              datatype = RDFaProcessor2.objectURI;
            }
          }
          if (!datatype) {
            if (typeofAtt && !aboutAtt) {
              datatype = RDFaProcessor2.objectURI;
              content = typedResource;
            } else {
              content = current.textContent;
              if (this.inHTMLMode && current.localName === "time") {
                datatype = RDFaProcessor2.deriveDateTimeType(content);
              }
              if (!datatype) {
                datatype = RDFaProcessor2.PlainLiteralURI;
              }
            }
          }
          values = this.tokenize(propertyAtt.value);
          for (var _i13 = 0; _i13 < values.length; _i13++) {
            var _predicate2 = this.parsePredicate(values[_i13], vocabulary, context.terms, prefixes, base);
            if (_predicate2) {
              if (inlistAtt) {
                var _list3 = listMapping[_predicate2];
                if (!_list3) {
                  _list3 = [];
                  listMapping[_predicate2] = _list3;
                }
                _list3.push(datatype === RDFaProcessor2.XMLLiteralURI || datatype === RDFaProcessor2.HTMLLiteralURI ? {
                  type: datatype,
                  value: current.childNodes
                } : {
                  type: datatype || RDFaProcessor2.PlainLiteralURI,
                  value: content,
                  language
                });
              } else {
                if (datatype === RDFaProcessor2.XMLLiteralURI || datatype === RDFaProcessor2.HTMLLiteralURI) {
                  this.addTriple(current, newSubject, _predicate2, {
                    type: datatype,
                    value: current.childNodes
                  });
                } else {
                  this.addTriple(current, newSubject, _predicate2, {
                    type: datatype || RDFaProcessor2.PlainLiteralURI,
                    value: content,
                    language
                  });
                }
              }
            }
          }
        }
        if (newSubject && !skip) {
          for (var _i14 = 0; _i14 < context.incomplete.length; _i14++) {
            if (context.incomplete[_i14].list) {
              context.incomplete[_i14].list.push({
                type: RDFaProcessor2.objectURI,
                value: newSubject
              });
            } else if (context.incomplete[_i14].forward) {
              this.addTriple(current, context.subject, context.incomplete[_i14].predicate, {
                type: RDFaProcessor2.objectURI,
                value: newSubject
              });
            } else {
              this.addTriple(current, newSubject, context.incomplete[_i14].predicate, {
                type: RDFaProcessor2.objectURI,
                value: context.subject
              });
            }
          }
        }
        var childContext = null;
        var listSubject = newSubject;
        if (skip) {
          childContext = this.push(context, context.subject);
          childContext.parentObject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
          childContext.incomplete = context.incomplete;
          childContext.language = language;
          childContext.prefixes = prefixes;
          childContext.vocabulary = vocabulary;
        } else {
          childContext = this.push(context, newSubject);
          childContext.parentObject = currentObjectResource || newSubject || context.subject;
          childContext.prefixes = prefixes;
          childContext.incomplete = incomplete;
          if (currentObjectResource) {
            listSubject = currentObjectResource;
            listMapping = {};
            listMappingDifferent = true;
          }
          childContext.listMapping = listMapping;
          childContext.language = language;
          childContext.vocabulary = vocabulary;
        }
        if (listMappingDifferent) {
          queue.unshift({
            parent: current,
            context,
            subject: listSubject,
            listMapping
          });
        }
        for (var child = current.lastChild; child; child = child.previousSibling) {
          if (child.nodeType === Node3.ELEMENT_NODE) {
            queue.unshift({
              current: child,
              context: childContext
            });
          }
        }
      }
      if (this.inHTMLMode) {
        this.copyProperties();
      }
      for (var _i15 = 0; _i15 < this.finishedHandlers.length; _i15++) {
        this.finishedHandlers[_i15](node);
      }
    }
  }, {
    key: "push",
    value: function push(parent, subject) {
      return {
        parent,
        subject: subject || (parent ? parent.subject : null),
        parentObject: null,
        incomplete: [],
        listMapping: parent ? parent.listMapping : {},
        language: parent ? parent.language : this.language,
        prefixes: parent ? parent.prefixes : this.target.graph.prefixes,
        terms: parent ? parent.terms : this.target.graph.terms,
        vocabulary: parent ? parent.vocabulary : this.vocabulary
      };
    }
  }, {
    key: "resolveAndNormalize",
    value: function resolveAndNormalize(base, uri) {
      return join(uri, base);
    }
  }, {
    key: "setContext",
    value: function setContext(node) {
      if (node.localName === "html" && node.getAttribute("version") === "XHTML+RDFa 1.1") {
        this.setXHTMLContext();
      } else if (node.localName === "html" || node.namespaceURI === "http://www.w3.org/1999/xhtml") {
        if (typeof document !== "undefined" && document.doctype) {
          if (document.doctype.publicId === "-//W3C//DTD XHTML+RDFa 1.0//EN" && document.doctype.systemId === "http://www.w3.org/MarkUp/DTD/xhtml-rdfa-1.dtd") {
            console.log("WARNING: RDF 1.0 is not supported.  Defaulting to HTML5 mode.");
            this.setHTMLContext();
          } else if (document.doctype.publicId === "-//W3C//DTD XHTML+RDFa 1.1//EN" && document.doctype.systemId === "http://www.w3.org/MarkUp/DTD/xhtml-rdfa-2.dtd") {
            this.setXHTMLContext();
          } else {
            this.setHTMLContext();
          }
        } else {
          this.setHTMLContext();
        }
      } else {
        this.setXMLContext();
      }
    }
  }, {
    key: "setHTMLContext",
    value: function setHTMLContext() {
      this.setInitialContext();
      this.langAttributes = [{
        namespaceURI: "http://www.w3.org/XML/1998/namespace",
        localName: "lang"
      }, {
        namespaceURI: null,
        localName: "lang"
      }];
      this.inXHTMLMode = false;
      this.inHTMLMode = true;
    }
  }, {
    key: "setInitialContext",
    value: function setInitialContext() {
      this.vocabulary = null;
      this.langAttributes = [{
        namespaceURI: "http://www.w3.org/XML/1998/namespace",
        localName: "lang"
      }];
    }
  }, {
    key: "setXHTMLContext",
    value: function setXHTMLContext() {
      this.setInitialContext();
      this.inXHTMLMode = true;
      this.inHTMLMode = false;
      this.langAttributes = [{
        namespaceURI: "http://www.w3.org/XML/1998/namespace",
        localName: "lang"
      }, {
        namespaceURI: null,
        localName: "lang"
      }];
      this.target.graph.terms["alternate"] = "http://www.w3.org/1999/xhtml/vocab#alternate";
      this.target.graph.terms["appendix"] = "http://www.w3.org/1999/xhtml/vocab#appendix";
      this.target.graph.terms["bookmark"] = "http://www.w3.org/1999/xhtml/vocab#bookmark";
      this.target.graph.terms["cite"] = "http://www.w3.org/1999/xhtml/vocab#cite";
      this.target.graph.terms["chapter"] = "http://www.w3.org/1999/xhtml/vocab#chapter";
      this.target.graph.terms["contents"] = "http://www.w3.org/1999/xhtml/vocab#contents";
      this.target.graph.terms["copyright"] = "http://www.w3.org/1999/xhtml/vocab#copyright";
      this.target.graph.terms["first"] = "http://www.w3.org/1999/xhtml/vocab#first";
      this.target.graph.terms["glossary"] = "http://www.w3.org/1999/xhtml/vocab#glossary";
      this.target.graph.terms["help"] = "http://www.w3.org/1999/xhtml/vocab#help";
      this.target.graph.terms["icon"] = "http://www.w3.org/1999/xhtml/vocab#icon";
      this.target.graph.terms["index"] = "http://www.w3.org/1999/xhtml/vocab#index";
      this.target.graph.terms["last"] = "http://www.w3.org/1999/xhtml/vocab#last";
      this.target.graph.terms["license"] = "http://www.w3.org/1999/xhtml/vocab#license";
      this.target.graph.terms["meta"] = "http://www.w3.org/1999/xhtml/vocab#meta";
      this.target.graph.terms["next"] = "http://www.w3.org/1999/xhtml/vocab#next";
      this.target.graph.terms["prev"] = "http://www.w3.org/1999/xhtml/vocab#prev";
      this.target.graph.terms["previous"] = "http://www.w3.org/1999/xhtml/vocab#previous";
      this.target.graph.terms["section"] = "http://www.w3.org/1999/xhtml/vocab#section";
      this.target.graph.terms["stylesheet"] = "http://www.w3.org/1999/xhtml/vocab#stylesheet";
      this.target.graph.terms["subsection"] = "http://www.w3.org/1999/xhtml/vocab#subsection";
      this.target.graph.terms["start"] = "http://www.w3.org/1999/xhtml/vocab#start";
      this.target.graph.terms["top"] = "http://www.w3.org/1999/xhtml/vocab#top";
      this.target.graph.terms["up"] = "http://www.w3.org/1999/xhtml/vocab#up";
      this.target.graph.terms["p3pv1"] = "http://www.w3.org/1999/xhtml/vocab#p3pv1";
      this.target.graph.terms["related"] = "http://www.w3.org/1999/xhtml/vocab#related";
      this.target.graph.terms["role"] = "http://www.w3.org/1999/xhtml/vocab#role";
      this.target.graph.terms["transformation"] = "http://www.w3.org/1999/xhtml/vocab#transformation";
    }
  }, {
    key: "setXMLContext",
    value: function setXMLContext() {
      this.setInitialContext();
      this.inXHTMLMode = false;
      this.inHTMLMode = false;
    }
  }, {
    key: "tokenize",
    value: function tokenize(str) {
      return this.trim(str).split(/\s+/);
    }
  }, {
    key: "toRDFNodeObject",
    value: function toRDFNodeObject(x) {
      var _this = this;
      if (typeof x === "undefined") return void 0;
      if (typeof x === "string") {
        if (x.substring(0, 2) === "_:") {
          if (typeof this.blankNodes[x.substring(2)] === "undefined") {
            this.blankNodes[x.substring(2)] = new BlankNode(x.substring(2));
          }
          return this.blankNodes[x.substring(2)];
        }
        return canonical_data_factory_default.namedNode(x);
      }
      switch (x.type) {
        case RDFaProcessor2.objectURI:
          if (x.value.substring(0, 2) === "_:") {
            if (typeof this.blankNodes[x.value.substring(2)] === "undefined") {
              this.blankNodes[x.value.substring(2)] = new BlankNode(x.value.substring(2));
            }
            return this.blankNodes[x.value.substring(2)];
          }
          return canonical_data_factory_default.namedNode(x.value);
        case RDFaProcessor2.PlainLiteralURI:
          return new Literal(x.value, x.language || "");
        case RDFaProcessor2.XMLLiteralURI:
        case RDFaProcessor2.HTMLLiteralURI:
          var string = "";
          Object.keys(x.value).forEach(function(i) {
            string += domToString(x.value[i], _this.htmlOptions);
          });
          return new Literal(string, "", new NamedNode(x.type));
        default:
          return new Literal(x.value, "", new NamedNode(x.type));
      }
    }
  }, {
    key: "trim",
    value: function trim(str) {
      return str.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
  }], [{
    key: "parseRDFaDOM",
    value: function parseRDFaDOM2(dom, kb, base) {
      var p = new RDFaProcessor2(kb, {
        "base": base
      });
      if (!dom.baseURI) {
        dom.baseURI = base;
      }
      p.process(dom, {
        baseURI: base
      });
    }
  }, {
    key: "tokenize",
    value: function tokenize(str) {
      return this.trim(str).split(/\s+/);
    }
  }, {
    key: "trim",
    value: function trim(str) {
      return str.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
  }]);
}();
RDFaProcessor.XMLLiteralURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#XMLLiteral";
RDFaProcessor.HTMLLiteralURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#HTML";
RDFaProcessor.PlainLiteralURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#PlainLiteral";
RDFaProcessor.objectURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#object";
RDFaProcessor.typeURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
RDFaProcessor.nameChar = "[-A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u10000-\uEFFFF.0-9\xB7\u0300-\u036F\u203F-\u2040]";
RDFaProcessor.nameStartChar = "[A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\xFF\u0100-\u0131\u0134-\u013E\u0141-\u0148\u014A-\u017E\u0180-\u01C3\u01CD-\u01F0\u01F4-\u01F5\u01FA-\u0217\u0250-\u02A8\u02BB-\u02C1\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03CE\u03D0-\u03D6\u03DA\u03DC\u03DE\u03E0\u03E2-\u03F3\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E-\u0481\u0490-\u04C4\u04C7-\u04C8\u04CB-\u04CC\u04D0-\u04EB\u04EE-\u04F5\u04F8-\u04F9\u0531-\u0556\u0559\u0561-\u0586\u05D0-\u05EA\u05F0-\u05F2\u0621-\u063A\u0641-\u064A\u0671-\u06B7\u06BA-\u06BE\u06C0-\u06CE\u06D0-\u06D3\u06D5\u06E5-\u06E6\u0905-\u0939\u093D\u0958-\u0961\u0985-\u098C\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09DC-\u09DD\u09DF-\u09E1\u09F0-\u09F1\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33\u0A35-\u0A36\u0A38-\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8B\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0AE0\u0B05-\u0B0C\u0B0F-\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B36-\u0B39\u0B3D\u0B5C-\u0B5D\u0B5F-\u0B61\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB5\u0BB7-\u0BB9\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C60-\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CDE\u0CE0-\u0CE1\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D28\u0D2A-\u0D39\u0D60-\u0D61\u0E01-\u0E2E\u0E30\u0E32-\u0E33\u0E40-\u0E45\u0E81-\u0E82\u0E84\u0E87-\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA-\u0EAB\u0EAD-\u0EAE\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0F40-\u0F47\u0F49-\u0F69\u10A0-\u10C5\u10D0-\u10F6\u1100\u1102-\u1103\u1105-\u1107\u1109\u110B-\u110C\u110E-\u1112\u113C\u113E\u1140\u114C\u114E\u1150\u1154-\u1155\u1159\u115F-\u1161\u1163\u1165\u1167\u1169\u116D-\u116E\u1172-\u1173\u1175\u119E\u11A8\u11AB\u11AE-\u11AF\u11B7-\u11B8\u11BA\u11BC-\u11C2\u11EB\u11F0\u11F9\u1E00-\u1E9B\u1EA0-\u1EF9\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2126\u212A-\u212B\u212E\u2180-\u2182\u3041-\u3094\u30A1-\u30FA\u3105-\u312C\uAC00-\uD7A3\u4E00-\u9FA5\u3007\u3021-\u3029_]";
RDFaProcessor.NCNAME = new RegExp("^" + RDFaProcessor.nameStartChar + RDFaProcessor.nameChar + "*$");
RDFaProcessor.dateTimeTypes = [{
  pattern: /-?P(?:[0-9]+Y)?(?:[0-9]+M)?(?:[0-9]+D)?(?:T(?:[0-9]+H)?(?:[0-9]+M)?(?:[0-9]+(?:\.[0-9]+)?S)?)?/,
  type: "http://www.w3.org/2001/XMLSchema#duration"
}, {
  pattern: /-?(?:[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9])-[0-9][0-9]-[0-9][0-9]T(?:[0-1][0-9]|2[0-4]):[0-5][0-9]:[0-5][0-9](?:\.[0-9]+)?(?:Z|[+\-][0-9][0-9]:[0-9][0-9])?/,
  type: "http://www.w3.org/2001/XMLSchema#dateTime"
}, {
  pattern: /-?(?:[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9])-[0-9][0-9]-[0-9][0-9](?:Z|[+\-][0-9][0-9]:[0-9][0-9])?/,
  type: "http://www.w3.org/2001/XMLSchema#date"
}, {
  pattern: /(?:[0-1][0-9]|2[0-4]):[0-5][0-9]:[0-5][0-9](?:\.[0-9]+)?(?:Z|[+\-][0-9][0-9]:[0-9][0-9])?/,
  type: "http://www.w3.org/2001/XMLSchema#time"
}, {
  pattern: /-?(?:[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9])-[0-9][0-9]/,
  type: "http://www.w3.org/2001/XMLSchema#gYearMonth"
}, {
  pattern: /-?[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9]/,
  type: "http://www.w3.org/2001/XMLSchema#gYear"
}];
var parseRDFaDOM = RDFaProcessor.parseRDFaDOM;

// ../node_modules/rdflib/esm/rdfxmlparser.js
var RDFParser = /* @__PURE__ */ function() {
  function RDFParser2(store) {
    _classCallCheck(this, RDFParser2);
    this.store = store;
    this.bnodes = {};
    this.why = null;
    this.reify = false;
  }
  return _createClass(RDFParser2, [{
    key: "frameFactory",
    value: (
      /**
       * Frame class for namespace and base URI lookups
       * Base lookups will always resolve because the parser knows
       * the default base.
       *
       * @private
       */
      function frameFactory(parser, parent, element) {
        return {
          "NODE": 1,
          "ARC": 2,
          "parent": parent,
          "parser": parser,
          "store": parser.store,
          "element": element,
          "lastChild": 0,
          "base": null,
          "lang": null,
          "node": null,
          "nodeType": null,
          "listIndex": 1,
          "rdfid": null,
          "datatype": null,
          "collection": false,
          /** Terminate the frame and notify the store that we're done */
          "terminateFrame": function terminateFrame() {
            if (this.collection) {
              this.node.close();
            }
          },
          /** Add a symbol of a certain type to the this frame */
          "addSymbol": function addSymbol(type, uri) {
            uri = join(uri, this.base);
            this.node = this.store.sym(uri);
            this.nodeType = type;
          },
          /** Load any constructed triples into the store */
          "loadTriple": function loadTriple() {
            if (this.parent.parent.collection) {
              this.parent.parent.node.append(this.node);
            } else {
              this.store.add(this.parent.parent.node, this.parent.node, this.node, this.parser.why);
            }
            if (this.parent.rdfid != null) {
              var triple3 = this.store.sym(join("#" + this.parent.rdfid, this.base));
              this.store.add(triple3, this.store.sym(RDFParser2.ns.RDF + "type"), this.store.sym(RDFParser2.ns.RDF + "Statement"), this.parser.why);
              this.store.add(triple3, this.store.sym(RDFParser2.ns.RDF + "subject"), this.parent.parent.node, this.parser.why);
              this.store.add(triple3, this.store.sym(RDFParser2.ns.RDF + "predicate"), this.parent.node, this.parser.why);
              this.store.add(triple3, this.store.sym(RDFParser2.ns.RDF + "object"), this.node, this.parser.why);
            }
          },
          /** Check if it's OK to load a triple */
          "isTripleToLoad": function isTripleToLoad() {
            return this.parent != null && this.parent.parent != null && this.nodeType === this.NODE && this.parent.nodeType === this.ARC && this.parent.parent.nodeType === this.NODE;
          },
          /** Add a symbolic node to this frame */
          "addNode": function addNode(uri) {
            this.addSymbol(this.NODE, uri);
            if (this.isTripleToLoad()) {
              this.loadTriple();
            }
          },
          /** Add a collection node to this frame */
          "addCollection": function addCollection() {
            this.nodeType = this.NODE;
            this.node = this.store.collection();
            this.collection = true;
            if (this.isTripleToLoad()) {
              this.loadTriple();
            }
          },
          /** Add a collection arc to this frame */
          "addCollectionArc": function addCollectionArc() {
            this.nodeType = this.ARC;
          },
          /** Add a bnode to this frame */
          "addBNode": function addBNode(id3) {
            if (id3 != null) {
              if (this.parser.bnodes[id3] != null) {
                this.node = this.parser.bnodes[id3];
              } else {
                this.node = this.parser.bnodes[id3] = this.store.bnode();
              }
            } else {
              this.node = this.store.bnode();
            }
            this.nodeType = this.NODE;
            if (this.isTripleToLoad()) {
              this.loadTriple();
            }
          },
          /** Add an arc or property to this frame */
          "addArc": function addArc(uri) {
            if (uri === RDFParser2.ns.RDF + "li") {
              uri = RDFParser2.ns.RDF + "_" + this.parent.listIndex;
              this.parent.listIndex++;
            }
            this.addSymbol(this.ARC, uri);
          },
          /** Add a literal to this frame */
          "addLiteral": function addLiteral(value) {
            if (this.parent.datatype && this.parent.datatype !== RDFParser2.ns.RDF + "langString") {
              this.node = this.store.literal(value, this.store.sym(this.parent.datatype));
            } else {
              this.node = this.store.literal(value, this.lang);
            }
            this.nodeType = this.NODE;
            if (this.isTripleToLoad()) {
              this.loadTriple();
            }
          }
        };
      }
    )
    // from the OpenLayers source .. needed to get around IE problems.
  }, {
    key: "getAttributeNodeNS",
    value: function getAttributeNodeNS(node, uri, name) {
      var attributeNode = null;
      if (node.getAttributeNodeNS) {
        attributeNode = node.getAttributeNodeNS(uri, name);
      } else {
        var attributes = node.attributes;
        var potentialNode, fullName;
        for (var i = 0; i < attributes.length; ++i) {
          potentialNode = attributes[i];
          if (potentialNode.namespaceURI === uri) {
            fullName = potentialNode.prefix ? potentialNode.prefix + ":" + name : name;
            if (fullName === potentialNode.nodeName) {
              attributeNode = potentialNode;
              break;
            }
          }
        }
      }
      return attributeNode;
    }
    /**
     * Build our initial scope frame and parse the DOM into triples
     * @param {HTMLDocument} document The DOM to parse
     * @param {String} base The base URL to use
     * @param {Object} why The context to which this resource belongs
     */
  }, {
    key: "parse",
    value: function parse3(document3, base, why) {
      var children = document3.childNodes;
      this.cleanParser();
      var root;
      if (document3.nodeType === RDFParser2.nodeType.DOCUMENT) {
        for (var c = 0; c < children.length; c++) {
          if (children[c].nodeType === RDFParser2.nodeType.ELEMENT) {
            root = children[c];
            break;
          }
        }
      } else if (document3.nodeType === RDFParser2.nodeType.ELEMENT) {
        root = document3;
      } else {
        throw new Error("RDFParser: can't find root in " + base + ". Halting. ");
      }
      this.why = why;
      var f = this.frameFactory(this);
      this.base = base;
      f.base = base;
      f.lang = null;
      this.parseDOM(this.buildFrame(f, root));
      return true;
    }
  }, {
    key: "parseDOM",
    value: function parseDOM(frame) {
      var rdfid;
      var elementURI = function(el) {
        var result = "";
        if (el.namespaceURI == null) {
          throw new Error("RDF/XML syntax error: No namespace for " + el.localName + " in " + this.base);
        }
        if (el.namespaceURI) {
          result = result + el.namespaceURI;
        }
        if (el.localName) {
          result = result + el.localName;
        } else if (el.nodeName) {
          if (el.nodeName.indexOf(":") >= 0) result = result + el.nodeName.split(":")[1];
          else result = result + el.nodeName;
        }
        return result;
      }.bind(this);
      var dig = true;
      while (frame.parent) {
        var dom = frame.element;
        var attrs = dom.attributes;
        if (dom.nodeType === RDFParser2.nodeType.TEXT || dom.nodeType === RDFParser2.nodeType.CDATA_SECTION) {
          if (frame.parent.nodeType === frame.NODE) {
            frame.addArc(RDFParser2.ns.RDF + "value");
            frame = this.buildFrame(frame);
          }
          frame.addLiteral(dom.nodeValue);
        } else if (elementURI(dom) !== RDFParser2.ns.RDF + "RDF") {
          if (frame.parent && frame.parent.collection) {
            frame.addCollectionArc();
            frame = this.buildFrame(frame, frame.element);
            frame.parent.element = null;
          }
          if (!frame.parent || !frame.parent.nodeType || frame.parent.nodeType === frame.ARC) {
            var about = this.getAttributeNodeNS(dom, RDFParser2.ns.RDF, "about");
            rdfid = this.getAttributeNodeNS(dom, RDFParser2.ns.RDF, "ID");
            if (about && rdfid) {
              throw new Error("RDFParser: " + dom.nodeName + " has both rdf:id and rdf:about. Halting. Only one of these properties may be specified on a node.");
            }
            if (!about && rdfid) {
              frame.addNode("#" + rdfid.nodeValue);
              dom.removeAttributeNode(rdfid);
            } else if (about == null && rdfid == null) {
              var bnid = this.getAttributeNodeNS(dom, RDFParser2.ns.RDF, "nodeID");
              if (bnid) {
                frame.addBNode(bnid.nodeValue);
                dom.removeAttributeNode(bnid);
              } else {
                frame.addBNode();
              }
            } else {
              frame.addNode(about.nodeValue);
              dom.removeAttributeNode(about);
            }
            var rdftype = this.getAttributeNodeNS(dom, RDFParser2.ns.RDF, "type");
            if (RDFParser2.ns.RDF + "Description" !== elementURI(dom)) {
              rdftype = {
                "nodeValue": elementURI(dom)
              };
            }
            if (rdftype != null) {
              this.store.add(frame.node, this.store.sym(RDFParser2.ns.RDF + "type"), this.store.sym(join(rdftype.nodeValue, frame.base)), this.why);
              if (rdftype.nodeName) {
                dom.removeAttributeNode(rdftype);
              }
            }
            for (var x = attrs.length - 1; x >= 0; x--) {
              this.store.add(frame.node, this.store.sym(elementURI(attrs[x])), this.store.literal(attrs[x].nodeValue, frame.lang), this.why);
            }
          } else {
            frame.addArc(elementURI(dom));
            if (this.reify) {
              rdfid = this.getAttributeNodeNS(dom, RDFParser2.ns.RDF, "ID");
              if (rdfid) {
                frame.rdfid = rdfid.nodeValue;
                dom.removeAttributeNode(rdfid);
              }
            }
            var parsetype = this.getAttributeNodeNS(dom, RDFParser2.ns.RDF, "parseType");
            var datatype = this.getAttributeNodeNS(dom, RDFParser2.ns.RDF, "datatype");
            if (datatype) {
              frame.datatype = datatype.nodeValue;
              dom.removeAttributeNode(datatype);
            }
            if (parsetype) {
              var nv = parsetype.nodeValue;
              if (nv === "Literal") {
                frame.datatype = RDFParser2.ns.RDF + "XMLLiteral";
                frame = this.buildFrame(frame);
                frame.addLiteral(dom.innerHTML || dom.childNodes);
                dig = false;
              } else if (nv === "Resource") {
                frame = this.buildFrame(frame, frame.element);
                frame.parent.element = null;
                frame.addBNode();
              } else if (nv === "Collection") {
                frame = this.buildFrame(frame, frame.element);
                frame.parent.element = null;
                frame.addCollection();
              }
              dom.removeAttributeNode(parsetype);
            }
            if (attrs.length !== 0) {
              var resource = this.getAttributeNodeNS(dom, RDFParser2.ns.RDF, "resource");
              var bnid2 = this.getAttributeNodeNS(dom, RDFParser2.ns.RDF, "nodeID");
              frame = this.buildFrame(frame);
              if (resource) {
                frame.addNode(resource.nodeValue);
                dom.removeAttributeNode(resource);
              } else {
                if (bnid2) {
                  frame.addBNode(bnid2.nodeValue);
                  dom.removeAttributeNode(bnid2);
                } else {
                  frame.addBNode();
                }
              }
              for (var x1 = attrs.length - 1; x1 >= 0; x1--) {
                var f = this.buildFrame(frame);
                f.addArc(elementURI(attrs[x1]));
                if (elementURI(attrs[x1]) === RDFParser2.ns.RDF + "type") {
                  this.buildFrame(f).addNode(attrs[x1].nodeValue);
                } else {
                  this.buildFrame(f).addLiteral(attrs[x1].nodeValue);
                }
              }
            } else if (dom.childNodes.length === 0) {
              this.buildFrame(frame).addLiteral("");
            }
          }
        }
        dom = frame.element;
        while (frame.parent) {
          var pframe = frame;
          while (dom == null) {
            frame = frame.parent;
            dom = frame.element;
          }
          var candidate = dom.childNodes && dom.childNodes[frame.lastChild];
          if (!candidate || !dig) {
            frame.terminateFrame();
            if (!(frame = frame.parent)) {
              break;
            }
            dom = frame.element;
            dig = true;
          } else if (candidate.nodeType !== RDFParser2.nodeType.ELEMENT && candidate.nodeType !== RDFParser2.nodeType.TEXT && candidate.nodeType !== RDFParser2.nodeType.CDATA_SECTION || (candidate.nodeType === RDFParser2.nodeType.TEXT || candidate.nodeType === RDFParser2.nodeType.CDATA_SECTION) && dom.childNodes.length !== 1) {
            frame.lastChild++;
          } else {
            frame.lastChild++;
            frame = this.buildFrame(pframe, dom.childNodes[frame.lastChild - 1]);
            break;
          }
        }
      }
    }
    /**
     * Cleans out state from a previous parse run
     * @private
     */
  }, {
    key: "cleanParser",
    value: function cleanParser() {
      this.bnodes = {};
      this.why = null;
    }
    /**
     * Builds scope frame
     * @private
     */
  }, {
    key: "buildFrame",
    value: function buildFrame(parent, element) {
      var frame = this.frameFactory(this, parent, element);
      if (parent) {
        frame.base = parent.base;
        frame.lang = parent.lang;
      }
      if (!element || element.nodeType === RDFParser2.nodeType.TEXT || element.nodeType === RDFParser2.nodeType.CDATA_SECTION) {
        return frame;
      }
      var attrs = element.attributes;
      var base = element.getAttributeNode("xml:base");
      if (base != null) {
        frame.base = base.nodeValue;
        element.removeAttribute("xml:base");
      }
      var lang = element.getAttributeNode("xml:lang");
      if (lang != null) {
        frame.lang = lang.nodeValue;
        element.removeAttribute("xml:lang");
      }
      for (var x = attrs.length - 1; x >= 0; x--) {
        if (attrs[x].nodeName.substr(0, 3) === "xml") {
          if (attrs[x].name.slice(0, 6) === "xmlns:") {
            var uri = attrs[x].nodeValue;
            if (this.base) uri = join(uri, this.base);
            this.store.setPrefixForURI(attrs[x].name.slice(6), uri);
          }
          element.removeAttributeNode(attrs[x]);
        }
      }
      return frame;
    }
  }]);
}();
_defineProperty(RDFParser, "ns", {
  "RDF": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
  "RDFS": "http://www.w3.org/2000/01/rdf-schema#"
});
_defineProperty(RDFParser, "nodeType", {
  "ELEMENT": 1,
  "ATTRIBUTE": 2,
  "TEXT": 3,
  "CDATA_SECTION": 4,
  "ENTITY_REFERENCE": 5,
  "ENTITY": 6,
  "PROCESSING_INSTRUCTION": 7,
  "COMMENT": 8,
  "DOCUMENT": 9,
  "DOCUMENT_TYPE": 10,
  "DOCUMENT_FRAGMENT": 11,
  "NOTATION": 12
});

// ../node_modules/rdflib/esm/patch-parser.js
function sparqlUpdateParser(str, kb, base) {
  var i, j, k;
  var keywords = ["INSERT", "DELETE", "WHERE"];
  var SQNS = Namespace("http://www.w3.org/ns/pim/patch#");
  var p = n3parser_default(kb, kb, base, base, null, null, "", null);
  var clauses = {};
  var badSyntax = function badSyntax2(uri, lines, str2, i2, why) {
    return "Line " + (lines + 1) + " of <" + uri + ">: Bad syntax:\n   " + why + '\n   at: "' + str2.slice(i2, i2 + 30) + '"';
  };
  i = 0;
  var query = kb.sym(base + "#query");
  clauses["query"] = query;
  while (true) {
    j = p.skipSpace(str, i);
    if (j < 0) {
      return clauses;
    }
    if (str[j] === ";") {
      i = p.skipSpace(str, j + 1);
      if (i < 0) {
        return clauses;
      }
      j = i;
    }
    var found = false;
    for (k = 0; k < keywords.length; k++) {
      var key = keywords[k];
      if (str.slice(j, j + key.length) === key) {
        i = p.skipSpace(str, j + key.length);
        if (i < 0) {
          throw badSyntax(p._thisDoc, p.lines, str, j + key.length, "found EOF, needed {...} after " + key);
        }
        if ((key === "INSERT" || key === "DELETE") && str.slice(i, i + 4) === "DATA") {
          j = p.skipSpace(str, i + 4);
          if (j < 0) {
            throw badSyntax(p._thisDoc, p.lines, str, i + 4, "needed {...} after INSERT DATA " + key);
          }
          i = j;
        }
        var res2 = [];
        j = p.node(str, i, res2);
        if (j < 0) {
          throw badSyntax(p._thisDoc, p.lines, str, i, "bad syntax or EOF in {...} after " + key);
        }
        clauses[key.toLowerCase()] = res2[0];
        kb.add(query, SQNS(key.toLowerCase()), res2[0]);
        found = true;
        i = j;
      }
    }
    if (!found && str.slice(j, j + 7) === "@prefix") {
      i = p.directive(str, j);
      if (i < 0) {
        throw badSyntax(p._thisDoc, p.lines, str, i, "bad syntax or EOF after @prefix ");
      }
      i = p.checkDot(str, i);
      found = true;
    }
    if (!found) {
      throw badSyntax(p._thisDoc, p.lines, str, j, "Unknown syntax at start of statememt: '" + str.slice(j).slice(0, 20) + "'");
    }
  }
}

// ../node_modules/rdflib/esm/parse.js
function parse2(str, kb, base) {
  var contentType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "text/turtle";
  var callback = arguments.length > 4 ? arguments[4] : void 0;
  contentType = contentType || TurtleContentType;
  contentType = contentType.split(";")[0];
  try {
    if (contentType === N3ContentType || contentType === TurtleContentType) {
      var p = n3parser_default(kb, kb, base, base, null, null, "", null);
      p.loadBuf(str);
      executeCallback();
    } else if (contentType === RDFXMLContentType) {
      var parser = new RDFParser(kb);
      parser.parse(parseXML(str), base, kb.sym(base));
      executeCallback();
    } else if (contentType === XHTMLContentType) {
      parseRDFaDOM(parseXML(str, {
        contentType: XHTMLContentType
      }), kb, base);
      executeCallback();
    } else if (contentType === HTMLContentType) {
      parseRDFaDOM(parseXML(str, {
        contentType: HTMLContentType
      }), kb, base);
      executeCallback();
    } else if (contentType === SPARQLUpdateContentType || contentType === SPARQLUpdateSingleMatchContentType) {
      sparqlUpdateParser(str, kb, base);
      executeCallback();
    } else if (contentType === JSONLDContentType) {
      jsonldParser(str, kb, base, executeCallback);
    } else if (contentType === NQuadsContentType || contentType === NQuadsAltContentType) {
      var n3Parser = new N3Parser({
        factory: extended_term_factory_default
      });
      nquadCallback(null, str);
    } else if (contentType === void 0) {
      throw new Error("contentType is undefined");
    } else {
      throw new Error("Don't know how to parse " + contentType + " yet");
    }
  } catch (e) {
    executeErrorCallback(e);
  }
  parse2.handled = {
    "text/n3": true,
    "text/turtle": true,
    "application/rdf+xml": true,
    "application/xhtml+xml": true,
    "text/html": true,
    "application/sparql-update": true,
    "application/sparql-update-single-match": true,
    "application/ld+json": true,
    "application/nquads": true,
    "application/n-quads": true
  };
  function executeCallback() {
    if (callback) {
      callback(null, kb);
    } else {
      return;
    }
  }
  function executeErrorCallback(e) {
    if (
      // TODO: Always true, what is the right behavior
      contentType !== JSONLDContentType || // @ts-ignore always true?
      contentType !== NQuadsContentType || // @ts-ignore always true?
      contentType !== NQuadsAltContentType
    ) {
      if (callback) {
        callback(e, kb);
      } else {
        var e2 = new Error("" + e + " while trying to parse <" + base + "> as " + contentType);
        e2.cause = e;
        throw e2;
      }
    }
  }
  function nquadCallback(err, nquads) {
    if (err) {
      callback(err, kb);
    }
    try {
      n3Parser.parse(nquads, tripleCallback);
    } catch (err2) {
      callback(err2, kb);
    }
  }
  function tripleCallback(err, triple3) {
    if (triple3) {
      kb.add(triple3.subject, triple3.predicate, triple3.object, triple3.graph);
    } else {
      callback(err, kb);
    }
  }
}

// ../node_modules/rdflib/esm/fetcher.js
var import_cross_fetch = __toESM(require_browser_ponyfill());
function _createForOfIteratorHelper3(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray3(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length) return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null) it.return();
    } finally {
      if (didErr) throw err;
    }
  } };
}
function _unsupportedIterableToArray3(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray3(o, minLen);
}
function _arrayLikeToArray3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _callSuper8(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct8() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct8() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct8 = function _isNativeReflectConstruct10() {
    return !!t;
  })();
}
var Parsable = {
  "text/n3": true,
  "text/turtle": true,
  "application/rdf+xml": true,
  "application/xhtml+xml": true,
  "text/html": true,
  "application/ld+json": true
};
var CONTENT_TYPE_BY_EXT = {
  "rdf": RDFXMLContentType,
  "owl": RDFXMLContentType,
  "n3": "text/n3",
  "ttl": "text/turtle",
  "nt": "text/n3",
  "acl": "text/n3",
  "html": "text/html",
  "xml": "text/xml"
};
var getNS = function getNS2(factory) {
  return {
    link: Namespace("http://www.w3.org/2007/ont/link#", factory),
    http: Namespace("http://www.w3.org/2007/ont/http#", factory),
    httph: Namespace("http://www.w3.org/2007/ont/httph#", factory),
    // headers
    rdf: Namespace("http://www.w3.org/1999/02/22-rdf-syntax-ns#", factory),
    rdfs: Namespace("http://www.w3.org/2000/01/rdf-schema#", factory),
    dc: Namespace("http://purl.org/dc/elements/1.1/", factory),
    ldp: Namespace("http://www.w3.org/ns/ldp#", factory)
  };
};
var ns2 = getNS();
var Handler = /* @__PURE__ */ _createClass(function Handler2(response, dom) {
  _classCallCheck(this, Handler2);
  _defineProperty(this, "response", void 0);
  _defineProperty(this, "dom", void 0);
  this.response = response;
  this.dom = dom;
});
_defineProperty(Handler, "pattern", void 0);
var RDFXMLHandler = /* @__PURE__ */ function(_Handler2) {
  function RDFXMLHandler2() {
    _classCallCheck(this, RDFXMLHandler2);
    return _callSuper8(this, RDFXMLHandler2, arguments);
  }
  _inherits(RDFXMLHandler2, _Handler2);
  return _createClass(RDFXMLHandler2, [{
    key: "parse",
    value: function parse3(fetcher3, responseText, options) {
      var kb = fetcher3.store;
      if (!this.dom) {
        this.dom = parseXML(responseText);
      }
      var root = this.dom.documentElement;
      if (root.nodeName === "parsererror") {
        return fetcher3.failFetch(options, "Badly formed XML in " + options.resource.value, "parse_error");
      }
      var parser = new RDFParser(kb);
      try {
        parser.parse(this.dom, options.original.value, options.original);
      } catch (err) {
        return fetcher3.failFetch(options, "Syntax error parsing RDF/XML! " + err, "parse_error");
      }
      if (!options.noMeta) {
        kb.add(options.original, ns2.rdf("type"), ns2.link("RDFDocument"), fetcher3.appNode);
      }
      return fetcher3.doneFetch(options, this.response);
    }
  }], [{
    key: "toString",
    value: function toString() {
      return "RDFXMLHandler";
    }
  }, {
    key: "register",
    value: function register(fetcher3) {
      fetcher3.mediatypes[RDFXMLContentType] = {
        "q": 0.9
      };
    }
  }]);
}(Handler);
RDFXMLHandler.pattern = new RegExp("application/rdf\\+xml");
var XHTMLHandler = /* @__PURE__ */ function(_Handler3) {
  function XHTMLHandler2() {
    _classCallCheck(this, XHTMLHandler2);
    return _callSuper8(this, XHTMLHandler2, arguments);
  }
  _inherits(XHTMLHandler2, _Handler3);
  return _createClass(XHTMLHandler2, [{
    key: "parse",
    value: function parse3(fetcher3, responseText, options) {
      var relation, reverse;
      if (!this.dom) {
        this.dom = parseXML(responseText);
      }
      var kb = fetcher3.store;
      var title = this.dom.getElementsByTagName("title");
      if (title.length > 0) {
        kb.add(options.resource, ns2.dc("title"), kb.rdfFactory.literal(title[0].textContent), options.resource);
      }
      var links = this.dom.getElementsByTagName("link");
      for (var x = links.length - 1; x >= 0; x--) {
        relation = links[x].getAttribute("rel");
        reverse = false;
        if (!relation) {
          relation = links[x].getAttribute("rev");
          reverse = true;
        }
        if (relation) {
          fetcher3.linkData(options.original, relation, links[x].getAttribute("href"), options.resource, reverse);
        }
      }
      var scripts = this.dom.getElementsByTagName("script");
      for (var i = 0; i < scripts.length; i++) {
        var contentType = scripts[i].getAttribute("type");
        if (Parsable[contentType]) {
          parse2(scripts[i].textContent, kb, options.original.value, contentType);
          parse2(scripts[i].textContent, kb, options.original.value, contentType);
        }
      }
      if (!options.noMeta) {
        kb.add(options.resource, ns2.rdf("type"), ns2.link("WebPage"), fetcher3.appNode);
      }
      if (!options.noRDFa && parseRDFaDOM) {
        try {
          parseRDFaDOM(this.dom, kb, options.original.value);
        } catch (err) {
          var msg2 = "Error trying to parse " + options.resource + " as RDFa:\n" + err + ":\n" + err.stack;
          return fetcher3.failFetch(options, msg2, "parse_error");
        }
      }
      return fetcher3.doneFetch(options, this.response);
    }
  }], [{
    key: "toString",
    value: function toString() {
      return "XHTMLHandler";
    }
  }, {
    key: "register",
    value: function register(fetcher3) {
      fetcher3.mediatypes[XHTMLContentType] = {};
    }
  }]);
}(Handler);
XHTMLHandler.pattern = new RegExp("application/xhtml");
var XMLHandler = /* @__PURE__ */ function(_Handler4) {
  function XMLHandler2() {
    _classCallCheck(this, XMLHandler2);
    return _callSuper8(this, XMLHandler2, arguments);
  }
  _inherits(XMLHandler2, _Handler4);
  return _createClass(XMLHandler2, [{
    key: "parse",
    value: function parse3(fetcher3, responseText, options) {
      var dom = parseXML(responseText);
      for (var c = 0; c < dom.childNodes.length; c++) {
        var node = dom.childNodes[c];
        if (XMLHandler2.isElement(node)) {
          var _ns = node.namespaceURI;
          if (_ns && _ns === _ns["rdf"]) {
            fetcher3.addStatus(options.req, "Has XML root element in the RDF namespace, so assume RDF/XML.");
            var rdfHandler = new RDFXMLHandler(this.response, dom);
            return rdfHandler.parse(fetcher3, responseText, options);
          }
          break;
        }
      }
      if (dom.doctype) {
        if (dom.doctype.name === "html" && dom.doctype.publicId.match(/^-\/\/W3C\/\/DTD XHTML/) && dom.doctype.systemId.match(/http:\/\/www.w3.org\/TR\/xhtml/)) {
          fetcher3.addStatus(options.req, "Has XHTML DOCTYPE. Switching to XHTML Handler.\n");
          var xhtmlHandler = new XHTMLHandler(this.response, dom);
          return xhtmlHandler.parse(fetcher3, responseText, options);
        }
      }
      var html = dom.getElementsByTagName("html")[0];
      if (html) {
        var xmlns = html.getAttribute("xmlns");
        if (xmlns && xmlns.match(/^http:\/\/www.w3.org\/1999\/xhtml/)) {
          fetcher3.addStatus(options.req, "Has a default namespace for XHTML. Switching to XHTMLHandler.\n");
          var _xhtmlHandler = new XHTMLHandler(this.response, dom);
          return _xhtmlHandler.parse(fetcher3, responseText, options);
        }
      }
      return fetcher3.failFetch(options, "Unsupported dialect of XML: not RDF or XHTML namespace, etc.\n" + responseText.slice(0, 80), 901);
    }
  }], [{
    key: "toString",
    value: function toString() {
      return "XMLHandler";
    }
  }, {
    key: "register",
    value: function register(fetcher3) {
      fetcher3.mediatypes["text/xml"] = {
        "q": 0.5
      };
      fetcher3.mediatypes["application/xml"] = {
        "q": 0.5
      };
    }
  }, {
    key: "isElement",
    value: function isElement(node) {
      return node.nodeType === Node.ELEMENT_NODE;
    }
  }]);
}(Handler);
XMLHandler.pattern = new RegExp("(text|application)/(.*)xml");
var HTMLHandler = /* @__PURE__ */ function(_Handler5) {
  function HTMLHandler2() {
    _classCallCheck(this, HTMLHandler2);
    return _callSuper8(this, HTMLHandler2, arguments);
  }
  _inherits(HTMLHandler2, _Handler5);
  return _createClass(HTMLHandler2, [{
    key: "parse",
    value: function parse3(fetcher3, responseText, options) {
      var kb = fetcher3.store;
      if (isXML(responseText)) {
        fetcher3.addStatus(options.req, "Has an XML declaration. We'll assume it's XHTML as the content-type was text/html.\n");
        var xhtmlHandler = new XHTMLHandler(this.response);
        return xhtmlHandler.parse(fetcher3, responseText, options);
      }
      if (isXHTML(responseText)) {
        fetcher3.addStatus(options.req, "Has XHTML DOCTYPE. Switching to XHTMLHandler.\n");
        var _xhtmlHandler2 = new XHTMLHandler(this.response);
        return _xhtmlHandler2.parse(fetcher3, responseText, options);
      }
      if (isXMLNS(responseText)) {
        fetcher3.addStatus(options.req, "Has default namespace for XHTML, so switching to XHTMLHandler.\n");
        var _xhtmlHandler3 = new XHTMLHandler(this.response);
        return _xhtmlHandler3.parse(fetcher3, responseText, options);
      }
      var titleMatch = new RegExp("<title>([\\s\\S]+?)</title>", "im").exec(responseText);
      if (titleMatch) {
        kb.add(options.resource, ns2.dc("title"), kb.rdfFactory.literal(titleMatch[1]), options.resource);
      }
      kb.add(options.resource, ns2.rdf("type"), ns2.link("WebPage"), fetcher3.appNode);
      fetcher3.addStatus(options.req, "non-XML HTML document, not parsed for data.");
      return fetcher3.doneFetch(options, this.response);
    }
  }], [{
    key: "toString",
    value: function toString() {
      return "HTMLHandler";
    }
  }, {
    key: "register",
    value: function register(fetcher3) {
      fetcher3.mediatypes["text/html"] = {
        "q": 0.9
      };
    }
  }]);
}(Handler);
HTMLHandler.pattern = new RegExp("text/html");
var JsonLdHandler = /* @__PURE__ */ function(_Handler6) {
  function JsonLdHandler2() {
    _classCallCheck(this, JsonLdHandler2);
    return _callSuper8(this, JsonLdHandler2, arguments);
  }
  _inherits(JsonLdHandler2, _Handler6);
  return _createClass(JsonLdHandler2, [{
    key: "parse",
    value: function parse3(fetcher3, responseText, options, response) {
      var kb = fetcher3.store;
      return new Promise(function(resolve, reject) {
        try {
          jsonldParser(responseText, kb, options.original.value, function() {
            resolve(fetcher3.doneFetch(options, response));
          });
        } catch (err) {
          var msg2 = "Error trying to parse " + options.resource + " as JSON-LD:\n" + err;
          resolve(fetcher3.failFetch(options, msg2, "parse_error", response));
        }
      });
    }
  }], [{
    key: "toString",
    value: function toString() {
      return "JsonLdHandler";
    }
  }, {
    key: "register",
    value: function register(fetcher3) {
      fetcher3.mediatypes["application/ld+json"] = {
        "q": 0.9
      };
    }
  }]);
}(Handler);
JsonLdHandler.pattern = /application\/ld\+json/;
var TextHandler = /* @__PURE__ */ function(_Handler7) {
  function TextHandler2() {
    _classCallCheck(this, TextHandler2);
    return _callSuper8(this, TextHandler2, arguments);
  }
  _inherits(TextHandler2, _Handler7);
  return _createClass(TextHandler2, [{
    key: "parse",
    value: function parse3(fetcher3, responseText, options) {
      if (isXML(responseText)) {
        fetcher3.addStatus(options.req, "Warning: " + options.resource + " has an XML declaration. We'll assume it's XML but its content-type wasn't XML.\n");
        var xmlHandler = new XMLHandler(this.response);
        return xmlHandler.parse(fetcher3, responseText, options);
      }
      if (responseText.slice(0, 500).match(/xmlns:/)) {
        fetcher3.addStatus(options.req, "May have an XML namespace. We'll assume it's XML but its content-type wasn't XML.\n");
        var _xmlHandler = new XMLHandler(this.response);
        return _xmlHandler.parse(fetcher3, responseText, options);
      }
      fetcher3.addStatus(options.req, "Plain text document, no known RDF semantics.");
      return fetcher3.doneFetch(options, this.response);
    }
  }], [{
    key: "toString",
    value: function toString() {
      return "TextHandler";
    }
  }, {
    key: "register",
    value: function register(fetcher3) {
      fetcher3.mediatypes["text/plain"] = {
        "q": 0.5
      };
    }
  }]);
}(Handler);
TextHandler.pattern = new RegExp("text/plain");
var N3Handler = /* @__PURE__ */ function(_Handler8) {
  function N3Handler2() {
    _classCallCheck(this, N3Handler2);
    return _callSuper8(this, N3Handler2, arguments);
  }
  _inherits(N3Handler2, _Handler8);
  return _createClass(N3Handler2, [{
    key: "parse",
    value: function parse3(fetcher3, responseText, options, response) {
      var kb = fetcher3.store;
      var p = n3parser_default(kb, kb, options.original.value, options.original.value, null, null, "", null);
      try {
        p.loadBuf(responseText);
      } catch (err) {
        var msg2 = "Error trying to parse " + options.resource + " as Notation3:\n" + err;
        return fetcher3.failFetch(options, msg2, "parse_error", response);
      }
      fetcher3.addStatus(options.req, "N3 parsed: " + p.statementCount + " triples in " + p.lines + " lines.");
      fetcher3.store.add(options.original, ns2.rdf("type"), ns2.link("RDFDocument"), fetcher3.appNode);
      return fetcher3.doneFetch(options, this.response);
    }
  }], [{
    key: "toString",
    value: function toString() {
      return "N3Handler";
    }
  }, {
    key: "register",
    value: function register(fetcher3) {
      fetcher3.mediatypes["text/n3"] = {
        "q": "1.0"
      };
      fetcher3.mediatypes["text/turtle"] = {
        "q": 1
      };
    }
  }]);
}(Handler);
N3Handler.pattern = new RegExp("(application|text)/(x-)?(rdf\\+)?(n3|turtle)");
var defaultHandlers = {
  RDFXMLHandler,
  XHTMLHandler,
  XMLHandler,
  HTMLHandler,
  TextHandler,
  N3Handler,
  JsonLdHandler
};
function isXHTML(responseText) {
  var docTypeStart = responseText.indexOf("<!DOCTYPE html");
  var docTypeEnd = responseText.indexOf(">");
  if (docTypeStart === -1 || docTypeEnd === -1 || docTypeStart > docTypeEnd) {
    return false;
  }
  return responseText.substr(docTypeStart, docTypeEnd - docTypeStart).indexOf("XHTML") !== -1;
}
function isXML(responseText) {
  var match = responseText.match(/\s*<\?xml\s+version\s*=[^<>]+\?>/);
  return !!match;
}
function isXMLNS(responseText) {
  var match = responseText.match(/[^(<html)]*<html\s+[^<]*xmlns=['"]http:\/\/www.w3.org\/1999\/xhtml["'][^<]*>/);
  return !!match;
}
var Fetcher = /* @__PURE__ */ function() {
  function Fetcher2(store) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck(this, Fetcher2);
    _defineProperty(this, "store", void 0);
    _defineProperty(this, "timeout", void 0);
    _defineProperty(this, "_fetch", void 0);
    _defineProperty(this, "mediatypes", void 0);
    _defineProperty(this, "appNode", void 0);
    _defineProperty(this, "requested", void 0);
    _defineProperty(this, "timeouts", void 0);
    _defineProperty(this, "redirectedTo", void 0);
    _defineProperty(this, "fetchQueue", void 0);
    _defineProperty(this, "fetchCallbacks", void 0);
    _defineProperty(this, "nonexistent", void 0);
    _defineProperty(this, "lookedUp", void 0);
    _defineProperty(this, "handlers", void 0);
    _defineProperty(this, "ns", void 0);
    _defineProperty(this, "fireCallbacks", void 0);
    this.store = store || new IndexedFormula();
    this.ns = getNS(this.store.rdfFactory);
    this.timeout = options.timeout || 3e4;
    this._fetch = options.fetch || typeof global !== "undefined" && (global.solidFetcher || global.solidFetch) || typeof window !== "undefined" && (window.solidFetcher || window.solidFetch) || import_cross_fetch.default;
    if (!this._fetch) {
      throw new Error("No _fetch function available for Fetcher");
    }
    this.appNode = this.store.sym("chrome://TheCurrentSession");
    this.store.fetcher = this;
    this.requested = {};
    this.timeouts = {};
    this.redirectedTo = {};
    this.fetchQueue = {};
    this.fetchCallbacks = {};
    this.nonexistent = {};
    this.lookedUp = {};
    this.handlers = [];
    this.mediatypes = {
      "image/*": {
        "q": 0.9
      },
      "*/*": {
        "q": 0.1
      }
      // Must allow access to random content
    };
    callbackify(this, ["request", "fail", "refresh", "retract", "done"]);
    Object.keys(options.handlers || defaultHandlers).map(function(key) {
      return _this.addHandler(defaultHandlers[key]);
    });
  }
  return _createClass(Fetcher2, [{
    key: "load",
    value: (
      /**
       * Promise-based load function
       *
       * Loads a web resource or resources into the store.
       *
       * A resource may be given as NamedNode object, or as a plain URI.
       * an array of resources will be given, in which they will be fetched in parallel.
       * By default, the HTTP headers are recorded also, in the same store, in a separate graph.
       * This allows code like editable() for example to test things about the resource.
       *
       * @param uri {Array<RDFlibNamedNode>|Array<string>|RDFlibNamedNode|string}
       *
       * @param [options={}] {Object}
       *
       * @param [options.fetch] {Function}
       *
       * @param [options.referringTerm] {RDFlibNamedNode} Referring term, the resource which
       *   referred to this (for tracking bad links)
       *
       * @param [options.contentType] {string} Provided content type (for writes)
       *
       * @param [options.forceContentType] {string} Override the incoming header to
       *   force the data to be treated as this content-type (for reads)
       *
       * @param [options.force] {boolean} Load the data even if loaded before.
       *   Also sets the `Cache-Control:` header to `no-cache`
       *
       * @param [options.baseURI=docuri] {Node|string} Original uri to preserve
       *   through proxying etc (`xhr.original`).
       *
       * @param [options.proxyUsed] {boolean} Whether this request is a retry via
       *   a proxy (generally done from an error handler)
       *
       * @param [options.withCredentials] {boolean} flag for XHR/CORS etc
       *
       * @param [options.clearPreviousData] {boolean} Before we parse new data,
       *   clear old, but only on status 200 responses
       *
       * @param [options.noMeta] {boolean} Prevents the addition of various metadata
       *   triples (about the fetch request) to the store
       *
       * @param [options.noRDFa] {boolean}
       *
       * @returns {Promise<Result>}
       */
      function load(uri) {
        var _this2 = this;
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        options = Object.assign({}, options);
        if (uri instanceof Array) {
          return Promise.all(uri.map(function(x) {
            return _this2.load(x, Object.assign({}, options));
          }));
        }
        var uriIn = uri;
        var docuri = termValue(uriIn);
        docuri = docuri.split("#")[0];
        options = this.initFetchOptions(docuri, options);
        var meta = this.appNode;
        var kb = this.store;
        var requests = kb.statementsMatching(void 0, this.ns.link("requestedURI"), kb.sym(docuri), meta).map(function(st3) {
          return st3.subject;
        });
        var _iterator = _createForOfIteratorHelper3(requests), _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            var request = _step.value;
            var _response = kb.any(request, this.ns.link("response"), null, meta);
            if (_response != void 0) {
              var quad4 = kb.statementsMatching(_response, this.ns.link("outOfDate"), true, meta);
              kb.remove(quad4);
              options.force = true;
              options.clearPreviousData = true;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var initialisedOptions = this.initFetchOptions(docuri, options);
        return this.pendingFetchPromise(docuri, initialisedOptions.baseURI, initialisedOptions);
      }
    )
  }, {
    key: "pendingFetchPromise",
    value: function() {
      var _pendingFetchPromise = _asyncToGenerator(/* @__PURE__ */ import_regenerator.default.mark(function _callee(uri, originalUri, options) {
        var _this3 = this;
        var pendingPromise;
        return import_regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = !options.force;
              if (!_context.t0) {
                _context.next = 5;
                break;
              }
              _context.next = 4;
              return this.fetchQueue[originalUri];
            case 4:
              _context.t0 = _context.sent;
            case 5:
              if (!_context.t0) {
                _context.next = 9;
                break;
              }
              pendingPromise = this.fetchQueue[originalUri];
              _context.next = 12;
              break;
            case 9:
              pendingPromise = Promise.race([this.setRequestTimeout(uri, options), this.fetchUri(uri, options)]);
              this.fetchQueue[originalUri] = pendingPromise;
              this.cleanupFetchRequest(originalUri, void 0, this.timeout);
            case 12:
              return _context.abrupt("return", pendingPromise.then(function(x) {
                if (uri in _this3.timeouts) {
                  _this3.timeouts[uri].forEach(clearTimeout);
                  delete _this3.timeouts[uri];
                }
                return x;
              }));
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function pendingFetchPromise(_x, _x2, _x3) {
        return _pendingFetchPromise.apply(this, arguments);
      }
      return pendingFetchPromise;
    }()
    /**
     * @param _options - DEPRECATED
     */
  }, {
    key: "cleanupFetchRequest",
    value: function cleanupFetchRequest(originalUri, _options, timeout) {
      var _this4 = this;
      if (_options !== void 0) {
        console.warn("_options is deprecated");
      }
      this.timeouts[originalUri] = (this.timeouts[originalUri] || []).concat(setTimeout(function() {
        if (!_this4.isPending(originalUri)) {
          delete _this4.fetchQueue[originalUri];
        }
      }, timeout));
    }
  }, {
    key: "initFetchOptions",
    value: function initFetchOptions(uri, options) {
      var kb = this.store;
      var isGet = !options.method || options.method.toUpperCase() === "GET";
      if (!isGet) {
        options.force = true;
      }
      options.resource = kb.rdfFactory.namedNode(uri);
      options.baseURI = options.baseURI || uri;
      options.original = kb.rdfFactory.namedNode(options.baseURI);
      options.req = kb.bnode();
      options.headers = options.headers || new import_cross_fetch.Headers();
      if (options.contentType) {
        options.headers["content-type"] = options.contentType;
      }
      if (options.force) {
        options.cache = "no-cache";
      }
      var acceptString = this.acceptString();
      options.headers["accept"] = acceptString;
      var requestedURI = Fetcher2.offlineOverride(uri);
      options.requestedURI = requestedURI;
      Fetcher2.setCredentials(requestedURI, options);
      var actualProxyURI = Fetcher2.proxyIfNecessary(requestedURI);
      if (requestedURI !== actualProxyURI) {
        options.proxyUsed = true;
      }
      options.actualProxyURI = actualProxyURI;
      return options;
    }
    /**
     * (The promise chain ends in either a `failFetch()` or a `doneFetch()`)
     *
     * @param docuri {string}
     * @param options {Object}
     *
     * @returns {Promise<Object>} fetch() result or an { error, status } object
     */
  }, {
    key: "fetchUri",
    value: function fetchUri(docuri, options) {
      var _this5 = this;
      if (!docuri) {
        return Promise.reject(new Error("Cannot fetch an empty uri"));
      }
      if (Fetcher2.unsupportedProtocol(docuri)) {
        return this.failFetch(options, "fetcher: Unsupported protocol", "unsupported_protocol");
      }
      var state = this.getState(docuri);
      if (!options.force) {
        if (state === "fetched") {
          return Promise.resolve(
            // @ts-ignore This is not a valid response object
            this.doneFetch(options, {
              status: 200,
              ok: true,
              statusText: "Already loaded into quadstore."
            })
          );
        }
        if (state === "failed" && this.requested[docuri] === 404) {
          var _message = "Previously failed: " + this.requested[docuri];
          var dummyResponse = {
            url: docuri,
            // This does not comply to Fetch spec, it can be a string value in rdflib
            status: this.requested[docuri],
            statusText: _message,
            responseText: _message,
            headers: new import_cross_fetch.Headers(),
            // Headers() ???
            ok: false,
            body: null,
            bodyUsed: false,
            size: 0,
            timeout: 0
          };
          return this.failFetch(options, _message, this.requested[docuri], dummyResponse);
        }
      } else {
        delete this.nonexistent[docuri];
      }
      this.fireCallbacks("request", [docuri]);
      this.requested[docuri] = true;
      if (!options.noMeta) {
        this.saveRequestMetadata(docuri, options);
      }
      var actualProxyURI = options.actualProxyURI;
      return this._fetch(actualProxyURI, options).then(function(response) {
        return _this5.handleResponse(response, docuri, options);
      }, function(error2) {
        var dummyResponse2 = {
          url: actualProxyURI,
          status: 999,
          // @@ what number/string should fetch failures report?
          statusText: (error2.name || "network failure") + ": " + (error2.errno || error2.code || error2.type),
          responseText: error2.message,
          headers: new import_cross_fetch.Headers(),
          // Headers() ???
          ok: false,
          body: null,
          bodyUsed: false,
          size: 0,
          timeout: 0
        };
        return _this5.handleError(dummyResponse2, docuri, options);
      });
    }
    /**
     * Asks for a doc to be loaded if necessary then calls back
     *
     * Calling methods:
     *   nowOrWhenFetched (uri, userCallback)
     *   nowOrWhenFetched (uri, options, userCallback)
     *   nowOrWhenFetched (uri, referringTerm, userCallback, options)  <-- old
     *   nowOrWhenFetched (uri, referringTerm, userCallback) <-- old
     *
     *  Options include:
     *   referringTerm    The document in which this link was found.
     *                    this is valuable when finding the source of bad URIs
     *   force            boolean.  Never mind whether you have tried before,
     *                    load this from scratch.
     *   forceContentType Override the incoming header to force the data to be
     *                    treated as this content-type.
     *
     *  Callback function takes:
     *
     *    ok               True if the fetch worked, and got a 200 response.
     *                     False if any error happened
     *
     *    errmessage       Text error message if not OK.
     *
     *    response         The fetch Response object (was: XHR) if there was was one
     *                     includes response.status as the HTTP status if any.
     */
  }, {
    key: "nowOrWhenFetched",
    value: function nowOrWhenFetched(uriIn, p2, userCallback) {
      var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      var uri = termValue(uriIn);
      if (typeof p2 === "function") {
        userCallback = p2;
      } else if (typeof p2 === "undefined") {
      } else if (isNamedNode(p2)) {
        options.referringTerm = p2;
      } else {
        options = p2;
      }
      this.load(uri, options).then(function(fetchResponse) {
        if (userCallback) {
          if (fetchResponse) {
            if (fetchResponse.ok) {
              userCallback(true, "OK", fetchResponse);
            } else {
              var oops = "HTTP error: Status " + fetchResponse.status + " (" + fetchResponse.statusText + ")";
              if (fetchResponse.responseText) {
                oops += " " + fetchResponse.responseText;
              }
              userCallback(false, oops, fetchResponse);
            }
          } else {
            var _oops = "@@ nowOrWhenFetched:  no response object!";
            userCallback(false, _oops);
          }
        }
      }, function(err) {
        var message = err.message || err.statusText;
        message = "Failed to load  <" + uri + "> " + message;
        if (err.response && err.response.status) {
          message += " status: " + err.response.status;
        }
        userCallback(false, message, err.response);
      });
    }
    /**
     * Records a status message (as a literal node) by appending it to the
     * request's metadata status collection.
     *
     */
  }, {
    key: "addStatus",
    value: function addStatus(req, statusMessage) {
      var now = /* @__PURE__ */ new Date();
      statusMessage = "[" + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds() + "." + now.getMilliseconds() + "] " + statusMessage;
      var kb = this.store;
      var statusNode = kb.the(req, this.ns.link("status"));
      if (isCollection(statusNode)) {
        statusNode.append(kb.rdfFactory.literal(statusMessage));
      } else {
        log_default.warn("web.js: No list to add to: " + statusNode + "," + statusMessage);
      }
    }
    /**
     * Records errors in the system on failure:
     *
     *  - Adds an entry to the request status collection
     *  - Adds an error triple with the fail message to the metadata
     *  - Fires the 'fail' callback
     *  - Rejects with an error result object, which has a response object if any
     */
  }, {
    key: "failFetch",
    value: function failFetch(options, errorMessage, statusCode, response) {
      this.addStatus(options.req, errorMessage);
      if (!options.noMeta) {
        this.store.add(options.original, this.ns.link("error"), this.store.rdfFactory.literal(errorMessage));
      }
      var meth = (options.method || "GET").toUpperCase();
      var isGet = meth === "GET" || meth === "HEAD";
      if (isGet) {
        if (!options.resource.equals(options.original)) {
        } else {
        }
        this.requested[docpart(options.original.value)] = statusCode;
        this.fireCallbacks("fail", [options.original.value, errorMessage]);
      }
      var err = new Error("Fetcher: " + errorMessage);
      err.status = statusCode;
      err.statusText = errorMessage;
      err.response = response;
      return Promise.reject(err);
    }
    // in the why part of the quad distinguish between HTML and HTTP header
    // Reverse is set iif the link was rev= as opposed to rel=
  }, {
    key: "linkData",
    value: function linkData(originalUri, rel, uri, why, reverse) {
      if (!uri) return;
      var kb = this.store;
      var predicate;
      var obj = kb.rdfFactory.namedNode(join(uri, originalUri.value));
      if (rel === "alternate" || rel === "seeAlso" || rel === "meta" || rel === "describedby") {
        if (obj.value === originalUri.value) {
          return;
        }
        predicate = this.ns.rdfs("seeAlso");
      } else if (rel === "type") {
        predicate = kb.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type");
      } else {
        predicate = kb.rdfFactory.namedNode(join(encodeURIComponent(rel), "http://www.iana.org/assignments/link-relations/"));
      }
      if (reverse) {
        kb.add(obj, predicate, originalUri, why);
      } else {
        kb.add(originalUri, predicate, obj, why);
      }
    }
  }, {
    key: "parseLinkHeader",
    value: function parseLinkHeader(linkHeader, originalUri, reqNode) {
      if (!linkHeader) {
        return;
      }
      var linkexp = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^\(\)<>@,;:"\/\[\]\?={} \t]+)|("[^"]*")))*(,|$)/g;
      var paramexp = /[^\(\)<>@,;:"\/\[\]\?={} \t]+=(([^\(\)<>@,;:"\/\[\]\?={} \t]+)|("[^"]*"))/g;
      var matches = linkHeader.match(linkexp);
      if (matches == null) return;
      for (var i = 0; i < matches.length; i++) {
        var split = matches[i].split(">");
        var href = split[0].substring(1);
        var ps = split[1];
        var s = ps.match(paramexp);
        if (s == null) return;
        for (var j = 0; j < s.length; j++) {
          var p = s[j];
          var paramsplit = p.split("=");
          var rel = paramsplit[1].replace(/["']/g, "");
          this.linkData(originalUri, rel, href, reqNode);
        }
      }
    }
  }, {
    key: "doneFetch",
    value: function doneFetch(options, response) {
      this.addStatus(options.req, "Done.");
      this.requested[options.original.value] = "done";
      this.fireCallbacks("done", [options.original.value]);
      response.req = options.req;
      return response;
    }
    /**
     * Note two nodes are now smushed
     * If only one was flagged as looked up, then the new node is looked up again,
     * which will make sure all the URIs are dereferenced
     */
  }, {
    key: "nowKnownAs",
    value: function nowKnownAs(was, now) {
      if (this.lookedUp[was.value]) {
        if (!this.lookedUp[now.value]) {
          this.lookUpThing(now, was);
        }
      } else if (this.lookedUp[now.value]) {
        if (!this.lookedUp[was.value]) {
          this.lookUpThing(was, now);
        }
      }
    }
    /**
     * Writes back to the web what we have in the store for this uri
     */
  }, {
    key: "putBack",
    value: function putBack(uri) {
      var _this6 = this;
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var uriSting = termValue(uri);
      var doc = new NamedNode(uriSting).doc();
      options.contentType = options["content-type"] || options["Content-Type"] || options.contentType || TurtleContentType;
      if (options.contentType === "application/ld+json") {
        return new Promise(function(resolve, reject) {
          serialize(doc, _this6.store, doc.uri, options.contentType, function(err, jsonString) {
            if (err) {
              reject(err);
            } else {
              options.data = jsonString;
              _this6.webOperation("PUT", uri, options).then(function(res) {
                return resolve(res);
              }).catch(function(error2) {
                return reject(error2);
              });
            }
          });
        });
      }
      options.data = serialize(doc, this.store, doc.value, options.contentType);
      return this.webOperation("PUT", uriSting, options);
    }
  }, {
    key: "webCopy",
    value: function webCopy(here, there, contentType) {
      var _this7 = this;
      return this.webOperation("GET", here).then(function(result) {
        return _this7.webOperation(
          "PUT",
          // change to binary from text
          there,
          {
            data: result.responseText,
            contentType
          }
        );
      });
    }
  }, {
    key: "delete",
    value: function _delete(uri, options) {
      var _this8 = this;
      return this.webOperation("DELETE", uri, options).then(function(response) {
        _this8.requested[uri] = 404;
        _this8.nonexistent[uri] = true;
        _this8.unload(_this8.store.rdfFactory.namedNode(uri));
        return response;
      });
    }
    /** Create an empty resource if it really does not exist
     *  Be absolutely sure something does not exist before creating a new empty file
     * as otherwise existing could  be deleted.
     * @param doc - The resource
    */
  }, {
    key: "createIfNotExists",
    value: function() {
      var _createIfNotExists = _asyncToGenerator(/* @__PURE__ */ import_regenerator.default.mark(function _callee2(doc) {
        var contentType, data, fetcher3, response, _args2 = arguments;
        return import_regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              contentType = _args2.length > 1 && _args2[1] !== void 0 ? _args2[1] : TurtleContentType;
              data = _args2.length > 2 && _args2[2] !== void 0 ? _args2[2] : "";
              fetcher3 = this;
              _context2.prev = 3;
              _context2.next = 6;
              return fetcher3.load(doc);
            case 6:
              response = _context2.sent;
              _context2.next = 26;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](3);
              if (!(_context2.t0.response.status === 404)) {
                _context2.next = 25;
                break;
              }
              _context2.prev = 12;
              _context2.next = 15;
              return fetcher3.webOperation("PUT", doc.value, {
                data,
                contentType
              });
            case 15:
              response = _context2.sent;
              _context2.next = 21;
              break;
            case 18:
              _context2.prev = 18;
              _context2.t1 = _context2["catch"](12);
              throw _context2.t1;
            case 21:
              delete fetcher3.requested[doc.value];
              return _context2.abrupt("return", response);
            case 25:
              throw _context2.t0;
            case 26:
              return _context2.abrupt("return", response);
            case 27:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 9], [12, 18]]);
      }));
      function createIfNotExists(_x4) {
        return _createIfNotExists.apply(this, arguments);
      }
      return createIfNotExists;
    }()
  }, {
    key: "createContainer",
    value: function createContainer(parentURI, folderName, data) {
      var headers = {
        // Force the right mime type for containers
        "content-type": TurtleContentType,
        "link": this.ns.ldp("BasicContainer") + '; rel="type"'
      };
      if (folderName) {
        headers["slug"] = folderName;
      }
      var options = {
        headers
      };
      if (data) {
        options.body = data;
      }
      return this.webOperation("POST", parentURI, options);
    }
  }, {
    key: "invalidateCache",
    value: function invalidateCache(iri) {
      var uri = termValue(iri);
      var fetcher3 = this;
      if (fetcher3.fetchQueue && fetcher3.fetchQueue[uri]) {
        var promise = fetcher3.fetchQueue[uri];
        if (promise["PromiseStatus"] === "resolved") {
          delete fetcher3.fetchQueue[uri];
        } else {
          delete fetcher3.fetchQueue[uri];
        }
      }
      if (fetcher3.requested[uri] && fetcher3.requested[uri] !== "done" && fetcher3.requested[uri] !== "failed" && fetcher3.requested[uri] !== 404) {
        var msg2 = "Rdflib: fetcher: Destructive operation on <".concat(fetcher3.requested[uri], "> file being fetched! ") + uri;
        console.error(msg2);
      } else {
        delete fetcher3.requested[uri];
        delete fetcher3.nonexistent[uri];
      }
    }
    /**
     * A generic web operation, at the fetch() level.
     * does not involve the quad store.
     *
     *  Returns promise of Response
     *  If data is returned, copies it to response.responseText before returning
     */
  }, {
    key: "webOperation",
    value: function webOperation(method, uriIn) {
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var uri = termValue(uriIn);
      options.method = method;
      options.body = options.data || options.body;
      options.force = true;
      var fetcher3 = this;
      if (options.body && !options.contentType) {
        throw new Error("Web operation sending data must have a defined contentType.");
      }
      if (options.contentType) {
        options.headers = options.headers || {};
        options.headers["content-type"] = options.contentType;
      }
      Fetcher2.setCredentials(uri, options);
      return new Promise(function(resolve, reject) {
        fetcher3._fetch(uri, options).then(function(response) {
          if (response.ok) {
            if (method === "PUT" || method === "PATCH" || method === "POST" || method === "DELETE") {
              fetcher3.invalidateCache(uri);
            }
            if (response.text) {
              response.text().then(function(data) {
                response.responseText = data;
                resolve(response);
              });
            } else {
              resolve(response);
            }
          } else {
            var msg2 = "Web error: " + response.status;
            if (response.statusText) msg2 += " (" + response.statusText + ")";
            msg2 += " on " + method + " of <" + uri + ">";
            if (response.responseText) msg2 += ": " + response.responseText;
            var e2 = new Error(msg2);
            e2.response = response;
            reject(e2);
          }
        }, function(err) {
          var msg2 = "Fetch error for " + method + " of <" + uri + ">:" + err;
          reject(new Error(msg2));
        });
      });
    }
    /**
     * Looks up something.
     * Looks up all the URIs a things has.
     *
     * @param term - canonical term for the thing whose URI is
     *   to be dereferenced
     * @param rterm - the resource which referred to this
     *   (for tracking bad links)
     */
  }, {
    key: "lookUpThing",
    value: function lookUpThing(term2, rterm) {
      var _this9 = this;
      var uris = this.store.uris(term2);
      uris = uris.map(function(u) {
        return docpart(u);
      });
      uris.forEach(function(u) {
        _this9.lookedUp[u] = true;
      });
      return this.load(uris, {
        referringTerm: rterm
      });
    }
    /**
     * Looks up response header.
     *
     * @returns {Array|undefined} a list of header values found in a stored HTTP
     *   response, or [] if response was found but no header found,
     *   or undefined if no response is available.
     * Looks for { [] link:requestedURI ?uri; link:response [ httph:header-name  ?value ] }
     */
  }, {
    key: "getHeader",
    value: function getHeader(doc, header) {
      var kb = this.store;
      var docuri = doc.value;
      var requests = kb.each(void 0, this.ns.link("requestedURI"), kb.rdfFactory.literal(docuri));
      for (var r = 0; r < requests.length; r++) {
        var request = requests[r];
        if (request !== void 0) {
          var _response2 = kb.any(request, this.ns.link("response"));
          if (_response2 !== void 0 && kb.anyValue(_response2, this.ns.http("status")) && kb.anyValue(_response2, this.ns.http("status")).startsWith("2")) {
            var results = kb.each(_response2, this.ns.httph(header.toLowerCase()));
            if (results.length) {
              return results.map(function(v) {
                return v.value;
              });
            }
            return [];
          }
        }
      }
      return void 0;
    }
  }, {
    key: "saveRequestMetadata",
    value: function saveRequestMetadata(docuri, options) {
      var req = options.req;
      var kb = this.store;
      var rterm = options.referringTerm;
      this.addStatus(options.req, "Accept: " + options.headers["accept"]);
      if (isNamedNode(rterm)) {
        kb.add(kb.rdfFactory.namedNode(docuri), this.ns.link("requestedBy"), rterm, this.appNode);
      }
      if (options.original && options.original.value !== docuri) {
        kb.add(req, this.ns.link("orginalURI"), kb.rdfFactory.literal(options.original.value), this.appNode);
      }
      var now = /* @__PURE__ */ new Date();
      var timeNow = "[" + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds() + "] ";
      kb.add(req, this.ns.rdfs("label"), kb.rdfFactory.literal(timeNow + " Request for " + docuri), this.appNode);
      kb.add(req, this.ns.link("requestedURI"), kb.rdfFactory.literal(docuri), this.appNode);
      kb.add(req, this.ns.link("status"), kb.collection(), this.appNode);
    }
  }, {
    key: "saveResponseMetadata",
    value: function saveResponseMetadata(response, options) {
      var _this10 = this;
      var kb = this.store;
      var responseNode = kb.bnode();
      kb.add(options.req, this.ns.link("response"), responseNode, this.appNode);
      kb.add(responseNode, this.ns.http("status"), kb.rdfFactory.literal(response.status), this.appNode);
      kb.add(responseNode, this.ns.http("statusText"), kb.rdfFactory.literal(response.statusText), this.appNode);
      response.headers.forEach(function(value, header) {
        kb.add(responseNode, _this10.ns.httph(header), _this10.store.rdfFactory.literal(value), _this10.appNode);
        if (header === "content-type") {
          kb.add(
            options.resource,
            _this10.ns.rdf("type"),
            kb.rdfFactory.namedNode(mediaTypeClass(value).value),
            _this10.appNode
            // responseNode
          );
        }
      });
      return responseNode;
    }
  }, {
    key: "objectRefresh",
    value: function objectRefresh(term2) {
      var uris = this.store.uris(term2);
      if (typeof uris !== "undefined") {
        for (var i = 0; i < uris.length; i++) {
          this.refresh(this.store.rdfFactory.namedNode(docpart(uris[i])));
        }
      }
    }
    /* refresh  Reload data from a given document
    **
    ** @param term - An RDF Named Node for the eodcument in question
    ** @param userCallback - A function userCallback(ok, message, response)
    */
  }, {
    key: "refresh",
    value: function refresh(term2, userCallback) {
      this.fireCallbacks("refresh", arguments);
      this.nowOrWhenFetched(term2, {
        force: true,
        clearPreviousData: true
      }, userCallback);
    }
    /* refreshIfExpired   Conditional refresh if Expired
    **
    ** @param term - An RDF Named Node for the eodcument in question
    ** @param userCallback - A function userCallback(ok, message, response)
    */
  }, {
    key: "refreshIfExpired",
    value: function refreshIfExpired(term2, userCallback) {
      var exp = this.getHeader(term2, "Expires");
      if (!exp || new Date(exp[0]).getTime() <= (/* @__PURE__ */ new Date()).getTime()) {
        this.refresh(term2, userCallback);
      } else {
        userCallback(true, "Not expired", {});
      }
    }
  }, {
    key: "retract",
    value: function retract(term2) {
      this.store.removeMany(void 0, void 0, void 0, term2);
      if (term2.value) {
        delete this.requested[docpart(term2.value)];
      }
      this.fireCallbacks("retract", arguments);
    }
  }, {
    key: "getState",
    value: function getState(docuri) {
      if (typeof this.requested[docuri] === "undefined") {
        return "unrequested";
      } else if (this.requested[docuri] === true) {
        return "requested";
      } else if (this.requested[docuri] === "done") {
        return "fetched";
      } else if (this.requested[docuri] === "redirected") {
        return this.getState(this.redirectedTo[docuri]);
      } else {
        return "failed";
      }
    }
  }, {
    key: "isPending",
    value: function isPending(docuri) {
      return this.requested[docuri] === true;
    }
  }, {
    key: "unload",
    value: function unload(term2) {
      this.store.removeDocument(term2);
      delete this.requested[term2.value];
    }
  }, {
    key: "addHandler",
    value: function addHandler(handler) {
      this.handlers.push(handler);
      handler.register(this);
    }
  }, {
    key: "retryNoCredentials",
    value: function retryNoCredentials(docuri, options) {
      options.retriedWithNoCredentials = true;
      delete this.requested[docuri];
      delete this.fetchQueue[docuri];
      var newOptions = Object.assign({}, options, {
        credentials: "omit"
      });
      this.addStatus(options.req, "Abort: Will retry with credentials SUPPRESSED to see if that helps");
      return this.load(docuri, newOptions);
    }
    /**
     * Tests whether a request is being made to a cross-site URI (for purposes
     * of retrying with a proxy)
     */
  }, {
    key: "isCrossSite",
    value: function isCrossSite(uri) {
      if (typeof document === "undefined" || !document.location) {
        return false;
      }
      var hostpart2 = hostpart;
      var here = "" + document.location;
      return (hostpart2(here) && hostpart2(uri) && hostpart2(here)) !== hostpart2(uri);
    }
    /**
     * Called when there's a network error in fetch(), or a response
     * with status of 0.
     */
  }, {
    key: "handleError",
    value: function handleError(response, docuri, options) {
      if (this.isCrossSite(docuri)) {
        if (options.credentials && options.credentials === "include" && !options.retriedWithNoCredentials) {
          return this.retryNoCredentials(docuri, options);
        }
        var proxyUri = Fetcher2.crossSiteProxy(docuri);
        if (proxyUri && !options.proxyUsed) {
          return this.redirectToProxy(proxyUri, options);
        }
      }
      var message;
      if (response instanceof Error) {
        message = "Fetch error: " + response.message;
      } else {
        message = response.statusText;
        if (response.responseText) {
          message += " ".concat(response.responseText);
        }
      }
      return this.failFetch(options, message, response.status || 998, response);
    }
    // deduce some things from the HTTP transaction
  }, {
    key: "addType",
    value: function addType(rdfType, req, kb, locURI) {
      var prev = req;
      if (locURI) {
        var reqURI = kb.any(prev, this.ns.link("requestedURI"));
        if (reqURI && reqURI.value !== locURI) {
          kb.add(kb.rdfFactory.namedNode(locURI), this.ns.rdf("type"), rdfType, this.appNode);
        }
      }
      for (; ; ) {
        var doc = kb.any(prev, this.ns.link("requestedURI"));
        if (doc && doc.value) {
          kb.add(kb.rdfFactory.namedNode(doc.value), this.ns.rdf("type"), rdfType, this.appNode);
        }
        prev = kb.any(void 0, kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/link#redirectedRequest"), prev);
        if (!prev) {
          break;
        }
        var response = kb.any(prev, kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/link#response"));
        if (!response) {
          break;
        }
        var redirection = kb.any(response, kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/http#status"));
        if (!redirection) {
          break;
        }
        if (redirection !== "301" && redirection !== "302") {
          break;
        }
      }
    }
    /**
     * Handle fetch() response
     */
  }, {
    key: "handleResponse",
    value: function handleResponse(response, docuri, options) {
      var _this11 = this;
      var kb = this.store;
      var headers = response.headers;
      var reqNode = options.req;
      var responseNode = this.saveResponseMetadata(response, options);
      var contentType = this.normalizedContentType(options, headers) || "";
      var contentLocation = headers.get("content-location");
      if (response.status === 0) {
        return this.handleError(response, docuri, options);
      }
      if (response.status >= 400) {
        if (response.status === 404) {
          this.nonexistent[options.original.value] = true;
          this.nonexistent[docuri] = true;
        }
        return this.saveErrorResponse(response, responseNode).then(function() {
          var errorMessage = options.resource + " " + response.statusText;
          return _this11.failFetch(options, errorMessage, response.status, response);
        });
      }
      var diffLocation = null;
      var absContentLocation = null;
      if (contentLocation) {
        absContentLocation = join(contentLocation, docuri);
        if (absContentLocation !== docuri) {
          diffLocation = absContentLocation;
        }
      }
      if (response.status === 200) {
        this.addType(this.ns.link("Document"), reqNode, kb, docuri);
        if (diffLocation) {
          this.addType(this.ns.link("Document"), reqNode, kb, diffLocation);
        }
        if (options.clearPreviousData) {
          var sts = kb.statementsMatching(void 0, void 0, void 0, options.resource).slice();
          for (var i = 0; i < sts.length; i++) {
            kb.removeStatement(sts[i]);
          }
        }
        var isImage = contentType.includes("image/") || contentType.includes("application/pdf");
        if (contentType && isImage) {
          this.addType(kb.rdfFactory.namedNode("http://purl.org/dc/terms/Image"), reqNode, kb, docuri);
          if (diffLocation) {
            this.addType(kb.rdfFactory.namedNode("http://purl.org/dc/terms/Image"), reqNode, kb, diffLocation);
          }
        }
      }
      if (contentLocation) {
        if (!options.force && diffLocation && this.requested[absContentLocation] === "done") {
          return this.doneFetch(options, response);
        }
        this.requested[absContentLocation] = true;
      }
      this.parseLinkHeader(headers.get("link"), options.original, reqNode);
      var handler = this.handlerForContentType(contentType, response);
      if (!handler) {
        this.addStatus(reqNode, "Fetch over. No data handled.");
        return this.doneFetch(options, response);
      }
      return response.text().then(function(responseText) {
        response.responseText = responseText;
        return handler.parse(_this11, responseText, options, response);
      });
    }
  }, {
    key: "saveErrorResponse",
    value: function saveErrorResponse(response, responseNode) {
      var _this12 = this;
      var kb = this.store;
      return response.text().then(function(content) {
        if (content.length > 10) {
          kb.add(responseNode, _this12.ns.http("content"), kb.rdfFactory.literal(content), responseNode);
        }
      });
    }
  }, {
    key: "handlerForContentType",
    value: function handlerForContentType(contentType, response) {
      if (!contentType) {
        return null;
      }
      var Handler3 = this.handlers.find(function(handler) {
        return contentType.match(handler.pattern);
      });
      return Handler3 ? new Handler3(response) : null;
    }
  }, {
    key: "guessContentType",
    value: function guessContentType(uri) {
      return CONTENT_TYPE_BY_EXT[uri.split(".").pop()];
    }
  }, {
    key: "normalizedContentType",
    value: function normalizedContentType(options, headers) {
      if (options.forceContentType) {
        return options.forceContentType;
      }
      var contentType = headers.get("content-type");
      if (!contentType || contentType.includes("application/octet-stream")) {
        var guess = this.guessContentType(options.resource.value);
        if (guess) {
          return guess;
        }
      }
      var protocol2 = protocol(options.resource.value);
      if (!contentType && ["file", "chrome"].includes(protocol2)) {
        return "text/xml";
      }
      return contentType;
    }
    /**
     * Sends a new request to the specified uri. (Extracted from `onerrorFactory()`)
     */
  }, {
    key: "redirectToProxy",
    value: function redirectToProxy(newURI, options) {
      var _this13 = this;
      this.addStatus(options.req, "BLOCKED -> Cross-site Proxy to <" + newURI + ">");
      options.proxyUsed = true;
      var kb = this.store;
      var oldReq = options.req;
      if (!options.noMeta) {
        kb.add(oldReq, this.ns.link("redirectedTo"), kb.rdfFactory.namedNode(newURI), oldReq);
        this.addStatus(oldReq, "redirected to new request");
      }
      this.requested[options.resource.value] = "redirected";
      this.redirectedTo[options.resource.value] = newURI;
      var newOptions = Object.assign({}, options);
      newOptions.baseURI = options.resource.value;
      return this.fetchUri(newURI, newOptions).then(function(response) {
        if (!newOptions.noMeta) {
          kb.add(oldReq, _this13.ns.link("redirectedRequest"), newOptions.req, _this13.appNode);
        }
        return response;
      });
    }
  }, {
    key: "setRequestTimeout",
    value: function setRequestTimeout(uri, options) {
      var _this14 = this;
      return new Promise(function(resolve) {
        _this14.timeouts[uri] = (_this14.timeouts[uri] || []).concat(setTimeout(function() {
          if (_this14.isPending(uri) && !options.retriedWithNoCredentials && !options.proxyUsed) {
            resolve(_this14.failFetch(options, "Request to ".concat(uri, " timed out"), "timeout"));
          }
        }, _this14.timeout));
      });
    }
  }, {
    key: "addFetchCallback",
    value: function addFetchCallback(uri, callback) {
      if (!this.fetchCallbacks[uri]) {
        this.fetchCallbacks[uri] = [callback];
      } else {
        this.fetchCallbacks[uri].push(callback);
      }
    }
  }, {
    key: "acceptString",
    value: function acceptString() {
      var acceptstring = "";
      for (var mediaType in this.mediatypes) {
        if (acceptstring !== "") {
          acceptstring += ", ";
        }
        acceptstring += mediaType;
        for (var property in this.mediatypes[mediaType]) {
          acceptstring += ";" + property + "=" + this.mediatypes[mediaType][property];
        }
      }
      return acceptstring;
    }
    // var updatesVia = new $rdf.UpdatesVia(this) // Subscribe to headers
    // @@@@@@@@ This is turned off because it causes a websocket to be set up for ANY fetch
    // whether we want to track it ot not. including ontologies loaed though the XSSproxy
  }], [{
    key: "crossSiteProxy",
    value: function crossSiteProxy(uri) {
      if (Fetcher2.crossSiteProxyTemplate) {
        return Fetcher2.crossSiteProxyTemplate.replace("{uri}", encodeURIComponent(uri));
      } else {
        return void 0;
      }
    }
  }, {
    key: "offlineOverride",
    value: function offlineOverride(uri) {
      var requestedURI = uri;
      var UI;
      if (typeof window !== "undefined" && window.panes && (UI = window.panes.UI) && UI.preferences && UI.preferences.get("offlineModeUsingLocalhost")) {
        if (requestedURI.slice(0, 7) === "http://" && requestedURI.slice(7, 17) !== "localhost/") {
          requestedURI = "http://localhost/" + requestedURI.slice(7);
          log_default.warn("Localhost kludge for offline use: actually getting <" + requestedURI + ">");
        } else {
        }
      } else {
      }
      return requestedURI;
    }
  }, {
    key: "proxyIfNecessary",
    value: function proxyIfNecessary(uri) {
      var UI;
      if (typeof window !== "undefined" && window.panes && (UI = window.panes.UI) && UI.isExtension) {
        return uri;
      }
      if (typeof $SolidTestEnvironment !== "undefined" && $SolidTestEnvironment.localSiteMap) {
        var hostpath = uri.split("/").slice(2);
        var lookup = function lookup2(parts, index) {
          var z = index[parts.shift()];
          if (!z) {
            return null;
          }
          if (typeof z === "string") {
            return z + parts.join("/");
          }
          if (!parts) {
            return null;
          }
          return lookup2(parts, z);
        };
        var y = lookup(hostpath, $SolidTestEnvironment.localSiteMap);
        if (y) {
          return y;
        }
      }
      if (Fetcher2.crossSiteProxyTemplate && typeof document !== "undefined" && document.location && ("" + document.location).slice(0, 6) === "https:" && // origin is secure
      uri.slice(0, 5) === "http:") {
        return Fetcher2.crossSiteProxyTemplate.replace("{uri}", encodeURIComponent(uri));
      }
      return uri;
    }
    /**
     * Tests whether the uri's protocol is supported by the Fetcher.
     * @param uri
     */
  }, {
    key: "unsupportedProtocol",
    value: function unsupportedProtocol(uri) {
      var pcol = protocol(uri);
      return pcol === "tel" || pcol === "mailto" || pcol === "urn";
    }
    /** Decide on credentials using old XXHR api or new fetch()  one
     * @param requestedURI
     * @param options
     */
  }, {
    key: "setCredentials",
    value: function setCredentials(requestedURI) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (options.credentials === void 0) {
        if (options.withCredentials !== void 0) {
          options.credentials = options.withCredentials ? "include" : "omit";
        } else {
          options.credentials = "include";
        }
      }
    }
  }]);
}();
_defineProperty(Fetcher, "HANDLERS", void 0);
_defineProperty(Fetcher, "CONTENT_TYPE_BY_EXT", void 0);
_defineProperty(Fetcher, "crossSiteProxyTemplate", void 0);
Fetcher.HANDLERS = defaultHandlers;
Fetcher.CONTENT_TYPE_BY_EXT = CONTENT_TYPE_BY_EXT;

// ../node_modules/rdflib/esm/factories/rdflib-data-factory.js
function ownKeys2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys2(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
var RDFlibDataFactory = _objectSpread2(_objectSpread2({}, extended_term_factory_default), {}, {
  /**
   * Creates a new fetcher
   * @param store - The store to use
   * @param options - The options
   */
  fetcher: function fetcher(store, options) {
    return new Fetcher(store, options);
  },
  /**
   * Creates a new graph (store)
   */
  graph: function graph() {
    var features = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
    return new IndexedFormula(features, opts || {
      rdfFactory: extended_term_factory_default
    });
  },
  /**
   * Creates a new literal node
   * @param val The lexical value
   * @param lang The language
   * @param dt The datatype
   */
  lit: function lit(val, lang, dt) {
    return this.literal("" + val, lang || dt);
  },
  /**
   * Creates a new statement
   * @param subject The subject
   * @param predicate The predicate
   * @param object The object
   * @param graph The containing graph
   */
  st: function st(subject, predicate, object, graph3) {
    return this.quad(subject, predicate, object, graph3);
  }
});
var rdflib_data_factory_default = RDFlibDataFactory;

// ../node_modules/rdflib/esm/index.js
var boundDataFactory = {};
for (name in rdflib_data_factory_default) {
  if (typeof rdflib_data_factory_default[name] === "function") boundDataFactory[name] = rdflib_data_factory_default[name].bind(rdflib_data_factory_default);
}
var name;
var fetcher2 = boundDataFactory.fetcher;
var graph2 = boundDataFactory.graph;
var lit2 = boundDataFactory.lit;
var st2 = boundDataFactory.st;
var namedNode3 = boundDataFactory.namedNode;
var variable3 = boundDataFactory.variable;
var blankNode3 = boundDataFactory.blankNode;
var defaultGraph4 = boundDataFactory.defaultGraph;
var literal3 = boundDataFactory.literal;
var quad3 = boundDataFactory.quad;
var triple2 = boundDataFactory.triple;
var formula = new Formula();
var term = node_default.fromValue;
var NextId = BlankNode.nextId;

// ../node_modules/rdflib/esm/store.js
function ownKeys3(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread3(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys3(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys3(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _createForOfIteratorHelper4(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray4(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length) return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null) it.return();
    } finally {
      if (didErr) throw err;
    }
  } };
}
function _unsupportedIterableToArray4(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray4(o, minLen);
}
function _arrayLikeToArray4(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _callSuper9(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct9() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct9() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct9 = function _isNativeReflectConstruct10() {
    return !!t;
  })();
}
var owlNamespaceURI = "http://www.w3.org/2002/07/owl#";
function handleFP(formula2, subj, pred, obj) {
  var o1 = formula2.any(subj, pred, void 0);
  if (!o1) {
    return false;
  }
  formula2.equate(o1, obj);
  return true;
}
function handleIFP(formula2, subj, pred, obj) {
  var s1 = formula2.any(void 0, pred, obj);
  if (!s1) {
    return false;
  }
  formula2.equate(s1, subj);
  return true;
}
function handleRDFType(formula2, subj, pred, obj, why) {
  if (formula2.typeCallback) {
    formula2.typeCallback(formula2, obj, why);
  }
  var x = formula2.classActions[formula2.id(obj)];
  var done = false;
  if (x) {
    for (var i = 0; i < x.length; i++) {
      done = done || x[i](formula2, subj, pred, obj, why);
    }
  }
  return done;
}
var IndexedFormula = /* @__PURE__ */ function(_Formula) {
  function IndexedFormula2(features) {
    var _this;
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck(this, IndexedFormula2);
    _this = _callSuper9(this, IndexedFormula2, [void 0, void 0, void 0, void 0, opts]);
    _defineProperty(_this, "updater", void 0);
    _defineProperty(_this, "namespaces", void 0);
    _defineProperty(_this, "classActions", void 0);
    _defineProperty(_this, "propertyActions", void 0);
    _defineProperty(_this, "redirections", void 0);
    _defineProperty(_this, "aliases", void 0);
    _defineProperty(_this, "HTTPRedirects", void 0);
    _defineProperty(_this, "subjectIndex", void 0);
    _defineProperty(_this, "predicateIndex", void 0);
    _defineProperty(_this, "objectIndex", void 0);
    _defineProperty(_this, "whyIndex", void 0);
    _defineProperty(_this, "index", void 0);
    _defineProperty(_this, "features", void 0);
    _defineProperty(_this, "_universalVariables", void 0);
    _defineProperty(_this, "_existentialVariables", void 0);
    _defineProperty(_this, "rdfArrayRemove", void 0);
    _defineProperty(_this, "dataCallbacks", void 0);
    _this.propertyActions = {};
    _this.classActions = {};
    _this.redirections = [];
    _this.aliases = [];
    _this.HTTPRedirects = [];
    _this.subjectIndex = [];
    _this.predicateIndex = [];
    _this.objectIndex = [];
    _this.whyIndex = [];
    _this.index = [_this.subjectIndex, _this.predicateIndex, _this.objectIndex, _this.whyIndex];
    _this.namespaces = {};
    _this.features = features || [
      // By default, devs do not expect these features.
      // See https://github.com/linkeddata/rdflib.js/issues/458
      //      'sameAs',
      //      'InverseFunctionalProperty',
      //      'FunctionalProperty',
    ];
    _this.rdfArrayRemove = opts.rdfArrayRemove || RDFArrayRemove;
    if (opts.dataCallback) {
      _this.dataCallbacks = [opts.dataCallback];
    }
    _this.initPropertyActions(_this.features);
    return _this;
  }
  _inherits(IndexedFormula2, _Formula);
  return _createClass(IndexedFormula2, [{
    key: "substitute",
    value: (
      /**
       * Gets this graph with the bindings substituted
       * @param bindings The bindings
       */
      function substitute(bindings) {
        var statementsCopy = this.statements.map(function(ea) {
          return ea.substitute(bindings);
        });
        var y = new IndexedFormula2();
        y.add(statementsCopy);
        return y;
      }
    )
    /**
     * Add a callback which will be triggered after a statement has been added to the store.
     * @param cb
     */
  }, {
    key: "addDataCallback",
    value: function addDataCallback(cb) {
      if (!this.dataCallbacks) {
        this.dataCallbacks = [];
      }
      this.dataCallbacks.push(cb);
    }
    /**
     * Apply a set of statements to be deleted and to be inserted
     *
     * @param patch - The set of statements to be deleted and to be inserted
     * @param target - The name of the document to patch
     * @param patchCallback - Callback to be called when patching is complete
     */
  }, {
    key: "applyPatch",
    value: function applyPatch(patch, target, patchCallback) {
      var targetKB = this;
      var ds;
      var binding = null;
      function doPatch(onDonePatch) {
        if (patch["delete"]) {
          ds = patch["delete"];
          if (binding) ds = ds.substitute(binding);
          ds = ds.statements;
          var bad = [];
          var ds2 = ds.map(function(st3) {
            var sts = targetKB.statementsMatching(st3.subject, st3.predicate, st3.object, target);
            if (sts.length === 0) {
              bad.push(st3);
              return null;
            } else {
              return sts[0];
            }
          });
          if (bad.length) {
            return patchCallback("Could not find to delete: " + bad.join("\n or "));
          }
          ds2.map(function(st3) {
            targetKB.remove(st3);
          });
        }
        if (patch["insert"]) {
          ds = patch["insert"];
          if (binding) ds = ds.substitute(binding);
          ds = ds.statements;
          ds.map(function(st3) {
            st3.graph = target;
            targetKB.add(st3.subject, st3.predicate, st3.object, st3.graph);
          });
        }
        onDonePatch();
      }
      if (patch.where) {
        var query = new Query("patch");
        query.pat = patch.where;
        query.pat.statements.map(function(st3) {
          st3.graph = namedNode3(target.value);
        });
        query.sync = true;
        var bindingsFound = [];
        targetKB.query(query, function onBinding(binding2) {
          bindingsFound.push(binding2);
        }, targetKB.fetcher, function onDone() {
          if (bindingsFound.length === 0) {
            return patchCallback("No match found to be patched:" + patch.where);
          }
          if (bindingsFound.length > 1) {
            return patchCallback("Patch ambiguous. No patch done.");
          }
          binding = bindingsFound[0];
          doPatch(patchCallback);
        });
      } else {
        doPatch(patchCallback);
      }
    }
    /**
     * N3 allows for declaring blank nodes, this function enables that support
     *
     * @param x The blank node to be declared, supported in N3
     */
  }, {
    key: "declareExistential",
    value: function declareExistential(x) {
      if (!this._existentialVariables) this._existentialVariables = [];
      this._existentialVariables.push(x);
      return x;
    }
    /**
     * @param features
     */
  }, {
    key: "initPropertyActions",
    value: function initPropertyActions(features) {
      this.propertyActions[this.rdfFactory.id(this.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"))] = [handleRDFType];
      if (ArrayIndexOf(features, "sameAs") >= 0) {
        this.propertyActions[this.rdfFactory.id(this.rdfFactory.namedNode("".concat(owlNamespaceURI, "sameAs")))] = [function(formula2, subj, pred, obj, why) {
          formula2.equate(subj, obj);
          return true;
        }];
      }
      if (ArrayIndexOf(features, "InverseFunctionalProperty") >= 0) {
        this.classActions[this.rdfFactory.id(this.rdfFactory.namedNode("".concat(owlNamespaceURI, "InverseFunctionalProperty")))] = [function(formula2, subj, pred, obj, addFn) {
          return formula2.newPropertyAction(subj, handleIFP);
        }];
      }
      if (ArrayIndexOf(features, "FunctionalProperty") >= 0) {
        this.classActions[this.rdfFactory.id(this.rdfFactory.namedNode("".concat(owlNamespaceURI, "FunctionalProperty")))] = [function(formula2, subj, proj, obj, addFn) {
          return formula2.newPropertyAction(subj, handleFP);
        }];
      }
    }
    /** @deprecated Use {add} instead */
  }, {
    key: "addStatement",
    value: function addStatement(st3) {
      this.add(st3.subject, st3.predicate, st3.object, st3.graph);
      return this.statements.length;
    }
    /**
     * Adds a triple (quad) to the store.
     *
     * @param subj - The thing about which the fact a relationship is asserted.
     *        Also accepts a statement or an array of Statements.
     * @param pred - The relationship which is asserted
     * @param obj - The object of the relationship, e.g. another thing or a value. If passed a string, this will become a literal.
     * @param why - The document in which the triple (S,P,O) was or will be stored on the web
     * @returns The statement added to the store, or the store
     */
  }, {
    key: "add",
    value: function add(subj, pred, obj, why) {
      var i;
      if (arguments.length === 1) {
        if (subj instanceof Array) {
          for (i = 0; i < subj.length; i++) {
            this.add(subj[i]);
          }
        } else if (isQuad(subj)) {
          this.add(subj.subject, subj.predicate, subj.object, subj.graph);
        } else if (isStore(subj)) {
          this.add(subj.statements);
        }
        return this;
      }
      var actions;
      var st3;
      if (!why) {
        why = this.fetcher ? this.fetcher.appNode : this.rdfFactory.defaultGraph();
      }
      if (typeof subj == "string") {
        subj = this.rdfFactory.namedNode(subj);
      }
      pred = node_default.fromValue(pred);
      var objNode = node_default.fromValue(obj);
      why = node_default.fromValue(why);
      if (!isRDFlibSubject(subj)) {
        throw new Error("Subject is not a subject type");
      }
      if (!isRDFlibPredicate(pred)) {
        throw new Error("Predicate ".concat(pred, " is not a predicate type"));
      }
      if (!isRDFlibObject(objNode)) {
        throw new Error("Object ".concat(objNode, " is not an object type"));
      }
      if (!isGraph(why)) {
        throw new Error("Why is not a graph type");
      }
      if (this.predicateCallback) {
        this.predicateCallback(this, pred, why);
      }
      var predHash = this.id(this.canon(pred));
      actions = this.propertyActions[predHash];
      var done = false;
      if (actions) {
        for (i = 0; i < actions.length; i++) {
          done = done || actions[i](this, subj, pred, objNode, why);
        }
      }
      if (this.holds(subj, pred, objNode, why)) {
        return null;
      }
      var hash = [this.id(this.canon(subj)), predHash, this.id(this.canon(objNode)), this.id(this.canon(why))];
      st3 = this.rdfFactory.quad(subj, pred, objNode, why);
      for (i = 0; i < 4; i++) {
        var ix = this.index[i];
        var h = hash[i];
        if (!ix[h]) {
          ix[h] = [];
        }
        ix[h].push(st3);
      }
      this.statements.push(st3);
      if (this.dataCallbacks) {
        var _iterator = _createForOfIteratorHelper4(this.dataCallbacks), _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            var callback = _step.value;
            callback(st3);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return st3;
    }
    /**
     * Returns the symbol with canonical URI as smushed
     * @param term - An RDF node
     */
  }, {
    key: "canon",
    value: function canon(term2) {
      if (!term2) {
        return term2;
      }
      var y = this.redirections[this.id(term2)];
      if (y) {
        return y;
      }
      switch (term2.termType) {
        case BlankNodeTermType:
          return new BlankNode(term2.value);
        case CollectionTermType:
          return term2;
        // non-RDF/JS type, should just need to cast
        case DefaultGraphTermType:
          return new DefaultGraph();
        case EmptyTermType:
          return term2;
        case GraphTermType:
          return term2;
        case LiteralTermType:
          return new Literal(term2.value, term2.language, term2.datatype);
        case NamedNodeTermType:
          return new NamedNode(term2.value);
        case VariableTermType:
          return new Variable(term2.value);
        default:
          throw new Error("Term Type not recognized for canonization: ".concat(term2.termType));
      }
    }
    /**
     * Checks this formula for consistency
     */
  }, {
    key: "check",
    value: function check() {
      this.checkStatementList(this.statements);
      for (var p = 0; p < 4; p++) {
        var ix = this.index[p];
        for (var key in ix) {
          if (ix.hasOwnProperty(key)) {
            this.checkStatementList(ix[key], p);
          }
        }
      }
    }
    /**
     * Checks a list of statements for consistency
     * @param sts - The list of statements to check
     * @param from - An index with the array ['subject', 'predicate', 'object', 'why']
     */
  }, {
    key: "checkStatementList",
    value: function checkStatementList(sts, from) {
      if (from === void 0) {
        from = 0;
      }
      var names = ["subject", "predicate", "object", "why"];
      var origin = " found in " + names[from] + " index.";
      var st3;
      for (var j = 0; j < sts.length; j++) {
        st3 = sts[j];
        var term2 = [st3.subject, st3.predicate, st3.object, st3.graph];
        var arrayContains = function arrayContains2(a, x) {
          for (var i = 0; i < a.length; i++) {
            if (a[i].subject.equals(x.subject) && a[i].predicate.equals(x.predicate) && a[i].object.equals(x.object) && a[i].why.equals(x.graph)) {
              return true;
            }
          }
        };
        for (var p = 0; p < 4; p++) {
          var c = this.canon(term2[p]);
          var h = this.id(c);
          if (!this.index[p][h]) {
          } else {
            if (!arrayContains(this.index[p][h], st3)) {
            }
          }
        }
        if (!arrayContains(this.statements, st3)) {
          throw new Error("Statement list does not statement " + st3 + "@" + st3.graph + origin);
        }
      }
    }
    /**
     * Closes this formula (and return it)
     */
  }, {
    key: "close",
    value: function close() {
      return this;
    }
  }, {
    key: "compareTerms",
    value: function compareTerms(u1, u2) {
      if (Object.prototype.hasOwnProperty.call(u1, "compareTerm")) {
        return u1.compareTerm(u2);
      }
      if (class_order_default[u1.termType] < class_order_default[u2.termType]) {
        return -1;
      }
      if (class_order_default[u1.termType] > class_order_default[u2.termType]) {
        return 1;
      }
      if (u1.value < u2.value) {
        return -1;
      }
      if (u1.value > u2.value) {
        return 1;
      }
      return 0;
    }
    /**
     * replaces @template with @target and add appropriate triples
     * removes no triples by default and is a one-direction replication
     * @param template node to copy
     * @param target node to copy to
     * @param flags Whether or not to do a two-directional copy and/or delete triples
     */
  }, {
    key: "copyTo",
    value: function copyTo(template, target, flags) {
      if (!flags) flags = [];
      var statList = this.statementsMatching(template);
      if (ArrayIndexOf(flags, "two-direction") !== -1) {
        statList.concat(this.statementsMatching(void 0, void 0, template));
      }
      for (var i = 0; i < statList.length; i++) {
        var st3 = statList[i];
        switch (st3.object.termType) {
          case "NamedNode":
            this.add(target, st3.predicate, st3.object);
            break;
          case "Literal":
          case "BlankNode":
          // @ts-ignore Collections can appear here
          case "Collection":
            this.add(target, st3.predicate, st3.object.copy(this));
        }
        if (ArrayIndexOf(flags, "delete") !== -1) {
          this.remove(st3);
        }
      }
    }
    /**
     * Simplify graph in store when we realize two identifiers are equivalent
     * We replace the bigger with the smaller.
     * @param u1in The first node
     * @param u2in The second node
     */
  }, {
    key: "equate",
    value: function equate(u1in, u2in) {
      var u1 = this.canon(u1in);
      var u2 = this.canon(u2in);
      var d = this.compareTerms(u1, u2);
      if (!d) {
        return true;
      }
      if (d < 0) {
        return this.replaceWith(u2, u1);
      } else {
        return this.replaceWith(u1, u2);
      }
    }
    /**
     * Creates a new empty indexed formula
     * Only applicable for IndexedFormula, but TypeScript won't allow a subclass to override a property
     * @param features The list of features
     */
  }, {
    key: "formula",
    value: function formula2(features) {
      return new IndexedFormula2(features);
    }
    /**
     * Returns the number of statements contained in this IndexedFormula.
     * (Getter proxy to this.statements).
     * Usage:
     *    ```
     *    var kb = rdf.graph()
     *    kb.length  // -> 0
     *    ```
     * @returns {Number}
     */
  }, {
    key: "length",
    get: function get() {
      return this.statements.length;
    }
    /**
     * Returns any quads matching the given arguments.
     * Standard RDFJS spec method for Source objects, implemented as an
     * alias to `statementsMatching()`
     * @param subject The subject
     * @param predicate The predicate
     * @param object The object
     * @param graph The graph that contains the statement
     */
  }, {
    key: "match",
    value: function match(subject, predicate, object, graph3) {
      return this.statementsMatching(node_default.fromValue(subject), node_default.fromValue(predicate), node_default.fromValue(object), node_default.fromValue(graph3));
    }
    /**
     * Find out whether a given URI is used as symbol in the formula
     * @param uri The URI to look for
     */
  }, {
    key: "mentionsURI",
    value: function mentionsURI(uri) {
      var hash = "<" + uri + ">";
      return !!this.subjectIndex[hash] || !!this.objectIndex[hash] || !!this.predicateIndex[hash];
    }
    /**
     * Existentials are BNodes - something exists without naming
     * @param uri An URI
     */
  }, {
    key: "newExistential",
    value: function newExistential(uri) {
      if (!uri) return this.bnode();
      var x = this.sym(uri);
      return this.declareExistential(x);
    }
    /**
     * Adds a new property action
     * @param pred the predicate that the function should be triggered on
     * @param action the function that should trigger
     */
  }, {
    key: "newPropertyAction",
    value: function newPropertyAction(pred, action) {
      var hash = this.id(pred);
      if (!this.propertyActions[hash]) {
        this.propertyActions[hash] = [];
      }
      this.propertyActions[hash].push(action);
      var toBeFixed = this.statementsMatching(void 0, pred, void 0);
      var done = false;
      for (var i = 0; i < toBeFixed.length; i++) {
        done = done || action(this, toBeFixed[i].subject, pred, toBeFixed[i].object);
      }
      return done;
    }
    /**
     * Creates a new universal node
     * Universals are Variables
     * @param uri An URI
     */
  }, {
    key: "newUniversal",
    value: function newUniversal(uri) {
      var x = this.sym(uri);
      if (!this._universalVariables) this._universalVariables = [];
      this._universalVariables.push(x);
      return x;
    }
    // convenience function used by N3 parser
  }, {
    key: "variable",
    value: function variable4(name) {
      return new Variable(name);
    }
    /**
     * Find an unused id for a file being edited: return a symbol
     * (Note: Slow iff a lot of them -- could be O(log(k)) )
     * @param doc A document named node
     */
  }, {
    key: "nextSymbol",
    value: function nextSymbol(doc) {
      for (var i = 0; ; i++) {
        var uri = doc.value + "#n" + i;
        if (!this.mentionsURI(uri)) return this.sym(uri);
      }
    }
    /**
     * Query this store asynchronously, return bindings in callback
     *
     * @param myQuery The query to be run
     * @param callback Function to call when bindings
     * @param Fetcher | null  If you want the query to do link following
     * @param onDone OBSOLETE - do not use this // @@ Why not ?? Called when query complete
     */
  }, {
    key: "query",
    value: function query(myQuery, callback, fetcher3, onDone) {
      return indexedFormulaQuery.call(this, myQuery, callback, fetcher3, onDone);
    }
    /**
     * Query this store synchronously and return bindings
     *
     * @param myQuery The query to be run
     */
  }, {
    key: "querySync",
    value: function querySync(myQuery) {
      var results = [];
      function saveBinginds(bindings) {
        results.push(bindings);
      }
      function onDone() {
        done = true;
      }
      var done = false;
      myQuery.sync = true;
      indexedFormulaQuery.call(this, myQuery, saveBinginds, null, onDone);
      if (!done) {
        throw new Error("Sync query should have called done function");
      }
      return results;
    }
    /**
     * Removes one or multiple statement(s) from this formula
     * @param st - A Statement or array of Statements to remove
     */
  }, {
    key: "remove",
    value: function remove(st3) {
      if (st3 instanceof Array) {
        for (var i = 0; i < st3.length; i++) {
          this.remove(st3[i]);
        }
        return this;
      }
      if (isStore(st3)) {
        return this.remove(st3.statements);
      }
      var sts = this.statementsMatching(st3.subject, st3.predicate, st3.object, st3.graph);
      if (!sts.length) {
        throw new Error("Statement to be removed is not on store: " + st3);
      }
      this.removeStatement(sts[0]);
      return this;
    }
    /**
     * Removes all statements in a doc, along with the related metadata including request/response/status
     * @param doc - The document / graph
     */
  }, {
    key: "removeDocument",
    value: function removeDocument(doc) {
      this.removeMetadata(doc);
      var sts = this.statementsMatching(void 0, void 0, void 0, doc).slice();
      for (var i = 0; i < sts.length; i++) {
        this.removeStatement(sts[i]);
      }
      this.removeMatches(doc, null, null);
      return this;
    }
  }, {
    key: "removeMetadata",
    value: function removeMetadata(doc) {
      var meta = this.sym("chrome://TheCurrentSession");
      var linkNamespaceURI = "http://www.w3.org/2007/ont/link#";
      var requests = this.statementsMatching(void 0, this.sym("".concat(linkNamespaceURI, "requestedURI")), this.rdfFactory.literal(doc.value), meta).map(function(st3) {
        return st3.subject;
      });
      for (var r = 0; r < requests.length; r++) {
        var request = requests[r];
        if (request != void 0) {
          var sts = void 0;
          var status = this.any(request, this.sym("".concat(linkNamespaceURI, "status")), null, meta);
          if (status != void 0) {
            sts = this.statementsMatching(status, this.sym("".concat(linkNamespaceURI, "status")), null, meta).slice();
            for (var i = 0; i < sts.length; i++) {
              this.removeStatement(sts[i]);
            }
          }
          var response = this.any(request, this.sym("".concat(linkNamespaceURI, "response")), null, meta);
          if (response != void 0) {
            sts = this.statementsMatching(response, null, null, meta).slice();
            for (var i = 0; i < sts.length; i++) {
              this.removeStatement(sts[i]);
            }
          }
          sts = this.statementsMatching(request, null, null, meta).slice();
          for (var i = 0; i < sts.length; i++) {
            this.removeStatement(sts[i]);
          }
        }
      }
      this.removeMatches(this.sym(doc.value), null, null, meta);
      return this;
    }
    /**
     * Remove all statements matching args (within limit) *
     * @param subj The subject
     * @param pred The predicate
     * @param obj The object
     * @param why The graph that contains the statement
     * @param limit The number of statements to remove
     */
  }, {
    key: "removeMany",
    value: function removeMany(subj, pred, obj, why, limit) {
      var sts = this.statementsMatching(subj, pred, obj, why, false);
      var statements = [];
      for (var i = 0; i < sts.length; i++) statements.push(sts[i]);
      if (limit) statements = statements.slice(0, limit);
      for (i = 0; i < statements.length; i++) this.remove(statements[i]);
    }
    /**
     * Remove all matching statements
     * @param subject The subject
     * @param predicate The predicate
     * @param object The object
     * @param graph The graph that contains the statement
     */
  }, {
    key: "removeMatches",
    value: function removeMatches(subject, predicate, object, graph3) {
      this.removeMany(subject, predicate, object, graph3);
      return this;
    }
    /**
     * Remove a particular statement object from the store
     *
     * @param st - a statement which is already in the store and indexed.
     *        Make sure you only use this for these.
     *        Otherwise, you should use remove() above.
     */
  }, {
    key: "removeStatement",
    value: function removeStatement(st3) {
      var term2 = [st3.subject, st3.predicate, st3.object, st3.graph];
      for (var p = 0; p < 4; p++) {
        var c = this.canon(term2[p]);
        var h = this.id(c);
        if (!this.index[p][h]) {
        } else {
          this.rdfArrayRemove(this.index[p][h], st3);
        }
      }
      this.rdfArrayRemove(this.statements, st3);
      return this;
    }
    /**
     * Removes statements
     * @param sts The statements to remove
     */
  }, {
    key: "removeStatements",
    value: function removeStatements(sts) {
      for (var i = 0; i < sts.length; i++) {
        this.remove(sts[i]);
      }
      return this;
    }
    /**
     * Replace big with small, obsoleted with obsoleting.
     */
  }, {
    key: "replaceWith",
    value: function replaceWith(big, small) {
      var oldhash = this.id(big);
      var newhash = this.id(small);
      var moveIndex = function moveIndex2(ix) {
        var oldlist = ix[oldhash];
        if (!oldlist) {
          return;
        }
        var newlist = ix[newhash];
        if (!newlist) {
          ix[newhash] = oldlist;
        } else {
          ix[newhash] = oldlist.concat(newlist);
        }
        delete ix[oldhash];
      };
      for (var i = 0; i < 4; i++) {
        moveIndex(this.index[i]);
      }
      this.redirections[oldhash] = small;
      if (big.value) {
        if (!this.aliases[newhash]) {
          this.aliases[newhash] = [];
        }
        this.aliases[newhash].push(big);
        if (this.aliases[oldhash]) {
          for (i = 0; i < this.aliases[oldhash].length; i++) {
            this.redirections[this.id(this.aliases[oldhash][i])] = small;
            this.aliases[newhash].push(this.aliases[oldhash][i]);
          }
        }
        this.add(small, this.sym("http://www.w3.org/2007/ont/link#uri"), big);
        if (this.fetcher) {
          this.fetcher.nowKnownAs(big, small);
        }
      }
      moveIndex(this.classActions);
      moveIndex(this.propertyActions);
      return true;
    }
    /**
     * Return all equivalent URIs by which this is known
     * @param x A named node
     */
  }, {
    key: "allAliases",
    value: function allAliases(x) {
      var a = this.aliases[this.id(this.canon(x))] || [];
      a.push(this.canon(x));
      return a;
    }
    /**
     * Compare by canonical URI as smushed
     * @param x A named node
     * @param y Another named node
     */
  }, {
    key: "sameThings",
    value: function sameThings(x, y) {
      if (x.equals(y)) {
        return true;
      }
      var x1 = this.canon(x);
      if (!x1) return false;
      var y1 = this.canon(y);
      if (!y1) return false;
      return x1.value === y1.value;
    }
  }, {
    key: "setPrefixForURI",
    value: function setPrefixForURI(prefix, nsuri) {
      if (prefix === "tab" && this.namespaces["tab"]) {
        return;
      }
      if (prefix.slice(0, 2) === "ns" || prefix.slice(0, 7) === "default") {
        return;
      }
      for (var existingPrefix in this.namespaces) {
        if (this.namespaces[existingPrefix] == nsuri) delete this.namespaces[existingPrefix];
      }
      this.namespaces[prefix] = nsuri;
    }
    /** Search the Store
     *
     * ALL CONVENIENCE LOOKUP FUNCTIONS RELY ON THIS!
     * @param subj - A node to search for as subject, or if null, a wildcard
     * @param pred - A node to search for as predicate, or if null, a wildcard
     * @param obj - A node to search for as object, or if null, a wildcard
     * @param why - A node to search for as graph, or if null, a wildcard
     * @param justOne - flag - stop when found one rather than get all of them?
     * @returns An array of nodes which match the wildcard position
     */
  }, {
    key: "statementsMatching",
    value: function statementsMatching(subj, pred, obj, why, justOne) {
      var pat = [subj, pred, obj, why];
      var pattern = [];
      var hash = [];
      var wild = [];
      var given = [];
      var p;
      var list;
      for (p = 0; p < 4; p++) {
        pattern[p] = this.canon(node_default.fromValue(pat[p]));
        if (!pattern[p]) {
          wild.push(p);
        } else {
          given.push(p);
          hash[p] = this.id(pattern[p]);
        }
      }
      if (given.length === 0) {
        return this.statements;
      }
      if (given.length === 1) {
        p = given[0];
        list = this.index[p][hash[p]];
        if (list && justOne) {
          if (list.length > 1) {
            list = list.slice(0, 1);
          }
        }
        list = list || [];
        return list;
      }
      var best = 1e10;
      var iBest;
      var i;
      for (i = 0; i < given.length; i++) {
        p = given[i];
        list = this.index[p][hash[p]];
        if (!list) {
          return [];
        }
        if (list.length < best) {
          best = list.length;
          iBest = i;
        }
      }
      var pBest = given[iBest];
      var possibles = this.index[pBest][hash[pBest]];
      var check = given.slice(0, iBest).concat(given.slice(iBest + 1));
      var results = [];
      var parts = ["subject", "predicate", "object", "why"];
      for (var j = 0; j < possibles.length; j++) {
        var st3 = possibles[j];
        for (i = 0; i < check.length; i++) {
          p = check[i];
          if (!this.canon(st3[parts[p]]).equals(pattern[p])) {
            st3 = null;
            break;
          }
        }
        if (st3 != null) {
          results.push(st3);
          if (justOne) break;
        }
      }
      return results;
    }
    /**
     * A list of all the URIs by which this thing is known
     * @param term
     */
  }, {
    key: "uris",
    value: function uris(term2) {
      var cterm = this.canon(term2);
      var terms = this.aliases[this.id(cterm)];
      if (!cterm.value) return [];
      var res = [cterm.value];
      if (terms) {
        for (var i = 0; i < terms.length; i++) {
          res.push(terms[i].uri);
        }
      }
      return res;
    }
  }, {
    key: "serialize",
    value: function serialize2(base, contentType, provenance, options) {
      var _options;
      var namespaces = (_options = options) !== null && _options !== void 0 && _options.namespaces ? _objectSpread3(_objectSpread3({}, this.namespaces), options.namespaces) : _objectSpread3({}, this.namespaces);
      options = _objectSpread3(_objectSpread3({}, options || {}), {}, {
        namespaces
      });
      return serialize(provenance, this, base, contentType, void 0, options);
    }
  }], [{
    key: "defaultGraphURI",
    get: function get() {
      return defaultGraphURI;
    }
  }]);
}(Formula);
_defineProperty(IndexedFormula, "handleRDFType", void 0);
IndexedFormula.handleRDFType = handleRDFType;

// ../node_modules/rdflib/esm/update-manager.js
function _createForOfIteratorHelper5(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray5(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i >= o.length) return { done: true };
        return { done: false, value: o[i++] };
      }, e: function e(_e) {
        throw _e;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s() {
    it = it.call(o);
  }, n: function n() {
    var step = it.next();
    normalCompletion = step.done;
    return step;
  }, e: function e(_e2) {
    didErr = true;
    err = _e2;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null) it.return();
    } finally {
      if (didErr) throw err;
    }
  } };
}
function _unsupportedIterableToArray5(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray5(o, minLen);
}
function _arrayLikeToArray5(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
var UpdateManager = /* @__PURE__ */ function() {
  function UpdateManager2(store) {
    _classCallCheck(this, UpdateManager2);
    _defineProperty(this, "store", void 0);
    _defineProperty(this, "ifps", void 0);
    _defineProperty(this, "fps", void 0);
    _defineProperty(this, "patchControl", void 0);
    _defineProperty(this, "ns", void 0);
    store = store || new IndexedFormula();
    if (store.updater) {
      throw new Error("You can't have two UpdateManagers for the same store");
    }
    if (!store.fetcher) {
      store.fetcher = new Fetcher(store);
    }
    this.store = store;
    store.updater = this;
    this.ifps = {};
    this.fps = {};
    this.ns = {};
    this.ns.link = Namespace("http://www.w3.org/2007/ont/link#");
    this.ns.http = Namespace("http://www.w3.org/2007/ont/http#");
    this.ns.httph = Namespace("http://www.w3.org/2007/ont/httph#");
    this.ns.ldp = Namespace("http://www.w3.org/ns/ldp#");
    this.ns.rdf = Namespace("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
    this.ns.rdfs = Namespace("http://www.w3.org/2000/01/rdf-schema#");
    this.ns.rdf = Namespace("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
    this.ns.owl = Namespace("http://www.w3.org/2002/07/owl#");
    this.patchControl = [];
  }
  return _createClass(UpdateManager2, [{
    key: "patchControlFor",
    value: function patchControlFor(doc) {
      if (!this.patchControl[doc.value]) {
        this.patchControl[doc.value] = [];
      }
      return this.patchControl[doc.value];
    }
  }, {
    key: "isHttpUri",
    value: function isHttpUri(uri) {
      return uri.slice(0, 4) === "http";
    }
    /** Remove from the store HTTP authorization metadata
    * The editable function below relies on copies we have in the store
    * of the results of previous HTTP transactions. However, when
    * the user logs in, then that data misrepresents what would happen
    * if the user tried again.
    */
  }, {
    key: "flagAuthorizationMetadata",
    value: function flagAuthorizationMetadata(kb) {
      var _kb$fetcher;
      if (!kb) {
        kb = this.store;
      }
      var meta = (_kb$fetcher = kb.fetcher) === null || _kb$fetcher === void 0 ? void 0 : _kb$fetcher.appNode;
      var requests = kb.statementsMatching(void 0, this.ns.link("requestedURI"), void 0, meta).map(function(st3) {
        return st3.subject;
      });
      var _iterator = _createForOfIteratorHelper5(requests), _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          var request = _step.value;
          var _response = kb.any(request, this.ns.link("response"), null, meta);
          if (_response != void 0) {
            kb.add(_response, this.ns.link("outOfDate"), true, meta);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Tests whether a file is editable.
     * If the file has a specific annotation that it is machine written,
     * for safety, it is editable (this doesn't actually check for write access)
     * If the file has wac-allow and accept patch headers, those are respected.
     * and local write access is determined by those headers.
     * This async version not only looks at past HTTP requests, it also makes new ones if necessary.
     *
     * @returns The method string N3PATCH or SPARQL or DAV or
     *   LOCALFILE or false if known, undefined if not known.
     */
  }, {
    key: "checkEditable",
    value: function() {
      var _checkEditable = _asyncToGenerator(/* @__PURE__ */ import_regenerator2.default.mark(function _callee(uri, kb) {
        var _kb$fetcher2;
        var initial, final;
        return import_regenerator2.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (uri) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", false);
            case 2:
              if (!kb) {
                kb = this.store;
              }
              initial = this.editable(uri, kb);
              if (!(initial !== void 0)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", initial);
            case 6:
              _context.next = 8;
              return (_kb$fetcher2 = kb.fetcher) === null || _kb$fetcher2 === void 0 ? void 0 : _kb$fetcher2.load(uri);
            case 8:
              final = this.editable(uri, kb);
              return _context.abrupt("return", final);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function checkEditable(_x, _x2) {
        return _checkEditable.apply(this, arguments);
      }
      return checkEditable;
    }()
  }, {
    key: "editable",
    value: function editable(uri, kb) {
      var _kb$fetcher3;
      if (!uri) {
        return false;
      }
      if (!kb) {
        kb = this.store;
      }
      uri = termValue(uri);
      if (!this.isHttpUri(uri)) {
        if (kb.holds(kb.rdfFactory.namedNode(uri), kb.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"), kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/link#MachineEditableDocument"))) {
          return "LOCALFILE";
        }
      }
      var request;
      var definitive = false;
      var meta = (_kb$fetcher3 = kb.fetcher) === null || _kb$fetcher3 === void 0 ? void 0 : _kb$fetcher3.appNode;
      var requests = kb.each(void 0, this.ns.link("requestedURI"), docpart(uri), meta);
      var method;
      for (var r = 0; r < requests.length; r++) {
        request = requests[r];
        if (request !== void 0) {
          var _response2 = kb.any(request, this.ns.link("response"), null, meta);
          if (_response2 !== void 0) {
            var outOfDate = kb.anyJS(_response2, this.ns.link("outOfDate"), null, meta);
            if (outOfDate) continue;
            var wacAllow = kb.anyValue(_response2, this.ns.httph("wac-allow"));
            if (wacAllow) {
              var _iterator2 = _createForOfIteratorHelper5(wacAllow.split(",")), _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                  var bit = _step2.value;
                  var lr = bit.split("=");
                  if (lr[0].includes("user") && !lr[1].includes("write") && !lr[1].includes("append")) {
                    return false;
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
            var acceptPatch = kb.each(_response2, this.ns.httph("accept-patch"));
            if (acceptPatch.length) {
              for (var i = 0; i < acceptPatch.length; i++) {
                method = acceptPatch[i].value.trim();
                if (method.indexOf("text/n3") >= 0) return "N3PATCH";
                if (method.indexOf("application/sparql-update") >= 0) return "SPARQL";
                if (method.indexOf("application/sparql-update-single-match") >= 0) return "SPARQL";
              }
            }
            var authorVia = kb.each(_response2, this.ns.httph("ms-author-via"));
            if (authorVia.length) {
              for (var _i = 0; _i < authorVia.length; _i++) {
                method = authorVia[_i].value.trim();
                if (method.indexOf("SPARQL") >= 0) {
                  return "SPARQL";
                }
                if (method.indexOf("DAV") >= 0) {
                  return "DAV";
                }
              }
            }
            if (!this.isHttpUri(uri)) {
              if (!wacAllow) return false;
              else return "LOCALFILE";
            }
            var status = kb.each(_response2, this.ns.http("status"));
            if (status.length) {
              for (var _i2 = 0; _i2 < status.length; _i2++) {
                if (status[_i2] === 200 || status[_i2] === 404) {
                  definitive = true;
                }
              }
            }
          } else {
          }
        }
      }
      if (requests.length === 0) {
      } else {
        if (definitive) {
          return false;
        }
      }
      return void 0;
    }
  }, {
    key: "anonymize",
    value: function anonymize(obj) {
      var anonymized = obj.toNT().substr(0, 2) === "_:" && this.mentioned(obj) ? "?" + obj.toNT().substr(2) : obj.toNT();
      return anonymized;
    }
  }, {
    key: "anonymizeNT",
    value: function anonymizeNT(stmt) {
      return this.anonymize(stmt.subject) + " " + this.anonymize(stmt.predicate) + " " + this.anonymize(stmt.object) + " .";
    }
  }, {
    key: "nTriples",
    value: function nTriples(stmt) {
      return "".concat(stmt.subject.toNT(), " ").concat(stmt.predicate.toNT(), " ").concat(stmt.object.toNT(), " .");
    }
    /**
     * Returns a list of all bnodes occurring in a statement
     * @private
     */
  }, {
    key: "statementBnodes",
    value: function statementBnodes(st3) {
      return [st3.subject, st3.predicate, st3.object].filter(function(x) {
        return isBlankNode(x);
      });
    }
    /**
     * Returns a list of all bnodes occurring in a list of statements
     * @private
     */
  }, {
    key: "statementArrayBnodes",
    value: function statementArrayBnodes(sts) {
      var bnodes = [];
      for (var i = 0; i < sts.length; i++) {
        bnodes = bnodes.concat(this.statementBnodes(sts[i]));
      }
      bnodes.sort();
      var bnodes2 = [];
      for (var j = 0; j < bnodes.length; j++) {
        if (j === 0 || !bnodes[j].equals(bnodes[j - 1])) {
          bnodes2.push(bnodes[j]);
        }
      }
      return bnodes2;
    }
    /**
     * Makes a cached list of [Inverse-]Functional properties
     * @private
     */
  }, {
    key: "cacheIfps",
    value: function cacheIfps() {
      this.ifps = {};
      var a = this.store.each(void 0, this.ns.rdf("type"), this.ns.owl("InverseFunctionalProperty"));
      for (var i = 0; i < a.length; i++) {
        this.ifps[a[i].value] = true;
      }
      this.fps = {};
      a = this.store.each(void 0, this.ns.rdf("type"), this.ns.owl("FunctionalProperty"));
      for (var _i3 = 0; _i3 < a.length; _i3++) {
        this.fps[a[_i3].value] = true;
      }
    }
    /**
     * Returns a context to bind a given node, up to a given depth
     * @private
     */
  }, {
    key: "bnodeContext2",
    value: function bnodeContext2(x, source, depth) {
      var sts = this.store.statementsMatching(void 0, void 0, x, source);
      var y;
      var res;
      for (var i = 0; i < sts.length; i++) {
        if (this.fps[sts[i].predicate.value]) {
          y = sts[i].subject;
          if (!y.isBlank) {
            return [sts[i]];
          }
          if (depth) {
            res = this.bnodeContext2(y, source, depth - 1);
            if (res) {
              return res.concat([sts[i]]);
            }
          }
        }
      }
      sts = this.store.statementsMatching(x, void 0, void 0, source);
      for (var _i4 = 0; _i4 < sts.length; _i4++) {
        if (this.ifps[sts[_i4].predicate.value]) {
          y = sts[_i4].object;
          if (!y.isBlank) {
            return [sts[_i4]];
          }
          if (depth) {
            res = this.bnodeContext2(y, source, depth - 1);
            if (res) {
              return res.concat([sts[_i4]]);
            }
          }
        }
      }
      return null;
    }
    /**
     * Returns the smallest context to bind a given single bnode
     * @private
     */
  }, {
    key: "bnodeContext1",
    value: function bnodeContext1(x, source) {
      for (var depth = 0; depth < 3; depth++) {
        var con = this.bnodeContext2(x, source, depth);
        if (con !== null) return con;
      }
      return this.store.connectedStatements(x, source);
    }
    /**
     * @private
     */
  }, {
    key: "mentioned",
    value: function mentioned(x) {
      return this.store.statementsMatching(x, null, null, null).length !== 0 || // Don't pin fresh bnodes
      this.store.statementsMatching(null, x).length !== 0 || this.store.statementsMatching(null, null, x).length !== 0;
    }
    /**
     * @private
     */
  }, {
    key: "bnodeContext",
    value: function bnodeContext(bnodes, doc) {
      var context = [];
      if (bnodes.length) {
        this.cacheIfps();
        for (var i = 0; i < bnodes.length; i++) {
          var bnode = bnodes[i];
          if (!this.mentioned(bnode)) continue;
          context = context.concat(this.bnodeContext1(bnode, doc));
        }
      }
      return context;
    }
    /**
     * Returns the best context for a single statement
     * @private
     */
  }, {
    key: "statementContext",
    value: function statementContext(st3) {
      var bnodes = this.statementBnodes(st3);
      return this.bnodeContext(bnodes, st3.graph);
    }
    /**
     * @private
     */
  }, {
    key: "contextWhere",
    value: function contextWhere(context) {
      var updater = this;
      return !context || context.length === 0 ? "" : "WHERE { " + context.map(function(x) {
        return updater.anonymizeNT(x);
      }).join("\n") + " }\n";
    }
    /**
     * @private
     */
  }, {
    key: "fire",
    value: function fire(uri, query, callbackFunction) {
      var _this = this;
      var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      return Promise.resolve().then(function() {
        if (!uri) {
          throw new Error("No URI given for remote editing operation: " + query);
        }
        options.noMeta = true;
        options.contentType = options.contentType || "application/sparql-update";
        options.body = query;
        return _this.store.fetcher.webOperation("PATCH", uri, options);
      }).then(function(response) {
        if (!response.ok) {
          var _message = "UpdateManager: update failed for <" + uri + "> status=" + response.status + ", " + response.statusText + "\n   for query: " + query;
          throw new Error(_message);
        }
        callbackFunction(uri, response.ok, response.responseText, response);
      }).catch(function(err) {
        callbackFunction(uri, false, err.message, err);
      });
    }
    // ARE THESE THREE FUNCTIONS USED? DEPRECATE?
    /** return a statemnet updating function
     *
     * This does NOT update the statement.
     * It returns an object which includes
     *  function which can be used to change the object of the statement.
     */
  }, {
    key: "update_statement",
    value: function update_statement(statement) {
      if (statement && !statement.graph) {
        return;
      }
      var updater = this;
      var context = this.statementContext(statement);
      return {
        statement: statement ? [statement.subject, statement.predicate, statement.object, statement.graph] : void 0,
        statementNT: statement ? this.anonymizeNT(statement) : void 0,
        where: updater.contextWhere(context),
        set_object: function set_object(obj, callbackFunction) {
          var query = this.where;
          query += "DELETE DATA { " + this.statementNT + " } ;\n";
          query += "INSERT DATA { " + // @ts-ignore `this` might refer to the wrong scope. Does this work?
          this.anonymize(this.statement[0]) + " " + // @ts-ignore
          this.anonymize(this.statement[1]) + " " + // @ts-ignore
          this.anonymize(obj) + "  . }\n";
          updater.fire(this.statement[3].value, query, callbackFunction);
        }
      };
    }
  }, {
    key: "insert_statement",
    value: function insert_statement(st3, callbackFunction) {
      var st0 = st3 instanceof Array ? st3[0] : st3;
      var query = this.contextWhere(this.statementContext(st0));
      if (st3 instanceof Array) {
        var stText = "";
        for (var i = 0; i < st3.length; i++) stText += st3[i] + "\n";
        query += "INSERT DATA { " + stText + " }\n";
      } else {
        query += "INSERT DATA { " + this.anonymize(st3.subject) + " " + this.anonymize(st3.predicate) + " " + this.anonymize(st3.object) + "  . }\n";
      }
      this.fire(st0.graph.value, query, callbackFunction);
    }
  }, {
    key: "delete_statement",
    value: function delete_statement(st3, callbackFunction) {
      var st0 = st3 instanceof Array ? st3[0] : st3;
      var query = this.contextWhere(this.statementContext(st0));
      if (st3 instanceof Array) {
        var stText = "";
        for (var i = 0; i < st3.length; i++) stText += st3[i] + "\n";
        query += "DELETE DATA { " + stText + " }\n";
      } else {
        query += "DELETE DATA { " + this.anonymize(st3.subject) + " " + this.anonymize(st3.predicate) + " " + this.anonymize(st3.object) + "  . }\n";
      }
      this.fire(st0.graph.value, query, callbackFunction);
    }
    /// //////////////////////
    /**
     * Requests a now or future action to refresh changes coming downstream
     * This is designed to allow the system to re-request the server version,
     * when a websocket has pinged to say there are changes.
     * If the websocket, by contrast, has sent a patch, then this may not be necessary.
     *
     * @param doc
     * @param action
     */
  }, {
    key: "requestDownstreamAction",
    value: function requestDownstreamAction(doc, action) {
      var control = this.patchControlFor(doc);
      if (!control.pendingUpstream) {
        action(doc);
      } else {
        if (control.downstreamAction) {
          if ("" + control.downstreamAction !== "" + action) {
            throw new Error("Can't wait for > 1 different downstream actions");
          }
        } else {
          control.downstreamAction = action;
        }
      }
    }
    /**
     * We want to start counting websocket notifications
     * to distinguish the ones from others from our own.
     */
  }, {
    key: "clearUpstreamCount",
    value: function clearUpstreamCount(doc) {
      var control = this.patchControlFor(doc);
      control.upstreamCount = 0;
    }
  }, {
    key: "getUpdatesVia",
    value: function getUpdatesVia(doc) {
      var linkHeaders = this.store.fetcher.getHeader(doc, "updates-via");
      if (!linkHeaders || !linkHeaders.length) return null;
      return linkHeaders[0].trim();
    }
  }, {
    key: "addDownstreamChangeListener",
    value: function addDownstreamChangeListener(doc, listener) {
      var _this2 = this;
      var control = this.patchControlFor(doc);
      if (!control.downstreamChangeListeners) {
        control.downstreamChangeListeners = [];
      }
      control.downstreamChangeListeners.push(listener);
      this.setRefreshHandler(doc, function(doc2) {
        _this2.reloadAndSync(doc2);
      });
    }
  }, {
    key: "reloadAndSync",
    value: function reloadAndSync(doc) {
      var control = this.patchControlFor(doc);
      var updater = this;
      if (control.reloading) {
        control.outOfDate = true;
        return;
      }
      control.reloading = true;
      var retryTimeout = 1e3;
      var tryReload = function tryReload2() {
        updater.reload(updater.store, doc, function(ok, message, response) {
          if (ok) {
            if (control.downstreamChangeListeners) {
              for (var i = 0; i < control.downstreamChangeListeners.length; i++) {
                control.downstreamChangeListeners[i]();
              }
            }
            control.reloading = false;
            if (control.outOfDate) {
              control.outOfDate = false;
              tryReload2();
            }
          } else {
            control.reloading = false;
            if (response && response.status === 0) {
              control.reloading = true;
              retryTimeout = retryTimeout * 2;
              setTimeout(tryReload2, retryTimeout);
            } else {
            }
          }
        });
      };
      tryReload();
    }
    /**
     * Sets up websocket to listen on
     *
     * There is coordination between upstream changes and downstream ones
     * so that a reload is not done in the middle of an upstream patch.
     * If you use this API then you get called when a change happens, and you
     * have to reload the file yourself, and then refresh the UI.
     * Alternative is addDownstreamChangeListener(), where you do not
     * have to do the reload yourself. Do mot mix them.
     *
     * kb contains the HTTP  metadata from previous operations
     *
     * @param doc
     * @param handler
     *
     * @returns {boolean}
     */
  }, {
    key: "setRefreshHandler",
    value: function setRefreshHandler(doc, handler) {
      var wssURI = this.getUpdatesVia(doc);
      var theHandler = handler;
      var self2 = this;
      var updater = this;
      var retryTimeout = 1500;
      var retries = 0;
      if (!wssURI) {
        return false;
      }
      wssURI = join(wssURI, doc.value);
      var validWssURI = wssURI.replace(/^http:/, "ws:").replace(/^https:/, "wss:");
      var openWebsocket = function openWebsocket2() {
        var socket;
        if (typeof WebSocket !== "undefined") {
          socket = new WebSocket(validWssURI);
        } else if (typeof window !== "undefined" && window.WebSocket) {
          socket = window.WebSocket(validWssURI);
        } else {
          return;
        }
        socket.onopen = function() {
          retryTimeout = 1500;
          this.send("sub " + doc.value);
          if (retries) {
            updater.requestDownstreamAction(doc, theHandler);
          }
        };
        var control = self2.patchControlFor(doc);
        control.upstreamCount = 0;
        socket.onerror = function onerror(err) {
        };
        socket.onclose = function(event) {
          retryTimeout *= 2;
          retries += 1;
          setTimeout(function() {
            openWebsocket2();
          }, retryTimeout);
        };
        socket.onmessage = function(msg2) {
          if (msg2.data && msg2.data.slice(0, 3) === "pub") {
            if ("upstreamCount" in control) {
              control.upstreamCount -= 1;
              if (control.upstreamCount >= 0) {
                return;
              }
            }
            control.upstreamCount = 0;
            self2.requestDownstreamAction(doc, theHandler);
          }
        };
      };
      openWebsocket();
      return true;
    }
    /**
     * This high-level function updates the local store iff the web is changed successfully.
     * Deletions, insertions may be undefined or single statements or lists or formulae (may contain bnodes which can be indirectly identified by a where clause).
     * The `why` property of each statement must be the give the web document to be updated.
     * The statements to be deleted and inserted may span more than one web document.
     * @param deletions - Statement or statements to be deleted.
     * @param insertions - Statement or statements to be inserted.
     * @returns a promise
     */
  }, {
    key: "updateMany",
    value: function updateMany(deletions) {
      var insertions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
      var docs = deletions.concat(insertions).map(function(st3) {
        return st3.why;
      });
      var thisUpdater = this;
      var uniqueDocs = [];
      docs.forEach(function(doc) {
        if (!uniqueDocs.find(function(uniqueDoc) {
          return uniqueDoc.equals(doc);
        })) uniqueDocs.push(doc);
      });
      var updates = uniqueDocs.map(function(doc) {
        return thisUpdater.update(deletions.filter(function(st3) {
          return st3.why.equals(doc);
        }), insertions.filter(function(st3) {
          return st3.why.equals(doc);
        }));
      });
      if (updates.length > 1) {
      }
      return Promise.all(updates);
    }
    /**
     * @private
     * 
     * This helper function constructs SPARQL Update query from resolved arguments.
     * 
     * @param ds: deletions array.
     * @param is: insertions array.
     * @param bnodes_context: Additional context to uniquely identify any blank nodes.
     */
  }, {
    key: "constructSparqlUpdateQuery",
    value: function constructSparqlUpdateQuery(ds, is, bnodes_context) {
      var whereClause = this.contextWhere(bnodes_context);
      var query = "";
      if (whereClause.length) {
        if (ds.length) {
          query += "DELETE { ";
          for (var i = 0; i < ds.length; i++) {
            query += this.anonymizeNT(ds[i]) + "\n";
          }
          query += " }\n";
        }
        if (is.length) {
          query += "INSERT { ";
          for (var _i5 = 0; _i5 < is.length; _i5++) {
            query += this.anonymizeNT(is[_i5]) + "\n";
          }
          query += " }\n";
        }
        query += whereClause;
      } else {
        if (ds.length) {
          query += "DELETE DATA { ";
          for (var _i6 = 0; _i6 < ds.length; _i6++) {
            query += this.anonymizeNT(ds[_i6]) + "\n";
          }
          query += " } \n";
        }
        if (is.length) {
          if (ds.length) query += " ; ";
          query += "INSERT DATA { ";
          for (var _i7 = 0; _i7 < is.length; _i7++) {
            query += this.nTriples(is[_i7]) + "\n";
          }
          query += " }\n";
        }
      }
      return query;
    }
    /**
     * @private
     * 
     * This helper function constructs n3-patch query from resolved arguments.
     * 
     * @param ds: deletions array.
     * @param is: insertions array.
     * @param bnodes_context: Additional context to uniquely identify any blanknodes.
     */
  }, {
    key: "constructN3PatchQuery",
    value: function constructN3PatchQuery(ds, is, bnodes_context) {
      var _this3 = this;
      var query = "\n@prefix solid: <http://www.w3.org/ns/solid/terms#>.\n@prefix ex: <http://www.example.org/terms#>.\n\n_:patch\n";
      if (bnodes_context && bnodes_context.length > 0) {
        query += "\n      solid:where {\n        ".concat(bnodes_context.map(function(x) {
          return _this3.anonymizeNT(x);
        }).join("\n        "), "\n      };");
      }
      if (ds.length > 0) {
        query += "\n      solid:deletes {\n        ".concat(ds.map(function(x) {
          return _this3.anonymizeNT(x);
        }).join("\n        "), "\n      };");
      }
      if (is.length > 0) {
        query += "\n      solid:inserts {\n        ".concat(is.map(function(x) {
          return _this3.anonymizeNT(x);
        }).join("\n        "), "\n      };");
      }
      query += "   a solid:InsertDeletePatch .\n";
      return query;
    }
    /**
     * This high-level function updates the local store if the web is changed successfully.
     * Deletions, insertions may be undefined or single statements or lists or formulae (may contain bnodes which can be indirectly identified by a where clause).
     * The `why` property of each statement must be the same and give the web document to be updated.
     * @param deletions - Statement or statements to be deleted.
     * @param insertions - Statement or statements to be inserted.
     * @param callback - called as callbackFunction(uri, success, errorbody)
     *           OR returns a promise
     * @param options - Options for the fetch call
     */
  }, {
    key: "update",
    value: function update(deletions, insertions, callback, secondTry) {
      var _this4 = this;
      var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
      if (!callback) {
        var thisUpdater = this;
        return new Promise(function(resolve, reject) {
          thisUpdater.update(deletions, insertions, function(uri, ok, errorBody) {
            if (!ok) {
              reject(new Error(errorBody));
            } else {
              resolve();
            }
          }, secondTry, options);
        });
      }
      try {
        var kb = this.store;
        var ds = !deletions ? [] : isStore(deletions) ? deletions.statements : deletions instanceof Array ? deletions : [deletions];
        var is = !insertions ? [] : isStore(insertions) ? insertions.statements : insertions instanceof Array ? insertions : [insertions];
        if (!(ds instanceof Array)) {
          throw new Error("Type Error " + _typeof(ds) + ": " + ds);
        }
        if (!(is instanceof Array)) {
          throw new Error("Type Error " + _typeof(is) + ": " + is);
        }
        if (ds.length === 0 && is.length === 0) {
          return callback(null, true);
        }
        var doc = ds.length ? ds[0].graph : is[0].graph;
        if (!doc) {
          var _message2 = "Error patching: statement does not specify which document to patch:" + ds[0] + ", " + is[0];
          throw new Error(_message2);
        }
        if (doc.termType !== "NamedNode") {
          var _message3 = "Error patching: document not a NamedNode:" + ds[0] + ", " + is[0];
          throw new Error(_message3);
        }
        var control = this.patchControlFor(doc);
        var startTime = Date.now();
        var props = ["subject", "predicate", "object", "why"];
        var verbs = ["insert", "delete"];
        var clauses = {
          "delete": ds,
          "insert": is
        };
        verbs.map(function(verb) {
          clauses[verb].map(function(st3) {
            if (!doc.equals(st3.graph)) {
              throw new Error("update: destination " + doc + " inconsistent with delete quad " + st3.graph);
            }
            props.map(function(prop) {
              if (typeof st3[prop] === "undefined") {
                throw new Error("update: undefined " + prop + " of statement.");
              }
            });
          });
        });
        var protocol2 = this.editable(doc.value, kb);
        if (protocol2 === false) {
          throw new Error("Update: Can't make changes in uneditable " + doc);
        }
        if (protocol2 === void 0) {
          if (secondTry) {
            throw new Error("Update: Loaded " + doc + "but still can't figure out what editing protocol it supports.");
          }
          this.store.fetcher.load(doc).then(function(response) {
            _this4.update(deletions, insertions, callback, true, options);
          }, function(err) {
            if (err.response.status === 404) {
              _this4.update(deletions, insertions, callback, true, options);
            } else {
              throw new Error("Update: Can't get updatability status ".concat(doc, " before patching: ").concat(err));
            }
          });
          return;
        } else if (protocol2.indexOf("SPARQL") >= 0 || protocol2.indexOf("N3PATCH") >= 0) {
          var isSparql = protocol2.indexOf("SPARQL") >= 0;
          var bnodes = [];
          if (ds.length) bnodes = this.statementArrayBnodes(ds);
          if (is.length) bnodes = bnodes.concat(this.statementArrayBnodes(is));
          var context = this.bnodeContext(bnodes, doc);
          var query = isSparql ? this.constructSparqlUpdateQuery(ds, is, context) : this.constructN3PatchQuery(ds, is, context);
          options.contentType = isSparql ? "application/sparql-update" : "text/n3";
          control.pendingUpstream = control.pendingUpstream ? control.pendingUpstream + 1 : 1;
          if ("upstreamCount" in control) {
            control.upstreamCount += 1;
          }
          this.fire(doc.value, query, function(uri, success2, body, response) {
            response.elapsedTimeMs = Date.now() - startTime;
            if (success2) {
              try {
                kb.remove(ds);
              } catch (e) {
                success2 = false;
                body = "Remote Ok BUT error deleting " + ds.length + " from store!!! " + e;
              }
              for (var i = 0; i < is.length; i++) {
                kb.add(is[i].subject, is[i].predicate, is[i].object, doc);
              }
            }
            callback(uri, success2, body, response);
            control.pendingUpstream -= 1;
            if (control.pendingUpstream === 0 && control.downstreamAction) {
              var downstreamAction = control.downstreamAction;
              delete control.downstreamAction;
              downstreamAction(doc);
            }
          }, options);
        } else if (protocol2.indexOf("DAV") >= 0) {
          this.updateDav(doc, ds, is, callback, options);
        } else {
          if (protocol2.indexOf("LOCALFILE") >= 0) {
            try {
              this.updateLocalFile(doc, ds, is, callback, options);
            } catch (e) {
              callback(
                doc.value,
                false,
                "Exception trying to write back file <" + doc.value + ">\n"
                // + tabulator.Util.stackString(e))
              );
            }
          } else {
            throw new Error("Unhandled edit method: '" + protocol2 + "' for " + doc);
          }
        }
      } catch (e) {
        callback(void 0, false, "Exception in update: " + e + "\n" + stackString(e));
      }
    }
  }, {
    key: "updateDav",
    value: function updateDav(doc, ds, is, callbackFunction) {
      var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
      var kb = this.store;
      var request = kb.any(doc, this.ns.link("request"));
      if (!request) {
        throw new Error("No record of our HTTP GET request for document: " + doc);
      }
      var response = kb.any(request, this.ns.link("response"));
      if (!response) {
        return null;
      }
      var contentType = kb.the(response, this.ns.httph("content-type")).value;
      var newSts = kb.statementsMatching(void 0, void 0, void 0, doc).slice();
      for (var i = 0; i < ds.length; i++) {
        RDFArrayRemove(newSts, ds[i]);
      }
      for (var _i8 = 0; _i8 < is.length; _i8++) {
        newSts.push(is[_i8]);
      }
      var documentString = this.serialize(doc.value, newSts, contentType);
      var candidateTarget = kb.the(response, this.ns.httph("content-location"));
      var targetURI;
      if (candidateTarget) {
        targetURI = join(candidateTarget.value, targetURI);
      }
      options.contentType = contentType;
      options.noMeta = true;
      options.body = documentString;
      return kb.fetcher.webOperation("PUT", targetURI, options).then(function(response2) {
        if (!response2.ok) {
          throw new Error(response2.error);
        }
        for (var _i9 = 0; _i9 < ds.length; _i9++) {
          kb.remove(ds[_i9]);
        }
        for (var _i10 = 0; _i10 < is.length; _i10++) {
          kb.add(is[_i10].subject, is[_i10].predicate, is[_i10].object, doc);
        }
        callbackFunction(doc.value, response2.ok, response2.responseText, response2);
      }).catch(function(err) {
        callbackFunction(doc.value, false, err.message, err);
      });
    }
    /**
     * Likely deprecated, since this lib no longer deals with browser extension
     *
     * @param doc
     * @param ds
     * @param is
     * @param callbackFunction
     * @param options
     */
  }, {
    key: "updateLocalFile",
    value: function updateLocalFile(doc, ds, is, callbackFunction) {
      var options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
      var kb = this.store;
      var newSts = kb.statementsMatching(void 0, void 0, void 0, doc).slice();
      for (var i = 0; i < ds.length; i++) {
        RDFArrayRemove(newSts, ds[i]);
      }
      for (var _i11 = 0; _i11 < is.length; _i11++) {
        newSts.push(is[_i11]);
      }
      var dot = doc.value.lastIndexOf(".");
      if (dot < 1) {
        throw new Error("Rewriting file: No filename extension: " + doc.value);
      }
      var ext = doc.value.slice(dot + 1);
      var contentType = Fetcher.CONTENT_TYPE_BY_EXT[ext];
      if (!contentType) {
        throw new Error("File extension ." + ext + " not supported for data write");
      }
      options.body = this.serialize(doc.value, newSts, contentType);
      options.contentType = contentType;
      kb.fetcher.webOperation("PUT", doc.value, options).then(function(response) {
        if (!response.ok) return callbackFunction(doc.value, false, response.error);
        for (var _i12 = 0; _i12 < ds.length; _i12++) {
          kb.remove(ds[_i12]);
        }
        for (var _i13 = 0; _i13 < is.length; _i13++) {
          kb.add(is[_i13].subject, is[_i13].predicate, is[_i13].object, doc);
        }
        callbackFunction(doc.value, true, "");
      });
    }
    /**
     * @throws {Error} On unsupported content type
     *
     * @returns {string}
     */
  }, {
    key: "serialize",
    value: function serialize2(uri, data, contentType) {
      var kb = this.store;
      var documentString;
      if (typeof data === "string") {
        return data;
      }
      var sz = createSerializer(kb);
      sz.suggestNamespaces(kb.namespaces);
      sz.setBase(uri);
      switch (contentType) {
        case "text/xml":
        case "application/rdf+xml":
          documentString = sz.statementsToXML(data);
          break;
        case "text/n3":
        case "text/turtle":
        case "application/x-turtle":
        // Legacy
        case "application/n3":
          documentString = sz.statementsToN3(data);
          break;
        default:
          throw new Error("Content-type " + contentType + " not supported for data serialization");
      }
      return documentString;
    }
    /**
     * This is suitable for an initial creation of a document.
     */
  }, {
    key: "put",
    value: function put(doc, data, contentType, callback) {
      var _this5 = this;
      var kb = this.store;
      var documentString;
      return Promise.resolve().then(function() {
        documentString = _this5.serialize(doc.value, data, contentType);
        return kb.fetcher.webOperation("PUT", doc.value, {
          contentType,
          body: documentString
        });
      }).then(function(response) {
        if (!response.ok) {
          return callback(doc.value, response.ok, response.error, response);
        }
        delete kb.fetcher.nonexistent[doc.value];
        delete kb.fetcher.requested[doc.value];
        if (typeof data !== "string") {
          data.map(function(st3) {
            kb.addStatement(st3);
          });
        }
        callback(doc.value, response.ok, "", response);
      }).catch(function(err) {
        callback(doc.value, false, err.message);
      });
    }
    /**
     * Reloads a document.
     *
     * Fast and cheap, no metadata. Measure times for the document.
     * Load it provisionally.
     * Don't delete the statements before the load, or it will leave a broken
     * document in the meantime.
     *
     * @param kb
     * @param doc {RDFlibNamedNode}
     * @param callbackFunction
     */
  }, {
    key: "reload",
    value: function reload(kb, doc, callbackFunction) {
      var startTime = Date.now();
      var options = {
        force: true,
        noMeta: true,
        clearPreviousData: true
      };
      kb.fetcher.nowOrWhenFetched(doc.value, options, function(ok, body, response) {
        if (!ok) {
          callbackFunction(false, "Error reloading data: " + body, response);
        } else if (response.onErrorWasCalled || response.status !== 200) {
          callbackFunction(false, "Non-HTTP error reloading data: " + body, response);
        } else {
          var elapsedTimeMs = Date.now() - startTime;
          if (!doc.reloadTimeTotal) doc.reloadTimeTotal = 0;
          if (!doc.reloadTimeCount) doc.reloadTimeCount = 0;
          doc.reloadTimeTotal += elapsedTimeMs;
          doc.reloadTimeCount += 1;
          callbackFunction(true);
        }
      });
    }
  }]);
}();

export {
  isLiteral,
  isNamedNode,
  isBlankNode,
  Namespace,
  UpdateManager,
  fetcher2 as fetcher,
  graph2 as graph,
  lit2 as lit,
  st2 as st,
  namedNode3 as namedNode
};
/*! Bundled license information:

@babel/runtime/helpers/regeneratorRuntime.js:
  (*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE *)

punycode/punycode.js:
  (*! https://mths.be/punycode v1.4.1 by @mathias *)

queue-microtask/index.js:
  (*! queue-microtask. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> *)
*/
